var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwacs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "matrix(0.591716, 0, 0, 0.591716, 0, 0)",
      transformOrigin: "50% 50%",
      cursor: "move",
      maxHeight: "none",
      transition: "transform 200ms ease-in-out 0s"
    },
    width: 871,
    height: 280,
    viewBox: "0 0 8710 2800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l28zwuVXh5JXE8vWI1S7Ftd",
    fill: "rgb(255,255,255)",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pvxiSri3r",
    d: "M3355 2535 c-107 -14 -182 -19 -186 -14 -3 5 -28 12 -55 15 -39 5 -53 3 -63 -10 -10 -12 -31 -16 -80 -16 -37 0 -88 -7 -114 -16 -44 -15 -47 -18 -47 -50 0 -24 5 -34 15 -34 9 0 18 -6 21 -13 7 -20 258 -21 296 -1 15 8 28 19 28 24 0 6 10 10 23 10 12 0 109 14 215 31 l192 32 0 34 c0 40 9 40 -245 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7ffjEDTr",
    d: "M2474 2229 c-11 -12 -26 -15 -60 -11 -39 4 -49 1 -75 -24 -22 -21 -29 -37 -29 -65 0 -37 1 -38 46 -45 25 -3 64 -3 87 0 23 4 57 7 75 6 43 -1 102 20 102 37 0 7 10 13 23 13 12 0 84 10 160 22 l137 22 0 33 0 33 -226 -3 c-194 -2 -227 -4 -240 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT8zSqp75",
    d: "M5348 1784 c-12 -12 -20 -14 -36 -5 -11 6 -35 11 -52 11 -31 0 -31 -1 -29 -45 2 -24 0 -47 -4 -51 -4 -4 -7 7 -7 24 l0 32 -85 0 -85 0 0 -71 0 -72 114 6 114 5 12 -29 c7 -16 11 -32 8 -34 -2 -2 -377 -41 -834 -85 -456 -44 -1122 -110 -1480 -145 -673 -67 -901 -83 -1504 -110 -195 -9 -395 -20 -445 -25 -49 -5 -98 -10 -108 -10 -16 0 -17 -9 -15 -92 l3 -93 135 -7 c95 -5 176 -3 272 7 75 8 282 28 460 45 178 16 1028 117 1889 225 862 107 1574 195 1583 195 20 0 21 -26 1 -34 -9 -3 -15 -18 -15 -38 0 -38 7 -51 35 -63 19 -8 19 -9 -4 -13 -24 -4 -24 -4 -17 -100 6 -100 33 -362 42 -420 5 -32 6 -32 59 -32 l55 0 0 63 c0 34 -9 170 -20 302 -11 132 -17 262 -14 289 5 31 3 50 -4 55 -7 4 96 20 228 36 l240 29 0 33 c0 40 17 39 -248 12 -112 -11 -206 -18 -209 -15 -3 2 -1 17 4 33 9 28 11 28 114 34 57 4 107 7 112 8 4 0 7 30 7 66 l0 65 -85 0 -85 0 0 -35 c0 -19 -4 -35 -10 -35 -5 0 -10 23 -10 50 0 50 0 50 -33 50 -18 0 -40 -7 -49 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP4GHCCIA",
    d: "M4190 1741 c-25 -9 -150 -42 -277 -72 l-233 -54 0 -32 c0 -25 5 -33 18 -33 9 -1 254 32 545 72 l527 73 0 32 0 33 -267 -1 c-232 0 -274 -2 -313 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQOiAWCur",
    d: "M7630 1712 c-82 -25 -95 -26 -410 -31 l-325 -6 -3 -33 c-4 -44 25 -68 103 -84 l60 -12 -65 -11 c-63 -10 -65 -11 -68 -42 -3 -27 30 -77 249 -380 139 -191 293 -405 343 -475 l91 -127 101 -1 c55 0 143 -3 194 -7 l93 -6 -5 44 c-3 24 -83 263 -177 530 -94 268 -171 489 -171 492 0 2 20 8 44 11 24 4 50 15 59 24 26 30 47 80 47 112 0 28 -2 30 -37 29 -21 0 -76 -12 -123 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8uzlKt6f",
    d: "M4928 1203 c-47 -4 -48 -5 -48 -36 0 -31 5 -35 75 -70 42 -20 89 -37 105 -37 30 0 30 1 30 53 0 91 -5 97 -64 95 -28 -1 -72 -3 -98 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14J8tUqQR",
    d: "M708 1103 c-33 -14 -38 -20 -38 -48 0 -33 1 -33 63 -44 109 -19 107 -20 107 49 l0 60 -47 -1 c-27 -1 -65 -8 -85 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7vMAodru",
    d: "M3613 1063 c-30 -4 -33 -8 -33 -37 l0 -33 128 -7 c70 -4 155 -9 190 -13 l62 -6 0 35 c0 33 -2 35 -50 46 -55 13 -247 23 -297 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn2rwIUnp",
    d: "M4330 848 c0 -27 10 -43 28 -44 34 -3 37 -4 22 -14 -23 -15 5 -30 58 -30 31 0 42 -4 42 -15 0 -12 13 -15 58 -15 31 -1 85 -2 120 -3 l62 -2 0 31 0 32 -82 12 c-46 7 -85 16 -88 19 -10 13 -148 51 -183 51 -32 0 -37 -3 -37 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZSU2CDLX",
    d: "M4770 741 c0 -25 4 -29 38 -35 75 -12 82 -10 82 29 l0 35 -60 0 c-59 0 -60 0 -60 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pB9mhaOz0",
    d: "M5670 760 c0 -5 -13 -10 -30 -10 -25 0 -30 -4 -30 -24 0 -13 -15 -43 -34 -67 -34 -45 -131 -119 -156 -119 -7 0 -41 -15 -74 -34 -81 -45 -222 -100 -339 -131 -52 -14 -98 -25 -101 -25 -3 0 -6 -9 -6 -21 0 -15 5 -19 15 -15 8 3 15 1 15 -3 0 -5 35 -12 78 -16 102 -8 133 -15 126 -26 -10 -16 110 -10 182 11 89 24 312 118 322 135 4 7 39 30 77 52 65 36 70 41 73 76 3 35 5 37 37 37 29 0 36 4 41 25 3 14 10 25 15 25 5 0 9 24 9 53 l0 54 -78 16 c-88 19 -142 22 -142 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14YzFYnd8",
    d: "M4635 626 c-38 -19 -85 -51 -104 -70 -29 -30 -35 -45 -39 -91 -5 -63 12 -92 53 -92 22 0 25 4 25 39 0 33 7 45 44 81 25 25 72 55 110 71 63 27 66 30 66 62 0 33 -1 34 -42 34 -28 0 -67 -12 -113 -34z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l7fscSH5HemZxyV1LtZcSIV",
    fill: "rgb(238,238,238)",
    style: {
      transform: "none"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pdWTCNLQ5",
    d: "M5111 2670 c-35 -4 -67 -13 -73 -21 -7 -11 -11 -11 -15 -1 -9 23 -93 10 -93 -14 0 -8 10 -14 23 -14 13 0 -25 -26 -95 -63 -65 -34 -118 -68 -118 -74 0 -7 -10 -13 -22 -13 -22 0 -150 -67 -156 -82 -2 -4 -10 -8 -18 -8 -8 0 -14 -7 -14 -15 0 -8 -8 -15 -18 -15 -23 0 -42 -19 -42 -42 0 -12 -8 -18 -23 -18 -27 0 -57 -28 -57 -53 0 -11 -8 -17 -23 -17 -28 0 -47 -17 -47 -42 0 -12 -8 -18 -23 -18 -28 0 -47 -17 -47 -42 0 -12 -8 -18 -24 -18 -36 0 -50 -24 -43 -75 7 -45 52 -147 68 -153 5 -2 9 -10 9 -18 0 -10 15 -14 60 -14 54 0 60 2 60 21 0 18 -5 20 -42 17 l-43 -3 -42 79 c-23 43 -40 82 -38 86 3 4 81 73 174 154 176 152 220 181 512 334 108 57 162 79 269 107 74 20 136 38 139 40 6 7 -123 4 -198 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXbBeg4Hc",
    d: "M3605 2635 c-82 -13 -153 -24 -157 -24 -5 -1 -8 -8 -8 -16 0 -20 17 -19 195 5 81 11 154 20 161 20 21 0 40 -75 26 -106 -7 -13 -12 -37 -12 -52 0 -24 8 -30 59 -49 32 -13 68 -23 80 -23 28 0 121 39 121 51 0 5 8 9 18 9 10 0 72 25 139 55 67 30 133 55 147 55 20 0 26 5 26 21 0 20 -4 21 -45 16 -25 -4 -116 -39 -203 -78 -210 -95 -193 -90 -250 -72 l-49 16 15 59 c13 52 13 60 -1 76 -8 9 -17 26 -19 37 -5 28 -60 28 -243 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxThMIJLW",
    d: "M4740 2634 c-63 -7 -116 -13 -117 -13 -2 -1 -3 -8 -3 -16 0 -18 9 -18 173 -3 112 10 127 14 127 30 0 21 -12 21 -180 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWk4Z5KNl",
    d: "M4548 2613 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B3W4t7my",
    d: "M3095 2600 c-22 -5 -57 -11 -77 -15 -26 -4 -38 -11 -38 -22 0 -14 9 -15 73 -8 39 5 98 7 130 6 69 -3 80 19 18 37 -43 13 -49 13 -106 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pioVk6hKM",
    d: "M3358 2603 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppo2XwQHJ",
    d: "M4438 2603 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AIoYQyXC",
    d: "M3268 2593 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLLvn6SIe",
    d: "M2858 2573 c-30 -3 -38 -9 -48 -36 -15 -39 -21 -153 -10 -183 11 -28 -3 -34 -73 -34 -29 0 -68 -5 -87 -10 -28 -9 -313 -50 -342 -50 -13 0 -31 -76 -32 -136 -1 -49 4 -68 25 -100 24 -35 38 -44 110 -69 67 -23 106 -30 192 -33 103 -4 107 -4 107 17 0 20 -5 21 -95 21 -71 0 -107 5 -145 20 -28 11 -59 20 -70 20 -43 0 -91 79 -89 144 1 27 2 25 10 -13 5 -24 11 -47 15 -50 11 -11 137 -6 141 5 3 8 18 10 43 7 50 -7 90 3 90 22 0 8 5 15 10 15 6 0 10 16 10 35 0 19 -4 35 -10 35 -5 0 -10 11 -10 25 0 19 -6 25 -22 26 -29 2 50 16 175 31 l97 11 0 38 c0 21 -4 41 -10 44 -5 3 -10 10 -10 16 0 5 5 9 10 9 6 0 10 -7 10 -15 0 -10 11 -15 35 -15 24 0 35 5 35 15 0 9 9 15 25 15 30 0 32 11 5 28 -16 10 -20 10 -20 0 -1 -8 -6 -6 -14 5 -17 23 -24 22 -28 -5 -3 -22 -3 -22 -15 4 -11 25 -10 26 33 38 27 8 44 18 44 28 0 12 -10 14 -55 8 -54 -6 -55 -6 -45 14 9 16 21 20 60 20 43 0 50 3 50 20 0 21 -11 22 -102 13z m-386 -348 c-4 -24 -22 -36 -22 -15 0 6 -21 10 -47 10 -35 0 -53 -6 -70 -22 l-24 -22 9 24 c8 22 18 26 83 36 41 7 75 12 75 13 1 0 -1 -10 -4 -24z m94 -13 c6 -4 14 -21 17 -38 5 -26 2 -31 -22 -40 -15 -6 -37 -7 -49 -3 -13 5 -35 3 -56 -6 -42 -18 -76 -19 -76 -4 0 6 -9 8 -20 4 -28 -9 -25 7 9 39 28 26 30 27 64 13 34 -15 36 -14 63 14 28 29 49 35 70 21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pABVLkQys",
    d: "M3388 2542 c-185 -23 -208 -28 -208 -44 0 -22 -12 -21 135 -3 167 21 173 17 16 -11 -74 -13 -139 -20 -144 -17 -6 4 -8 -1 -4 -11 4 -10 7 -20 7 -22 0 -10 57 -2 268 33 l222 38 0 32 c0 32 -1 33 -42 32 -24 -1 -136 -13 -250 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Bee0xXpx",
    d: "M3070 2530 c0 -5 -9 -10 -20 -10 -13 0 -20 -7 -20 -20 0 -23 31 -27 49 -6 6 7 22 11 36 8 20 -3 25 0 25 17 0 17 -6 21 -35 21 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfBpfAqZE",
    d: "M3140 2454 c0 -9 -17 -23 -40 -32 -47 -20 -53 -42 -10 -42 53 0 80 19 80 57 0 23 -5 33 -15 33 -8 0 -15 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDwq6UUnr",
    d: "M2980 2400 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paUhoqdJE",
    d: "M2851 2242 c-56 -11 -76 -12 -79 -4 -2 8 -28 12 -68 12 -58 0 -64 -2 -64 -20 0 -20 4 -20 138 -15 l137 5 -105 -20 c-58 -10 -120 -22 -137 -25 -41 -7 -45 -35 -5 -35 15 0 92 11 172 25 80 14 148 25 153 25 4 0 7 16 7 35 0 34 -1 35 -37 34 -21 -1 -72 -9 -112 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13b4wNCF5",
    d: "M7808 2013 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnd9m27hX",
    d: "M7910 1990 l0 -30 73 -1 c39 -1 63 -3 52 -6 -34 -7 -95 -36 -95 -45 0 -4 -9 -8 -20 -8 -24 0 -70 -21 -70 -32 0 -4 -9 -8 -21 -8 -11 0 -29 -5 -41 -11 -18 -10 -20 -18 -15 -77 3 -37 3 -59 1 -49 -7 24 -42 22 -149 -8 -87 -24 -101 -25 -397 -25 -168 0 -313 -3 -322 -6 -16 -6 -21 -48 -10 -78 3 -9 17 -16 30 -16 14 0 24 -6 24 -14 0 -8 17 -17 43 -21 l42 -8 -57 -10 c-57 -9 -58 -10 -58 -43 0 -19 5 -34 10 -34 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -7 10 -15 0 -8 7 -15 15 -15 8 0 15 -9 15 -20 0 -11 7 -20 15 -20 8 0 15 -9 15 -20 0 -11 5 -20 10 -20 6 0 10 -7 10 -15 0 -8 7 -15 15 -15 8 0 15 -9 15 -20 0 -15 7 -20 25 -20 22 0 25 -4 25 -35 0 -24 5 -35 15 -35 8 0 15 -9 15 -20 0 -11 5 -20 10 -20 6 0 10 -7 10 -15 0 -8 7 -15 15 -15 8 0 15 -9 15 -20 0 -15 7 -20 25 -20 22 0 25 -4 25 -35 0 -24 5 -35 15 -35 8 0 15 -9 15 -20 0 -15 7 -20 25 -20 22 0 25 -4 25 -35 0 -31 3 -35 25 -35 22 0 25 -4 25 -35 0 -24 5 -35 15 -35 8 0 15 -9 15 -20 0 -11 7 -20 15 -20 8 0 15 -9 15 -20 0 -11 5 -20 10 -20 6 0 10 -7 10 -15 0 -8 7 -15 15 -15 8 0 15 -9 15 -20 0 -15 7 -20 25 -20 22 0 25 -4 25 -35 0 -24 5 -35 15 -35 8 0 15 -9 15 -20 0 -11 5 -20 10 -20 6 0 10 -7 10 -15 0 -10 11 -15 35 -15 19 0 35 5 35 10 0 6 -6 10 -12 10 -7 1 -54 58 -104 128 -50 70 -203 282 -340 471 -137 190 -248 347 -247 350 1 3 58 15 127 27 69 11 129 24 133 27 3 4 4 7 1 7 -3 0 -60 11 -127 25 -113 23 -181 52 -164 69 3 3 143 6 310 6 235 0 303 -3 303 -12 1 -9 5 -7 13 3 7 9 48 27 92 39 44 12 88 24 98 27 17 4 17 2 -2 -34 -24 -48 -37 -59 -78 -68 -18 -3 -33 -12 -33 -18 0 -8 -3 -7 -9 2 -6 9 -18 11 -40 6 -37 -8 -42 -35 -7 -35 19 0 27 -9 42 -52 25 -68 49 -78 42 -17 -3 24 -9 52 -13 62 -6 14 -1 17 29 17 32 0 36 3 36 25 0 21 5 25 29 25 21 0 32 6 36 21 l7 21 22 -21 c12 -12 34 -21 49 -21 24 0 27 -4 27 -33 0 -43 72 -117 113 -117 24 0 27 -4 27 -33 0 -42 62 -107 103 -107 20 0 27 -5 27 -19 0 -28 -60 -36 -245 -35 -106 0 -154 -3 -162 -12 -21 -21 -18 -69 9 -140 34 -89 195 -558 238 -694 18 -58 35 -111 37 -118 3 -7 -3 -12 -16 -12 -14 0 -21 -6 -21 -20 0 -17 7 -20 45 -20 32 0 45 4 45 14 0 8 -72 230 -159 493 -88 262 -159 478 -158 479 1 1 34 -3 72 -8 88 -13 375 11 375 31 0 3 -89 101 -198 218 l-197 212 0 57 0 57 195 88 c107 48 196 92 198 97 1 5 -18 12 -44 16 -69 9 -74 8 -74 -14 0 -11 -4 -20 -10 -20 -5 0 -10 9 -10 20 0 18 -7 20 -80 20 l-80 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvhTmvvfh",
    d: "M7635 1975 c-382 -128 -450 -147 -507 -146 -52 1 -58 0 -58 -19 0 -18 6 -20 63 -20 51 -1 111 15 350 92 236 75 287 95 287 110 0 24 -18 22 -135 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjpPdeCpi",
    d: "M2770 1936 c0 -16 30 -26 79 -26 l34 0 -59 -38 c-32 -21 -118 -77 -190 -124 -146 -96 -127 -90 -434 -128 -91 -11 -210 -27 -265 -35 -55 -8 -190 -24 -299 -35 -110 -12 -202 -23 -205 -25 -4 -1 -87 -15 -186 -30 -372 -55 -578 -114 -775 -218 -78 -42 -238 -155 -250 -177 -30 -56 12 -68 50 -15 14 19 31 35 38 35 6 0 12 5 12 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 5 10 11 10 10 0 99 57 109 70 3 4 15 10 28 14 12 4 22 12 22 17 0 5 9 9 20 9 11 0 20 5 20 10 0 6 9 10 19 10 11 0 41 9 68 21 75 32 219 76 323 98 121 25 516 87 640 101 218 23 905 114 910 120 3 4 16 10 30 13 14 3 34 14 45 24 11 10 32 24 47 32 15 8 37 22 47 33 11 10 25 18 31 18 5 0 10 5 10 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 5 10 11 10 7 0 31 12 55 28 35 21 44 33 44 55 0 20 -5 27 -20 27 -11 0 -20 7 -20 15 0 11 -12 15 -45 15 -32 0 -45 -4 -45 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJwvKNyT3",
    d: "M5058 1943 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 50 -14 43 0 50 3 50 20 0 16 -6 20 -32 19 -18 -1 -41 -3 -50 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKY80fo7y",
    d: "M5600 1930 c0 -18 7 -20 55 -20 40 0 55 4 55 14 0 16 -30 26 -77 26 -26 0 -33 -4 -33 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12mWIKOBy",
    d: "M4918 1933 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzwkeq8kk",
    d: "M5860 1920 c0 -17 7 -20 50 -20 36 0 50 4 50 14 0 15 -30 26 -72 26 -21 0 -28 -5 -28 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdjiXO6Mg",
    d: "M4715 1914 c-60 -7 -111 -13 -112 -13 -2 -1 -3 -8 -3 -16 0 -18 2 -18 163 -3 112 10 127 14 127 30 0 21 -14 22 -175 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZjJoJ3ss",
    d: "M6000 1910 c0 -18 7 -20 55 -20 40 0 55 4 55 14 0 16 -30 26 -77 26 -26 0 -33 -4 -33 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPsJtms4Z",
    d: "M6140 1900 c0 -18 7 -20 60 -20 44 0 60 4 60 14 0 16 -30 26 -82 26 -31 0 -38 -4 -38 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAI1nfsbL",
    d: "M6280 1890 c0 -17 7 -20 50 -20 36 0 50 4 50 14 0 15 -30 26 -72 26 -21 0 -28 -5 -28 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNxwE4XXw",
    d: "M4518 1893 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRiAn25sp",
    d: "M6430 1880 c0 -17 7 -20 50 -20 36 0 50 4 50 14 0 15 -30 26 -72 26 -21 0 -28 -5 -28 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EF4azvaR",
    d: "M4408 1883 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1YcAcp0I",
    d: "M6550 1872 c0 -16 14 -20 108 -30 138 -15 152 -15 152 3 0 15 -16 19 -155 35 -113 13 -105 13 -105 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Hkqry7IQ",
    d: "M6820 1842 c0 -16 14 -20 94 -30 52 -7 106 -12 120 -12 39 0 33 28 -6 34 -18 2 -63 9 -99 15 -93 15 -109 14 -109 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15dRUMKSQ",
    d: "M5370 1795 c0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -10 0 -5 -4 -10 -10 -10 -5 0 -10 6 -10 14 0 17 -22 26 -61 26 -27 0 -29 -3 -29 -35 0 -19 5 -35 10 -35 6 0 10 -9 10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 5 -10 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10 0 -5 -11 -10 -25 -10 -14 0 -25 -4 -25 -10 0 -5 11 -10 25 -10 16 0 25 -6 25 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -7 -15 -16 0 -14 8 -16 55 -10 52 6 56 5 67 -19 9 -19 19 -25 45 -25 28 0 33 3 33 24 0 23 4 25 75 31 54 5 75 11 75 21 0 8 -7 14 -15 14 -8 0 -15 7 -15 15 0 8 7 15 15 15 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 7 -15 15 0 8 7 15 15 15 8 0 15 7 15 15 0 10 -11 15 -35 15 -28 0 -35 4 -35 20 0 16 -7 20 -35 20 -24 0 -35 -5 -35 -15z m21 -67 c-11 -29 -9 -35 10 -50 l21 -18 -26 0 c-15 0 -29 -6 -31 -12 -2 -7 -9 -26 -16 -43 l-11 -30 -15 38 c-13 31 -20 37 -46 37 -29 0 -30 1 -12 20 17 19 17 32 -1 75 -7 18 -6 18 30 -3 l38 -23 32 25 c17 13 33 22 35 20 2 -1 -2 -18 -8 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pB3HP2J9e",
    d: "M4194 1746 c-17 -8 -151 -42 -298 -77 l-266 -63 0 -33 c0 -25 4 -33 18 -33 9 -1 270 34 580 77 l562 77 0 33 c0 39 0 39 -134 21 l-91 -13 90 -5 c87 -5 76 -7 -370 -69 -253 -35 -478 -65 -500 -67 -22 -2 59 20 180 50 247 60 325 85 325 103 0 17 -56 16 -96 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p149nQm9x3",
    d: "M5040 1715 c0 -34 1 -35 38 -34 20 1 29 3 20 6 -22 5 -24 33 -3 33 8 0 15 7 15 15 0 10 -11 15 -35 15 -33 0 -35 -2 -35 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQc6DIrJd",
    d: "M5590 1722 c0 -5 -17 -13 -37 -19 l-38 -10 38 -2 c47 -1 48 -17 2 -25 -22 -4 -35 -13 -35 -22 0 -12 11 -14 53 -12 46 3 52 6 55 27 5 35 -7 71 -23 71 -8 0 -15 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phlQMZPIY",
    d: "M5785 1602 c-88 -8 -161 -17 -162 -21 -2 -3 -25 -4 -53 -3 -27 2 -50 0 -50 -5 0 -4 -22 -6 -50 -5 -27 2 -50 0 -50 -5 0 -6 -25 -8 -55 -5 -30 2 -55 1 -55 -4 0 -5 -22 -7 -50 -6 -41 3 -50 1 -50 -12 0 -9 -4 -16 -10 -16 -5 0 -10 5 -10 10 0 6 -18 10 -40 10 -29 0 -40 -4 -40 -15 0 -8 -4 -15 -10 -15 -5 0 -10 5 -10 10 0 6 -20 10 -45 10 -36 0 -45 -4 -46 -17 0 -11 -3 -13 -6 -5 -3 7 -23 12 -49 12 -37 0 -44 -3 -44 -20 0 -11 2 -20 4 -20 3 0 145 14 317 30 172 17 322 30 333 28 12 -2 -771 -101 -1739 -221 -968 -120 -1772 -220 -1788 -223 -34 -7 -36 -34 -3 -34 13 0 747 90 1631 200 884 110 1609 200 1611 200 2 0 4 -11 4 -25 0 -16 -6 -25 -15 -25 -11 0 -15 -11 -15 -40 0 -34 3 -40 23 -41 16 -1 18 -2 5 -6 -15 -4 -18 -16 -18 -79 0 -68 2 -74 21 -74 19 0 20 4 15 58 -5 51 -4 54 6 25 17 -52 28 -39 28 33 0 57 -3 67 -19 71 -29 7 -35 34 -10 40 14 4 19 12 16 24 -4 15 0 19 19 19 22 0 23 -2 14 -20 -6 -11 -8 -25 -5 -31 4 -6 -4 -8 -22 -4 -26 6 -27 5 -9 -9 10 -8 22 -17 27 -18 4 -2 15 -93 23 -203 25 -310 13 -275 109 -321 45 -21 88 -44 95 -51 6 -6 21 -15 32 -18 15 -5 20 -15 20 -41 0 -19 -4 -34 -10 -34 -5 0 -10 -9 -10 -20 0 -11 -7 -20 -15 -20 -8 0 -15 -9 -15 -20 0 -13 -7 -20 -20 -20 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -3 -15 -8 0 -4 -15 -13 -32 -20 -54 -21 -223 -106 -226 -114 -2 -5 -12 -8 -22 -8 -10 0 -46 -11 -81 -24 -35 -13 -115 -36 -176 -52 -69 -18 -113 -34 -113 -42 0 -17 -64 -7 -156 24 -39 13 -78 24 -87 24 -11 0 -18 9 -19 28 -2 50 2 64 27 84 14 11 25 25 25 32 0 8 13 16 29 19 16 3 36 13 44 22 9 8 21 15 29 15 7 0 32 8 55 18 38 15 43 21 43 50 0 22 5 32 15 32 8 0 15 5 15 10 0 6 14 10 30 10 27 0 30 3 30 34 0 38 -12 46 -70 46 -22 0 -86 9 -142 20 -57 11 -113 20 -125 20 -12 0 -23 3 -25 8 -4 10 -139 52 -166 52 -16 0 -22 6 -22 23 0 20 -12 26 -113 55 -120 35 -167 40 -167 19 0 -9 44 -26 120 -48 115 -33 120 -35 120 -61 0 -35 10 -59 21 -52 5 3 17 0 26 -5 10 -6 12 -11 6 -11 -34 -1 -6 -20 64 -45 68 -24 87 -27 147 -21 39 4 105 1 149 -5 l79 -12 -84 -27 c-88 -29 -190 -84 -228 -125 -33 -35 -38 -122 -9 -159 12 -15 26 -25 33 -23 6 3 22 -6 36 -18 38 -33 102 -55 230 -76 125 -21 190 -24 190 -10 0 10 -35 21 -72 21 -61 0 -29 17 86 47 140 36 283 89 372 139 33 19 67 34 74 34 25 0 122 74 156 119 19 24 34 54 34 67 0 21 5 24 43 24 32 0 39 3 27 11 -12 8 -10 10 10 5 14 -3 51 -11 83 -17 50 -10 57 -14 57 -35 0 -13 -4 -24 -9 -24 -5 0 -12 -11 -15 -25 -4 -14 -13 -25 -21 -25 -8 0 -15 -4 -15 -10 0 -5 16 -10 35 -10 31 0 35 3 41 35 3 19 4 44 1 55 -7 29 10 25 91 -16 72 -37 82 -50 82 -109 0 -28 7 -34 68 -65 l67 -33 -197 -28 c-108 -15 -260 -44 -338 -63 -78 -20 -149 -36 -159 -36 -9 0 26 19 77 41 69 31 92 46 92 60 0 11 7 19 15 19 32 0 65 23 65 47 0 18 5 23 25 23 22 0 25 4 25 35 0 33 -2 35 -35 35 -39 0 -46 -14 -15 -30 28 -15 21 -22 -58 -65 -37 -21 -70 -43 -74 -50 -13 -22 -246 -115 -361 -145 -59 -15 -111 -30 -115 -34 -4 -5 38 -5 93 -2 55 3 114 6 130 6 37 0 312 55 380 76 51 16 206 39 620 94 215 28 310 48 245 49 -14 1 -95 -4 -181 -10 l-155 -11 -91 45 c-82 42 -90 48 -86 71 7 34 -23 80 -68 105 -76 43 -247 92 -314 89 -27 -1 -69 15 -158 62 -67 34 -125 65 -129 69 -10 8 -33 299 -25 307 3 3 59 12 124 20 163 18 183 23 183 39 0 19 -16 19 -165 0 -163 -20 -155 -21 -155 20 0 24 -5 35 -15 35 -17 0 -21 26 -4 32 6 2 13 25 16 51 5 41 3 47 -13 48 -56 2 61 21 339 55 l307 37 0 34 c0 39 16 38 -225 15z m-147 -59 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4 22 1 32 -1 23 -4z m-1188 -728 l75 -24 -52 -1 c-48 0 -113 24 -113 43 0 11 8 9 90 -18z m180 -50 c58 -13 60 -14 16 -10 -27 3 -70 5 -95 5 -33 0 -42 3 -31 10 19 13 32 12 110 -5z m218 -32 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m-155 -138 c-83 -39 -153 -103 -153 -139 0 -14 -5 -28 -12 -32 -26 -17 2 70 34 103 33 35 160 103 188 102 8 0 -17 -16 -57 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pW49E3lQ1",
    d: "M7478 1583 c-31 -8 -19 -23 17 -23 24 0 35 5 35 15 0 15 -17 17 -52 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BetRdMjj",
    d: "M7380 1570 c-21 -7 -19 -8 18 -9 23 -1 42 4 42 9 0 12 -24 12 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18VgUjYTz",
    d: "M4800 1490 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HJWLBTOp",
    d: "M4700 1480 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTqrA4AtX",
    d: "M4590 1470 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEv2nHh7p",
    d: "M4490 1460 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Cpv9W4s8",
    d: "M4390 1450 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pb9o089ZS",
    d: "M4280 1440 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19LENmpzh",
    d: "M4180 1430 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFDCE5Gze",
    d: "M4080 1420 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFmvvrFuy",
    d: "M3980 1410 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13Oix1AdX",
    d: "M3870 1400 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRFYEJXyg",
    d: "M3770 1390 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pluckgpg1",
    d: "M7673 1348 c24 -67 47 -88 47 -42 0 14 -5 44 -12 65 -9 31 -16 39 -34 39 l-23 0 22 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn0BazkRm",
    d: "M3670 1380 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10jcY08Hm",
    d: "M3570 1370 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc7ftEg48",
    d: "M3460 1360 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwThViSLT",
    d: "M3360 1350 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ploWtaUfA",
    d: "M6153 1355 c-23 -7 -112 -21 -197 -31 -137 -16 -156 -20 -156 -36 0 -10 3 -18 8 -18 39 1 345 42 372 50 19 5 73 10 121 10 70 0 100 -5 170 -31 147 -53 208 -99 436 -330 205 -207 208 -210 211 -178 3 30 -8 44 -160 196 -90 89 -171 163 -180 163 -11 0 -18 8 -18 19 0 21 -44 61 -66 61 -8 0 -14 5 -14 10 0 6 -5 10 -10 10 -6 0 -20 9 -32 20 -28 25 -168 79 -238 91 -76 12 -197 10 -247 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ad6fCRky",
    d: "M3260 1340 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1b2XafmN",
    d: "M3150 1330 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prDnDMiPc",
    d: "M3050 1320 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GEs6c8P9",
    d: "M2950 1310 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvwNlZ2AS",
    d: "M2850 1300 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13dM3530J",
    d: "M2750 1290 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16HDATAF7",
    d: "M2650 1280 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJrdonwTg",
    d: "M5710 1280 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCTT2Rfct",
    d: "M2550 1270 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17LzcV3z0",
    d: "M2450 1260 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZOOIWUmA",
    d: "M2350 1250 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSH0TtSmb",
    d: "M2200 1240 c0 -16 7 -20 33 -20 47 0 77 10 77 26 0 10 -15 14 -55 14 -48 0 -55 -2 -55 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phkAiBQoV",
    d: "M2030 1230 c0 -16 7 -20 33 -20 47 0 77 10 77 26 0 10 -15 14 -55 14 -48 0 -55 -2 -55 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phOu58zj2",
    d: "M1850 1220 c0 -16 7 -20 33 -20 47 0 77 10 77 26 0 10 -15 14 -55 14 -48 0 -55 -2 -55 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxsbX887B",
    d: "M1660 1210 c0 -16 7 -20 38 -20 52 0 82 10 82 26 0 10 -16 14 -60 14 -53 0 -60 -2 -60 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEtmUxWYO",
    d: "M1420 1200 c0 -16 7 -20 38 -20 52 0 82 10 82 26 0 10 -16 14 -60 14 -53 0 -60 -2 -60 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjZl4mL6e",
    d: "M1180 1190 c0 -17 7 -20 43 -20 56 0 87 9 87 26 0 11 -16 14 -65 14 -58 0 -65 -2 -65 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHD2hYpMI",
    d: "M4903 1203 c-30 -4 -33 -8 -33 -36 0 -31 5 -35 75 -70 42 -20 88 -37 104 -37 26 0 29 4 35 46 3 26 6 60 6 75 l0 29 -77 -2 c-43 0 -93 -3 -110 -5z m151 -45 c3 -13 6 -33 6 -45 0 -22 -2 -22 -76 15 l-76 37 49 6 c88 11 90 10 97 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pduUTXS83",
    d: "M1060 1180 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqdoFI9x4",
    d: "M940 1181 c0 -5 -18 -12 -40 -16 -38 -6 -40 -9 -40 -41 0 -27 4 -34 20 -34 16 0 20 -7 20 -34 0 -54 8 -66 46 -66 38 0 48 24 14 33 -17 4 -20 14 -20 66 0 60 1 61 28 61 42 0 72 11 72 26 0 10 -14 14 -50 14 -27 0 -50 -4 -50 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6NCkdbMF",
    d: "M760 1120 c0 -5 -8 -10 -19 -10 -10 0 -32 -5 -50 -11 -26 -9 -31 -16 -31 -43 0 -29 4 -33 45 -44 25 -7 68 -12 95 -12 l50 0 0 43 c0 75 -7 87 -51 87 -22 0 -39 -4 -39 -10z m50 -59 c0 -28 0 -28 -42 -20 -24 4 -50 9 -58 9 -19 2 59 38 83 39 12 1 17 -7 17 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJBFwDhso",
    d: "M5260 1095 c0 -28 4 -35 20 -35 21 0 24 10 14 48 -10 36 -34 27 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvyTHXce0",
    d: "M1908 1083 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZu1579S6",
    d: "M1798 1073 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQtbWS82o",
    d: "M1688 1063 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPW1UC4Ky",
    d: "M3593 1063 c-18 -2 -33 -8 -33 -12 0 -4 -27 -5 -60 -3 -56 4 -60 3 -60 -17 0 -18 6 -21 43 -21 24 0 66 -7 93 -15 29 -9 90 -15 149 -15 55 0 147 -7 205 -15 134 -18 130 -19 130 5 0 15 -7 20 -29 20 -41 0 -61 9 -61 29 0 13 -14 21 -51 29 -28 7 -61 12 -75 12 -38 0 -29 -27 14 -39 31 -9 20 -10 -63 -6 -55 3 -120 5 -145 6 l-45 1 45 9 c25 5 71 7 103 3 53 -6 57 -5 57 15 0 18 -6 21 -44 21 -26 0 -47 -5 -50 -12 -5 -10 -7 -10 -12 0 -5 12 -42 13 -111 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptzwiKKZw",
    d: "M1578 1053 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poblSadTW",
    d: "M1455 1043 c-79 -9 -95 -14 -95 -30 0 -14 10 -15 68 -10 37 4 77 7 90 7 15 0 22 6 22 20 0 21 -11 22 -85 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2XiGie9V",
    d: "M3350 1020 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puskhqnWe",
    d: "M5270 1000 c0 -33 3 -40 20 -40 21 0 25 16 14 58 -11 39 -34 27 -34 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGTqdonZ9",
    d: "M210 1021 c0 -12 49 -47 84 -61 23 -8 26 -7 26 13 0 14 -11 29 -29 40 -31 18 -81 23 -81 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE2uDQzz5",
    d: "M1240 1020 c-30 -4 -83 -5 -117 -2 -59 5 -63 4 -63 -17 0 -20 5 -21 78 -21 42 0 107 3 145 7 56 5 67 9 67 24 0 21 -13 22 -110 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqUx8MM9Y",
    d: "M3068 1007 c-167 -18 -188 -23 -188 -39 0 -22 -20 -22 207 2 224 24 243 27 243 46 0 18 -22 17 -262 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piVeZP0me",
    d: "M2790 960 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pauhNS4OH",
    d: "M2508 947 c-168 -18 -188 -23 -188 -39 0 -22 -17 -22 208 2 226 25 242 28 242 46 0 18 -24 17 -262 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvpHZrKVA",
    d: "M342 948 c11 -33 295 -154 408 -174 101 -18 110 -18 110 5 0 15 -10 20 -57 26 -73 9 -186 46 -273 90 -38 19 -78 35 -89 35 -10 0 -21 7 -25 15 -7 19 -80 21 -74 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pA0SzXbHY",
    d: "M5280 910 c0 -33 3 -40 20 -40 21 0 25 16 14 58 -11 39 -34 27 -34 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfDQchINM",
    d: "M2220 900 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16sFHehnb",
    d: "M2130 890 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14k6Gf3od",
    d: "M1898 882 c-121 -14 -138 -18 -138 -34 0 -22 -8 -21 160 -3 182 20 200 23 200 40 0 18 -34 18 -222 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVQ9GU9s7",
    d: "M1670 840 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJt0qEWto",
    d: "M1570 830 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOEuR3qzQ",
    d: "M5290 815 c0 -32 2 -35 30 -35 17 0 30 -4 30 -10 0 -5 16 -10 35 -10 34 0 35 1 35 40 0 33 -3 40 -20 40 -15 0 -20 -7 -20 -25 0 -20 -5 -25 -24 -25 -19 0 -26 7 -31 30 -9 43 -35 39 -35 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11D9NoAd3",
    d: "M1480 820 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17iEh9UvM",
    d: "M1293 817 c-81 -8 -93 -12 -93 -28 0 -22 -2 -22 115 -9 135 15 155 19 155 35 0 17 -32 18 -177 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQDNtYrpZ",
    d: "M1100 780 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFiEcpmf9",
    d: "M910 776 c0 -14 29 -26 68 -26 15 0 22 6 22 20 0 17 -7 20 -45 20 -32 0 -45 -4 -45 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BRf2CYFL",
    d: "M1010 770 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMsvH95fA",
    d: "M7271 603 c8 -10 71 -76 141 -148 103 -105 124 -131 110 -137 -9 -4 -107 -26 -217 -48 -109 -22 -201 -43 -205 -46 -3 -3 55 -4 128 -2 81 2 136 7 140 14 4 6 22 14 40 17 24 5 32 3 32 -8 0 -11 11 -15 38 -15 52 0 82 10 82 26 0 8 -10 15 -22 15 -18 1 -16 3 7 8 25 5 31 11 33 40 3 31 -5 42 -100 138 -56 56 -111 103 -120 103 -11 0 -18 7 -18 18 0 26 -20 42 -53 42 -27 0 -28 -2 -16 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3DYqZ4KK",
    d: "M5654 601 c10 -16 46 -20 46 -5 0 8 -10 14 -26 14 -14 0 -23 -4 -20 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p176mGsE3A",
    d: "M7850 520 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYP0V3gJr",
    d: "M7810 270 c0 -17 7 -20 43 -20 56 0 87 9 87 26 0 11 -16 14 -65 14 -58 0 -65 -2 -65 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pa4mC0Osz",
    d: "M5000 270 c0 -5 17 -10 38 -10 27 0 33 3 22 10 -20 13 -60 13 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3gGdMmIB",
    d: "M7630 260 c0 -16 7 -20 38 -20 52 0 82 10 82 26 0 10 -16 14 -60 14 -53 0 -60 -2 -60 -20z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l5kEbnkcxblxkOheHLoBonh",
    fill: "rgb(221,221,221)",
    style: {
      transform: "none"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p5Rqc96AS",
    d: "M5145 2670 c-33 -4 -72 -12 -87 -18 -19 -8 -28 -8 -30 0 -6 18 -68 -1 -68 -22 0 -10 -12 -23 -30 -30 -21 -9 -30 -19 -30 -36 0 -30 3 -30 70 6 30 17 113 46 184 66 72 19 132 37 135 40 6 6 -72 3 -144 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18vJ470R1",
    d: "M3700 2644 c-149 -21 -160 -24 -160 -39 0 -19 12 -18 179 3 126 17 133 19 117 35 -10 9 -23 16 -29 16 -7 -1 -55 -8 -107 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSbAMDeZf",
    d: "M4878 2643 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12DBqNYHC",
    d: "M4778 2633 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ck4BTOMb",
    d: "M4678 2623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pG7Fn2k5i",
    d: "M3478 2613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18xd0fKn7",
    d: "M4568 2613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p177MJi1Au",
    d: "M3120 2600 c-19 -4 -52 -11 -72 -14 -24 -4 -38 -12 -38 -21 0 -18 22 -19 105 -5 40 6 61 6 63 0 2 -6 19 -10 38 -10 27 0 34 4 34 19 0 14 -9 20 -32 23 -18 3 -40 7 -48 10 -8 3 -31 2 -50 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GJdVzDVh",
    d: "M3378 2603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psl9hZbDE",
    d: "M4468 2603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8niBFRhY",
    d: "M3288 2593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFd7ogPD6",
    d: "M4358 2593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BF22lg4s",
    d: "M2918 2573 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8dijqVG7",
    d: "M3573 2567 c-46 -5 -83 -14 -83 -19 0 -5 -5 -6 -11 -2 -6 3 -81 -2 -166 -12 -123 -14 -156 -15 -162 -5 -5 8 -25 11 -57 9 -45 -3 -49 -5 -52 -30 -4 -31 4 -35 34 -14 32 23 62 10 70 -31 4 -19 13 -37 21 -40 8 -3 137 15 286 41 150 25 275 46 280 46 4 0 7 16 7 35 0 35 0 35 -42 34 -24 -1 -80 -6 -125 -12z m-172 -74 c-172 -30 -237 -35 -218 -17 7 7 337 52 382 52 17 0 -57 -16 -164 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16oUQrJXU",
    d: "M4263 2565 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19sUnf2IV",
    d: "M2810 2524 c-25 -58 -25 -74 0 -74 15 0 20 7 20 25 0 14 5 25 10 25 6 0 10 7 10 15 0 8 5 15 10 15 6 0 10 9 10 20 0 13 -7 20 -20 20 -15 0 -26 -13 -40 -46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paAEMwFTO",
    d: "M3826 2539 c-9 -46 -7 -79 4 -79 13 0 27 28 35 73 6 33 5 37 -13 37 -14 0 -21 -9 -26 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEzDRXsAL",
    d: "M4163 2520 c-51 -23 -55 -40 -10 -40 42 0 60 12 55 38 l-3 21 -42 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poacynfxK",
    d: "M4803 2533 c-7 -2 -13 -13 -13 -24 0 -14 -7 -19 -29 -19 -45 0 -61 -10 -61 -36 0 -13 3 -24 6 -24 13 0 174 94 174 102 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwUjDzC6l",
    d: "M2870 2501 c0 -5 -3 -16 -6 -24 -5 -13 1 -14 35 -5 52 13 55 38 6 38 -19 0 -35 -4 -35 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYeB5Odjy",
    d: "M4063 2475 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G40I4ePX",
    d: "M3860 2435 c0 -21 5 -25 30 -25 17 0 30 -4 30 -10 0 -5 16 -10 35 -10 31 0 35 3 35 25 0 22 -3 23 -24 15 -13 -5 -26 -7 -28 -5 -2 3 -21 11 -41 20 -37 15 -37 15 -37 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP2THifCe",
    d: "M2844 2425 c-4 -14 -4 -28 -1 -32 3 -3 44 -8 91 -10 76 -5 86 -4 86 11 0 19 -11 24 -65 29 -21 2 -41 9 -43 16 -7 21 -22 11 -23 -16 l-1 -28 -10 28 c-12 34 -26 35 -34 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbREPCamz",
    d: "M2790 2418 c0 -30 13 -58 26 -58 9 0 14 12 14 35 0 28 -4 35 -20 35 -11 0 -20 -6 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz1H8Kjqb",
    d: "M3073 2413 c-25 -3 -33 -9 -33 -24 0 -15 7 -19 35 -19 31 0 35 3 35 25 0 14 -1 24 -2 23 -2 0 -18 -3 -35 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxCGC9pLR",
    d: "M4540 2381 c0 -5 -9 -11 -20 -14 -15 -4 -20 -14 -20 -36 0 -29 -3 -31 -35 -31 -32 0 -35 -2 -35 -29 0 -27 -3 -30 -37 -33 -35 -3 -38 -6 -41 -35 -3 -30 -6 -33 -38 -33 -31 0 -34 -2 -34 -30 0 -28 -3 -30 -35 -30 -28 0 -35 -4 -35 -20 0 -13 -7 -20 -20 -20 -15 0 -20 -7 -20 -29 0 -45 10 -61 37 -61 20 0 24 4 18 18 -4 9 -8 24 -9 33 -1 16 309 293 367 327 36 22 34 32 -8 32 -19 0 -35 -4 -35 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13mkcS2JT",
    d: "M2718 2313 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p35VCDgMK",
    d: "M2625 2300 c-11 -5 -36 -9 -55 -9 -64 -2 -82 -11 -76 -37 5 -19 2 -24 -14 -24 -11 0 -20 -4 -20 -10 0 -5 -12 -10 -26 -10 -33 0 -27 -22 11 -35 25 -9 30 -6 51 21 19 25 30 30 50 26 15 -3 29 -13 31 -23 6 -23 63 -27 63 -5 0 8 14 17 30 21 17 4 30 13 30 21 0 10 -15 14 -57 15 -61 1 -61 3 0 14 28 4 37 11 37 25 0 21 -20 25 -55 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19ZR15Bzd",
    d: "M2428 2273 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15OLsNeej",
    d: "M2348 2263 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "picH76JSX",
    d: "M2847 2246 c-3 -8 -21 -16 -39 -19 -18 -2 3 -5 47 -6 l80 -3 -105 -19 c-58 -10 -120 -21 -137 -24 -35 -6 -47 -35 -15 -35 9 0 90 12 180 26 l162 27 0 34 0 33 -84 0 c-64 0 -85 -3 -89 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13ox2etSU",
    d: "M2280 2211 c-15 -28 -12 -51 5 -51 10 0 15 -10 15 -27 0 -46 10 -51 90 -51 93 0 110 4 110 29 0 23 -12 23 -65 4 -36 -12 -41 -12 -53 3 -11 15 -14 15 -22 2 -8 -12 -10 -12 -16 3 -3 9 -1 24 6 32 10 13 8 15 -14 15 -22 0 -26 4 -26 30 0 34 -14 39 -30 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUfTPyzCY",
    d: "M2590 2157 c0 -8 -11 -19 -25 -25 -36 -16 -31 -32 10 -32 33 0 35 2 35 35 0 19 -4 35 -10 35 -5 0 -10 -6 -10 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmqt7MHwk",
    d: "M2280 2050 c0 -5 14 -25 31 -45 35 -39 69 -47 69 -15 0 15 -7 20 -25 20 -20 0 -25 5 -25 25 0 20 -5 25 -25 25 -14 0 -25 -4 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puKB3B6wO",
    d: "M7810 2013 c-66 -4 -160 -34 -160 -50 0 -16 40 -17 93 -1 32 10 41 10 45 0 7 -23 182 -10 182 14 0 7 -8 15 -17 17 -17 4 -17 5 0 6 9 0 17 6 17 11 0 9 -57 11 -160 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxsL7B1BO",
    d: "M8010 2012 c0 -6 8 -13 18 -15 15 -4 15 -5 -2 -6 -14 -1 -17 -6 -12 -23 3 -13 6 -31 6 -41 0 -16 2 -16 38 -2 49 21 61 33 42 45 -12 8 -11 10 7 10 12 0 23 -4 25 -9 2 -6 21 -2 43 8 21 9 35 20 29 24 -20 12 -194 21 -194 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGAVqA3dJ",
    d: "M2412 1968 c3 -7 19 -18 36 -25 31 -13 32 -12 32 12 0 22 -4 25 -36 25 -23 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peWLWh3qQ",
    d: "M2640 1946 c0 -7 10 -16 23 -20 41 -11 57 -7 57 14 0 17 -7 20 -40 20 -27 0 -40 -4 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOdHjnBgV",
    d: "M2800 1936 c0 -7 10 -16 23 -20 41 -11 57 -7 57 14 0 17 -7 20 -40 20 -27 0 -40 -4 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOaxJzylL",
    d: "M5098 1943 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p149tODwmh",
    d: "M5470 1930 c0 -19 7 -20 95 -20 74 0 95 3 95 14 0 19 -32 26 -117 26 -66 0 -73 -2 -73 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pymTI4Spv",
    d: "M4948 1933 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9KZoHe7x",
    d: "M5840 1920 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18AKsI7jp",
    d: "M4848 1923 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5MytbKrs",
    d: "M5980 1910 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF81secmn",
    d: "M7433 1907 c-109 -36 -67 -65 44 -30 38 12 53 22 53 35 0 23 -18 22 -97 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIY8z8mev",
    d: "M4250 1886 c0 -33 1 -33 53 -40 80 -9 87 -8 87 14 0 19 -4 20 -48 14 -44 -6 -49 -4 -61 20 -19 36 -31 33 -31 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pi7UP1ncK",
    d: "M4748 1913 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p845jGgtY",
    d: "M6120 1900 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18q0WdQVn",
    d: "M7922 1911 c-8 -4 -12 -18 -10 -29 l3 -21 43 19 c23 10 42 24 42 30 0 12 -59 13 -78 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peUJy33U7",
    d: "M4648 1903 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EoazY0lU",
    d: "M6270 1890 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pR5WrFfed",
    d: "M4538 1893 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pypkiGJFC",
    d: "M6420 1880 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Dl7gOuop",
    d: "M4438 1883 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJFDwlJNp",
    d: "M6540 1870 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAKSBHWNv",
    d: "M6620 1860 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B0Lieu50",
    d: "M6710 1850 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p137QVhbMA",
    d: "M7820 1845 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKlzCwfVY",
    d: "M6810 1841 c0 -13 6 -21 18 -21 9 0 41 -3 70 -6 43 -6 52 -4 52 9 0 15 -12 20 -97 32 -39 6 -43 5 -43 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Eyz9vqpY",
    d: "M2723 1802 c-40 -26 -73 -50 -73 -54 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 9 0 15 9 15 25 0 14 -3 25 -7 25 -5 0 -41 -22 -80 -48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16LnMlju4",
    d: "M6960 1820 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AkEvjft8",
    d: "M7060 1810 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p04jcg67w",
    d: "M7168 1823 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6ieFfX6Z",
    d: "M5340 1775 c0 -12 -11 -14 -55 -10 l-55 5 0 -29 c0 -35 -9 -61 -21 -61 -5 0 -9 8 -10 18 0 10 -3 12 -6 5 -2 -7 -20 -13 -39 -13 -19 0 -34 -5 -34 -11 0 -8 12 -10 34 -6 36 6 46 -4 46 -44 0 -15 7 -19 39 -19 26 0 41 5 45 16 9 23 8 24 -20 24 l-26 0 22 18 c21 17 22 22 12 52 -7 18 -10 35 -8 37 2 2 19 -5 37 -16 l34 -20 40 34 40 34 -37 1 c-27 0 -38 -4 -38 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT9bEqieg",
    d: "M4230 1763 c-8 -3 -17 -9 -20 -12 -3 -4 -89 -27 -192 -51 -123 -29 -188 -48 -188 -57 0 -8 -9 -11 -29 -7 -16 4 -63 -2 -105 -12 -76 -18 -76 -18 -76 -51 0 -31 2 -33 36 -33 33 0 1098 144 1152 155 18 4 22 12 22 40 l0 35 -292 -1 c-161 0 -300 -3 -308 -6z m520 -39 c-36 -9 -1042 -145 -1046 -142 -2 2 107 30 242 62 135 32 260 64 277 71 25 11 92 14 287 13 140 0 248 -2 240 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9GyIri7o",
    d: "M7780 1750 c0 -16 -5 -19 -30 -13 -18 3 -67 -4 -120 -18 -88 -22 -90 -24 -90 -52 0 -25 2 -27 14 -17 13 10 177 60 198 60 4 0 3 -11 -2 -25 -9 -22 -7 -25 15 -25 18 0 25 5 25 19 0 11 4 21 9 23 10 3 14 22 12 51 -1 24 -31 22 -31 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18BBAQe8s",
    d: "M5393 1727 c-11 -35 -10 -38 15 -51 l27 -14 -38 -7 c-20 -4 -37 -11 -37 -15 0 -5 -5 -21 -11 -37 l-11 -28 -13 25 -14 25 -1 -32 c0 -18 -4 -33 -10 -33 -5 0 -10 -7 -10 -15 0 -8 -4 -15 -10 -15 -5 0 -10 5 -10 10 0 6 -18 10 -40 10 -29 0 -40 -4 -40 -15 0 -8 -4 -15 -10 -15 -5 0 -10 5 -10 10 0 6 -20 10 -45 10 -38 0 -45 -3 -45 -20 0 -11 3 -20 6 -20 3 0 167 16 365 36 199 19 365 34 370 32 5 -2 -365 -50 -823 -107 -458 -56 -843 -105 -855 -108 -29 -6 -30 -33 -2 -33 11 0 273 32 581 70 308 39 562 69 564 67 2 -2 -7 -9 -20 -17 -23 -12 -24 -18 -25 -96 0 -46 4 -84 9 -84 5 0 6 -22 3 -50 -5 -46 -4 -50 15 -50 20 0 21 4 17 68 -5 66 -5 66 9 32 l14 -35 1 68 c1 61 -1 67 -19 67 -25 0 -26 26 -1 40 13 7 17 16 14 31 -5 19 -3 20 18 14 32 -10 35 -13 22 -26 -6 -6 -9 -18 -6 -27 5 -12 1 -14 -23 -8 -28 6 -28 6 -9 -9 11 -9 26 -13 33 -10 8 3 18 5 23 5 5 0 9 7 9 15 0 8 4 15 9 15 6 0 11 17 13 37 l3 38 255 31 c140 18 299 38 353 44 l97 12 0 36 0 35 -62 -7 c-35 -3 -102 -9 -150 -12 -49 -4 -88 -10 -88 -14 0 -4 -22 -5 -50 -2 -29 3 -50 0 -50 -5 0 -6 -21 -8 -50 -5 -29 2 -50 0 -50 -5 0 -6 -23 -8 -55 -5 -30 2 -55 1 -55 -4 0 -5 -22 -7 -50 -6 -41 3 -50 1 -50 -12 0 -9 -4 -16 -9 -16 -6 0 -4 16 3 38 10 29 19 38 39 40 15 2 27 8 27 13 0 5 14 9 30 9 17 0 30 5 30 10 0 6 -9 10 -20 10 -13 0 -18 5 -14 15 4 8 15 15 25 15 10 0 19 5 19 10 0 6 -9 10 -20 10 -11 0 -23 7 -26 15 -9 22 -21 18 -28 -10 -9 -36 -21 -31 -32 13 l-9 37 -12 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8h98TvHA",
    d: "M5040 1700 c0 -41 5 -45 48 -34 24 7 30 24 8 24 -8 0 -16 7 -20 15 -4 10 1 15 14 15 11 0 20 5 20 10 0 6 -16 10 -35 10 -34 0 -35 -1 -35 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puaSX85dQ",
    d: "M5590 1720 c0 -5 -13 -10 -30 -10 -16 0 -30 -5 -30 -11 0 -7 12 -10 30 -7 34 5 53 -21 20 -29 -35 -9 -24 -33 15 -33 35 0 35 0 35 44 0 31 -5 46 -16 50 -21 8 -24 8 -24 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWju4kVBk",
    d: "M6893 1675 c-19 -20 -17 -75 2 -75 8 0 15 -4 15 -10 0 -5 7 -10 15 -10 8 0 15 -4 15 -9 0 -4 19 -12 43 -18 l42 -9 -57 -8 c-58 -7 -58 -8 -58 -42 0 -19 5 -34 10 -34 6 0 10 -7 10 -15 0 -9 9 -15 25 -15 22 0 25 -4 25 -35 0 -24 5 -35 15 -35 8 0 15 -9 15 -20 0 -15 7 -20 25 -20 22 0 25 -4 25 -35 0 -24 5 -35 15 -35 8 0 15 -9 15 -20 0 -15 7 -20 25 -20 22 0 25 -4 25 -35 0 -32 2 -35 31 -35 l31 0 -35 48 c-19 26 -75 103 -126 172 -50 69 -91 128 -91 131 0 3 59 16 132 28 73 12 134 23 135 25 2 2 -49 13 -114 26 -150 29 -224 69 -158 86 14 3 25 12 25 20 0 19 -61 18 -77 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQGzUQEgS",
    d: "M2510 1665 c-14 -8 -36 -15 -50 -15 -42 -1 -70 -12 -70 -27 0 -13 11 -14 67 -8 86 9 93 12 93 41 0 28 -5 29 -40 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfZ3IRIYl",
    d: "M7707 1624 c-15 -13 -35 -24 -43 -24 -8 0 -14 -7 -14 -15 0 -10 10 -15 33 -15 45 0 59 12 55 48 l-3 31 -28 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzhrjyPAc",
    d: "M2328 1633 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDc1j3sD7",
    d: "M7860 1607 c0 -40 12 -51 50 -45 20 3 20 5 -14 43 l-35 40 -1 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paklX0KMf",
    d: "M2248 1623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13LhjnTne",
    d: "M2170 1615 c-8 -2 -32 -6 -52 -10 -24 -4 -38 -11 -38 -20 0 -17 11 -18 88 -9 42 6 52 10 52 25 0 18 -12 21 -50 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqPJFxjt8",
    d: "M2020 1595 c-8 -2 -32 -6 -52 -10 -24 -4 -38 -11 -38 -20 0 -17 11 -18 88 -9 42 6 52 10 52 25 0 18 -12 21 -50 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8RzqtBr6",
    d: "M7578 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdfodZIc7",
    d: "M7488 1583 c-31 -8 -19 -23 17 -23 24 0 35 5 35 15 0 15 -17 17 -52 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p159JVXP5t",
    d: "M1868 1573 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQd9AkP9V",
    d: "M7390 1570 c-21 -7 -19 -8 18 -9 23 -1 42 4 42 9 0 12 -24 12 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14Lq1VVUI",
    d: "M1788 1563 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppFUB2boN",
    d: "M1708 1553 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9TTBJ2hg",
    d: "M1618 1543 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17vDelHyY",
    d: "M1518 1533 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQDXVeVKW",
    d: "M4980 1510 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puUn6mhrK",
    d: "M1378 1513 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSUFuCgUI",
    d: "M4880 1500 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1H8nd8WSJ",
    d: "M4780 1490 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CcR8F41o",
    d: "M1255 1495 c-5 -2 -27 -6 -47 -10 -24 -4 -38 -11 -38 -20 0 -17 15 -18 84 -9 36 5 46 11 46 25 0 18 -18 23 -45 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ0IMKp80",
    d: "M4670 1480 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQDcH5O9H",
    d: "M7990 1469 c0 -43 18 -62 56 -57 l26 3 -40 45 -41 45 -1 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5x12thYn",
    d: "M4570 1470 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyBvC6Xb3",
    d: "M4470 1460 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5mCK4KhW",
    d: "M4360 1450 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "perAAJsTa",
    d: "M7648 1423 c20 -54 42 -68 42 -26 0 52 -11 73 -36 73 l-24 0 18 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDv2W4geS",
    d: "M4260 1440 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19ydTZjup",
    d: "M4160 1430 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18ucjkNv1",
    d: "M908 1433 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pftlBfWMa",
    d: "M4060 1420 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14AA7eE3y",
    d: "M3950 1410 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puQnEzVa8",
    d: "M818 1413 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6KCkxsBL",
    d: "M3850 1400 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUzbjRLnZ",
    d: "M3750 1390 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6rTXNTeg",
    d: "M3640 1380 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pslCIcAn5",
    d: "M3540 1370 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn4PPMA3o",
    d: "M3440 1360 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWgWFKg33",
    d: "M640 1353 c-220 -101 -254 -123 -190 -123 31 0 132 45 138 61 2 5 15 9 28 9 15 0 24 6 24 15 0 10 11 15 35 15 28 0 35 4 35 20 0 24 -21 25 -70 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CWYK5gZW",
    d: "M3340 1350 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPCbLLrXW",
    d: "M6310 1356 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkVzRkV7A",
    d: "M3230 1340 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GdVclQGA",
    d: "M6150 1340 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1F7k1WNp7",
    d: "M8120 1328 c0 -21 -4 -38 -10 -38 -5 0 -10 -9 -10 -20 0 -23 18 -25 68 -6 l34 12 -41 44 -40 45 -1 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbZaeJy3R",
    d: "M3130 1330 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EHvtDCS0",
    d: "M4058 1343 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSVeQTc0P",
    d: "M3030 1320 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11KV4rfJ5",
    d: "M3978 1333 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTHnu0Ti2",
    d: "M5340 1328 c0 -30 13 -58 26 -58 9 0 14 12 14 35 0 28 -4 35 -20 35 -11 0 -20 -6 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BtMzllt8",
    d: "M6040 1320 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8ZfhCRyP",
    d: "M2930 1310 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pI06vBSZi",
    d: "M3898 1323 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pu3vChPpa",
    d: "M5960 1310 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CR6BHQ5T",
    d: "M6462 1318 c3 -7 19 -18 36 -25 31 -13 32 -12 32 12 0 22 -4 25 -36 25 -23 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pY7vfCUyc",
    d: "M2830 1300 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ5siygpC",
    d: "M3818 1313 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcI4ymzKB",
    d: "M5870 1300 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ1ccPyLa",
    d: "M2730 1290 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1832f1qau",
    d: "M3738 1303 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pW65g8Ue5",
    d: "M5790 1290 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DLxoEAoR",
    d: "M2630 1280 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUQqwLSin",
    d: "M3605 1289 c-110 -15 -125 -20 -125 -34 0 -18 0 -18 128 -3 88 10 102 14 102 30 0 20 -9 21 -105 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdQ1SzLFJ",
    d: "M5700 1280 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p163y5WahO",
    d: "M7713 1238 c24 -67 47 -88 47 -42 0 14 -5 44 -12 65 -9 31 -16 39 -34 39 l-23 0 22 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pInz1hK5g",
    d: "M2530 1270 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmPwCI87R",
    d: "M5610 1270 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8yEkCz6Y",
    d: "M2430 1260 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G0ycAQSf",
    d: "M5520 1260 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prCDAUyVs",
    d: "M7780 1266 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEUm7nKmE",
    d: "M8010 1260 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19tE3T74A",
    d: "M2330 1250 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11l5pJSqr",
    d: "M2730 1179 c-382 -48 -696 -88 -697 -89 -10 -1 0 -30 10 -30 6 -1 330 39 720 87 635 79 707 90 707 105 0 12 -7 18 -22 17 -13 -1 -336 -41 -718 -90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13XkPr2yF",
    d: "M5440 1250 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfTQb5AZl",
    d: "M7860 1256 c0 -18 50 -30 90 -21 17 4 30 13 30 21 0 10 -15 14 -60 14 -45 0 -60 -4 -60 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdKVR5YV8",
    d: "M2160 1240 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ArPmmAGU",
    d: "M5350 1223 c0 -54 10 -83 27 -83 12 0 13 8 8 41 -6 36 -5 41 14 46 35 9 25 33 -14 33 -34 0 -35 -1 -35 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjZl13lb8",
    d: "M6600 1253 c0 -8 82 -63 94 -63 3 0 6 11 6 25 0 16 -6 25 -15 25 -8 0 -15 5 -15 10 0 6 -16 10 -35 10 -19 0 -35 -3 -35 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8splOdHd",
    d: "M1990 1230 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNX5PoU1b",
    d: "M1810 1220 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSCsPWNHH",
    d: "M1600 1210 c0 -16 7 -20 38 -20 52 0 82 10 82 26 0 10 -16 14 -60 14 -53 0 -60 -2 -60 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pG5qzXLW2",
    d: "M1370 1200 c0 -16 7 -20 33 -20 47 0 77 10 77 26 0 10 -15 14 -55 14 -48 0 -55 -2 -55 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pax7aNub1",
    d: "M5010 1200 c0 -15 7 -20 25 -20 16 0 25 -6 25 -15 0 -8 7 -15 15 -15 10 0 15 11 15 35 0 34 -1 35 -40 35 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHX6eQebR",
    d: "M1150 1190 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8NYjj6uk",
    d: "M4920 1190 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDPpQ0nAG",
    d: "M1030 1180 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11OYMiOcM",
    d: "M285 1152 l-50 -37 35 -3 c19 -2 36 1 38 7 2 6 10 11 18 11 9 0 14 11 14 30 0 17 -1 30 -2 30 -2 0 -25 -17 -53 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14TIakwuk",
    d: "M870 1165 c-88 -37 -102 -42 -152 -55 -44 -11 -48 -15 -48 -42 0 -49 22 -61 129 -69 147 -12 171 -11 171 6 0 8 -7 15 -15 15 -18 0 -27 34 -23 86 3 34 7 39 36 48 17 5 32 15 32 22 0 21 -66 15 -130 -11z m-56 -87 c14 -53 -1 -59 -83 -35 l-44 14 54 20 c69 27 66 27 73 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz0z83csV",
    d: "M5260 1085 c0 -28 4 -35 20 -35 21 0 24 10 14 48 -10 36 -34 27 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzjwBt5vS",
    d: "M7220 1065 c0 -31 3 -35 25 -35 22 0 25 -4 25 -35 0 -24 5 -35 15 -35 8 0 15 -9 15 -20 0 -15 7 -20 25 -20 22 0 25 -4 25 -35 0 -32 2 -35 31 -35 l31 0 -38 53 c-105 144 -145 197 -149 197 -3 0 -5 -16 -5 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3uzcPFG8",
    d: "M7778 1053 c20 -54 42 -68 42 -26 0 52 -11 73 -36 73 l-24 0 18 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10cxqjQVd",
    d: "M1938 1083 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmcF9KJxw",
    d: "M5360 1078 c0 -30 13 -58 26 -58 15 0 17 12 8 48 -7 23 -34 31 -34 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDUUPRBQ3",
    d: "M1828 1073 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paZDPMSh5",
    d: "M1718 1063 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DXakl3jV",
    d: "M3610 1050 c0 -18 5 -19 63 -13 69 6 88 13 39 13 -18 0 -32 5 -32 10 0 6 -16 10 -35 10 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSSGNh9FY",
    d: "M3750 1056 c0 -15 17 -20 103 -31 42 -6 47 -4 47 13 0 16 -10 20 -52 26 -79 9 -98 8 -98 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paqs99v0z",
    d: "M1608 1053 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWligFrCo",
    d: "M1498 1043 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCwfNnA05",
    d: "M3430 1032 c0 -16 8 -19 60 -19 52 0 60 3 60 19 0 15 -8 18 -60 18 -52 0 -60 -3 -60 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pl8y2Ejm3",
    d: "M1408 1033 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZWgesl5t",
    d: "M3340 1020 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7QdnCuS0",
    d: "M3910 1026 c0 -8 8 -17 18 -20 9 -2 -28 -2 -83 0 -79 3 -95 2 -75 -7 19 -8 249 -47 293 -49 4 0 7 9 7 20 0 15 -7 20 -29 20 -42 0 -61 10 -61 31 0 15 -7 19 -35 19 -24 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3MEluMJU",
    d: "M1308 1023 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZy3IeT8O",
    d: "M3240 1010 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11jxmGGzi",
    d: "M1010 1000 c0 -18 7 -20 55 -20 40 0 55 4 55 14 0 16 -30 26 -77 26 -26 0 -33 -4 -33 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYGaXo2OQ",
    d: "M1218 1013 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRwS6ac9S",
    d: "M3150 1000 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcPSx7OaR",
    d: "M3610 1011 c0 -10 49 -21 96 -21 38 0 45 15 12 24 -35 9 -108 7 -108 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pykZyiC4W",
    d: "M5270 985 c0 -28 4 -35 20 -35 21 0 24 10 14 48 -10 36 -34 27 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjWRYJvZo",
    d: "M240 1001 c0 -9 134 -81 188 -102 19 -7 22 -5 22 16 0 19 -7 26 -27 31 -16 4 -30 10 -33 14 -22 31 -150 66 -150 41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psX4wwSKT",
    d: "M3050 990 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYT140EUA",
    d: "M2960 980 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p100k8zmRl",
    d: "M2870 970 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phRPONmjk",
    d: "M2780 960 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18yvzKiV5",
    d: "M5370 963 c0 -34 12 -63 26 -63 15 0 18 21 8 58 -7 26 -34 30 -34 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUZLR2aKT",
    d: "M2680 950 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3jI1qu1g",
    d: "M4170 947 c0 -8 31 -22 75 -35 91 -27 95 -27 95 -3 0 20 -25 31 -72 31 -16 0 -28 5 -28 10 0 6 -16 10 -35 10 -22 0 -35 -5 -35 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pguHc4UHB",
    d: "M2490 930 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVf1cg4qa",
    d: "M2400 920 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19TyRlw6p",
    d: "M2310 910 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17lAIquM1",
    d: "M5280 895 c0 -28 4 -35 20 -35 21 0 24 10 14 48 -10 36 -34 27 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14yN0pTUi",
    d: "M7843 868 c26 -73 53 -92 45 -32 -9 62 -25 94 -47 94 -20 0 -20 -1 2 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4lakzItW",
    d: "M2210 900 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWKwIajqp",
    d: "M2120 890 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfrpmWE5a",
    d: "M2020 880 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvnKoe2zI",
    d: "M1930 870 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py6SjKOwk",
    d: "M1840 860 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKMGHj6p4",
    d: "M4340 847 c0 -22 5 -34 14 -34 8 0 12 6 9 14 -7 18 11 16 97 -12 l75 -24 -60 -1 c-103 -2 -111 -14 -27 -41 63 -20 74 -21 82 -9 6 8 10 10 10 4 0 -7 46 -13 130 -17 153 -7 188 -18 111 -37 -28 -6 -51 -16 -51 -21 0 -5 -9 -9 -20 -9 -11 0 -20 -5 -20 -11 0 -6 -7 -8 -15 -5 -9 3 -40 -8 -70 -25 -56 -31 -87 -59 -66 -59 6 0 11 -7 11 -15 0 -12 11 -9 44 14 48 33 122 65 176 75 21 4 -2 -10 -57 -34 -66 -30 -104 -54 -133 -86 -46 -51 -50 -64 -15 -64 22 0 25 4 25 35 0 33 2 35 35 35 19 0 35 5 35 10 0 6 7 10 15 10 25 0 65 23 65 37 0 8 13 13 36 13 l37 0 -5 44 c-5 44 -5 44 31 50 20 3 48 6 64 6 24 0 27 3 27 36 l0 36 -60 -4 c-38 -3 -61 0 -64 7 -2 6 -64 22 -137 35 -74 13 -136 27 -139 31 -7 10 -138 49 -166 49 -21 0 -24 -5 -24 -33z m305 -82 l60 -15 -79 5 c-43 3 -93 5 -110 6 -26 0 -28 2 -11 9 29 13 72 11 140 -5z m208 -32 c-13 -2 -35 -2 -50 0 -16 2 -5 4 22 4 28 0 40 -2 28 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10WgQJieJ",
    d: "M530 860 c0 -13 26 -26 115 -55 94 -30 105 -31 105 -5 0 16 -7 20 -35 20 -19 0 -35 4 -35 10 0 5 -18 13 -40 16 -22 4 -40 10 -40 15 0 5 -16 9 -35 9 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plhfFHaa8",
    d: "M1750 850 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pO0KhRgPP",
    d: "M1650 840 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3CFvKxMQ",
    d: "M5490 837 c0 -27 34 -47 80 -47 43 0 37 13 -19 43 -59 33 -61 33 -61 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnYZuZLfW",
    d: "M1560 830 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNNBWpx6f",
    d: "M5384 820 c5 -28 3 -30 -24 -30 -23 0 -31 5 -36 25 -10 39 -34 31 -34 -10 0 -39 3 -40 84 -29 44 6 46 8 46 40 0 28 -4 34 -21 34 -19 0 -21 -4 -15 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMuMPHE3a",
    d: "M1460 820 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf3Jtzkft",
    d: "M1370 810 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZdXSmrYM",
    d: "M1280 800 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14FUZN44Q",
    d: "M7089 793 c10 -16 42 -50 70 -78 l51 -49 0 35 c0 28 -9 43 -43 77 -29 29 -51 42 -71 42 l-27 0 20 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDIK3rh8o",
    d: "M1190 790 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plLGg9SfL",
    d: "M7430 775 c0 -31 3 -35 25 -35 22 0 25 -4 25 -35 0 -24 5 -35 15 -35 8 0 15 -9 15 -20 0 -15 7 -20 25 -20 22 0 25 -4 25 -35 0 -32 2 -35 31 -35 l31 0 -38 53 c-105 144 -145 197 -149 197 -3 0 -5 -16 -5 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7ziHbBBi",
    d: "M800 786 c0 -7 10 -16 23 -20 41 -11 57 -7 57 14 0 17 -7 20 -40 20 -27 0 -40 -4 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBUh3HGI0",
    d: "M1090 780 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP3BFYBMW",
    d: "M940 776 c0 -8 14 -17 31 -21 42 -9 99 2 99 20 0 12 -15 15 -65 15 -49 0 -65 -3 -65 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CpOLx6Yz",
    d: "M5658 768 c-31 -8 -38 -15 -38 -34 0 -13 -4 -24 -10 -24 -5 0 -10 -7 -10 -15 0 -8 -4 -15 -10 -15 -5 0 -10 -9 -10 -20 0 -11 -6 -20 -13 -20 -7 0 -19 -9 -27 -20 -8 -11 -20 -20 -27 -20 -7 0 -13 -11 -13 -25 0 -23 -3 -25 -50 -25 -47 0 -50 -1 -50 -26 0 -21 3 -25 18 -19 9 4 24 8 32 9 8 1 40 18 71 39 63 43 119 113 119 149 0 22 4 24 38 20 28 -2 33 -1 22 7 -26 18 10 15 138 -14 26 -6 28 -29 6 -73 l-15 -32 -92 -1 -92 0 55 -27 c30 -15 57 -28 60 -30 8 -6 -41 -42 -93 -68 -26 -14 -45 -28 -43 -33 3 -4 -6 -13 -19 -19 -36 -16 -31 -32 10 -32 24 0 35 5 35 14 0 8 9 18 20 21 11 3 20 15 20 26 0 15 7 19 33 19 46 0 77 24 77 61 0 26 3 29 30 29 25 0 30 4 30 25 0 18 5 25 20 25 18 0 20 7 20 59 l0 59 -62 15 c-94 23 -139 27 -180 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pH64dEYP5",
    d: "M7918 655 c19 -53 32 -75 44 -75 15 0 14 8 -9 75 -19 57 -29 75 -43 75 -18 0 -17 -5 8 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FkVEfY5T",
    d: "M6030 646 c0 -37 10 -56 31 -56 23 0 25 27 3 58 -20 29 -34 28 -34 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poJGLdP7s",
    d: "M7830 520 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBRnoLVie",
    d: "M4484 493 c-7 -40 4 -84 24 -91 8 -2 12 8 12 32 0 19 4 46 9 59 8 20 6 27 -5 31 -28 11 -33 7 -40 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pizpYaBMO",
    d: "M5303 493 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUO97fdi7",
    d: "M6513 483 c-24 -2 -43 -9 -43 -14 0 -11 96 -1 120 12 16 9 6 9 -77 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgom08VnE",
    d: "M6328 473 c-70 -3 -78 -6 -78 -23 0 -23 -2 -23 104 -7 45 7 81 17 84 25 2 7 -4 11 -15 10 -10 -1 -53 -4 -95 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7IxIRODj",
    d: "M5200 425 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ6dZSa7y",
    d: "M6100 430 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvpTbE4lk",
    d: "M5883 417 c-61 -8 -73 -13 -73 -28 0 -22 -4 -22 80 -9 123 19 130 21 130 35 0 17 -26 17 -137 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7pA4eGZc",
    d: "M5120 395 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plUN1rNPh",
    d: "M5466 371 c-84 -35 -119 -61 -82 -61 9 0 16 -7 16 -15 0 -16 12 -18 48 -9 26 7 29 31 5 37 -11 3 -7 5 10 6 17 1 27 7 27 16 0 10 11 15 35 15 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -43 -18 -92 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMHZdT7B6",
    d: "M4564 361 c10 -11 31 -24 47 -30 27 -9 29 -8 29 13 0 27 -17 36 -62 36 -30 0 -31 -1 -14 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12IA9Pj2d",
    d: "M4893 352 c-35 -8 -63 -20 -63 -27 0 -6 -15 -9 -40 -7 -31 3 -40 1 -40 -11 0 -8 11 -18 24 -21 35 -9 204 -26 251 -25 62 1 15 15 -77 24 -43 3 -78 10 -78 14 0 4 34 15 75 25 50 12 75 22 75 32 0 18 -45 17 -127 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puVYElmfc",
    d: "M5578 352 c-53 -13 -68 -21 -68 -34 0 -23 4 -22 111 3 60 14 89 25 89 35 0 18 -43 17 -132 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6nudzHTC",
    d: "M5323 318 c-45 -15 -43 -38 2 -38 31 0 35 3 35 25 0 14 -1 25 -2 24 -2 -1 -18 -6 -35 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prf7JOSFp",
    d: "M8040 310 c0 -5 -16 -10 -35 -10 -29 0 -35 -4 -35 -21 0 -19 4 -20 53 -14 28 4 53 8 54 9 1 1 0 12 -4 24 -5 22 -33 32 -33 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYQyK6a8G",
    d: "M5198 286 c-59 -14 -71 -26 -27 -26 60 0 109 12 109 26 0 16 -17 16 -82 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19lnfrpb9",
    d: "M7290 265 c-85 -19 -162 -36 -170 -39 -8 -3 50 -3 129 -1 101 3 147 9 153 17 6 10 10 10 17 -1 12 -18 81 -6 81 14 0 8 -4 15 -10 15 -5 0 -10 7 -10 15 0 20 -9 19 -190 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqRCT3vvS",
    d: "M7790 270 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC7ZPyPSg",
    d: "M7610 260 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l7WQMf619lqgWke1sdl6wB6",
    fill: "rgb(204,204,204)",
    style: {
      transform: "none"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1HsrR87yh",
    d: "M5145 2668 c-38 -5 -88 -10 -110 -12 -22 -1 -46 -3 -52 -4 -12 -2 -19 -72 -8 -72 4 0 18 6 33 14 15 7 74 26 132 41 165 43 167 54 5 33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzlr9LJTI",
    d: "M3720 2645 c-8 -2 -32 -6 -52 -10 -26 -4 -38 -11 -38 -22 0 -13 8 -15 53 -9 28 3 62 6 75 6 15 0 22 6 22 20 0 20 -17 24 -60 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPV8HPpjO",
    d: "M3810 2620 c0 -16 5 -30 11 -30 8 0 9 -13 5 -42 -4 -22 -4 -61 0 -85 6 -41 8 -43 40 -43 41 0 44 18 6 32 l-28 11 14 52 c13 48 13 56 -4 94 -21 49 -44 54 -44 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUZAGV2SO",
    d: "M4888 2643 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CD2gXIE8",
    d: "M4788 2633 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phsMIM0DX",
    d: "M3568 2623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7ZV9ml6Z",
    d: "M4688 2623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phGkXxGTD",
    d: "M4578 2613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FJTAdUFZ",
    d: "M3388 2603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pijc478n2",
    d: "M4478 2603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyWT3HupS",
    d: "M3110 2595 c-8 -2 -32 -6 -52 -10 -21 -3 -38 -12 -38 -18 0 -10 31 -13 120 -14 111 0 120 1 120 18 0 14 -7 19 -27 19 -16 0 -46 2 -68 4 -22 3 -47 3 -55 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ArGLEXGD",
    d: "M3298 2593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdH6vkZz3",
    d: "M4368 2593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10MQlzsKd",
    d: "M3468 2557 c-221 -28 -248 -33 -248 -49 0 -10 2 -18 5 -18 3 0 98 11 212 25 113 14 210 24 215 23 6 -2 -97 -22 -227 -44 -236 -40 -237 -40 -245 -20 -7 17 -9 14 -9 -16 -1 -33 2 -38 21 -38 21 0 436 69 546 91 51 10 52 11 52 45 0 33 -1 34 -37 33 -21 -1 -149 -15 -285 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pibzETrVB",
    d: "M2938 2573 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HbQRgeAX",
    d: "M4873 2573 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10WtZpd43",
    d: "M2833 2563 c-26 -10 -13 -33 17 -33 23 0 30 4 30 20 0 20 -19 25 -47 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYJd5QKuM",
    d: "M4243 2555 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pG9LyERRL",
    d: "M3090 2530 c0 -6 -36 -10 -87 -10 -50 0 -111 -7 -145 -16 -56 -16 -58 -18 -58 -50 0 -32 2 -34 35 -34 24 0 35 5 35 15 0 18 -17 20 -22 3 -3 -9 -6 -9 -12 0 -12 19 41 35 134 40 57 3 91 9 102 19 21 18 68 10 68 -12 0 -8 5 -15 10 -15 6 0 10 16 10 35 0 33 -2 35 -35 35 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGt1eGBVC",
    d: "M4133 2505 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9WopvVfe",
    d: "M4770 2495 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHbaELuIS",
    d: "M4043 2465 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZhsnA8NB",
    d: "M4680 2450 c0 -16 -7 -20 -35 -20 -31 0 -35 -3 -35 -25 0 -14 2 -25 5 -25 12 0 135 75 135 82 0 4 -16 8 -35 8 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phyoStgOB",
    d: "M3140 2446 c0 -12 -56 -43 -70 -39 -3 0 -28 4 -55 6 -28 3 -58 9 -68 12 -11 5 -17 2 -17 -6 -1 -8 -7 -3 -15 11 -14 26 -14 27 -29 -24 -5 -15 18 -20 141 -32 97 -9 133 5 133 52 0 19 -4 34 -10 34 -5 0 -10 -6 -10 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkiQISzfR",
    d: "M2800 2373 c1 -19 22 -53 34 -53 3 0 6 16 6 35 0 28 -4 35 -20 35 -13 0 -20 -7 -20 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pefwQTcNl",
    d: "M2738 2313 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7azRQn4H",
    d: "M2638 2303 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAACj8W78",
    d: "M4440 2280 c0 -28 -3 -30 -35 -30 -32 0 -35 -2 -35 -31 l0 -30 28 20 c15 11 47 39 72 60 l45 40 -37 1 c-36 0 -38 -2 -38 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRndQpD1K",
    d: "M2548 2283 c-10 -2 -18 -9 -18 -14 0 -13 -38 -11 -42 2 -6 17 -68 1 -68 -17 0 -9 11 -14 30 -14 17 0 30 -4 30 -10 0 -11 -30 -13 -54 -4 -9 3 -16 15 -16 26 0 17 -5 19 -47 13 -66 -9 -73 -12 -73 -31 0 -13 7 -16 35 -11 34 6 35 5 35 -25 0 -26 2 -29 15 -18 13 10 24 11 56 1 40 -12 42 -12 68 18 20 24 32 29 52 25 21 -5 28 -13 33 -42 3 -20 1 -41 -4 -46 -5 -5 -33 -10 -62 -12 -29 -1 -70 -6 -90 -12 -30 -8 -40 -7 -49 5 -10 11 -14 11 -20 1 -5 -7 -9 -21 -9 -30 0 -15 9 -18 55 -18 30 0 55 5 55 10 0 6 28 10 65 10 62 0 65 1 65 25 0 22 3 24 29 19 16 -3 117 9 225 27 l196 32 0 32 0 32 -125 1 c-119 1 -125 0 -125 -19 0 -20 4 -20 103 -15 56 3 98 4 92 1 -12 -6 -307 -55 -329 -55 -9 0 -16 7 -16 15 0 8 -4 15 -10 15 -5 0 -10 9 -10 20 0 14 -7 20 -22 21 -17 1 -19 2 -5 6 9 2 17 13 17 24 0 19 -21 23 -62 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psTsgbzRS",
    d: "M4290 2150 c0 -28 -3 -30 -35 -30 -32 0 -35 -2 -35 -31 l0 -30 28 20 c15 11 47 39 72 60 l45 40 -37 1 c-36 0 -38 -2 -38 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKujPqnbF",
    d: "M4190 2001 c0 -45 10 -61 36 -61 29 0 29 3 2 51 -26 46 -38 50 -38 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxWPBFbzC",
    d: "M7835 2013 c-78 -6 -105 -14 -105 -28 0 -9 10 -15 25 -15 14 0 25 -4 25 -10 0 -6 33 -10 80 -10 75 0 80 1 80 21 0 20 -4 21 -62 16 l-63 -5 63 10 c34 6 62 15 62 19 0 9 -23 9 -105 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmewG10RW",
    d: "M8030 2012 c0 -6 8 -13 18 -15 16 -4 16 -5 0 -6 -22 -1 -24 -31 -3 -31 8 0 15 -7 15 -14 0 -12 6 -13 31 -4 30 10 59 51 46 64 -12 12 -107 17 -107 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVoES2Mzg",
    d: "M8150 1990 c0 -16 4 -18 22 -11 32 12 34 31 4 31 -19 0 -26 -5 -26 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6hJ6cewl",
    d: "M7623 1968 c-41 -13 -44 -38 -5 -38 47 0 72 11 72 31 0 21 -17 23 -67 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pic6OK0dD",
    d: "M2440 1960 c0 -12 33 -30 54 -30 9 0 16 9 16 20 0 16 -7 20 -35 20 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6R2ZGaoX",
    d: "M2660 1946 c0 -7 10 -16 23 -20 41 -11 57 -7 57 14 0 17 -7 20 -40 20 -27 0 -40 -4 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPUQbAuBD",
    d: "M2820 1936 c0 -7 15 -17 33 -22 l32 -10 -32 -19 c-42 -25 -42 -35 2 -35 19 0 35 5 35 10 0 6 7 10 15 10 10 0 15 10 15 34 0 26 -5 35 -22 40 -40 10 -78 7 -78 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzQDhw5z8",
    d: "M5128 1943 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDMCn1kL3",
    d: "M5430 1929 c0 -17 8 -19 105 -19 87 0 105 3 105 15 0 17 3 17 -117 20 -86 3 -93 2 -93 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16my1jEp6",
    d: "M4958 1933 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj6mTm9Zv",
    d: "M5820 1920 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HPMOeAp3",
    d: "M4858 1923 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15Gsmt30A",
    d: "M5970 1910 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pd834IfBy",
    d: "M7950 1905 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOZxOgBmf",
    d: "M4758 1913 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFRWYh2pk",
    d: "M6110 1900 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBGni2PJY",
    d: "M4658 1903 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgOeM2w6C",
    d: "M6260 1890 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12ahMhN1e",
    d: "M4558 1893 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcjiTo5Px",
    d: "M6400 1880 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14WAW9dEd",
    d: "M4448 1883 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8oX3UgOc",
    d: "M6530 1870 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4CtM3Ep0",
    d: "M7328 1872 c-87 -29 -46 -57 43 -30 27 8 39 17 39 30 0 22 -18 22 -82 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peOT1r6JO",
    d: "M4348 1873 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTdVLJ1np",
    d: "M6610 1860 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13gyjYDQR",
    d: "M7840 1855 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfwMzPoDQ",
    d: "M6700 1850 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6K9TLDvJ",
    d: "M6790 1841 c0 -15 6 -21 23 -21 12 0 46 -3 75 -6 43 -6 52 -4 52 9 0 16 -16 21 -102 33 -44 6 -48 5 -48 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNsJP9kel",
    d: "M6130 1796 c0 -25 5 -67 12 -95 6 -28 9 -53 6 -56 -3 -3 -36 -8 -74 -11 -38 -3 -76 -8 -84 -11 -8 -3 -36 -5 -62 -4 -27 2 -48 -2 -48 -7 0 -5 -22 -7 -50 -4 -29 2 -50 0 -50 -5 0 -6 -23 -8 -55 -5 -30 2 -55 1 -55 -4 0 -5 -22 -7 -50 -6 -41 3 -50 1 -50 -12 0 -9 -4 -16 -10 -16 -5 0 -10 5 -10 10 0 6 -18 10 -40 10 -29 0 -40 -4 -40 -15 0 -8 -4 -15 -10 -15 -5 0 -10 5 -10 10 0 6 -18 10 -40 10 -33 0 -40 3 -40 20 0 11 -4 20 -10 20 -5 0 -10 -7 -10 -15 0 -8 -4 -15 -9 -15 -5 0 -11 7 -15 15 -9 24 -26 17 -26 -10 0 -15 -6 -25 -14 -25 -7 0 -16 -9 -19 -20 -3 -11 -2 -20 1 -20 4 0 142 14 307 30 165 16 314 29 330 29 17 -1 -301 -43 -705 -95 -404 -51 -736 -93 -737 -94 -2 0 -3 -7 -3 -15 0 -21 -2 -21 400 30 195 25 365 45 378 45 18 0 22 -6 22 -30 0 -16 -4 -30 -10 -30 -6 0 -10 -33 -10 -80 0 -69 2 -80 18 -81 10 0 12 -3 5 -6 -7 -2 -13 -20 -13 -39 0 -27 4 -34 20 -34 19 0 20 5 14 58 -3 31 -7 68 -9 82 -3 18 1 13 15 -15 l19 -40 1 56 c0 48 -3 57 -20 62 -24 6 -27 42 -5 51 8 3 15 15 15 26 0 21 12 24 44 11 14 -5 16 -10 8 -15 -7 -4 -12 -16 -12 -28 0 -17 -4 -19 -27 -14 -27 6 -27 6 -9 -9 11 -8 23 -15 27 -15 3 0 9 -18 13 -40 4 -28 11 -40 23 -40 14 0 15 11 10 95 -4 69 -2 95 6 95 7 1 183 23 392 49 209 27 381 47 383 46 1 -1 6 -22 10 -46 l7 -44 70 -3 c38 -2 80 0 94 3 24 6 24 6 18 113 -3 59 -13 140 -22 180 l-17 72 -94 0 -94 0 0 -44z m-132 -213 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4 22 1 32 -1 23 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSGschw0f",
    d: "M7050 1810 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRkdEzIWA",
    d: "M7770 1795 c0 -29 4 -35 21 -35 17 0 20 5 17 25 -4 17 0 29 11 35 12 7 9 9 -16 10 -31 0 -33 -2 -33 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHhgf4UV5",
    d: "M5220 1756 c0 -28 4 -34 25 -38 29 -6 28 -7 15 27 l-10 27 34 -21 c42 -26 46 -26 46 3 0 18 -7 25 -31 30 -67 13 -79 9 -79 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdocgOtmN",
    d: "M2618 1732 c-32 -20 -58 -40 -58 -44 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 9 0 15 9 15 25 0 14 -3 25 -7 25 -5 0 -34 -17 -65 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1f6jqzJN",
    d: "M4230 1760 c0 -5 -11 -10 -25 -10 -14 0 -25 -4 -25 -10 0 -5 -11 -10 -24 -10 -13 0 -147 -29 -297 -65 -150 -36 -274 -65 -276 -65 -2 0 -3 -16 -3 -35 0 -32 2 -35 30 -35 25 0 1122 149 1218 165 29 5 32 9 32 41 l0 36 -47 -5 c-27 -3 -68 -10 -93 -15 l-45 -9 65 -2 c47 -2 59 -5 45 -11 -22 -9 -1125 -163 -1131 -157 -2 2 108 29 244 61 136 32 282 70 325 84 82 28 102 52 42 52 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNjtxu0A6",
    d: "M5440 1720 c0 -26 -4 -30 -27 -30 l-28 -1 25 -14 25 -15 -22 -6 c-39 -11 -28 -34 17 -34 28 0 40 4 40 14 0 8 10 17 23 19 l22 4 -23 2 c-43 2 -16 26 37 32 72 9 79 22 9 17 -42 -2 -59 1 -63 10 -7 20 -7 20 18 25 13 3 8 5 -15 6 -36 1 -38 -1 -38 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pga9AbNdl",
    d: "M7626 1721 c-101 -27 -118 -39 -94 -65 11 -11 16 -12 28 -1 14 12 162 55 189 55 8 0 11 -6 7 -15 -4 -10 1 -15 14 -15 16 0 20 7 20 35 0 33 -2 35 -32 34 -18 0 -78 -13 -132 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ApzGW6om",
    d: "M5040 1653 c0 -42 0 -43 35 -43 24 0 35 5 35 15 0 8 -7 15 -15 15 -8 0 -15 6 -15 14 0 18 101 31 112 13 12 -19 9 -25 -14 -30 -17 -3 -14 -5 10 -6 17 0 32 -5 32 -11 0 -5 16 -10 35 -10 29 0 35 4 35 21 0 19 -4 21 -32 15 l-33 -6 24 20 c23 20 23 20 2 20 -12 0 -21 3 -21 8 0 4 -43 7 -95 7 l-95 0 0 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdCwiDUeG",
    d: "M6880 1651 c0 -39 9 -61 26 -61 8 0 14 -4 14 -10 0 -5 11 -10 25 -10 14 0 25 -4 25 -9 0 -5 10 -12 23 -14 16 -3 13 -5 -10 -6 -22 -1 -33 -6 -33 -16 0 -8 -7 -15 -15 -15 -10 0 -15 -11 -15 -35 0 -24 5 -35 15 -35 8 0 15 -9 15 -20 0 -15 7 -20 25 -20 22 0 25 -4 25 -35 0 -24 5 -35 15 -35 8 0 15 -9 15 -20 0 -16 7 -20 31 -20 l30 0 -33 46 c-18 25 -52 71 -75 103 l-42 58 132 22 c72 12 133 23 135 25 1 2 -50 14 -115 26 -78 15 -129 30 -151 45 -34 23 -34 24 -13 37 30 19 26 28 -14 28 -32 0 -35 -2 -35 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11P5NoQXf",
    d: "M7850 1616 c0 -33 2 -36 31 -36 l30 0 -21 30 c-31 44 -40 45 -40 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZNLeWct7",
    d: "M7707 1620 c-9 -11 -24 -20 -32 -20 -8 0 -15 -7 -15 -15 0 -10 11 -15 35 -15 33 0 35 2 35 35 0 19 -1 35 -3 35 -1 0 -10 -9 -20 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwFnefCue",
    d: "M2258 1623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pR5yQhu1D",
    d: "M2180 1615 c-8 -2 -32 -6 -52 -10 -24 -4 -38 -11 -38 -20 0 -17 11 -18 88 -9 42 6 52 10 52 25 0 18 -12 21 -50 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BnozGLOf",
    d: "M2028 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkhQRZp01",
    d: "M7588 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8VEyUoy1",
    d: "M7498 1583 c-31 -8 -19 -23 17 -23 24 0 35 5 35 15 0 15 -17 17 -52 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peifXhkv2",
    d: "M1878 1573 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8Qi1Zxiy",
    d: "M7405 1570 c-16 -7 -13 -9 18 -9 20 -1 37 4 37 9 0 12 -27 12 -55 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pacQ0bOi4",
    d: "M1798 1563 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phLzA7eun",
    d: "M1718 1553 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjPpowU72",
    d: "M1628 1543 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNKqIgSB7",
    d: "M5160 1530 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYETfremQ",
    d: "M5060 1520 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BKgSESMj",
    d: "M1448 1523 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15hm1adCt",
    d: "M4950 1510 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE9mGeihp",
    d: "M7628 1483 c20 -54 42 -68 42 -26 0 52 -11 73 -36 73 l-24 0 18 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzRqEINgC",
    d: "M4850 1500 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4tgs6HHL",
    d: "M1325 1505 c-5 -2 -27 -6 -47 -10 -24 -4 -38 -11 -38 -20 0 -17 15 -18 84 -9 36 5 46 11 46 25 0 18 -18 23 -45 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16nNBydvr",
    d: "M4750 1490 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plFyD4xUE",
    d: "M7980 1476 c0 -33 2 -36 31 -36 l30 0 -21 30 c-31 44 -40 45 -40 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUdDV5Mm0",
    d: "M4650 1480 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSiCB20E7",
    d: "M4550 1470 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxYyBBVgK",
    d: "M1095 1469 c-134 -25 -155 -31 -155 -45 0 -18 14 -18 138 3 85 14 102 20 102 35 0 20 -9 21 -85 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17XaamjOF",
    d: "M4440 1460 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9Tt9VNp7",
    d: "M4340 1450 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15oLHB8j3",
    d: "M4240 1440 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poLBgCfMv",
    d: "M4130 1430 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzX9G9NoN",
    d: "M4030 1420 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GJolBzw5",
    d: "M868 1423 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3kgxvBiO",
    d: "M3930 1410 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0HWuwmuS",
    d: "M3830 1400 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbsHjtQoa",
    d: "M773 1398 c-41 -13 -44 -38 -5 -38 47 0 72 11 72 31 0 21 -17 23 -67 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxYriLTom",
    d: "M3720 1390 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pm61jzNXc",
    d: "M3620 1380 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKbgMD4Bg",
    d: "M3520 1370 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKZJaGnQh",
    d: "M4398 1383 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvEq8x2PQ",
    d: "M3410 1360 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11SBewp7x",
    d: "M4318 1373 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B4JzE4ll",
    d: "M653 1355 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ECOKxbrY",
    d: "M3310 1350 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwMFQgsoY",
    d: "M3155 1230 c-605 -77 -1101 -139 -1102 -140 -10 -1 0 -30 10 -30 6 -1 510 61 1120 137 1002 124 1107 139 1107 155 0 11 -7 18 -17 17 -10 0 -513 -63 -1118 -139z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXF5W0TxP",
    d: "M6180 1360 c0 -5 -16 -10 -35 -10 -28 0 -35 -4 -35 -20 0 -24 4 -24 80 -3 68 18 82 43 25 43 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFiz7brbi",
    d: "M6320 1356 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZY8cQKZB",
    d: "M8110 1336 c0 -33 2 -36 31 -36 l30 0 -21 30 c-31 44 -40 45 -40 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DyDwyYH6",
    d: "M3210 1340 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peifrXRtF",
    d: "M3110 1330 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pu5qjNTy5",
    d: "M3000 1320 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pI7VbpQSX",
    d: "M2900 1310 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdo7SMCpu",
    d: "M5950 1310 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRjqI9BAW",
    d: "M7693 1298 c19 -46 37 -48 37 -4 0 32 -3 36 -25 36 -24 0 -25 -1 -12 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18VGMoT8B",
    d: "M2800 1300 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pasgKg6u8",
    d: "M5860 1300 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piDUR9e4w",
    d: "M2710 1290 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Bb8QMLut",
    d: "M5780 1290 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puLhcc6wC",
    d: "M2610 1280 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CAJkNea2",
    d: "M5690 1280 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPOgjJSbm",
    d: "M2510 1270 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DomCBb77",
    d: "M5600 1270 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pN6xshjkg",
    d: "M8090 1270 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHJu3xOt4",
    d: "M2410 1260 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTx6yo8Zv",
    d: "M6570 1272 c0 -8 52 -42 64 -42 3 0 6 11 6 25 0 22 -4 25 -35 25 -19 0 -35 -4 -35 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz3QYN7NX",
    d: "M7790 1266 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py9vi15dg",
    d: "M8000 1260 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkFjSlm9L",
    d: "M2290 1250 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgLtj2Q8U",
    d: "M5430 1250 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYnGWhmyX",
    d: "M7870 1256 c0 -17 42 -28 75 -20 46 11 30 34 -25 34 -36 0 -50 -4 -50 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn7cthZ5y",
    d: "M378 1215 c-83 -55 -89 -65 -44 -65 20 0 36 5 36 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 9 0 15 9 15 25 0 14 -3 25 -8 25 -4 0 -37 -20 -74 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piTUD8fLe",
    d: "M2120 1240 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CMsjFvnp",
    d: "M1950 1230 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbaiFsna9",
    d: "M7110 1216 c0 -33 2 -36 31 -36 l30 0 -21 30 c-31 44 -40 45 -40 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pR1V3qbXU",
    d: "M1770 1220 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p37i4bzUp",
    d: "M1550 1210 c0 -16 7 -20 33 -20 47 0 77 10 77 26 0 10 -15 14 -55 14 -48 0 -55 -2 -55 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phQq6EuX1",
    d: "M1310 1200 c0 -16 7 -20 38 -20 52 0 82 10 82 26 0 10 -16 14 -60 14 -53 0 -60 -2 -60 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p196vntRe9",
    d: "M1120 1190 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py250VxfH",
    d: "M4910 1190 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5enaJ5C3",
    d: "M1000 1180 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psYGspop1",
    d: "M5358 1160 c3 -26 9 -40 18 -40 15 0 18 21 8 58 -11 39 -30 26 -26 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pk3mRYiL5",
    d: "M843 1158 c-18 -6 -33 -15 -33 -19 0 -5 -10 -9 -22 -9 -39 0 -68 -12 -68 -26 0 -9 -12 -14 -35 -14 -33 0 -35 -2 -35 -34 0 -36 15 -46 73 -46 38 0 35 27 -4 35 -17 4 -27 10 -24 13 4 4 59 25 123 47 118 41 153 66 90 64 -18 -1 -48 -6 -65 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paYTYEbgK",
    d: "M7758 1113 c20 -54 42 -68 42 -26 0 52 -11 73 -36 73 l-24 0 18 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EylGLtva",
    d: "M7190 1107 c0 -33 3 -37 25 -37 22 0 25 -4 25 -35 0 -32 2 -35 31 -35 l31 0 -38 53 c-20 28 -46 61 -56 72 -18 19 -18 19 -18 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1vsUxfWp",
    d: "M5060 1108 c0 -14 -5 -18 -15 -14 -8 3 -22 9 -30 12 -11 5 -15 -1 -15 -19 0 -28 16 -37 66 -37 32 0 34 2 34 34 0 25 -5 35 -20 39 -15 4 -20 0 -20 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17ASe40Dk",
    d: "M5260 1075 c0 -28 4 -35 20 -35 21 0 24 10 14 48 -10 36 -34 27 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzIsfMi58",
    d: "M5364 1069 c3 -17 6 -38 6 -45 0 -8 7 -14 16 -14 13 0 15 7 10 31 -3 17 -6 38 -6 45 0 8 -7 14 -16 14 -13 0 -15 -7 -10 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPmiPvt0k",
    d: "M1958 1083 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgQbwjaJ7",
    d: "M1848 1073 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p47h2ThqF",
    d: "M1738 1063 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQkP6rrO9",
    d: "M3600 1050 c0 -19 4 -20 53 -14 55 7 75 14 39 14 -12 0 -22 5 -22 10 0 6 -16 10 -35 10 -29 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1OrsXSkD",
    d: "M3770 1056 c0 -14 29 -26 67 -26 16 0 20 5 16 20 -4 16 -14 20 -44 20 -27 0 -39 -4 -39 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CzLMROBv",
    d: "M1628 1053 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWEvEAtBm",
    d: "M1518 1043 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prjBiTyZN",
    d: "M3420 1030 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdgMB8KJe",
    d: "M3870 1036 c0 -9 17 -19 43 -25 35 -9 28 -10 -50 -6 -58 3 -93 1 -93 -5 0 -6 4 -10 8 -10 5 0 73 -9 152 -20 79 -11 147 -20 152 -20 4 0 8 14 8 30 0 25 -4 30 -25 30 -14 0 -25 5 -25 10 0 6 -22 10 -50 10 -27 0 -50 5 -50 10 0 6 -16 10 -35 10 -24 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkWI4rd0w",
    d: "M210 1025 c0 -12 28 -35 44 -35 3 0 6 11 6 25 0 20 -5 25 -25 25 -15 0 -25 -6 -25 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUEY6eTnN",
    d: "M1428 1033 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBHv4aJ3u",
    d: "M3330 1020 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p132ZvFvx6",
    d: "M3520 1026 c0 -8 19 -18 44 -25 53 -13 146 -15 146 -2 0 12 -36 21 -82 21 -21 0 -38 5 -38 10 0 6 -16 10 -35 10 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pk1HkLmNe",
    d: "M7800 1018 c0 -39 123 -378 137 -378 7 0 13 5 13 12 0 32 -126 388 -137 388 -7 0 -13 -10 -13 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNmqrusp9",
    d: "M830 1010 c0 -17 7 -20 45 -20 49 0 64 23 23 34 -45 12 -68 7 -68 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnlMGvb8F",
    d: "M1328 1023 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptxdgTrew",
    d: "M3230 1010 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11NjmNM7a",
    d: "M950 1000 c0 -18 7 -20 60 -20 44 0 60 4 60 14 0 16 -30 26 -82 26 -31 0 -38 -4 -38 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1D3LRe2mL",
    d: "M1238 1013 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqupPLSyg",
    d: "M3140 1000 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10cwEPzr7",
    d: "M2950 980 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FFh5iBgs",
    d: "M2860 970 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p25ukF86L",
    d: "M2770 960 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZu3EPcep",
    d: "M5374 949 c3 -17 6 -38 6 -45 0 -8 10 -14 25 -14 20 0 25 -5 25 -23 0 -27 34 -47 80 -47 46 0 36 15 -35 51 -59 31 -66 37 -71 72 -4 23 -12 37 -22 37 -11 0 -13 -7 -8 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg9jkQFeM",
    d: "M2670 950 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paUreNk3h",
    d: "M4140 957 c0 -8 25 -21 60 -30 76 -21 80 -21 80 3 0 16 -7 20 -35 20 -19 0 -35 5 -35 10 0 6 -16 10 -35 10 -23 0 -35 -5 -35 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVdQdjFA3",
    d: "M2580 940 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBAY1W75W",
    d: "M7320 926 c0 -33 2 -36 31 -36 l30 0 -21 30 c-31 44 -40 45 -40 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF9GWiJZP",
    d: "M2480 930 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paI0AHJDm",
    d: "M2390 920 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTKftuHHl",
    d: "M2300 910 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnJLFnEqb",
    d: "M5280 885 c0 -28 4 -35 20 -35 21 0 24 10 14 48 -10 36 -34 27 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AVK3HWYk",
    d: "M2110 890 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqVrEINqM",
    d: "M490 880 c0 -6 19 -20 43 -30 l42 -19 3 21 c2 11 -2 25 -10 29 -19 12 -78 11 -78 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2sSF93Zu",
    d: "M1920 870 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRZ6RcvNQ",
    d: "M1830 860 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12RFatKoi",
    d: "M4340 848 c0 -27 2 -30 13 -16 11 15 19 14 97 -11 l85 -28 -70 -7 c-38 -4 -74 -9 -80 -10 -5 -1 22 -12 60 -24 47 -14 96 -21 145 -20 98 1 229 -12 236 -23 3 -5 0 -9 -6 -9 -6 0 -18 -7 -27 -15 -8 -8 -19 -13 -24 -9 -16 9 -69 -7 -69 -21 0 -18 27 -26 69 -20 l36 5 -40 -20 -40 -20 49 5 c27 3 55 5 62 5 9 0 14 11 14 28 0 16 8 34 20 42 29 21 24 38 -12 44 -76 12 -199 25 -288 32 -93 7 -94 7 -55 18 33 10 60 8 155 -10 163 -31 220 -35 220 -16 0 11 -10 13 -40 10 -25 -2 -40 1 -40 8 0 6 -45 19 -102 29 -57 10 -134 29 -172 42 -38 13 -82 23 -98 23 -15 0 -28 5 -28 10 0 6 -16 10 -35 10 -33 0 -35 -2 -35 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14JsvsPXa",
    d: "M1740 850 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peP0R7OQs",
    d: "M1640 840 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AoLZRAvh",
    d: "M5380 848 c0 -30 13 -58 26 -58 9 0 14 12 14 35 0 28 -4 35 -20 35 -11 0 -20 -6 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOD2tEjkC",
    d: "M1550 830 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1D7zFQDOZ",
    d: "M7400 817 c0 -33 3 -37 25 -37 22 0 25 -4 25 -35 0 -32 2 -35 31 -35 l31 0 -38 53 c-20 28 -46 61 -56 72 -18 19 -18 19 -18 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FSlNEXM",
    d: "M1360 810 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prjP7uZL6",
    d: "M5292 793 c3 -36 5 -38 41 -41 32 -3 37 0 37 17 0 15 -6 21 -21 21 -12 0 -23 8 -26 20 -3 11 -12 20 -20 20 -10 0 -13 -10 -11 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHuamOidU",
    d: "M1270 800 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgu6evdlK",
    d: "M740 796 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BkajwOXe",
    d: "M1180 790 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyRvZfdO2",
    d: "M820 786 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1As0eTyji",
    d: "M1080 780 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1KCSnTAd",
    d: "M960 776 c0 -17 42 -28 75 -20 46 11 30 34 -25 34 -36 0 -50 -4 -50 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTDvq4e1f",
    d: "M5630 760 c0 -11 -7 -20 -15 -20 -10 0 -15 -11 -15 -35 0 -24 -5 -35 -15 -35 -8 0 -15 -9 -15 -20 0 -11 -7 -20 -15 -20 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -9 0 -5 -11 -12 -25 -15 -34 -9 -35 -44 -1 -41 64 7 196 138 196 194 0 20 3 22 33 16 24 -5 28 -4 17 4 -12 8 -7 11 23 11 25 0 37 5 37 14 0 16 -30 26 -82 26 -31 0 -38 -4 -38 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pspWP64bo",
    d: "M5770 745 c0 -10 14 -17 40 -21 40 -7 60 -26 60 -58 0 -9 -6 -16 -14 -16 -8 0 -17 -11 -20 -25 -6 -25 -7 -25 -86 -19 -44 4 -80 4 -80 1 0 -4 23 -18 50 -32 28 -14 48 -30 45 -35 -3 -5 -37 -26 -75 -46 -38 -21 -67 -41 -64 -46 3 -4 -11 -14 -31 -22 -45 -19 -45 -36 0 -36 24 0 35 5 35 15 0 8 7 15 15 15 8 0 15 7 15 15 0 8 9 15 20 15 37 0 70 22 70 47 0 18 5 23 25 23 21 0 25 5 25 30 0 28 3 30 35 30 33 0 35 2 41 40 4 22 10 40 15 40 5 0 9 9 9 20 0 11 5 20 10 20 6 0 10 -4 10 -10 0 -5 14 -10 30 -10 20 0 30 -5 30 -15 0 -10 11 -15 35 -15 19 0 35 4 35 8 0 15 -91 59 -166 81 -84 25 -114 26 -114 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plO0VjDr6",
    d: "M7179 703 c10 -16 40 -48 65 -73 l46 -44 0 35 c0 45 -61 109 -104 109 l-27 0 20 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE3P4Q0AF",
    d: "M7530 635 c0 -31 3 -35 25 -35 22 0 25 -4 25 -35 0 -34 1 -35 37 -35 31 0 34 2 21 13 -8 6 -34 38 -57 70 -23 31 -44 57 -46 57 -3 0 -5 -16 -5 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paVd99mek",
    d: "M4648 642 c-37 -22 -35 -32 7 -32 31 0 35 3 35 25 0 29 -6 30 -42 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTzKlvb4k",
    d: "M7943 594 c3 -16 9 -38 13 -48 7 -18 3 -19 -74 -12 -76 6 -82 5 -82 -13 0 -22 34 -31 114 -31 l52 0 31 -95 31 -95 -39 0 c-32 0 -39 -3 -39 -20 0 -23 13 -25 75 -8 29 8 45 18 44 28 -1 35 -105 314 -118 318 -11 4 -13 -2 -8 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18ybytFlo",
    d: "M4610 590 c0 -13 11 -13 30 0 12 8 11 10 -7 10 -13 0 -23 -4 -23 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcHgzzuTF",
    d: "M4643 564 c-43 -21 -42 -34 2 -34 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 0 -18 -8 -35 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16d6cf9ui",
    d: "M4508 543 c-25 -27 -27 -117 -3 -143 26 -29 35 -25 22 10 -8 21 -8 41 -1 67 5 21 7 49 4 61 -5 23 -6 23 -22 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph0shqCvm",
    d: "M6478 481 c-81 -6 -109 -14 -96 -27 7 -7 178 16 198 27 13 7 13 8 0 7 -8 -1 -54 -4 -102 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIB1HVlz5",
    d: "M5262 471 c-8 -4 -12 -18 -10 -30 l3 -21 43 21 c23 12 42 25 42 30 0 11 -61 12 -78 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSx80uu70",
    d: "M6230 468 c0 -5 -13 -8 -30 -8 -24 0 -30 -4 -30 -21 0 -22 12 -22 113 -3 42 8 33 31 -13 36 -22 2 -40 0 -40 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgeCnd2I3",
    d: "M6058 443 c-30 -3 -38 -8 -38 -24 0 -19 4 -20 43 -14 83 12 97 17 97 31 0 14 -19 15 -102 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwzH9wbvB",
    d: "M5170 415 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plEFTgn7j",
    d: "M4540 410 c0 -22 41 -70 60 -70 16 0 12 50 -5 56 -8 4 -15 12 -15 20 0 8 -9 14 -20 14 -13 0 -20 -7 -20 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14NozPkQe",
    d: "M5813 408 c-35 -5 -63 -14 -63 -19 0 -5 -16 -9 -35 -9 -28 0 -35 -4 -35 -20 0 -25 0 -25 102 0 46 11 100 22 121 25 23 4 37 11 37 20 0 17 -31 18 -127 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plHCGDyVY",
    d: "M5503 385 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3kfliqNZ",
    d: "M4620 339 c0 -12 51 -35 103 -44 33 -7 37 -5 37 14 0 17 -6 21 -35 21 -19 0 -35 5 -35 10 0 6 -16 10 -35 10 -19 0 -35 -5 -35 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9QWOKWdD",
    d: "M5550 330 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmhGNXhPJ",
    d: "M7540 335 c16 -19 24 -17 -195 -61 -99 -20 -189 -40 -200 -44 -22 -8 250 -3 303 6 18 3 32 11 32 19 0 8 18 16 50 20 49 7 50 8 50 41 0 30 -3 34 -26 34 -22 0 -24 -2 -14 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ps4jeQSWg",
    d: "M5323 316 c-70 -23 -84 -46 -28 -46 21 0 35 5 35 13 0 9 3 8 9 -2 11 -17 71 -5 71 15 0 8 -4 14 -9 14 -5 0 -11 6 -13 13 -2 10 -17 8 -65 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15pI4OZua",
    d: "M5450 310 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6pMT7jCz",
    d: "M4820 296 c0 -17 28 -23 145 -30 103 -6 82 8 -27 19 -37 4 -70 11 -73 16 -10 14 -45 10 -45 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDqbO4VyP",
    d: "M5170 277 c-26 -7 -30 -11 -17 -15 27 -6 87 7 87 18 0 12 -25 11 -70 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1C3tRYcAx",
    d: "M7770 270 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p24Wa7Uot",
    d: "M7590 260 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l7hzEZpvXDgP60WanIryFPC",
    fill: "rgb(187,187,187)",
    style: {
      transform: "none"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pfPrrfsNK",
    d: "M5015 2655 l-220 -22 -90 -50 c-49 -28 -213 -117 -364 -198 -256 -139 -282 -155 -395 -253 -76 -66 -122 -114 -124 -127 -2 -15 -12 -25 -30 -28 -23 -5 -37 -25 -94 -141 -38 -75 -68 -144 -68 -154 0 -15 -57 -30 -397 -105 -219 -49 -429 -91 -468 -94 -81 -6 -171 8 -231 37 l-42 21 -299 -36 c-164 -19 -451 -53 -638 -75 -556 -66 -981 -144 -1087 -201 -13 -7 -53 -32 -91 -56 -37 -24 -69 -43 -71 -43 -3 0 -6 7 -8 16 -2 12 -12 8 -42 -18 -31 -27 -39 -42 -43 -74 l-4 -41 70 -37 c59 -31 78 -36 136 -36 l68 0 -7 -31 c-5 -27 -2 -32 27 -44 18 -7 33 -9 35 -4 2 5 16 8 30 8 18 -1 21 -3 9 -6 -26 -7 -16 -25 21 -40 31 -13 32 -12 32 13 0 19 4 24 18 20 9 -2 51 -10 93 -16 136 -22 349 -7 1129 78 410 45 833 91 940 102 107 12 341 37 520 56 179 19 429 45 555 59 641 68 1084 116 1123 121 38 6 42 4 42 -15 0 -16 -6 -21 -25 -21 -19 0 -25 -5 -25 -21 0 -18 4 -21 29 -16 29 6 29 6 33 -48 1 -30 0 -54 -3 -53 -3 2 -30 15 -60 30 -30 14 -81 38 -114 53 l-60 26 -193 -20 c-106 -12 -197 -21 -203 -21 -5 0 -9 -15 -9 -33 l0 -33 223 -106 c122 -58 261 -121 309 -140 l88 -33 0 -37 c0 -35 2 -38 29 -38 15 0 53 5 82 10 30 6 93 11 142 11 81 0 87 2 87 21 0 16 -5 19 -26 15 -14 -2 -27 0 -29 7 -2 6 -13 108 -25 226 -12 118 -23 235 -26 260 l-4 45 19 -40 20 -40 0 53 c1 46 -1 52 -19 52 -25 0 -28 45 -4 54 10 4 14 14 11 26 -5 21 14 27 47 14 13 -5 14 -9 5 -20 -6 -8 -9 -21 -5 -29 4 -11 -2 -15 -22 -16 -26 0 -26 -1 -4 -9 12 -5 22 -14 22 -20 0 -5 11 -10 25 -10 17 0 25 -6 25 -17 0 -14 11 -15 98 -10 126 9 777 74 821 83 33 7 33 7 27 -23 -7 -30 -6 -30 56 -46 95 -23 219 -74 257 -105 71 -56 229 -202 306 -283 44 -46 194 -202 335 -347 140 -145 256 -266 258 -270 1 -4 -85 -24 -190 -46 -106 -21 -200 -43 -208 -48 -10 -6 -7 -6 10 -1 14 4 63 6 110 5 100 -2 791 36 799 44 3 3 -22 87 -55 187 -44 133 -65 183 -77 185 -16 3 -16 -1 3 -50 30 -79 29 -81 -32 -74 -29 3 -103 9 -165 12 l-112 6 -239 332 c-132 182 -288 396 -346 475 -58 80 -105 146 -103 147 1 1 61 13 132 25 l130 23 -114 23 c-137 27 -214 68 -165 87 9 3 150 6 315 6 225 0 299 -3 299 -12 0 -7 5 -6 13 4 6 9 56 27 109 41 l98 25 -3 -26 c-1 -15 -19 -43 -44 -68 -71 -70 -66 -82 85 -206 71 -59 145 -122 166 -141 l37 -35 100 10 c55 6 98 15 97 20 -2 4 -86 98 -188 208 -123 133 -191 200 -205 200 -18 0 -20 7 -20 61 l0 61 90 42 c50 24 143 67 207 96 109 49 135 70 87 70 -10 0 -19 -4 -19 -10 0 -15 -26 -12 -40 5 -7 8 -25 15 -41 15 -32 0 -40 -16 -11 -22 9 -2 -41 -7 -112 -11 -144 -8 -182 -2 -57 9 45 3 81 11 81 17 0 6 -23 7 -62 3 -35 -4 -86 -8 -113 -10 -28 -2 -140 -32 -248 -66 l-197 -64 0 -32 0 -33 83 -3 82 -3 -72 -30 c-51 -21 -73 -35 -73 -47 0 -10 -4 -18 -10 -18 -5 0 -10 9 -10 20 0 19 -7 20 -175 20 -110 0 -175 -4 -175 -10 0 -11 -42 -13 -77 -4 -13 4 -23 11 -23 16 0 5 -11 24 -25 42 -14 18 -25 38 -25 44 0 16 -56 25 -160 24 -52 0 -97 3 -100 8 -3 6 -20 13 -38 16 -25 5 -32 3 -32 -10 0 -11 -9 -16 -30 -16 -19 0 -30 5 -30 14 0 13 -28 26 -57 26 -7 0 -13 -9 -13 -20 0 -17 -6 -20 -47 -19 -27 0 -42 3 -35 6 20 8 14 30 -10 37 -38 10 -48 7 -48 -14 0 -20 -7 -20 -302 -20 -167 0 -367 -3 -446 -7 l-143 -6 3 -53 3 -53 24 16 c23 15 24 14 17 -3 -17 -43 -19 -76 -5 -85 23 -14 29 -11 29 16 0 32 31 45 107 45 50 0 55 -2 50 -20 -3 -11 -1 -23 4 -26 5 -3 9 -12 9 -21 0 -13 -12 -15 -79 -11 -78 5 -79 4 -95 -24 -21 -35 -55 -55 -66 -38 -5 8 -9 4 -13 -12 -6 -21 -8 -20 -28 20 -21 42 -23 43 -58 38 l-36 -6 24 20 c23 20 23 20 2 20 -12 0 -21 -4 -21 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -6 -28 -10 -65 -10 -51 0 -65 3 -65 15 0 10 11 15 33 16 17 0 41 4 52 9 15 6 6 9 -32 9 -40 1 -53 5 -53 16 0 12 13 15 60 15 47 0 60 -3 60 -15 0 -29 27 -14 46 25 10 22 27 43 37 46 12 4 17 16 17 40 0 42 35 42 -430 4 -201 -17 -404 -33 -452 -37 -77 -5 -88 -8 -88 -24 0 -18 14 -19 257 -19 141 0 254 -3 251 -6 -3 -3 -262 -41 -575 -84 -312 -43 -586 -82 -608 -85 -93 -14 -9 10 261 74 305 73 384 97 384 118 0 7 -5 13 -12 13 -9 0 -9 3 0 12 26 26 13 78 -49 200 l-29 56 184 159 c180 154 190 161 413 284 192 106 243 130 327 152 55 15 104 31 110 37 5 5 8 9 6 9 -3 -1 -104 -11 -225 -24z m1290 -916 c9 -39 19 -107 22 -150 6 -77 6 -78 -19 -84 -14 -4 -42 -5 -64 -3 l-39 3 -8 65 c-4 36 -14 99 -22 140 -21 106 -24 100 49 100 l64 0 17 -71z m-2170 -390 c-1089 -136 -2126 -262 -2305 -279 -179 -16 -392 -38 -475 -46 -99 -11 -198 -15 -292 -12 l-143 5 0 -27 c0 -35 -38 -49 -58 -22 -11 15 -10 17 7 20 12 2 21 9 21 17 0 16 -30 24 -90 26 -25 0 -63 6 -85 13 l-40 12 59 22 c32 12 63 22 70 22 7 0 21 7 32 15 16 12 17 16 5 24 -20 13 3 41 33 40 17 -1 17 -2 4 -6 -11 -3 -18 -14 -18 -29 l0 -24 53 20 c65 24 201 36 652 55 556 24 785 41 1370 99 303 31 901 89 1330 131 1486 144 1690 164 1725 168 19 2 55 4 80 4 25 0 -846 -111 -1935 -248z m955 52 c0 -21 -6 -32 -20 -36 -11 -3 -20 -13 -20 -22 0 -12 -6 -14 -27 -8 -41 10 -49 22 -29 44 17 18 72 50 89 51 4 0 7 -13 7 -29z m2238 -1158 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peXdTAodd",
    d: "M3735 2643 c-11 -2 -135 -16 -275 -32 -175 -20 -260 -26 -273 -20 -12 7 -43 7 -90 0 -40 -6 -103 -13 -142 -16 -130 -11 -129 -11 -145 -58 -8 -23 -14 -59 -12 -79 3 -37 4 -38 43 -38 37 0 40 2 33 23 -9 29 -16 35 -21 19 -5 -13 -23 -7 -23 7 0 15 115 41 178 41 33 0 64 5 67 10 3 6 17 10 31 10 27 0 45 -31 36 -63 -7 -28 -58 -50 -95 -41 -18 4 -44 7 -59 6 -15 -1 -29 2 -33 8 -11 18 -27 11 -20 -9 5 -16 -1 -20 -35 -26 -33 -6 -40 -11 -40 -30 0 -21 -6 -24 -72 -34 -40 -6 -113 -17 -163 -26 -49 -8 -137 -19 -195 -25 -58 -6 -112 -13 -121 -16 -28 -8 -40 -86 -31 -196 3 -29 30 -21 35 10 2 15 5 3 6 -25 1 -45 4 -53 20 -53 11 0 21 -4 23 -10 7 -23 157 -49 290 -50 146 -2 250 -16 227 -31 -11 -7 -11 -9 4 -9 9 0 17 7 17 16 0 18 2 18 223 -2 l67 -7 0 37 c0 33 -3 36 -27 36 -67 1 -49 18 82 79 133 63 135 64 135 97 0 30 -4 34 -52 53 l-53 21 180 -5 c99 -3 201 -8 228 -11 l47 -6 0 35 c0 20 -5 37 -11 39 -5 2 47 29 118 60 103 45 129 60 131 78 2 12 -1 20 -6 16 -5 -3 -36 5 -68 17 -44 17 -60 29 -62 45 -2 14 2 22 11 22 26 0 29 58 5 101 -19 35 -26 39 -57 38 -20 -1 -45 -3 -56 -6z m-15 -99 c-47 -13 -526 -91 -532 -87 -5 2 -8 10 -8 17 0 10 66 21 243 43 214 27 341 38 297 27z m-1134 -339 c15 -20 22 -19 27 3 3 10 5 6 6 -10 1 -19 -4 -28 -14 -28 -8 0 -15 -7 -15 -15 0 -21 -38 -38 -71 -31 -16 3 -41 1 -57 -5 -48 -19 -80 -19 -87 -1 -5 14 -7 14 -16 2 -8 -13 -10 -13 -19 0 -7 11 -1 23 22 47 30 31 31 31 69 18 38 -14 39 -13 61 16 19 24 28 28 53 24 17 -3 35 -12 41 -20z m419 20 c-5 -3 -80 -16 -165 -30 -85 -14 -165 -27 -177 -30 -20 -5 -23 -1 -23 24 l0 30 93 4 c146 5 283 6 272 2z m230 -2 c-11 -2 -35 -8 -52 -13 -26 -7 -33 -5 -33 6 0 10 13 14 53 13 28 -1 43 -3 32 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzNaiZ643",
    d: "M4588 2613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9slRlR8P",
    d: "M4488 2603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjYIVwvuA",
    d: "M4378 2593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ADn21D0U",
    d: "M4223 2545 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pay2wIu6M",
    d: "M4113 2495 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJdJIL4Z9",
    d: "M4023 2455 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p104HOMrzB",
    d: "M2897 2444 c-16 -16 -7 -44 14 -44 16 0 19 3 12 13 -6 6 -12 18 -14 25 -3 7 -8 10 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pngSUmcCd",
    d: "M5148 1943 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRLUypguN",
    d: "M5390 1930 c0 -17 7 -20 50 -20 36 0 50 4 50 14 0 15 -30 26 -72 26 -21 0 -28 -5 -28 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19EXNwR6U",
    d: "M5558 1943 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 32 0 45 4 45 14 0 11 -33 28 -50 25 -3 -1 -13 -3 -22 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ8BBkOtT",
    d: "M4968 1933 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptL0R6Qsd",
    d: "M5810 1920 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pytLPsokv",
    d: "M4868 1923 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p170HBz8X1",
    d: "M5950 1910 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11xEPI3mo",
    d: "M4768 1913 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzlNgamwN",
    d: "M6100 1900 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8FYLnoBu",
    d: "M4668 1903 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19gP9qsui",
    d: "M4458 1883 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOKXmXCGC",
    d: "M2803 1852 c-24 -15 -43 -30 -43 -34 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 9 0 15 9 15 25 0 31 -5 31 -57 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE7tBT1Q9",
    d: "M4358 1873 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEwktNtPe",
    d: "M7253 1848 c-41 -13 -44 -38 -5 -38 47 0 72 11 72 31 0 21 -17 23 -67 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DxCmf76X",
    d: "M6950 1820 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7HxFnSYk",
    d: "M7040 1816 c0 -40 39 -54 109 -40 21 5 31 12 31 25 0 15 -8 19 -39 19 -21 0 -53 3 -70 6 -25 5 -31 3 -31 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSPhREecV",
    d: "M2543 1682 c-24 -15 -43 -30 -43 -34 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 9 0 15 9 15 25 0 31 -5 31 -57 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pi2ICxQjd",
    d: "M5470 1698 c0 -11 60 -9 85 2 14 7 5 9 -32 7 -29 -1 -53 -5 -53 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2zgDY4pO",
    d: "M2418 1643 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgyxIiKSG",
    d: "M2338 1633 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10Icr8tFk",
    d: "M2188 1613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pihfX1dEC",
    d: "M2038 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFxYyhIj9",
    d: "M7598 1593 c-19 -5 -25 -33 -8 -33 5 0 16 -16 24 -35 22 -51 36 -43 36 20 0 58 -4 61 -52 48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMZOGpKRW",
    d: "M1958 1583 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg8fWJ5Dr",
    d: "M7508 1583 c-31 -8 -19 -23 17 -23 24 0 35 5 35 15 0 15 -17 17 -52 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Hk5rmTAX",
    d: "M1728 1553 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13zQBjaOb",
    d: "M1638 1543 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmiKAaLfU",
    d: "M1538 1533 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plg91DscI",
    d: "M1388 1513 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCLees3fV",
    d: "M1205 1485 c-5 -2 -27 -6 -47 -10 -24 -4 -38 -11 -38 -20 0 -17 15 -18 84 -9 36 5 46 11 46 25 0 18 -18 23 -45 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIfkcZiDr",
    d: "M918 1433 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4EbOrmh5",
    d: "M713 1378 c-41 -13 -44 -38 -5 -38 47 0 72 11 72 31 0 21 -17 23 -67 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pr20bWPaR",
    d: "M7678 1343 c20 -54 42 -68 42 -26 0 52 -11 73 -36 73 l-24 0 18 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC3pOP776",
    d: "M583 1325 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFKw8YQdw",
    d: "M6030 1320 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puXU2Kcue",
    d: "M5940 1310 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p158hkJGCG",
    d: "M5770 1290 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmtf4nWOz",
    d: "M5680 1280 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDSKXFHnD",
    d: "M5510 1260 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP1xHm3Tq",
    d: "M7800 1266 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ple2OkuDG",
    d: "M5420 1250 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDUF01uMf",
    d: "M7880 1256 c0 -16 32 -26 60 -19 37 10 23 33 -20 33 -27 0 -40 -4 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p165DDNqCy",
    d: "M5354 1193 c3 -21 8 -73 11 -115 5 -60 10 -78 22 -78 11 0 14 8 9 38 -3 20 -8 72 -12 115 -5 58 -10 77 -21 77 -11 0 -14 -9 -9 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdmV5wbPA",
    d: "M7776 1064 c49 -139 51 -144 65 -144 16 0 10 31 -28 153 -32 103 -39 117 -58 117 -22 0 -22 -2 21 -126z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRJVgj1aZ",
    d: "M3740 1060 c0 -15 7 -20 29 -20 16 0 43 -3 60 -6 26 -6 31 -4 31 13 0 16 -9 22 -37 27 -67 11 -83 8 -83 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7YCH4XaA",
    d: "M3550 1036 c0 -31 7 -35 70 -43 63 -7 69 12 8 25 l-43 9 45 8 c44 9 44 9 15 16 -16 3 -45 7 -62 8 -29 1 -33 -2 -33 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwJdnnuSg",
    d: "M3410 1030 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSHluDn5R",
    d: "M3320 1020 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GsPc3zA3",
    d: "M3895 1032 c-29 -5 -29 -5 15 -18 44 -13 42 -13 -52 -10 -54 2 -98 -1 -98 -5 0 -5 6 -9 13 -9 6 0 99 -11 206 -25 107 -14 196 -23 199 -21 2 3 1 18 -3 35 -5 25 -12 31 -33 31 -15 0 -59 7 -97 15 -71 15 -96 16 -150 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phm4YKcOM",
    d: "M3130 1000 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9DfvnfXx",
    d: "M3040 990 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZbz032kN",
    d: "M2940 980 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DI4we7VU",
    d: "M2850 970 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvl2KV5TZ",
    d: "M5374 959 c3 -17 6 -42 6 -55 0 -13 7 -24 18 -27 15 -4 15 -5 -2 -6 -15 -1 -17 -6 -12 -32 3 -17 6 -42 6 -55 0 -23 2 -24 80 -24 l80 0 0 33 c-1 29 -7 36 -62 67 -79 45 -88 55 -88 96 0 25 -4 34 -16 34 -13 0 -15 -7 -10 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4wqrw00L",
    d: "M2760 960 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18P4xo5zm",
    d: "M2660 950 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11oNNYaFu",
    d: "M2570 940 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYHMVZLJu",
    d: "M2380 920 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAuaE7VdH",
    d: "M2290 910 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMP0nJnSm",
    d: "M4280 916 c0 -8 14 -17 30 -21 25 -6 30 -11 30 -37 0 -24 3 -28 13 -19 10 8 36 4 103 -17 l89 -28 -42 -7 c-29 -5 -43 -12 -43 -22 0 -24 48 -36 135 -34 97 2 233 -10 241 -22 3 -5 21 -9 40 -9 32 0 34 2 34 34 0 33 -1 33 -50 39 -28 3 -140 33 -250 67 -110 33 -213 60 -230 60 -20 0 -30 5 -30 15 0 10 -11 15 -35 15 -24 0 -35 -5 -35 -14z m425 -155 c66 -12 137 -23 159 -27 21 -3 36 -7 33 -10 -2 -3 -65 2 -138 10 -74 9 -170 19 -214 22 l-80 7 45 12 c25 7 52 11 60 10 8 -2 69 -13 135 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkQXBHRR7",
    d: "M2200 900 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEztchJ0l",
    d: "M2100 890 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwN6P6spR",
    d: "M2010 880 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ff37KyQy",
    d: "M1820 860 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15hPeQIn",
    d: "M1730 850 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWPs8NAfG",
    d: "M1540 830 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc0N9Jyto",
    d: "M1450 820 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPyYIPlCn",
    d: "M650 816 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz4o4baPC",
    d: "M1350 810 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ6HBlMU7",
    d: "M1260 800 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10QUupuRd",
    d: "M7872 790 c18 -53 45 -54 33 -1 -4 21 -13 31 -25 31 -17 0 -18 -4 -8 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1E4acit2A",
    d: "M750 796 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPhb39bd8",
    d: "M1170 790 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pShOtPbEh",
    d: "M830 786 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzI2xqJh1",
    d: "M970 776 c0 -16 32 -26 60 -19 37 10 23 33 -20 33 -27 0 -40 -4 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8gXVgmVV",
    d: "M5580 738 c0 -42 -4 -48 -63 -104 -83 -77 -104 -94 -122 -94 -9 0 -15 -10 -15 -25 0 -29 3 -30 38 -12 15 8 45 23 67 33 49 24 145 118 145 143 0 34 12 51 34 51 17 0 18 2 6 11 -12 8 -11 9 5 5 11 -3 46 -8 78 -12 47 -5 57 -4 57 9 0 19 -26 26 -137 34 l-93 6 0 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piQsb8N2S",
    d: "M5940 695 c0 -22 4 -25 35 -25 28 0 35 -4 35 -20 0 -16 7 -20 30 -20 40 0 30 22 -23 53 -68 39 -77 40 -77 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGS6nIK3y",
    d: "M4788 693 c-10 -2 -18 -13 -18 -24 0 -10 -7 -19 -15 -19 -8 0 -15 5 -15 11 0 15 -62 3 -75 -14 -5 -8 -21 -17 -35 -20 -38 -11 -61 -32 -54 -51 4 -9 9 -15 13 -13 55 30 153 70 180 73 33 4 31 2 -24 -25 l-60 -29 53 -1 c28 -1 52 3 52 9 0 6 9 10 19 10 37 0 51 12 51 42 0 47 -24 64 -72 51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBtL140D6",
    d: "M5870 665 c0 -8 -5 -15 -10 -15 -6 0 -15 -12 -21 -26 -10 -27 -10 -27 -97 -22 l-87 5 58 -26 c31 -14 56 -30 54 -36 -2 -5 -28 -24 -58 -42 -30 -17 -63 -40 -74 -51 -11 -11 -37 -27 -57 -35 -48 -20 -49 -37 -3 -37 24 0 35 5 35 15 0 9 9 15 23 15 48 0 207 97 207 126 0 8 6 14 14 14 8 0 19 14 25 31 14 40 14 99 1 99 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnBDhg2xb",
    d: "M6040 581 c0 -25 -32 -59 -87 -96 -37 -24 -43 -33 -43 -62 l0 -35 68 7 c37 4 86 16 109 26 47 21 70 24 75 9 3 -9 296 25 307 36 11 10 -11 11 -104 5 l-100 -7 -92 45 c-77 38 -93 50 -93 68 0 16 -6 23 -20 23 -13 0 -20 -7 -20 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNNXdymos",
    d: "M4639 560 c-19 -10 -41 -26 -48 -34 -12 -14 -9 -16 23 -16 32 0 36 3 36 25 0 16 6 25 15 25 8 0 15 5 15 10 0 12 2 13 -41 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py1LYJPtJ",
    d: "M4510 465 c0 -19 2 -35 4 -35 2 0 6 16 8 35 2 19 0 35 -4 35 -4 0 -8 -16 -8 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Fz2TAqRn",
    d: "M4552 480 c-18 -29 -15 -50 8 -50 16 0 20 7 20 35 0 39 -9 44 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pybNxbh4q",
    d: "M5220 435 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPs56CYTe",
    d: "M4547 392 c2 -10 13 -23 24 -30 17 -11 19 -9 19 18 0 25 -4 30 -24 30 -18 0 -23 -4 -19 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pixhtqUrg",
    d: "M4998 381 c-77 -20 -98 -29 -98 -43 0 -23 2 -23 123 8 107 27 137 39 137 54 0 16 -58 9 -162 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B9qf766s",
    d: "M5790 400 c0 -5 -16 -10 -35 -10 -29 0 -35 -4 -35 -21 0 -17 4 -20 23 -16 12 3 43 11 70 17 57 14 65 40 12 40 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pifP3RlIo",
    d: "M5465 368 c-27 -10 -56 -28 -64 -38 -8 -12 -25 -20 -42 -20 -23 0 -29 -5 -29 -21 0 -19 4 -21 38 -15 85 15 90 17 96 42 8 29 36 32 36 4 0 -21 10 -24 48 -14 30 8 28 34 -2 34 -18 0 -25 6 -28 24 l-3 24 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGVO1ZVGZ",
    d: "M4602 348 c3 -7 19 -18 36 -25 31 -13 32 -12 32 12 0 22 -4 25 -36 25 -23 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbZ4FuKvV",
    d: "M5590 340 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ECQ0aPuJ",
    d: "M4700 316 c0 -14 11 -18 93 -32 32 -5 37 -4 37 14 0 15 -9 21 -46 26 -69 9 -84 8 -84 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15MUdarel",
    d: "M5208 286 c-55 -13 -79 -32 -29 -22 18 3 51 6 72 6 28 0 39 4 39 15 0 17 -16 17 -82 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvIQAZqil",
    d: "M4965 270 c11 -5 36 -8 55 -8 32 0 33 1 10 8 -14 4 -38 8 -55 8 -25 1 -27 -1 -10 -8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l0GOCY1B5jJeh6kryoFaP7",
    fill: "rgb(170,170,170)",
    style: {
      transform: "none"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pB8qB17If",
    d: "M4964 2650 c-94 -10 -180 -23 -191 -29 -16 -8 -22 -8 -25 0 -6 17 -68 1 -68 -17 0 -9 11 -14 30 -14 17 0 30 -4 30 -10 0 -5 -13 -10 -30 -10 -36 0 -160 -59 -160 -77 0 -7 -9 -13 -20 -13 -20 0 -100 -36 -110 -49 -3 -4 -25 -15 -49 -26 -24 -11 -49 -24 -55 -30 -6 -5 -35 -21 -63 -34 -29 -14 -53 -30 -53 -38 0 -7 -9 -13 -20 -13 -24 0 -90 -31 -90 -42 0 -4 -7 -8 -15 -8 -8 0 -15 -9 -15 -20 0 -14 -7 -20 -23 -20 -28 0 -47 -17 -47 -42 0 -12 -8 -18 -23 -18 -27 0 -57 -28 -57 -53 0 -10 -10 -17 -27 -19 -17 -2 -32 -12 -38 -25 -5 -13 -15 -23 -22 -23 -7 0 -13 -9 -13 -20 0 -12 -7 -20 -16 -20 -31 0 -74 -68 -74 -120 0 -45 17 -36 47 25 31 62 13 54 231 106 72 17 132 34 132 39 0 4 -60 -3 -132 -16 -73 -13 -136 -23 -139 -21 -4 1 48 49 114 107 110 95 143 116 361 235 133 72 303 164 378 204 l138 72 177 25 c98 14 183 26 188 29 22 8 -90 2 -251 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11JhbW6UG",
    d: "M3750 2644 c-46 -11 -540 -61 -566 -57 -29 5 -32 2 -37 -29 -3 -18 -4 -65 -2 -105 l2 -71 -86 -16 c-47 -9 -106 -18 -131 -20 -40 -5 -38 -4 15 9 33 8 74 19 90 23 l30 8 -30 16 c-18 10 -37 13 -45 8 -8 -4 -27 -10 -41 -14 -21 -5 -28 -2 -32 14 -6 25 -24 26 -30 3 -3 -14 -6 -11 -11 10 -8 26 -26 38 -26 17 0 -5 -5 -10 -11 -10 -7 0 -9 10 -5 25 4 14 2 25 -4 25 -5 0 -10 -9 -10 -20 0 -11 -7 -20 -15 -20 -16 0 -18 -12 -9 -47 8 -28 34 -30 34 -3 0 11 5 20 10 20 6 0 10 -11 10 -25 0 -19 -5 -25 -21 -25 -16 0 -19 -4 -14 -20 3 -11 2 -20 -3 -20 -26 0 -180 -24 -199 -31 -29 -11 -38 -58 -19 -102 11 -27 11 -37 3 -40 -9 -3 -9 -12 0 -37 9 -24 10 -36 2 -41 -18 -11 -226 -52 -240 -47 -8 3 28 13 79 23 50 9 92 21 92 26 0 10 -69 24 -77 15 -4 -3 -15 2 -25 11 -16 15 -21 15 -28 3 -7 -12 -10 -12 -16 3 -8 22 -24 22 -25 0 0 -14 -3 -13 -11 5 -7 13 -17 21 -25 18 -16 -6 -18 49 -4 87 8 21 20 25 112 41 155 25 147 35 -12 16 -133 -17 -126 -13 -139 -73 -17 -73 -11 -111 18 -115 27 -4 29 -20 2 -30 -19 -7 -19 -9 8 -42 17 -20 39 -35 53 -35 13 -1 42 -10 63 -19 22 -10 64 -20 93 -23 44 -5 53 -3 53 10 0 11 -17 19 -57 28 l-58 12 110 25 c61 13 112 28 115 32 3 4 130 39 284 78 l278 71 56 -21 56 -21 -67 -34 c-37 -18 -67 -38 -67 -43 0 -19 60 -10 115 17 50 24 55 30 55 59 0 32 -13 44 -51 44 -10 0 -19 5 -19 10 0 6 -8 10 -17 11 -11 0 -13 3 -5 6 24 9 12 32 -20 37 -52 8 -348 13 -348 6 0 -8 73 -27 139 -36 l54 -7 -45 -18 c-52 -20 -409 -101 -416 -94 -8 7 12 13 193 50 93 20 171 38 174 40 10 11 -53 3 -209 -25 -126 -22 -166 -26 -173 -17 -6 10 -1 108 6 113 1 0 45 8 97 16 83 14 97 14 117 1 17 -11 30 -12 55 -5 18 6 85 18 148 27 63 9 124 23 136 30 11 7 146 35 300 61 262 44 283 46 348 35 38 -6 71 -10 73 -7 2 2 -16 12 -40 21 -44 17 -45 18 -36 48 12 44 12 47 -11 47 -13 0 -20 7 -20 20 0 11 5 20 10 20 6 0 10 7 10 15 0 8 -9 15 -20 15 -18 0 -20 -7 -20 -59 0 -58 0 -59 -32 -65 -101 -18 -311 -47 -320 -44 -6 2 42 12 106 22 64 10 116 22 116 27 0 4 -15 5 -32 3 -138 -22 -444 -60 -448 -57 -5 5 -3 113 2 118 2 1 122 15 268 29 328 33 340 35 340 52 0 13 -17 16 -50 8z m-520 -241 c-8 -3 -18 -11 -22 -17 -9 -14 -22 -1 -13 13 3 6 16 11 28 10 15 0 17 -2 7 -6z m-40 -187 c0 -2 -11 -6 -25 -8 -14 -3 -25 -1 -25 3 0 5 11 9 25 9 14 0 25 -2 25 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvrtSi09N",
    d: "M4598 2613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BfvvA8jL",
    d: "M4775 2486 c-222 -119 -237 -129 -422 -282 -124 -102 -191 -164 -189 -174 2 -8 24 -58 49 -112 43 -90 44 -97 28 -112 -26 -23 -87 -46 -165 -61 -39 -8 -145 -30 -235 -50 -187 -40 -185 -40 -177 -20 3 8 9 22 12 30 5 11 -1 15 -19 15 -18 0 -28 -7 -35 -28 -10 -28 -12 -29 -403 -115 -217 -48 -404 -87 -416 -87 -17 0 -23 -6 -23 -21 0 -18 4 -20 48 -14 26 4 308 64 627 135 319 71 614 131 655 135 117 9 140 14 140 30 0 8 5 15 10 15 6 0 10 -7 10 -15 0 -10 10 -15 33 -15 47 0 77 10 77 26 0 10 -14 14 -49 14 l-49 0 5 40 c5 33 -2 54 -41 131 -26 50 -46 92 -44 93 2 1 82 69 178 152 166 143 186 157 395 273 200 112 248 141 234 141 -2 0 -108 -56 -234 -124z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkBVviG9K",
    d: "M4388 2593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GNrzurL8",
    d: "M2973 2577 c-76 -7 -103 -13 -103 -23 0 -8 6 -14 13 -14 24 0 240 39 245 45 7 6 -23 5 -155 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppKBkjjXJ",
    d: "M4298 2579 c-29 -16 -21 -29 17 -29 28 0 35 4 35 20 0 22 -24 26 -52 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Cfy5KGd1",
    d: "M2817 2539 c-4 -16 -1 -20 16 -17 12 2 23 11 25 21 5 25 -34 22 -41 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqMbJhHyI",
    d: "M4203 2535 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw249GUiL",
    d: "M3975 2434 c-180 -75 -361 -159 -371 -171 -6 -7 -19 -13 -28 -13 -9 0 -16 -8 -16 -19 0 -15 10 -19 53 -25 28 -3 69 -6 90 -6 36 0 37 1 37 35 0 21 -5 35 -12 36 -7 0 -3 5 10 11 12 6 22 15 22 20 0 4 9 8 19 8 30 0 51 11 51 26 0 9 11 14 27 14 37 0 113 32 113 48 0 7 14 12 35 12 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -30 -12 -63 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNzV02Ix1",
    d: "M3087 2018 c-58 -28 -104 -55 -101 -60 3 -4 -4 -8 -15 -8 -14 0 -21 -6 -21 -20 0 -17 7 -20 50 -20 37 0 50 4 50 14 0 8 -8 16 -17 18 -13 3 -11 5 8 9 14 3 34 2 45 -2 17 -7 17 -8 2 -8 -11 -1 -18 -9 -18 -21 0 -18 7 -20 65 -20 l65 0 0 34 c0 36 -12 46 -58 47 -25 0 -23 2 16 22 31 15 42 27 42 44 0 13 -1 23 -3 23 -2 0 -51 -23 -110 -52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piqRfsiUx",
    d: "M7868 2014 c-43 -13 -10 -19 99 -18 65 1 96 0 68 -2 -27 -2 -70 -7 -95 -10 -42 -6 -43 -7 -20 -16 14 -5 59 -6 100 -3 l75 6 -120 -51 c-486 -209 -516 -220 -549 -211 -17 5 -26 10 -19 10 16 1 426 181 438 192 15 15 1 11 -108 -31 -75 -29 -124 -42 -173 -44 -38 -3 -70 -9 -72 -15 -2 -6 -15 -11 -28 -11 -17 0 -24 -6 -24 -19 0 -12 -9 -21 -25 -25 -14 -4 -25 -11 -25 -16 0 -5 -21 -7 -50 -3 -41 5 -50 3 -50 -10 0 -8 8 -18 18 -20 10 -3 6 -5 -10 -6 -16 0 -28 -5 -28 -11 0 -15 62 -22 165 -18 94 3 96 2 102 -20 4 -18 8 -21 14 -10 5 7 9 23 9 34 0 18 16 27 92 54 82 29 92 31 103 17 7 -10 20 -14 34 -10 18 4 21 12 19 36 l-3 31 198 90 c150 68 193 92 181 99 -18 10 -289 19 -316 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p119TUUVD0",
    d: "M7745 1999 c-22 -5 -121 -35 -220 -67 l-180 -58 -3 -32 c-3 -29 -1 -32 24 -32 15 0 45 6 68 13 l41 12 -48 5 c-47 5 -46 5 130 68 132 46 192 62 233 63 40 0 50 3 35 9 -17 7 -17 9 -2 9 9 1 17 6 17 11 0 12 -38 11 -95 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9afU585h",
    d: "M2690 1946 c0 -18 31 -26 107 -26 34 0 69 -3 77 -6 15 -6 15 -8 -1 -20 -17 -12 -16 -13 10 -14 24 0 27 4 27 34 0 33 -1 33 -52 40 -94 11 -168 8 -168 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9mcIFi5t",
    d: "M5158 1943 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HRVdCVf4",
    d: "M5360 1930 c0 -17 7 -20 45 -20 49 0 64 23 23 34 -45 12 -68 7 -68 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJNQrbtPa",
    d: "M4978 1933 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNPcwki7o",
    d: "M5800 1920 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pW8MA2cqI",
    d: "M4878 1923 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2kAO5mbk",
    d: "M5940 1910 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prhHHFFCt",
    d: "M4778 1913 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCVcyq1vx",
    d: "M6090 1900 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EnELazoK",
    d: "M6234 1878 c3 -17 9 -34 12 -37 3 -3 57 -8 120 -9 110 -4 114 -3 114 17 0 12 -6 21 -14 21 -8 0 -16 4 -18 10 -1 5 -18 12 -35 16 -26 5 -33 3 -33 -10 0 -12 -9 -16 -35 -16 -23 0 -35 5 -35 14 0 14 -29 26 -64 26 -15 0 -17 -5 -12 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfvGlTnXi",
    d: "M4568 1893 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13zJzsEXc",
    d: "M4468 1883 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJpYLdHVj",
    d: "M4368 1873 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Bhpl6JX3",
    d: "M5760 1860 c0 -17 7 -20 40 -20 33 0 40 3 40 20 0 17 -7 20 -40 20 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pD1KNyEp9",
    d: "M6600 1860 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CbY0GIP5",
    d: "M5460 1850 c0 -17 7 -20 53 -20 66 0 97 9 97 26 0 11 -18 14 -75 14 -68 0 -75 -2 -75 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjjL1KmRB",
    d: "M5240 1853 c0 -5 -27 -6 -60 -5 -56 4 -60 2 -60 -18 0 -22 2 -22 70 -16 l69 7 -29 -31 c-17 -18 -30 -36 -30 -41 0 -4 -30 -9 -67 -11 l-68 -3 -3 -59 -3 -59 69 6 c67 7 70 6 86 -18 25 -39 91 -68 134 -60 53 10 90 32 106 64 9 16 28 32 48 38 l33 11 -32 1 c-38 1 -48 31 -10 32 12 0 31 4 42 9 15 7 11 9 -20 7 -30 -2 -40 2 -43 16 -3 13 3 17 27 17 17 0 31 5 31 10 0 6 -16 10 -35 10 -18 0 -38 6 -42 13 -4 7 -21 23 -37 35 l-29 22 27 0 c14 0 26 4 26 9 0 12 -26 21 -61 21 -28 0 -29 -2 -29 -45 0 -41 -2 -45 -24 -45 -22 0 -23 3 -18 45 l5 45 -37 0 c-20 0 -36 -3 -36 -7z m166 -98 c-4 -14 -2 -25 4 -25 5 0 10 6 11 13 0 6 4 3 9 -8 12 -28 12 -105 0 -105 -5 0 -29 -13 -52 -29 l-43 -30 -16 37 -16 37 -116 -4 c-102 -2 -117 -1 -117 13 0 11 9 16 28 17 15 0 36 5 47 10 15 6 9 8 -25 6 -36 -2 -45 2 -48 16 -3 14 4 17 41 17 25 0 52 3 61 6 12 4 16 0 17 -17 1 -15 3 -18 6 -8 2 9 18 19 34 23 26 5 29 9 23 28 l-6 21 36 -21 c46 -27 54 -27 91 3 37 31 39 31 31 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTfLh7rHP",
    d: "M5230 1680 c0 -30 0 -30 25 -14 14 9 25 23 25 30 0 8 -10 14 -25 14 -21 0 -25 -5 -25 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTpsHJbzg",
    d: "M6760 1845 c0 -8 7 -15 15 -15 18 0 91 -87 87 -105 -3 -16 32 -22 201 -30 80 -5 117 -3 117 4 0 7 -30 12 -77 13 l-78 2 80 6 80 6 -62 2 c-39 1 -63 6 -63 13 0 8 -22 9 -72 5 l-73 -7 -17 31 c-9 16 -24 30 -33 30 -8 0 -15 9 -15 20 0 13 -10 24 -26 30 -37 14 -64 12 -64 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4FMmrrBx",
    d: "M6860 1830 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjFPQAuNU",
    d: "M2728 1802 c-32 -20 -58 -40 -58 -44 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 9 0 15 9 15 25 0 14 -3 25 -7 25 -5 0 -34 -17 -65 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTkyEQDS4",
    d: "M5000 1820 c0 -16 7 -20 33 -20 47 0 77 10 77 26 0 10 -15 14 -55 14 -48 0 -55 -2 -55 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvMFN3NVG",
    d: "M6940 1820 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnl7mrfa2",
    d: "M7184 1825 c-30 -9 -55 -10 -93 -3 -29 5 -55 7 -58 4 -3 -3 -3 -17 1 -31 6 -22 11 -25 52 -25 25 0 74 7 109 16 51 13 65 20 65 35 0 22 -17 23 -76 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXTyv5Lip",
    d: "M4880 1810 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16sfops4Q",
    d: "M3676 1804 c-9 -25 -7 -74 4 -74 8 0 50 70 50 85 0 13 -48 3 -54 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJnZyTSAU",
    d: "M4760 1800 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEp9sRhZI",
    d: "M4630 1790 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BM5ZT8on",
    d: "M4510 1780 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1D1aVb9a0",
    d: "M4390 1770 c0 -16 7 -20 33 -20 47 0 77 10 77 26 0 10 -15 14 -55 14 -48 0 -55 -2 -55 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWEL89MQM",
    d: "M5540 1750 c0 -5 11 -10 25 -10 29 0 36 -30 8 -31 -16 0 -16 -1 1 -8 11 -4 23 -16 27 -27 5 -12 8 -1 8 34 l1 52 -35 0 c-19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Go0vBQXC",
    d: "M7810 1682 c0 -7 -13 -12 -30 -12 -25 0 -30 -4 -30 -25 0 -18 -5 -25 -20 -25 -11 0 -20 -4 -20 -9 0 -5 -10 -11 -22 -13 -19 -2 -24 -10 -26 -40 -3 -35 -1 -38 22 -38 18 0 25 -6 28 -22 2 -14 11 -24 23 -26 11 -2 25 -13 30 -25 6 -12 19 -23 30 -25 11 -2 25 -13 30 -25 6 -12 20 -23 33 -25 12 -2 22 -9 22 -16 0 -18 33 -46 53 -46 9 0 17 -7 17 -15 0 -9 7 -18 15 -21 8 -4 15 -13 15 -20 0 -16 48 -13 158 8 55 10 66 30 22 36 -20 3 -22 2 -12 -11 10 -12 5 -15 -38 -21 -60 -8 -39 -21 -249 154 -157 130 -161 135 -139 148 13 8 34 28 47 46 l24 32 161 -164 c117 -119 167 -163 181 -161 17 4 -63 96 -311 359 -10 10 -14 10 -14 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AD37BQZh",
    d: "M2498 1657 c-40 -16 -36 -37 7 -37 31 0 35 3 35 25 0 27 -2 28 -42 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptujo7kAA",
    d: "M2348 1633 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCIKnBkg0",
    d: "M2268 1623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8McqFXeb",
    d: "M2118 1603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRJcDUENf",
    d: "M7570 1575 c0 -8 7 -15 15 -15 8 0 19 -9 25 -20 16 -31 30 -24 30 15 0 33 -2 35 -35 35 -24 0 -35 -5 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pS0y77bOZ",
    d: "M1888 1573 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOVccpohW",
    d: "M7410 1570 c-21 -7 -19 -8 18 -9 23 -1 42 4 42 9 0 12 -24 12 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AnVgGuvZ",
    d: "M1808 1563 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOXr9CbYT",
    d: "M1648 1543 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCEnDrFtb",
    d: "M1548 1533 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1qdgYsqg",
    d: "M1810 1465 c-809 -98 -1135 -152 -1317 -221 -24 -8 -43 -20 -43 -25 0 -5 -7 -9 -15 -9 -8 0 -15 -4 -15 -9 0 -5 -11 -12 -25 -15 -14 -4 -25 -11 -25 -16 0 -6 -7 -10 -15 -10 -8 0 -15 -4 -15 -9 0 -13 -43 -22 -51 -10 -4 7 -21 -4 -43 -25 -40 -41 -48 -83 -18 -108 26 -24 119 -68 142 -68 37 0 20 26 -28 43 -27 10 -58 25 -70 33 -24 17 -29 44 -9 44 7 0 59 29 114 64 55 35 110 69 122 75 106 57 527 135 1091 201 195 23 476 56 623 74 148 17 270 29 273 25 6 -11 93 -37 147 -45 43 -6 47 -5 47 15 0 16 -6 21 -27 21 -16 0 -59 12 -98 25 -38 14 -86 24 -105 24 -19 -1 -307 -34 -640 -74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFn0U4nPg",
    d: "M1458 1523 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pthhHVpdd",
    d: "M1335 1505 c-5 -2 -27 -6 -47 -10 -24 -4 -38 -11 -38 -20 0 -17 15 -18 84 -9 36 5 46 11 46 25 0 18 -18 23 -45 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwsaxFCEW",
    d: "M6535 1465 c-154 -24 -329 -48 -390 -55 -145 -14 -165 -19 -165 -36 0 -18 21 -18 185 1 170 19 165 19 165 -7 0 -20 10 -26 78 -45 42 -11 83 -23 91 -25 8 -1 40 -17 70 -34 31 -17 72 -40 91 -50 19 -10 37 -22 38 -26 2 -5 20 -8 39 -8 29 0 33 2 24 14 -33 40 -153 104 -267 141 l-122 41 141 37 c78 20 186 47 240 59 53 12 97 25 97 30 0 11 0 11 -315 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQLH77jgQ",
    d: "M1075 1463 c-11 -2 -44 -9 -72 -14 -35 -7 -53 -15 -53 -25 0 -17 19 -18 110 -2 56 10 70 16 70 30 0 18 -13 20 -55 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14b9aOjWu",
    d: "M5097 1463 c-4 -3 -7 -19 -7 -33 0 -55 -12 -90 -30 -90 -10 0 -21 -6 -23 -12 -4 -10 -6 -10 -6 0 -1 6 -12 12 -26 12 -30 0 -32 14 -5 37 11 10 20 23 20 30 0 8 12 13 30 13 24 0 30 4 30 21 0 19 -4 21 -32 15 -17 -3 -46 -18 -65 -32 -34 -26 -55 -75 -35 -82 7 -2 12 -10 12 -17 0 -7 14 -16 31 -20 17 -4 29 -9 27 -11 -2 -2 -67 -10 -144 -19 -191 -21 -204 -24 -204 -40 0 -19 19 -19 185 0 72 8 152 15 178 15 44 0 48 2 47 23 -4 45 1 53 45 75 52 25 55 34 19 51 -24 11 -25 13 -12 29 30 35 30 42 0 42 -16 0 -32 -3 -35 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFyopIpCq",
    d: "M5330 1461 c0 -6 6 -11 14 -11 21 0 40 -27 24 -33 -10 -4 -8 -10 6 -21 21 -17 17 -20 -22 -16 -19 1 -23 -2 -18 -17 3 -10 8 -30 12 -45 6 -26 34 -40 34 -17 0 5 4 8 9 4 6 -3 46 -3 90 1 71 6 81 9 81 26 0 19 -5 20 -72 14 l-73 -7 28 21 c15 12 27 27 27 34 0 19 -42 53 -75 60 -16 4 -38 9 -47 12 -10 3 -18 1 -18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paxuFdkGu",
    d: "M7032 1353 c146 -213 579 -821 591 -831 7 -6 24 -8 38 -5 l24 7 -25 6 c-18 4 -56 49 -133 155 -471 652 -652 896 -495 668z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEVzlb51r",
    d: "M828 1413 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8Jug6zJ9",
    d: "M7663 1388 c19 -46 37 -48 37 -4 0 32 -3 36 -25 36 -24 0 -25 -1 -12 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVwaB3Wjs",
    d: "M5898 1383 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peOfQghcd",
    d: "M5770 1373 c-79 -8 -100 -14 -100 -30 0 -14 10 -15 77 -9 42 3 87 6 100 6 16 0 23 6 23 20 0 21 -10 22 -100 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNKN92lKG",
    d: "M643 1350 c-52 -23 -55 -40 -8 -40 19 0 35 5 35 10 0 6 11 10 25 10 18 0 25 5 25 20 0 25 -21 25 -77 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBoAxNjN4",
    d: "M5588 1353 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1D491svvG",
    d: "M6140 1340 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyhQ2zaI7",
    d: "M6020 1320 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pk8q2kXM",
    d: "M5850 1300 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppHE9cAfL",
    d: "M5760 1290 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poKxGjPmD",
    d: "M5590 1270 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmKgp290n",
    d: "M5500 1260 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjEv5MKAr",
    d: "M7720 1250 c0 -44 26 -100 46 -100 17 0 16 13 -2 78 -5 16 -2 22 10 22 9 0 16 7 16 15 0 10 -11 15 -35 15 -32 0 -35 -2 -35 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTYWHO6lZ",
    d: "M4360 1219 c-135 -15 -246 -28 -247 -28 -2 -1 -3 -8 -3 -16 0 -20 -7 -20 293 12 231 24 257 29 257 45 0 23 7 23 -300 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcceunn3q",
    d: "M5271 1150 c-1 -99 5 -140 20 -140 9 0 3 104 -11 190 -6 37 -8 27 -9 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HWFxMI2Y",
    d: "M5350 1228 c0 -24 12 -58 20 -58 4 0 10 16 12 35 3 29 1 35 -14 35 -10 0 -18 -6 -18 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVm2YnsLg",
    d: "M5020 1206 c0 -19 4 -23 19 -19 17 4 19 -2 23 -49 2 -29 3 -54 2 -56 -1 -1 -52 23 -113 54 l-112 56 -94 -7 c-84 -6 -95 -9 -95 -26 0 -21 9 -22 102 -10 56 7 59 6 185 -59 l128 -65 7 -90 c5 -49 7 -93 5 -97 -4 -11 -248 93 -447 190 -119 58 -176 91 -160 91 42 2 70 13 70 27 0 15 -31 18 -92 8 -35 -6 -38 -9 -38 -38 0 -29 6 -35 55 -59 31 -15 69 -27 85 -27 18 0 30 -5 30 -13 0 -18 184 -107 220 -107 19 0 30 -5 30 -14 0 -14 72 -46 103 -46 9 0 17 -4 17 -8 0 -5 18 -15 40 -22 38 -12 40 -15 40 -53 l0 -40 53 7 c28 3 64 6 80 6 21 0 27 5 27 21 0 19 -4 20 -34 15 -21 -4 -37 -2 -41 5 -4 6 -9 56 -11 112 -5 143 -10 165 -37 170 l-22 4 23 2 c25 1 27 16 16 109 -6 49 -8 52 -35 52 -24 0 -29 -4 -29 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSPoV3csZ",
    d: "M875 1212 c-62 -4 -75 -15 -75 -63 0 -46 6 -47 84 -18 50 19 56 25 56 50 0 34 -2 35 -65 31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzZEjLAhR",
    d: "M4900 1190 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLST9ESd4",
    d: "M4038 1183 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16kaBp9rl",
    d: "M3935 1174 c-11 -2 -110 -12 -220 -24 -240 -25 -255 -28 -255 -46 0 -18 -15 -19 288 13 234 25 262 29 262 45 0 18 -20 21 -75 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p66uhWMi6",
    d: "M4560 1150 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQuzlVlKb",
    d: "M6749 1143 c11 -16 75 -83 144 -151 109 -109 127 -123 153 -120 28 3 23 9 -115 151 -120 122 -149 147 -173 147 l-29 0 20 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNJiy1D8t",
    d: "M3180 1094 c-266 -29 -280 -31 -280 -49 0 -19 -18 -20 288 12 235 24 262 29 262 45 0 22 5 22 -270 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZaMVhcWH",
    d: "M5366 1058 c3 -35 8 -76 11 -93 3 -16 7 -62 8 -102 3 -70 3 -71 -23 -76 -36 -7 -42 -2 -42 37 0 56 -11 96 -28 96 -12 0 -14 -11 -8 -65 6 -63 6 -65 -19 -71 -14 -3 -25 -12 -25 -20 0 -11 18 -14 80 -14 73 0 80 2 80 20 0 11 5 20 10 20 6 0 10 11 10 25 0 29 4 30 49 6 l35 -19 -32 -7 c-18 -3 -32 -13 -32 -21 0 -10 15 -14 60 -14 l60 0 0 33 c0 30 -5 35 -76 71 -42 21 -77 44 -79 50 -2 6 -7 55 -10 109 -5 73 -10 97 -21 97 -11 0 -13 -13 -8 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHfsVID53",
    d: "M3710 1060 c0 -17 6 -20 48 -19 26 1 65 -4 87 -10 70 -19 239 -51 270 -51 22 0 26 -3 16 -9 -8 -5 -28 -7 -45 -5 -17 2 -78 11 -136 18 -192 26 -210 28 -210 19 0 -4 89 -19 198 -31 108 -13 217 -30 241 -38 59 -19 71 -18 71 6 0 16 -7 20 -30 20 -25 0 -30 4 -30 24 0 22 -5 24 -75 31 -41 3 -79 4 -84 1 -5 -4 -35 -3 -65 0 -43 5 -56 11 -56 24 0 20 -75 40 -151 40 -42 0 -49 -3 -49 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3SkYO9kb",
    d: "M3543 1058 c-32 -6 -53 -15 -53 -23 0 -18 114 -45 148 -35 25 8 25 8 -10 9 -51 1 -56 17 -8 25 26 4 40 12 40 21 0 17 -35 18 -117 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJQ00Gbub",
    d: "M2540 1025 c-162 -19 -296 -34 -297 -34 -10 -3 -1 -31 10 -31 6 -1 153 14 325 32 281 29 312 34 312 50 0 23 11 23 -350 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEQuv8Ked",
    d: "M7793 1018 c15 -37 37 -49 37 -20 0 34 -11 52 -31 52 -17 0 -18 -3 -6 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2dPitVfX",
    d: "M3310 1020 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11TFNrabn",
    d: "M810 1010 c0 -11 7 -36 14 -55 12 -29 20 -35 44 -35 61 0 92 11 92 34 0 42 -12 66 -32 66 -17 0 -20 -5 -16 -31 4 -27 2 -30 -21 -27 -21 2 -26 8 -23 29 2 20 -3 28 -20 33 -35 9 -38 8 -38 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHiybO5YC",
    d: "M3220 1010 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1NrI2VsD",
    d: "M555 1012 c-4 -4 -10 -7 -13 -7 -4 0 -29 -9 -55 -20 -40 -17 -47 -24 -44 -42 2 -13 0 -23 -4 -23 -5 0 -9 -5 -9 -10 0 -13 81 -51 92 -44 4 3 64 -4 133 -16 69 -11 137 -20 150 -20 34 0 32 27 -2 34 -32 7 -275 46 -284 46 -3 0 -6 6 -6 14 0 8 5 12 11 10 6 -2 31 -1 56 4 38 6 45 11 45 31 0 16 -9 27 -32 36 -17 7 -34 10 -38 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HIslRnzG",
    d: "M3120 1000 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDFKlKkeL",
    d: "M3030 990 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwRAZC9JT",
    d: "M5280 965 c0 -24 5 -35 15 -35 16 0 18 12 9 48 -10 34 -24 26 -24 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw5ttEEUI",
    d: "M1930 959 c-135 -15 -246 -28 -247 -28 -2 -1 -3 -8 -3 -16 0 -20 -7 -20 293 12 231 24 257 29 257 45 0 23 7 23 -300 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPstwjvh3",
    d: "M2840 970 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUez22JgB",
    d: "M2750 960 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX6Ns5tGa",
    d: "M2560 940 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRgBKzfI9",
    d: "M2470 930 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAB2dJDUj",
    d: "M1370 899 c-135 -15 -246 -28 -247 -28 -10 -3 -1 -31 10 -31 6 -1 130 12 275 27 235 24 262 29 262 45 0 23 7 23 -300 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLvIMja8a",
    d: "M2280 910 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDo7raX4K",
    d: "M2190 900 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13E3pA9x9",
    d: "M4320 900 c0 -5 5 -10 10 -10 6 0 10 -6 10 -14 0 -9 7 -12 18 -9 10 2 108 -23 217 -56 110 -33 218 -63 240 -66 120 -19 112 -30 -11 -15 -49 5 -107 12 -129 15 -36 4 -37 4 -11 -5 16 -5 60 -12 98 -16 38 -4 70 -10 73 -14 2 -3 -33 -17 -78 -30 -86 -25 -117 -39 -117 -54 0 -9 65 -3 140 13 61 13 61 7 1 -15 -28 -10 -49 -19 -47 -21 2 -2 27 -1 55 3 50 6 51 8 51 39 0 35 16 45 73 45 24 0 27 4 27 35 0 35 0 35 -45 35 -25 0 -45 5 -45 10 0 6 -8 10 -17 10 -10 0 -54 11 -98 25 -44 14 -92 25 -107 25 -14 0 -28 4 -30 8 -4 12 -139 52 -172 52 -14 0 -26 5 -26 10 0 6 -18 10 -40 10 -22 0 -40 -4 -40 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pq1KFtsbH",
    d: "M2000 880 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWuWBIW6B",
    d: "M1910 870 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkn7gy8c4",
    d: "M1048 863 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAwVpvZvR",
    d: "M1720 850 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1D4NYRi7w",
    d: "M1630 840 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pATXOdrCh",
    d: "M7862 820 c18 -53 45 -54 33 -1 -4 21 -13 31 -25 31 -17 0 -18 -4 -8 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMrdlmDWi",
    d: "M1440 820 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3SaTgvWh",
    d: "M690 806 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DtIMQn8k",
    d: "M1250 800 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pm5MfrvIA",
    d: "M1160 790 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPbRBhtkD",
    d: "M5580 773 c0 -21 -3 -63 -6 -93 l-6 -55 23 22 c16 16 23 34 24 63 0 37 2 40 28 40 39 0 34 23 -10 40 -21 8 -41 16 -45 18 -5 2 -8 -14 -8 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7eeyPCGN",
    d: "M840 786 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBYxiFxI0",
    d: "M1070 780 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6KJp7gHa",
    d: "M4473 783 c-20 -3 -33 -10 -33 -18 0 -8 14 -16 33 -19 79 -12 123 -14 142 -6 16 7 13 9 -16 9 -20 1 -58 4 -85 8 l-49 6 40 13 c40 12 29 14 -32 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTf3RoPgE",
    d: "M5780 745 c0 -8 14 -17 36 -21 19 -3 40 -14 46 -24 9 -13 21 -16 55 -12 35 4 43 2 43 -12 0 -12 9 -16 35 -16 19 0 35 4 35 9 0 13 -84 50 -160 72 -78 23 -90 23 -90 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppy8NW7TL",
    d: "M7221 695 c0 -24 18 -49 92 -126 81 -85 95 -96 117 -90 24 7 19 13 -92 127 -110 112 -118 117 -117 89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10gs8V7Mx",
    d: "M7923 648 c12 -31 37 -50 37 -29 0 24 -21 61 -35 61 -13 0 -13 -4 -2 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0CtQrWuI",
    d: "M5853 621 c-15 -38 -16 -38 -52 -30 -20 5 -56 8 -81 8 l-45 0 63 -18 c34 -10 65 -21 68 -23 7 -8 -83 -71 -138 -97 -27 -13 -48 -27 -48 -32 0 -15 67 -10 84 6 8 8 24 15 35 15 11 0 24 6 28 13 4 8 16 16 26 20 9 3 17 14 17 22 0 19 23 45 39 45 6 0 11 9 11 20 0 11 7 20 15 20 10 0 15 11 15 35 0 46 -18 44 -37 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pk3bilNja",
    d: "M4535 569 c-59 -52 -69 -138 -20 -179 11 -9 12 0 8 48 -4 39 -2 62 6 66 6 4 11 16 11 27 0 11 6 19 13 17 14 -3 77 33 77 44 0 21 -62 6 -95 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIE8sajW4",
    d: "M5460 580 c0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -25 0 -14 4 -25 8 -25 11 0 92 58 92 65 0 3 -16 5 -35 5 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSgMaS4Jz",
    d: "M6035 560 c-4 -17 -13 -30 -21 -30 -8 0 -17 -7 -20 -15 -4 -8 -12 -15 -20 -15 -8 0 -14 -4 -14 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -9 -15 -20 0 -13 -7 -20 -20 -20 -13 0 -20 -7 -20 -20 0 -24 -7 -24 105 -4 50 8 109 16 131 18 50 3 74 24 74 63 0 23 -8 33 -50 56 -33 19 -47 32 -43 42 3 10 -1 15 -15 15 -15 0 -22 -9 -27 -30z m75 -60 c25 -13 31 -20 20 -24 -29 -10 -190 -53 -190 -51 0 2 22 17 49 34 27 18 52 38 55 46 7 20 23 18 66 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxiA4PXoo",
    d: "M4600 530 l-35 -29 38 -1 c35 0 37 2 37 30 0 17 -1 30 -3 30 -1 0 -18 -13 -37 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7GAz5js8",
    d: "M7960 543 c0 -10 15 -61 34 -113 54 -153 56 -137 -14 -145 -33 -4 -60 -12 -60 -17 0 -6 18 -8 48 -4 75 11 102 17 102 25 0 23 -88 265 -98 269 -7 2 -12 -5 -12 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjmVldqDQ",
    d: "M7783 523 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10r1TBDMk",
    d: "M6425 470 c-16 -7 -13 -9 15 -9 19 0 55 4 80 8 l45 8 -60 1 c-33 0 -69 -3 -80 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnZ7DA3c1",
    d: "M6230 447 c0 -19 15 -19 113 -1 53 11 26 24 -43 22 -60 -3 -70 -6 -70 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcS4jn3iV",
    d: "M4540 435 c0 -16 5 -37 10 -45 7 -12 10 -8 10 15 0 17 -5 37 -10 45 -7 12 -10 8 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5TsTVeva",
    d: "M5140 405 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj9JHR4jf",
    d: "M5630 350 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmDRV68eJ",
    d: "M4860 340 c0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -24 0 -27 22 -36 85 -35 l40 1 -35 10 c-64 19 -66 21 -27 30 48 13 50 38 2 38 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZYRbbkZU",
    d: "M5368 327 c-32 -15 -48 -28 -48 -41 0 -16 5 -17 33 -12 17 4 34 11 35 16 2 6 10 10 18 10 8 0 14 10 14 25 0 14 -1 25 -2 25 -2 0 -24 -10 -50 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptY467HG2",
    d: "M4650 330 c0 -12 33 -30 54 -30 9 0 16 9 16 20 0 16 -7 20 -35 20 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11BR2gPFe",
    d: "M7570 325 c-14 -7 -109 -30 -212 -50 -104 -21 -187 -40 -185 -41 5 -6 442 58 450 66 4 3 -1 13 -10 22 -15 12 -23 12 -43 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAe80lRPv",
    d: "M5440 310 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4nd32EzV",
    d: "M4975 270 c11 -5 31 -8 45 -8 l25 0 -25 8 c-14 4 -34 8 -45 8 l-20 1 20 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHxKFkYLm",
    d: "M5160 270 c-13 -9 -13 -10 0 -9 8 0 24 4 35 9 l20 9 -20 0 c-11 0 -27 -4 -35 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11D9xXll7",
    d: "M7783 273 c-24 -2 -43 -9 -43 -15 0 -7 14 -8 38 -4 20 3 54 6 75 6 20 0 37 5 37 10 0 10 -22 10 -107 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prI9MAk2e",
    d: "M7487 254 c-197 -14 -261 -27 -97 -19 251 11 340 18 340 26 0 11 -11 10 -243 -7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "lMPz3SnTpggvYPuDCNycXU",
    fill: "rgb(153,153,153)",
    style: {
      transform: "none"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p8kl2RRpG",
    d: "M5022 2655 c-116 -12 -142 -18 -130 -30 2 -3 76 6 164 19 174 26 159 31 -34 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVcQWO3Di",
    d: "M3733 2643 c-29 -3 -43 -9 -43 -19 0 -11 11 -13 54 -8 l53 6 8 -38 c5 -23 10 -32 12 -21 3 9 10 17 18 17 8 0 11 7 8 20 -3 11 -12 20 -19 20 -8 0 -14 7 -14 15 0 8 -8 14 -17 13 -10 -1 -37 -3 -60 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p188cdShz9",
    d: "M3580 2623 c-78 -11 -90 -15 -90 -24 0 -7 21 -8 58 -4 85 9 112 16 112 26 0 9 -31 10 -80 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12Gb2eUBB",
    d: "M4707 2623 c-13 -3 -17 -11 -14 -24 3 -12 -1 -20 -14 -24 -17 -6 -29 -55 -13 -55 3 0 33 14 65 31 58 31 74 49 44 49 -8 0 -15 7 -15 15 0 15 -17 17 -53 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pacwtok81",
    d: "M3418 2603 c-20 -5 -24 -23 -5 -23 24 0 57 12 57 21 0 9 -22 10 -52 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13JmFT5bL",
    d: "M4498 2603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZDwgVSA2",
    d: "M3323 2593 c-27 -5 -31 -23 -5 -23 28 0 62 12 62 21 0 9 -17 10 -57 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plQDuuMVS",
    d: "M4398 2593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pneR5lCci",
    d: "M3060 2580 c-20 -6 -21 -8 -5 -8 11 0 29 3 40 8 25 11 -1 11 -35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQJLx6kwn",
    d: "M3228 2583 c-31 -5 -39 -23 -10 -23 28 0 62 12 62 21 0 9 -4 9 -52 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMHnCcV30",
    d: "M4293 2575 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMdVpbNLU",
    d: "M2848 2563 c-10 -2 -18 -11 -18 -20 0 -11 6 -14 23 -9 12 3 28 6 35 6 6 0 12 7 12 15 0 15 -17 17 -52 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pojGCcPZb",
    d: "M3147 2548 c-7 -26 -1 -144 8 -157 6 -10 -7 -13 -147 -37 -123 -20 -160 -14 -49 9 46 9 87 19 90 22 10 11 -23 25 -50 23 -15 -1 -34 4 -44 12 -14 12 -18 12 -25 0 -7 -12 -10 -11 -16 3 -8 21 -24 13 -24 -13 0 -10 -7 -25 -15 -34 -8 -8 -15 -22 -15 -30 0 -9 -4 -16 -10 -16 -5 0 -10 14 -10 30 0 20 5 30 15 30 9 0 15 10 15 26 0 21 -4 24 -20 19 -19 -6 -20 -3 -14 34 5 34 4 41 -9 41 -9 0 -21 -8 -26 -19 -13 -23 -3 -119 14 -147 13 -21 11 -21 -62 -32 -42 -6 -79 -16 -83 -22 -5 -8 -19 -10 -38 -5 -16 3 -32 3 -35 -2 -11 -20 -15 -59 -8 -72 14 -22 49 -4 56 29 4 17 10 30 13 30 4 0 47 7 97 15 79 13 92 13 113 -1 12 -8 27 -12 33 -9 5 4 61 15 124 25 63 10 121 25 129 33 8 8 16 29 18 48 2 27 7 34 23 32 22 -2 437 65 444 73 7 6 2 6 -228 -26 -118 -16 -217 -27 -220 -24 -3 3 -6 33 -6 67 0 49 -3 62 -16 65 -10 2 -19 -6 -22 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMIMvU7f",
    d: "M4867 2533 c-37 -20 -66 -38 -63 -40 4 -4 136 66 136 73 0 6 0 6 -73 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13Gl2dQ9Y",
    d: "M3807 2533 c-4 -3 -7 -14 -7 -24 0 -10 -8 -20 -17 -22 -10 -3 -145 -25 -301 -48 -272 -41 -282 -43 -276 -63 4 -12 8 -22 9 -24 4 -4 304 46 365 62 123 32 211 38 275 22 84 -22 89 -19 20 14 -33 16 -53 29 -44 29 17 1 32 37 23 53 -6 10 -38 11 -47 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKQ0mnmy7",
    d: "M4183 2525 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWU0pV6hE",
    d: "M4093 2485 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwcpOC7xm",
    d: "M4523 2493 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3Du4YljY",
    d: "M4663 2423 c-57 -31 -103 -61 -103 -66 0 -5 15 0 33 11 17 10 59 34 92 52 74 41 103 60 90 60 -6 -1 -56 -26 -112 -57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11Kjb33U7",
    d: "M3953 2423 c-35 -15 -61 -28 -59 -31 3 -2 32 -1 65 3 56 6 61 9 61 31 0 13 -1 24 -2 23 -2 0 -31 -12 -65 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18PNG8Yl6",
    d: "M4400 2405 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plAUWlLKz",
    d: "M3791 2352 c-91 -41 -112 -62 -63 -62 40 0 62 9 62 26 0 9 11 14 33 14 42 0 60 12 55 38 -3 20 -6 20 -87 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2Ay7dsUr",
    d: "M4283 2363 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfFg3uAbV",
    d: "M4352 2199 c-178 -149 -213 -189 -161 -189 14 0 19 5 16 14 -4 9 22 39 71 83 42 37 82 72 88 78 6 5 48 41 93 79 68 58 93 86 78 86 -1 0 -85 -68 -185 -151z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNgxPl7sn",
    d: "M4173 2303 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjhpZ6UrZ",
    d: "M3634 2280 c-42 -19 -40 -22 36 -39 l45 -10 -50 5 c-27 3 -65 8 -82 11 -28 4 -33 2 -33 -14 0 -17 9 -21 53 -27 28 -3 73 -6 100 -6 l47 0 0 35 c0 30 -3 35 -24 35 -14 0 -31 6 -39 14 -12 12 -19 12 -53 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDiETKbAh",
    d: "M2455 2270 l-20 -9 20 1 c11 0 31 4 45 8 l25 8 -25 0 c-14 0 -34 -3 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9xox4dpb",
    d: "M2352 2259 c-56 -11 -57 -12 -72 -64 -17 -60 -7 -142 20 -169 l20 -20 0 32 c0 29 3 32 30 32 25 0 30 4 30 25 0 31 -20 33 -21 3 l0 -23 -9 21 c-10 25 -30 41 -30 24 0 -6 -5 -8 -11 -5 -5 4 -8 20 -5 36 19 94 13 87 67 94 27 4 51 11 55 16 6 11 -14 10 -74 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paXQsmn7W",
    d: "M2940 2260 c0 -10 89 -30 130 -30 21 0 41 -4 44 -9 10 -15 -67 -39 -254 -81 -187 -42 -210 -45 -210 -32 0 4 51 18 113 30 178 37 249 54 245 58 -3 2 -81 -10 -174 -26 -93 -17 -175 -28 -181 -25 -7 2 -13 11 -13 20 0 8 -7 15 -16 15 -12 0 -15 -9 -14 -37 4 -81 6 -78 -67 -93 -38 -7 -62 -15 -55 -17 6 -3 12 -11 12 -19 0 -16 15 -18 56 -5 16 5 46 12 67 16 23 4 37 11 37 20 0 9 15 17 40 21 22 4 40 12 40 19 0 9 13 11 45 7 36 -4 45 -1 45 10 0 12 9 14 45 10 36 -4 45 -2 45 11 0 12 7 15 35 10 47 -8 295 54 295 73 0 8 -10 14 -25 14 -15 0 -25 6 -25 15 0 8 -13 16 -32 19 -47 8 -228 12 -228 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn3JA7ufZ",
    d: "M4070 2230 c0 -15 -7 -20 -25 -20 -21 0 -25 -5 -25 -30 0 -28 -3 -30 -35 -30 -32 0 -35 -2 -35 -29 0 -27 -3 -30 -37 -33 -35 -3 -38 -6 -41 -35 -3 -30 -6 -33 -38 -33 -27 0 -34 -4 -34 -20 0 -13 -7 -20 -20 -20 -16 0 -20 -7 -20 -35 0 -40 5 -43 28 -16 12 13 68 31 172 57 85 20 150 39 145 41 -6 2 -66 -8 -135 -21 -69 -13 -126 -23 -128 -21 -4 4 228 204 265 229 42 27 41 36 -2 36 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOnG6rE4y",
    d: "M3280 2189 c0 -6 18 -18 41 -27 40 -15 40 -16 17 -28 -23 -13 -22 -13 10 -14 30 0 32 2 32 34 0 26 -5 35 -22 40 -36 9 -78 7 -78 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzdM7VuLa",
    d: "M2394 2075 c-4 -18 -13 -25 -30 -25 -13 0 -24 -4 -24 -10 0 -13 1 -13 98 7 45 9 82 20 82 24 0 12 -40 21 -66 15 -14 -4 -24 -2 -24 4 0 21 -30 9 -36 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8HR65sZ1",
    d: "M3203 2070 c-68 -32 -80 -50 -33 -50 47 0 100 30 100 57 0 13 -1 23 -2 23 -2 0 -31 -13 -65 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkA5wfTLZ",
    d: "M2390 2020 c-19 -5 -38 -6 -42 -4 -5 3 -8 -4 -8 -15 0 -23 16 -26 83 -15 27 5 37 11 37 25 0 21 -13 22 -70 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pt5jzw5yc",
    d: "M7750 2000 c-79 -15 -185 -56 -188 -73 -3 -14 9 -12 78 13 45 16 100 30 124 30 35 0 42 3 43 20 1 11 -1 19 -5 19 -4 -1 -27 -5 -52 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcPgz2w13",
    d: "M7830 2000 c0 -12 27 -12 55 0 16 7 13 9 -17 9 -21 1 -38 -3 -38 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbM3oauWO",
    d: "M7948 2003 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTyJwWyp1",
    d: "M8075 2001 c18 -7 16 -9 -12 -15 -18 -4 -42 -5 -53 -1 -11 4 -35 3 -53 -2 -26 -7 -17 -9 52 -13 l84 -5 -308 -130 c-298 -125 -364 -161 -278 -151 21 2 41 5 46 5 4 1 7 7 7 15 0 7 13 16 29 19 17 4 47 13 68 22 21 9 38 16 38 15 0 -1 12 3 27 9 25 9 28 8 34 -14 10 -39 31 -30 37 16 3 22 7 42 9 43 1 1 92 43 201 92 207 93 217 103 107 103 -37 0 -48 -3 -35 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKS0OVABA",
    d: "M3011 1976 l-23 -13 23 -6 c13 -4 49 -7 79 -7 30 0 62 -5 70 -11 15 -10 -61 -7 -182 7 -45 5 -48 4 -48 -16 0 -22 2 -23 65 -16 40 4 65 3 65 -3 0 -6 33 -10 75 -10 l75 0 0 34 c0 41 -20 50 -91 40 -33 -5 -49 -3 -49 4 0 15 -30 13 -59 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15fmHhwNe",
    d: "M4206 1943 c9 -21 18 -44 21 -50 5 -13 53 -19 53 -7 0 3 -12 25 -26 50 -16 28 -33 44 -45 44 -18 0 -19 -2 -3 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phNqZwLCZ",
    d: "M7848 1973 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVdZYdN4x",
    d: "M2480 1950 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pY0piZCad",
    d: "M2700 1946 c0 -16 30 -26 78 -26 37 0 45 24 10 34 -42 11 -88 7 -88 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE48PAi0W",
    d: "M2850 1936 c0 -7 10 -16 22 -20 22 -5 22 -6 3 -20 -19 -15 -19 -15 13 -16 30 0 32 2 32 35 0 33 -2 35 -35 35 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BvLGFbwF",
    d: "M5178 1943 c-10 -2 -18 -11 -18 -19 0 -11 24 -14 130 -14 104 0 130 3 130 14 0 7 -10 16 -22 20 -26 7 -194 6 -220 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbEINMtP1",
    d: "M4988 1933 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ewp15NUb",
    d: "M5760 1920 c0 -17 7 -20 50 -20 36 0 50 4 50 14 0 15 -30 26 -72 26 -21 0 -28 -5 -28 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CMPRkDAy",
    d: "M4888 1923 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbXBanSgi",
    d: "M5930 1910 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDLxi9TSu",
    d: "M6080 1900 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14FTCSWAe",
    d: "M4678 1903 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pv8z7YvrL",
    d: "M6220 1890 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p131UFIuBA",
    d: "M7413 1898 c-18 -6 -33 -15 -33 -19 0 -5 -13 -9 -30 -9 -28 0 -30 -3 -30 -35 0 -35 0 -35 48 -36 l47 -1 -37 -15 c-34 -14 -38 -19 -38 -53 0 -40 13 -50 73 -50 38 0 34 18 -5 22 -27 2 4 19 185 98 218 94 289 136 102 60 -109 -44 -109 -44 -100 -30 4 6 -36 10 -112 11 l-118 0 59 22 c91 34 81 64 -11 35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2S85rmhy",
    d: "M4578 1893 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DLqHjDbC",
    d: "M6370 1881 c0 -16 6 -21 24 -21 13 0 26 -5 28 -11 9 -28 238 -21 238 6 0 12 -34 24 -70 23 -8 0 -30 3 -47 7 -22 5 -33 4 -33 -4 0 -14 -67 -15 -72 -1 -1 5 -18 12 -35 16 -29 6 -33 4 -33 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppTv2zXkJ",
    d: "M4478 1883 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16nuyjlHu",
    d: "M3702 1855 c-7 -14 -12 -37 -12 -50 0 -14 -6 -25 -13 -25 -8 0 -19 -11 -25 -25 -14 -30 -16 -85 -3 -85 8 0 81 134 102 188 7 19 5 22 -15 22 -15 0 -27 -9 -34 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phrIPBLby",
    d: "M5710 1861 c0 -18 9 -19 125 -20 118 -1 125 0 125 19 0 19 -7 20 -125 20 -116 0 -125 -1 -125 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plS4K2SEj",
    d: "M5410 1850 c0 -16 7 -20 33 -20 47 0 77 10 77 26 0 10 -15 14 -55 14 -48 0 -55 -2 -55 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GuXajYXs",
    d: "M6680 1850 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pK9fyGHPB",
    d: "M5220 1840 c0 -14 7 -20 21 -20 18 0 17 -4 -13 -40 -24 -29 -41 -40 -63 -41 -16 0 -39 -5 -50 -10 -14 -7 -7 -8 28 -4 41 4 47 2 47 -14 0 -16 -11 -20 -65 -26 -60 -6 -65 -9 -65 -30 0 -29 7 -33 45 -24 l30 7 -32 1 c-21 1 -33 6 -33 15 0 16 100 34 119 21 17 -10 13 -35 -6 -36 -14 0 -15 -2 -3 -6 8 -3 25 -15 38 -26 12 -11 22 -15 22 -9 0 7 15 12 36 12 28 0 35 3 32 18 -3 13 -12 16 -43 14 l-40 -3 29 26 c29 26 29 27 12 61 -20 43 -20 48 -1 40 8 -3 15 -1 15 4 0 5 9 12 20 15 15 5 20 15 20 41 l0 34 -50 0 c-43 0 -50 -3 -50 -20z m17 -147 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2rdiz7XV",
    d: "M6770 1846 c0 -9 6 -16 13 -16 8 0 32 -23 56 -52 31 -38 38 -54 29 -60 -9 -5 -3 -8 15 -8 23 0 27 4 27 30 0 23 -4 30 -20 30 -14 0 -20 7 -20 23 0 28 -31 56 -71 64 -22 4 -29 2 -29 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPIEt396G",
    d: "M4256 1836 c8 -20 -26 -48 -85 -71 -28 -11 -51 -23 -51 -28 0 -13 103 2 112 16 6 9 10 9 17 -2 12 -18 81 -6 81 14 0 8 -9 15 -20 15 -16 0 -20 7 -20 35 0 28 -4 35 -20 35 -12 0 -17 -5 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EbaNHdlt",
    d: "M5100 1830 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKo7NbB4o",
    d: "M4980 1820 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CPFf1QNT",
    d: "M4850 1810 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXytHTTKz",
    d: "M7000 1805 c0 -21 5 -25 28 -25 15 0 51 -3 80 -6 48 -6 52 -5 52 14 0 17 -10 22 -63 31 -91 16 -97 15 -97 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piH4VaU9u",
    d: "M4730 1800 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDqIw2ORN",
    d: "M4610 1790 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6zI3BxYX",
    d: "M5418 1771 c3 -27 9 -41 18 -41 8 0 14 -4 14 -10 0 -5 -13 -10 -30 -10 -37 0 -38 -14 -3 -37 l27 -18 -38 -5 c-34 -4 -41 -9 -52 -42 -13 -37 -12 -38 11 -38 18 0 25 8 33 38 l10 37 7 -33 c7 -31 9 -32 26 -16 10 9 21 25 24 35 3 10 14 20 23 22 16 4 16 5 0 6 -21 1 -24 27 -5 34 10 4 10 6 0 6 -7 1 -13 10 -13 21 0 17 7 20 44 20 24 0 51 3 60 6 11 4 16 0 16 -14 0 -17 -8 -22 -37 -25 l-38 -4 43 -1 c34 -2 42 -6 42 -21 0 -12 -8 -21 -22 -24 -20 -4 -19 -4 5 -6 26 -1 27 0 27 55 l0 57 -71 -5 c-69 -5 -72 -5 -98 24 l-27 30 4 -41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19dMTsiT",
    d: "M4490 1780 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHUyqMOPH",
    d: "M4370 1770 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGXEpKFEK",
    d: "M2653 1752 c-24 -15 -43 -30 -43 -34 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 9 0 15 9 15 25 0 31 -5 31 -57 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOFjzLlcD",
    d: "M6948 1743 c-16 -2 -28 -10 -28 -17 0 -17 32 -26 85 -25 31 0 36 2 20 9 -17 7 -17 9 -2 9 9 1 17 8 17 16 0 15 -29 18 -92 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DdRNxo0k",
    d: "M3858 1696 c-173 -37 -241 -56 -199 -56 15 0 360 76 406 89 76 22 -26 6 -207 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQIsbrsz2",
    d: "M7260 1730 c0 -5 16 -10 35 -10 19 0 35 5 35 10 0 6 -16 10 -35 10 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BWQA0XEO",
    d: "M7143 1723 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poylV85Ux",
    d: "M7760 1707 c0 -7 -13 -34 -30 -60 -25 -40 -34 -47 -62 -47 -48 0 -78 -10 -78 -26 0 -9 12 -14 34 -14 28 0 35 -4 40 -25 5 -20 13 -25 36 -25 25 0 30 -4 30 -25 0 -21 5 -25 30 -25 25 0 30 -4 30 -25 0 -21 5 -25 30 -25 25 0 30 -4 30 -25 0 -22 4 -25 34 -25 32 0 35 -3 38 -32 2 -25 8 -34 24 -36 12 -2 24 -12 27 -23 4 -16 13 -19 69 -18 34 1 50 4 33 6 -16 3 -52 23 -80 46 -278 231 -307 258 -286 264 11 3 21 12 21 20 0 8 4 12 9 8 6 -3 20 8 32 25 17 22 26 27 35 19 7 -6 22 -9 33 -7 20 3 20 4 -6 37 l-27 35 -7 -25 c-6 -22 -7 -21 -8 9 -1 21 -6 32 -16 32 -8 0 -15 -6 -15 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EKCVDCEw",
    d: "M7135 1700 c28 -12 75 -12 75 0 0 6 -21 10 -47 9 -36 0 -43 -3 -28 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psRmwIz3F",
    d: "M7260 1700 c0 -5 16 -10 35 -10 19 0 35 5 35 10 0 6 -16 10 -35 10 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p55caP9mG",
    d: "M3543 1653 c-15 -3 -23 -12 -23 -24 0 -22 6 -23 66 -8 82 21 44 49 -43 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pabT3oGg8",
    d: "M2428 1643 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOwv1dSXh",
    d: "M2278 1623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUQ43zZmO",
    d: "M3430 1610 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJAqyX8ft",
    d: "M2198 1613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peOXovKIk",
    d: "M3340 1590 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTo8k9nVE",
    d: "M2048 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcd3m7aM3",
    d: "M1968 1583 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pN9JXmTiU",
    d: "M3250 1570 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piCkm3OPw",
    d: "M7518 1583 c-31 -8 -19 -23 17 -23 24 0 35 5 35 15 0 15 -17 17 -52 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDJIrbW8o",
    d: "M7420 1570 c-21 -7 -19 -8 18 -9 23 -1 42 4 42 9 0 12 -24 12 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMhpsLVIk",
    d: "M1818 1563 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyUEhbHa1",
    d: "M3160 1550 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDCR7Gs5c",
    d: "M1738 1553 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxhj8m1up",
    d: "M7930 1539 c0 -30 31 -62 55 -57 13 2 10 11 -19 43 -34 39 -35 39 -36 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3cTzsHrU",
    d: "M3070 1530 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkwO9t4Zg",
    d: "M1558 1533 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwOGsWRWq",
    d: "M2400 1520 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdr0yQS2S",
    d: "M2273 1523 c-35 -3 -43 -8 -43 -25 0 -18 4 -19 53 -13 88 10 107 16 107 31 0 14 -20 15 -117 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPGxfZKPF",
    d: "M2980 1510 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ6SYC2Gu",
    d: "M1398 1513 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzprDTUbu",
    d: "M2492 1508 c3 -7 19 -18 36 -25 31 -13 32 -12 32 12 0 22 -4 25 -36 25 -23 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prhIRt6DH",
    d: "M2150 1490 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyxav14mb",
    d: "M2890 1490 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZgrhxTel",
    d: "M2060 1480 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10NqGW7yq",
    d: "M6495 1455 c-154 -24 -283 -44 -287 -44 -5 -1 -8 -8 -8 -16 0 -17 39 -19 110 -5 29 5 47 5 51 -2 8 -12 69 -1 69 13 0 5 12 9 26 9 24 0 274 57 349 79 l30 9 -30 0 c-16 0 -156 -20 -310 -43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BU00ask5",
    d: "M1215 1485 c-5 -2 -27 -6 -47 -10 -24 -4 -38 -11 -38 -20 0 -17 15 -18 84 -9 36 5 46 11 46 25 0 18 -18 23 -45 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyoqcH9Qg",
    d: "M1980 1470 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptcgRl9ey",
    d: "M2620 1476 c0 -18 32 -26 110 -26 78 0 110 8 110 26 0 11 -23 14 -110 14 -87 0 -110 -3 -110 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1852zejqH",
    d: "M1890 1460 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPwhowuTK",
    d: "M1810 1450 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj2GZrmE0",
    d: "M5048 1456 c-71 -22 -127 -96 -99 -130 6 -7 25 -16 42 -20 32 -6 31 -26 -1 -26 -13 0 -17 -5 -14 -15 4 -9 19 -15 35 -15 19 0 29 -5 29 -15 0 -9 -9 -15 -25 -15 -18 0 -25 -5 -25 -20 0 -25 22 -26 62 -2 28 16 30 20 24 65 -4 40 -2 50 16 67 12 11 25 20 30 20 4 0 8 5 8 10 0 16 -60 12 -76 -5 -18 -17 -43 -19 -64 -4 -11 8 -12 12 -2 16 6 2 12 13 12 24 0 14 7 19 25 19 14 0 25 5 25 10 0 6 7 10 15 10 9 0 15 -9 15 -25 0 -22 4 -25 38 -25 35 1 36 1 17 16 -15 11 -17 18 -9 32 25 40 -6 51 -78 28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2CmTC0na",
    d: "M1683 1453 c-35 -3 -43 -8 -43 -25 0 -18 4 -19 53 -13 88 10 107 16 107 31 0 14 -20 15 -117 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDNwc2Jqc",
    d: "M5358 1449 c15 -8 20 -18 17 -30 -3 -9 -1 -20 5 -24 23 -14 8 -26 -26 -19 -35 6 -35 6 -22 -15 7 -11 23 -21 35 -21 13 0 24 -8 28 -20 5 -16 15 -20 46 -20 33 0 39 3 39 21 0 16 -6 20 -27 19 -45 -3 -47 -1 -17 22 l28 22 -25 7 c-23 7 -23 7 -1 8 52 2 3 46 -63 55 -35 6 -37 5 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10kqo9MLn",
    d: "M7653 1418 c19 -46 37 -48 37 -4 0 32 -3 36 -25 36 -24 0 -25 -1 -12 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYjD6gIYu",
    d: "M1560 1420 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgKcJKq9P",
    d: "M878 1423 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0BBVf1fU",
    d: "M1470 1410 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOWNNJKWA",
    d: "M1390 1400 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOFoUaHtO",
    d: "M798 1403 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZKwW79fR",
    d: "M1310 1390 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10mz6XXZa",
    d: "M6128 1403 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGld3EtTA",
    d: "M8067 1396 c-8 -21 92 -130 115 -125 11 3 -1 22 -47 72 -47 51 -64 64 -68 53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8zfMt907",
    d: "M940 1350 c-158 -26 -286 -53 -288 -59 -2 -6 -15 -11 -28 -11 -19 0 -24 5 -24 25 0 24 -1 25 -32 12 -40 -17 -48 -37 -14 -37 14 0 26 -4 26 -10 0 -5 -12 -10 -27 -10 -43 0 -73 -11 -73 -26 0 -8 -10 -14 -25 -14 -14 0 -25 -4 -25 -10 0 -5 -6 -10 -14 -10 -8 0 -17 -8 -19 -17 -3 -11 -5 -7 -6 10 l-1 28 -47 -32 c-73 -49 -103 -80 -103 -107 0 -19 3 -22 13 -13 8 6 17 8 20 5 4 -4 59 26 124 67 171 107 248 127 871 225 19 3 32 11 32 19 0 23 -47 18 -360 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxUrr43SM",
    d: "M6028 1393 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEsd6wjDb",
    d: "M5928 1383 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p23i6nJZP",
    d: "M5828 1373 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pymiNLK9M",
    d: "M5728 1363 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p38sMKdE3",
    d: "M6360 1360 c0 -5 6 -10 14 -10 8 0 16 -4 18 -10 2 -5 18 -12 36 -16 25 -5 32 -3 32 9 0 9 -16 19 -44 26 -55 13 -56 13 -56 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYqglhZz8",
    d: "M5618 1353 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EXErr573",
    d: "M5518 1343 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p071zwBsD",
    d: "M6100 1330 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8CYYRjoD",
    d: "M5930 1310 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Fqvxokvn",
    d: "M6492 1314 c2 -9 19 -22 38 -28 19 -7 72 -36 118 -64 46 -29 92 -52 103 -52 13 0 19 -7 19 -23 0 -14 24 -49 65 -92 64 -70 64 -70 65 -39 0 25 -13 46 -66 103 -75 81 -121 115 -231 172 -83 42 -117 49 -111 23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pllbQHi6H",
    d: "M5840 1300 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKRmuZI7K",
    d: "M5670 1280 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pymviPH1V",
    d: "M5580 1270 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3WYdFQI5",
    d: "M7126 1223 c87 -124 125 -173 131 -173 3 0 1 6 -4 13 -5 6 -45 60 -88 120 -43 59 -80 107 -82 107 -3 0 17 -30 43 -67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ6X0Smq1",
    d: "M7714 1282 c-9 -5 -7 -19 5 -51 21 -58 45 -68 39 -17 -4 32 -2 36 19 36 16 0 23 6 23 20 0 16 -7 20 -37 20 -21 0 -43 -4 -49 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Dj0Agskn",
    d: "M4908 1273 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9Wy41iKI",
    d: "M7810 1266 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7VrdbInF",
    d: "M4808 1263 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDW0LNGGP",
    d: "M5410 1250 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnN9WQOhh",
    d: "M4718 1253 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19eKMUJjM",
    d: "M4618 1243 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOsC40fHk",
    d: "M5354 1218 c10 -53 19 -53 29 0 6 28 4 32 -14 32 -19 0 -21 -4 -15 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWv7vgT5l",
    d: "M4528 1233 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19UB2s7pd",
    d: "M4438 1223 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKgMekDc6",
    d: "M5271 1204 c-2 -57 12 -184 20 -184 9 0 3 83 -11 170 -6 36 -8 39 -9 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppmOnYrvu",
    d: "M4348 1213 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0IYIeGD8",
    d: "M855 1201 c-39 -6 -40 -7 -43 -48 -2 -24 -1 -43 2 -43 3 0 30 9 61 21 49 18 55 23 55 50 0 31 -1 31 -75 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FkbOIeEk",
    d: "M4248 1203 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPYNfpHiK",
    d: "M4158 1193 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXIptWh8S",
    d: "M4798 1193 c-61 -4 -68 -6 -68 -24 0 -19 4 -20 39 -14 29 5 49 1 80 -14 39 -21 101 -29 101 -13 0 4 -12 15 -26 23 l-26 16 28 7 c22 6 25 9 13 17 -7 5 -27 8 -44 7 -16 -1 -60 -3 -97 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p107tyfZzR",
    d: "M4058 1183 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBiAWhJxI",
    d: "M3968 1173 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2vqLwlTU",
    d: "M4640 1160 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph2Ztg5Hr",
    d: "M3878 1163 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxrKOilBb",
    d: "M4540 1150 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6ELRlV8u",
    d: "M5360 1138 c0 -42 10 -78 21 -78 10 0 12 54 3 88 -9 33 -24 27 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15HCuPjDQ",
    d: "M3778 1153 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pH1VBbr3Y",
    d: "M4450 1140 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfX2Rm0tt",
    d: "M5063 1124 c3 -20 9 -39 12 -42 12 -12 17 9 11 43 -9 47 -31 47 -23 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pinXudBIv",
    d: "M3688 1143 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FEUMkNWu",
    d: "M3598 1133 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFghbgKvw",
    d: "M3508 1123 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poNL35JVU",
    d: "M3408 1113 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjTG9tTCD",
    d: "M3318 1103 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12I2FzMX6",
    d: "M3218 1093 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pa9DPojEJ",
    d: "M3128 1083 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwUf22Le8",
    d: "M5018 1083 c-27 -7 -22 -18 16 -38 30 -16 34 -24 38 -67 3 -27 8 -51 12 -55 14 -14 18 10 11 75 -6 61 -10 71 -31 81 -14 6 -26 10 -27 10 -1 -1 -10 -3 -19 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13dbPChRB",
    d: "M3038 1073 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHgvAa0oZ",
    d: "M3690 1060 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pelI47885",
    d: "M7783 1048 c15 -37 37 -49 37 -20 0 34 -11 52 -31 52 -17 0 -18 -3 -6 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9hjyshGs",
    d: "M2938 1063 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14XEuCFOX",
    d: "M3580 1061 c0 -5 -10 -11 -22 -13 -13 -2 -24 -10 -26 -19 -4 -20 61 -39 98 -28 22 6 21 7 -10 8 -43 2 -79 21 -40 21 41 0 70 11 70 26 0 9 -12 14 -35 14 -19 0 -35 -4 -35 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HlEdHMPe",
    d: "M4530 1047 c0 -18 12 -29 55 -50 55 -27 115 -36 115 -17 0 9 -92 60 -146 80 -21 8 -24 7 -24 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3ZU3Cxzx",
    d: "M2848 1053 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBwq2VEfE",
    d: "M2758 1043 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnWc1CUpy",
    d: "M3400 1030 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkibDwIms",
    d: "M5370 1018 c0 -42 10 -78 21 -78 10 0 12 54 3 88 -9 33 -24 27 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMSf8SGBQ",
    d: "M2658 1033 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAuEkKVFW",
    d: "M3923 1026 c-9 -11 7 -16 87 -30 55 -9 112 -16 127 -17 27 0 27 -1 5 -9 -20 -9 -131 1 -292 26 -24 3 -30 2 -20 -4 8 -5 78 -17 155 -26 77 -10 150 -19 163 -22 19 -4 22 0 22 26 0 25 -4 30 -25 30 -14 0 -25 4 -25 8 0 8 -135 33 -170 32 -8 -1 -20 -7 -27 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pb6GRLamP",
    d: "M2568 1023 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1H7CB08BY",
    d: "M3210 1010 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDNcH8lx5",
    d: "M820 1001 c0 -11 4 -31 10 -46 9 -24 13 -26 67 -23 62 3 61 2 48 66 -5 20 -11 22 -65 22 -53 0 -60 -2 -60 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTXQsOMs5",
    d: "M2478 1013 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPqxwjgto",
    d: "M7292 988 c13 -18 88 -124 167 -235 132 -188 174 -240 158 -201 -10 27 -331 468 -341 468 -4 0 3 -15 16 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peo8Jfqmv",
    d: "M270 995 c0 -16 30 -35 55 -35 26 0 12 23 -23 37 -27 11 -32 11 -32 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peJSO4ce2",
    d: "M559 988 c-1 -17 -3 -18 -6 -5 -5 20 -13 21 -48 5 -16 -7 -24 -17 -20 -26 4 -12 3 -13 -10 -2 -13 10 -15 9 -15 -9 0 -16 -6 -21 -25 -21 -14 0 -25 -5 -25 -10 0 -13 83 -50 111 -50 10 0 19 -5 19 -10 0 -6 15 -17 33 -25 29 -12 33 -12 37 3 4 13 12 16 40 11 l35 -6 -32 -2 c-38 -1 -45 -25 -10 -35 37 -10 47 -7 47 15 0 19 4 20 33 15 17 -4 96 -9 175 -13 140 -5 142 -5 142 16 0 20 -4 21 -114 21 -66 0 -172 9 -248 20 -180 28 -174 26 -174 49 0 15 3 17 13 9 7 -5 21 -7 30 -3 17 7 26 9 65 13 21 2 13 38 -10 46 -10 3 -23 9 -29 12 -8 4 -13 -3 -14 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIBCRr1U0",
    d: "M2378 1003 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HmnXpMCE",
    d: "M3020 990 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p76UKpzUx",
    d: "M3700 1000 c0 -5 24 -10 53 -9 38 0 47 3 32 9 -28 12 -85 12 -85 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pthfQspAz",
    d: "M2288 993 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZGz4L6RX",
    d: "M2930 980 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Bgu1uY5d",
    d: "M2188 983 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9jX7BNOL",
    d: "M2098 973 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Gv45mN2j",
    d: "M2740 960 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15ixEIWLd",
    d: "M2008 963 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7hsp8xFz",
    d: "M2650 950 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZ2b1C9Cr",
    d: "M1918 953 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF0H645hR",
    d: "M1818 943 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2mhZoooX",
    d: "M2460 930 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjqzjNK2H",
    d: "M4780 926 c0 -26 17 -36 61 -36 50 0 34 24 -35 50 -23 9 -26 7 -26 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8EwVjC2n",
    d: "M5280 936 c0 -51 14 -106 28 -106 11 0 13 7 8 31 -3 17 -6 44 -6 60 0 19 -5 29 -15 29 -8 0 -15 -6 -15 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G38fySqe",
    d: "M1728 933 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjhxGlNto",
    d: "M2370 920 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWqkr1GOk",
    d: "M4250 926 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puQ3dzpt3",
    d: "M1628 923 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GP9fJWvp",
    d: "M1538 913 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOJ82SlTv",
    d: "M2180 900 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0DsMRKjS",
    d: "M1448 903 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHanWNQTi",
    d: "M2090 890 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKDW3RnOu",
    d: "M7847 865 c25 -75 54 -76 33 0 -9 32 -18 45 -31 45 -17 0 -17 -3 -2 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxCAQHBfc",
    d: "M1348 893 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKmEt5mEP",
    d: "M4370 886 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg7ycWz7K",
    d: "M5080 865 c0 -19 -2 -35 -4 -35 -5 0 -21 6 -103 39 l-53 21 0 -25 c0 -20 5 -25 25 -25 14 0 25 -4 25 -10 0 -5 11 -10 25 -10 14 0 25 -4 25 -9 0 -5 8 -12 18 -14 13 -4 11 -5 -5 -6 -19 -1 -23 -7 -23 -36 0 -33 2 -35 35 -35 28 0 35 4 35 20 0 11 -5 20 -11 20 -6 0 -4 7 5 15 8 8 19 15 25 15 12 0 14 51 5 88 -10 34 -24 26 -24 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPtKrWef1",
    d: "M1258 883 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15xoYDbjc",
    d: "M1900 870 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2kt5AstH",
    d: "M5386 840 c6 -47 5 -49 -19 -55 -30 -8 -47 0 -47 21 0 8 -7 14 -15 14 -10 0 -15 -11 -15 -35 l0 -35 60 0 c47 0 60 3 60 15 0 9 10 15 23 16 15 1 17 3 6 6 -21 5 -30 36 -22 74 5 25 2 29 -16 29 -20 0 -21 -3 -15 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AyWVPA0I",
    d: "M1168 873 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUhBLVlMD",
    d: "M1810 860 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15djAiRiN",
    d: "M1068 863 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcU2tuaO",
    d: "M4470 857 c0 -14 285 -103 365 -114 46 -6 47 -5 34 15 -10 16 -28 23 -69 28 -30 4 -58 11 -61 16 -3 5 -26 12 -50 15 -24 3 -47 10 -50 16 -4 5 -27 12 -53 14 -25 3 -46 10 -46 14 0 5 -16 9 -35 9 -22 0 -35 -5 -35 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G7qmNdGb",
    d: "M1620 840 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQHXkHqNT",
    d: "M1530 830 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6Qrpl4e1",
    d: "M1340 810 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10q4G3Hbv",
    d: "M5540 806 c0 -26 16 -36 61 -36 40 0 36 12 -10 38 -48 27 -51 27 -51 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CWNa8ZGC",
    d: "M1150 790 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptFiCsmiC",
    d: "M850 786 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkTYEshY4",
    d: "M1060 780 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIbsj62wQ",
    d: "M7150 765 c0 -41 66 -108 101 -103 21 3 18 8 -38 68 -62 65 -62 65 -63 35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pULoAQsec",
    d: "M4410 771 c0 -9 75 -31 105 -31 28 0 5 20 -23 21 -24 0 -25 1 -7 9 15 6 8 9 -27 9 -27 1 -48 -3 -48 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pemkCtoBN",
    d: "M5148 773 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWPSCfgSL",
    d: "M5660 766 c0 -10 13 -17 38 -21 20 -4 70 -13 111 -21 88 -17 81 -17 81 0 0 13 -77 34 -187 51 -35 6 -43 4 -43 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLk8i6VLY",
    d: "M4703 733 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn464jln5",
    d: "M4798 723 c38 -4 62 -23 27 -23 -8 0 -15 -7 -15 -15 0 -10 11 -15 35 -15 30 0 35 3 35 24 0 18 -7 25 -31 30 -17 3 -46 5 -63 4 -23 -1 -21 -2 12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pptURA88W",
    d: "M7973 505 c38 -113 67 -209 63 -212 -4 -4 -49 -10 -101 -13 -52 -3 -98 -10 -102 -14 -8 -8 228 2 237 11 2 2 -27 99 -66 216 -48 143 -75 213 -86 215 -11 2 2 -48 55 -203z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJUctvGo2",
    d: "M4713 668 c-18 -6 -33 -15 -33 -19 0 -5 -7 -9 -16 -9 -27 0 -74 -33 -74 -52 0 -23 -1 -23 57 6 26 14 67 30 91 38 28 9 42 19 42 30 0 20 -18 21 -67 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12xBrciFv",
    d: "M6020 651 c0 -26 4 -31 25 -31 35 0 32 18 -7 49 -16 12 -18 11 -18 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prDno5Uwr",
    d: "M5848 605 c-6 -14 -17 -24 -24 -21 -7 3 -41 7 -76 10 l-63 5 53 -13 c29 -8 59 -19 67 -26 9 -7 26 -9 45 -5 26 6 30 11 30 41 0 40 -16 44 -32 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6jtSS8FF",
    d: "M4715 596 l-50 -24 53 -1 c49 -1 52 0 52 24 0 14 -1 25 -2 25 -2 0 -25 -11 -53 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4X2wsZNk",
    d: "M4516 547 c-37 -49 -41 -107 -8 -139 l23 -23 -12 32 c-9 28 -8 40 11 78 12 24 20 55 18 67 -3 21 -5 20 -32 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzdJjair1",
    d: "M6020 535 c0 -20 -5 -25 -25 -25 -21 0 -25 -5 -25 -31 l0 -30 28 19 c15 11 35 29 46 41 l18 20 39 -22 c21 -12 39 -24 39 -27 0 -5 -188 -60 -205 -60 -5 0 0 7 11 15 18 13 16 14 -23 15 -42 0 -43 -1 -43 -33 l0 -34 91 13 c51 7 95 17 98 22 8 13 80 20 84 9 1 -5 17 -6 35 -2 35 7 44 35 12 35 -13 0 -20 7 -20 20 0 14 -17 28 -60 50 -75 38 -100 39 -100 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHoWlus1S",
    d: "M4579 514 c-26 -30 -39 -61 -38 -91 0 -15 3 -22 6 -15 2 6 11 12 19 12 8 0 14 9 14 19 0 11 5 21 11 23 6 2 9 19 7 37 -3 32 -4 33 -19 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ft4bNDe",
    d: "M5360 505 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psGgPIv0k",
    d: "M5760 510 c-14 -12 -40 -27 -57 -35 -43 -18 -42 -35 2 -35 24 0 35 5 35 15 0 9 9 15 25 15 21 0 25 5 25 30 0 35 2 35 -30 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVlL2gr6F",
    d: "M7378 503 c11 -16 34 -41 51 -57 l31 -30 0 29 c0 36 -45 85 -78 85 l-23 0 19 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdo6yGhHl",
    d: "M6413 473 c-24 -2 -43 -9 -43 -14 0 -12 100 -1 115 12 5 5 1 8 -10 7 -11 -1 -39 -3 -62 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G2HKhwk6",
    d: "M6288 463 c-10 -2 -18 -9 -18 -14 0 -15 63 -6 68 9 4 12 -16 14 -50 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYBw3XBtu",
    d: "M5190 425 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQKLvegrN",
    d: "M5553 405 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16HL7cW50",
    d: "M5780 390 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppcGnpzBn",
    d: "M7520 384 c0 -18 7 -37 15 -44 8 -7 15 -16 15 -20 0 -4 -74 -22 -165 -40 -91 -18 -164 -35 -162 -37 7 -6 381 50 392 59 6 5 -11 29 -43 61 l-52 52 0 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWjmPSEtM",
    d: "M5463 365 c-41 -18 -42 -35 -3 -35 20 0 30 -5 30 -15 0 -18 4 -18 70 -4 34 7 50 16 50 26 0 13 -9 15 -54 9 -49 -5 -55 -4 -58 13 -3 18 -5 18 -35 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p79WQrijp",
    d: "M5670 360 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDej5sVPm",
    d: "M4582 358 c3 -7 19 -18 36 -25 31 -13 32 -12 32 12 0 22 -4 25 -36 25 -23 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcCnqAuUj",
    d: "M5318 312 c-67 -22 -65 -46 2 -40 59 6 66 11 54 36 -8 18 -12 18 -56 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AS8qIwGD",
    d: "M4770 306 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0INfYSXi",
    d: "M5195 280 c-16 -7 -13 -9 18 -9 20 -1 37 4 37 9 0 12 -27 12 -55 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph0rBJ63y",
    d: "M7685 260 c-15 -6 -7 -9 30 -9 28 0 59 4 70 9 15 6 7 9 -30 9 -27 0 -59 -4 -70 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poSGzpHCL",
    d: "M7535 250 c-16 -7 -13 -9 15 -9 19 0 44 4 55 9 16 7 13 9 -15 9 -19 0 -44 -4 -55 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8sZfsDtV",
    d: "M7433 243 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYb8q0FGG",
    d: "M7323 233 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l448Nv0uMtT7a8Ui3Ild7Of",
    fill: "rgb(136,136,136)",
    style: {
      transform: "none"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pdNM6LXie",
    d: "M5153 2663 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTl8PrAMO",
    d: "M4966 2649 c-76 -8 -95 -13 -84 -24 6 -7 169 16 188 26 18 10 9 10 -104 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbzVTWLnw",
    d: "M3755 2643 c-70 -8 -95 -15 -95 -24 0 -7 24 -8 69 -3 l69 6 7 -33 c5 -19 10 -28 12 -21 3 6 11 12 19 12 15 0 17 12 8 48 -6 23 -16 24 -89 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcaP4H5Zp",
    d: "M4813 2633 c-15 -3 -23 -12 -23 -24 0 -23 1 -23 45 -2 55 26 44 39 -22 26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16BkKW6Jm",
    d: "M3598 2623 c-20 -5 -24 -23 -5 -23 24 0 57 12 57 21 0 9 -22 10 -52 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p82i8RGlI",
    d: "M4718 2623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p06RjzDHR",
    d: "M3503 2613 c-13 -2 -23 -9 -23 -15 0 -6 12 -8 31 -4 17 3 35 6 40 6 5 0 9 5 9 10 0 10 -16 11 -57 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1En2tODdS",
    d: "M4608 2613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyMJIevG9",
    d: "M3413 2603 c-13 -2 -23 -9 -23 -15 0 -6 12 -8 31 -4 17 3 35 6 40 6 5 0 9 5 9 10 0 10 -16 11 -57 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GZ5mRHPJ",
    d: "M4508 2603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pb87HeQqW",
    d: "M3335 2595 c-5 -2 -40 -6 -77 -10 -38 -4 -68 -11 -68 -17 0 -6 15 -8 38 -4 20 3 63 8 95 11 31 4 57 11 57 16 0 9 -25 11 -45 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvR8zHAaE",
    d: "M4408 2593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZxWMjFL3",
    d: "M2910 2569 c-84 -8 -93 -16 -109 -91 -12 -56 -6 -98 15 -98 10 0 14 13 14 45 0 25 6 61 14 79 13 32 18 34 88 46 40 6 84 15 98 20 23 8 22 8 -10 8 -19 0 -69 -4 -110 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18uN5Vp3U",
    d: "M4273 2565 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjQxGsUXt",
    d: "M3146 2538 c-10 -38 -7 -48 14 -48 16 0 20 7 20 35 0 40 -24 49 -34 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxPtITJip",
    d: "M4633 2553 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9IBOk6BD",
    d: "M3800 2505 c-6 -16 -17 -25 -32 -25 -12 0 -47 -5 -77 -10 -54 -10 -364 -59 -406 -64 -19 -2 -36 -46 -18 -46 4 0 125 20 269 44 246 42 265 43 323 31 33 -7 61 -11 61 -9 0 2 -18 11 -40 20 -25 10 -39 22 -38 32 4 55 -24 74 -42 27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2D40coBC",
    d: "M4767 2478 c-31 -17 -56 -33 -54 -34 4 -5 117 56 117 62 0 6 -1 6 -63 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16fm6zpaF",
    d: "M4073 2475 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf0EiCGEr",
    d: "M3375 2454 c-88 -13 -175 -23 -194 -24 -30 0 -33 -2 -29 -25 6 -29 14 -26 -150 -53 -62 -11 -115 -16 -117 -11 -5 7 33 17 128 34 31 6 36 10 26 22 -7 8 -25 13 -39 11 -15 -1 -34 3 -43 10 -13 11 -17 10 -25 -4 -9 -16 -10 -15 -17 5 -8 26 -25 18 -26 -12 0 -19 -2 -18 -11 6 -15 42 -32 27 -38 -34 l-5 -54 -80 -13 c-44 -6 -95 -14 -112 -17 -19 -4 -33 -12 -33 -20 0 -7 -5 -15 -10 -17 -6 -2 -11 -12 -11 -23 1 -60 9 -123 18 -146 l11 -26 -92 -17 c-89 -17 -93 -18 -88 -42 2 -14 0 -24 -7 -24 -6 0 -11 -5 -11 -11 0 -13 62 -39 95 -39 42 0 29 26 -22 40 l-46 13 44 13 c24 6 61 15 82 18 20 4 37 11 37 17 0 5 11 7 24 3 14 -3 34 1 48 9 12 8 101 34 197 58 156 39 197 56 178 75 -3 3 -79 -11 -169 -31 -234 -54 -238 -54 -238 -40 0 7 60 24 160 45 88 18 158 35 156 37 -3 4 -232 -36 -307 -53 -26 -6 -26 -6 -23 47 3 35 0 55 -8 60 -20 13 -6 19 78 35 44 8 97 19 119 25 35 10 41 9 53 -9 12 -18 17 -19 40 -9 15 6 29 14 32 18 9 11 59 17 62 7 5 -15 180 18 193 36 7 9 17 16 24 16 6 0 11 9 11 20 0 14 -7 20 -22 20 -51 0 0 12 168 40 204 34 220 38 179 38 -16 0 -102 -11 -190 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1C8RMLE3G",
    d: "M4483 2473 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvsWT23pT",
    d: "M3941 2417 c-66 -27 -77 -47 -27 -47 20 0 36 5 36 10 0 6 11 10 25 10 20 0 25 5 25 25 0 14 -1 25 -2 25 -2 -1 -27 -11 -57 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgt2bjnPh",
    d: "M4608 2392 c-36 -21 -152 -109 -257 -196 -166 -138 -189 -161 -180 -177 13 -25 29 -24 29 2 0 11 15 33 33 49 238 206 333 283 387 314 71 42 78 46 64 46 -5 -1 -39 -18 -76 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgiJbuODr",
    d: "M4373 2413 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pG3RhRZXN",
    d: "M3803 2355 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6cBRedu8",
    d: "M4250 2325 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIZOk9EqV",
    d: "M3713 2315 c-18 -8 -33 -19 -33 -26 0 -6 -6 -9 -13 -6 -7 3 -24 -1 -38 -8 -27 -15 -24 -17 51 -34 41 -10 40 -10 -22 -5 -86 7 -89 -9 -4 -24 101 -19 106 -18 106 23 0 31 -3 35 -27 36 -24 2 -25 2 -5 6 15 3 22 11 22 29 0 13 -1 24 -2 24 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZY2oZCP8",
    d: "M4140 2265 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYeS35607",
    d: "M2390 2260 c-12 -8 -11 -10 5 -9 11 1 34 5 50 9 l30 8 -35 1 c-19 0 -42 -4 -50 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5mlUIRut",
    d: "M2308 2249 c-22 -12 -23 -29 -3 -29 8 0 15 5 15 10 0 6 9 10 20 10 11 0 20 5 20 10 0 13 -30 12 -52 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp0DPTW3t",
    d: "M2985 2245 c48 -16 75 -18 75 -6 0 12 -37 21 -80 20 l-35 -1 40 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf1m6BhKl",
    d: "M3090 2240 c-22 -6 -21 -8 15 -11 l40 -4 -37 -17 c-48 -21 -49 -38 -3 -38 19 0 35 5 35 10 0 6 9 10 20 10 16 0 20 7 20 30 0 27 -3 30 -32 29 -18 -1 -44 -4 -58 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX5SVTl0E",
    d: "M4037 2223 c-4 -3 -7 -19 -7 -35 0 -25 -3 -28 -35 -28 -32 0 -35 -2 -35 -30 0 -28 -3 -30 -35 -30 -33 0 -35 -2 -35 -31 0 -29 2 -30 17 -18 41 32 203 172 203 175 0 7 -67 4 -73 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOYwZJZmb",
    d: "M3230 2207 c0 -8 16 -18 35 -24 33 -11 35 -10 35 13 0 21 -5 24 -35 24 -22 0 -35 -5 -35 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BNXqZZM",
    d: "M2276 2178 c-14 -53 -3 -128 19 -128 7 0 16 6 18 13 3 7 6 6 6 -5 2 -39 87 -32 97 9 7 28 -3 44 -15 24 -7 -10 -10 -9 -16 8 -8 28 -25 27 -25 -1 -1 -21 -2 -20 -17 7 -9 17 -18 25 -20 18 -3 -7 -9 -13 -15 -13 -7 0 -8 16 -4 45 6 36 4 45 -7 45 -8 0 -17 -10 -21 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0O8eJtB",
    d: "M3340 2159 l25 -10 -27 -15 c-38 -20 -35 -34 7 -34 33 0 35 2 35 35 0 33 -2 35 -32 34 -32 0 -33 0 -8 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1G9wmFgJc",
    d: "M2448 2083 c-10 -2 -18 -11 -18 -20 0 -12 7 -14 37 -8 50 9 61 17 37 26 -21 8 -31 9 -56 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2rKhAVC7",
    d: "M3133 2035 c-59 -27 -68 -45 -23 -45 46 0 80 20 80 47 0 12 -1 23 -2 23 -2 0 -27 -11 -55 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2bJnt46B",
    d: "M3810 1995 c0 -30 3 -35 23 -35 34 0 67 11 67 22 0 6 -14 8 -36 3 l-37 -6 29 25 29 25 -37 1 c-37 0 -38 -1 -38 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11s2g9Pvy",
    d: "M2340 2008 c0 -5 16 -8 35 -8 19 0 35 4 35 9 0 5 -16 9 -35 8 -19 -1 -35 -5 -35 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXRtSol3P",
    d: "M3978 2008 c-32 -6 -58 -14 -58 -19 0 -13 16 -11 95 10 75 21 56 25 -37 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWcjV3Y2k",
    d: "M7755 2000 c-94 -19 -250 -76 -253 -93 -3 -14 12 -11 95 19 124 46 156 53 202 48 28 -3 32 -2 16 5 -17 8 -18 10 -2 10 9 1 17 6 17 11 0 11 -18 11 -75 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5ybrdesu",
    d: "M7968 2003 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pk9IGIh0V",
    d: "M8075 2000 l30 -8 -27 -1 c-16 0 -28 -6 -28 -12 0 -8 12 -9 38 -4 20 4 35 5 32 2 -3 -2 -72 -33 -155 -67 -170 -72 -158 -65 -154 -79 2 -6 76 22 164 62 88 40 174 79 190 86 28 12 28 14 10 22 -11 4 -45 7 -75 7 -45 0 -50 -2 -25 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPoxSqMQG",
    d: "M3020 1980 c-22 -14 -6 -22 50 -28 33 -3 50 -1 50 7 0 6 -9 11 -20 11 -11 0 -20 5 -20 10 0 13 -40 13 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9IXMeSEb",
    d: "M7965 1980 c-16 -7 -13 -9 18 -9 20 -1 37 4 37 9 0 12 -27 12 -55 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxJ1GzgWq",
    d: "M2700 1945 c0 -8 6 -15 14 -15 7 0 28 -3 45 -6 24 -5 31 -3 31 9 0 8 -13 17 -31 21 -47 9 -59 7 -59 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVrAkdLPC",
    d: "M2860 1935 c0 -8 7 -15 15 -15 26 0 17 -14 -25 -40 -22 -14 -40 -28 -40 -32 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 5 10 11 10 14 0 39 25 39 39 0 6 14 11 30 11 36 0 41 25 8 34 -46 12 -108 7 -108 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSPsb2N7e",
    d: "M3010 1930 c0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 16 -10 35 -10 40 0 49 24 13 34 -36 9 -88 7 -88 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p38Qdjs3K",
    d: "M4221 1913 c24 -63 42 -83 76 -83 26 0 33 4 33 20 0 13 -7 20 -19 20 -11 0 -28 15 -41 35 -27 44 -65 50 -49 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19qKFZ9GD",
    d: "M5008 1933 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6OjqZhxb",
    d: "M5730 1920 c0 -17 7 -20 45 -20 49 0 64 23 23 34 -45 12 -68 7 -68 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmNWxw6nL",
    d: "M5920 1910 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxVPVSDpE",
    d: "M4788 1913 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8LiyxaZo",
    d: "M6070 1900 c0 -18 -7 -20 -85 -20 -66 0 -85 -3 -85 -14 0 -18 31 -26 108 -26 55 0 62 2 62 20 0 16 7 20 35 20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pM5Ne7lqO",
    d: "M4688 1903 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plJeKeTMg",
    d: "M6210 1890 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pN9vXDtzX",
    d: "M4588 1893 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAirBpXIw",
    d: "M6360 1880 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HlliM1MN",
    d: "M7370 1882 c-50 -16 -55 -20 -58 -50 -3 -31 -2 -32 32 -32 20 0 36 5 36 10 0 6 12 11 28 12 16 0 10 3 -18 7 l-45 6 54 20 c54 20 80 46 44 44 -10 0 -43 -8 -73 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plIhYdzGI",
    d: "M6500 1873 c0 -25 67 -43 165 -43 60 0 75 3 75 15 0 8 -1 15 -2 16 -2 0 -43 4 -93 9 -49 5 -102 12 -117 16 -23 5 -28 3 -28 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pO70IFDix",
    d: "M7690 1857 c-62 -25 -87 -30 -142 -28 -43 1 -68 -2 -68 -8 0 -6 -11 -11 -25 -11 -14 0 -25 -4 -25 -10 0 -5 -11 -10 -25 -10 -14 0 -28 -7 -31 -15 -4 -9 -19 -15 -35 -15 -16 0 -29 -4 -29 -10 0 -5 -19 -10 -42 -11 -24 0 -61 -4 -83 -8 -33 -7 -23 -9 54 -10 52 0 92 -4 88 -7 -3 -4 -46 -6 -94 -6 -55 1 -81 -2 -68 -7 26 -11 295 -20 295 -10 0 4 -20 9 -45 11 -44 3 -40 6 160 92 182 78 224 99 198 95 -5 -1 -42 -15 -83 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2qBLaecZ",
    d: "M4378 1873 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSLkMCkMx",
    d: "M5660 1860 c0 -16 7 -20 33 -20 47 0 77 10 77 26 0 10 -15 14 -55 14 -48 0 -55 -2 -55 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxGdZFPkX",
    d: "M5347 1863 c-4 -3 -7 -21 -7 -40 0 -26 4 -33 20 -33 11 0 20 -5 20 -11 0 -6 7 -9 15 -5 9 3 15 0 15 -9 0 -9 9 -15 21 -15 31 0 20 30 -20 57 -32 22 -32 23 -10 23 40 0 69 11 69 26 0 10 -15 14 -58 14 -32 0 -62 -3 -65 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQuQasQiK",
    d: "M5200 1839 c0 -20 4 -21 48 -15 l47 7 -32 -20 c-18 -11 -39 -31 -48 -45 -9 -14 -26 -27 -38 -29 -22 -4 -22 -4 1 -6 37 -2 23 -36 -18 -44 -21 -4 -20 -4 8 -6 25 -1 32 -5 32 -20 0 -17 -8 -21 -52 -24 l-53 -3 54 -2 c38 -1 58 -7 68 -19 12 -16 13 -10 8 42 -3 36 -2 55 3 47 5 -8 19 -12 30 -10 21 3 21 3 2 45 -10 23 -16 44 -12 47 3 3 23 6 44 6 37 0 38 1 38 35 l0 35 -65 0 c-59 0 -65 -2 -65 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX75q215C",
    d: "M6760 1845 c0 -8 6 -15 13 -15 6 0 22 -3 35 -6 16 -5 22 -2 22 9 0 8 -10 17 -22 21 -36 9 -48 7 -48 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p138I4405Q",
    d: "M5080 1830 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p52aAlWZ7",
    d: "M4950 1820 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOjJ01EzB",
    d: "M6930 1821 c0 -17 6 -21 30 -21 17 0 30 -4 30 -9 0 -15 58 -21 135 -14 64 5 75 9 75 24 0 22 -16 24 -57 8 -33 -13 -124 -2 -102 12 10 6 5 9 -17 9 -17 0 -46 3 -63 6 -27 6 -31 4 -31 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DYVkxhna",
    d: "M7780 1832 c-8 -3 -42 -17 -75 -32 -33 -15 -98 -43 -144 -62 -87 -35 -123 -67 -61 -53 27 6 32 4 37 -14 7 -27 23 -17 23 15 0 14 7 27 18 31 9 3 33 13 52 21 19 8 43 17 54 19 10 2 31 11 47 20 16 9 31 15 33 12 9 -9 -13 -134 -24 -137 -5 -2 -10 -20 -10 -40 l1 -37 33 39 c19 22 36 34 40 28 3 -5 15 -8 25 -5 19 5 19 7 -5 43 -15 23 -23 46 -20 57 3 10 2 36 -2 59 -5 30 -11 40 -22 36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOMTB3Q8w",
    d: "M4830 1810 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqYYLXn8B",
    d: "M4710 1800 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16ibCxQft",
    d: "M4223 1787 c-18 -10 -33 -23 -33 -27 0 -13 57 -22 90 -15 36 8 41 35 6 35 -14 0 -26 6 -28 13 -2 10 -11 9 -35 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peFgX2KYj",
    d: "M4590 1790 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15H7yyw70",
    d: "M6840 1780 c31 -44 40 -45 40 -6 0 33 -2 36 -31 36 l-30 0 21 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUzG9r6xe",
    d: "M4470 1780 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4JpNhQSG",
    d: "M4350 1770 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18pEOObe8",
    d: "M4148 1755 c-3 -3 -25 -9 -49 -14 l-44 -9 40 -1 c48 -1 85 8 85 20 0 10 -23 12 -32 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13Pf2xqCW",
    d: "M5515 1749 c-15 -7 -8 -8 26 -5 40 5 48 3 52 -14 4 -15 -1 -20 -27 -23 l-31 -4 32 -1 c24 -2 33 -7 36 -24 3 -13 4 0 3 27 -1 50 -1 50 -36 52 -19 1 -44 -2 -55 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZI2TcTd",
    d: "M2593 1712 c-24 -15 -43 -30 -43 -34 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 9 0 15 9 15 25 0 31 -5 31 -57 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8S24hsLq",
    d: "M6960 1726 c0 -16 32 -26 75 -25 30 2 30 2 -5 9 l-35 7 33 2 c52 2 37 21 -18 21 -36 0 -50 -4 -50 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjdt3wZTe",
    d: "M3612 1685 c-14 -31 -15 -55 -3 -55 18 0 146 32 151 37 5 6 -61 -4 -94 -14 -15 -4 -17 -2 -13 11 4 9 10 23 13 31 12 28 -41 18 -54 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HL3T4uCK",
    d: "M3845 1690 c-38 -10 -63 -18 -55 -18 8 -1 49 7 90 17 41 11 66 19 55 19 -11 0 -51 -8 -90 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwGo5MS6v",
    d: "M5061 1680 c0 -19 3 -30 7 -24 4 7 16 14 27 17 19 4 19 5 -2 6 -12 0 -24 9 -26 19 -3 9 -5 1 -6 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcOGLFyDm",
    d: "M5538 1653 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Gv7ULxiG",
    d: "M3493 1643 c-15 -3 -23 -12 -23 -24 0 -22 6 -23 66 -8 82 21 44 49 -43 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyqmHnUTu",
    d: "M2358 1633 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p75cri5eB",
    d: "M5270 1620 c0 -13 7 -20 20 -20 15 0 20 -7 20 -25 0 -21 5 -25 31 -25 34 0 69 15 69 30 0 6 -6 10 -14 10 -8 0 -17 6 -19 13 -4 8 -12 4 -25 -12 l-20 -24 -13 36 c-14 41 -49 52 -49 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "powdgcWtg",
    d: "M3380 1600 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJyYoCIFA",
    d: "M2128 1603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Hc8qMHrS",
    d: "M3290 1580 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p194HU4APA",
    d: "M7650 1565 c0 -24 5 -35 15 -35 8 0 15 -7 15 -15 0 -10 10 -15 30 -15 25 0 30 -4 30 -25 0 -21 5 -25 30 -25 25 0 30 -4 30 -25 0 -21 5 -25 30 -25 25 0 30 -4 30 -25 0 -22 4 -25 37 -25 44 0 50 -7 -97 115 -109 91 -122 105 -96 105 9 0 16 7 16 15 0 10 -11 15 -35 15 -33 0 -35 -2 -35 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pID1pZl9c",
    d: "M1978 1583 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTqyVLfEC",
    d: "M1898 1573 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19DLsHZ4L",
    d: "M3200 1560 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HerYYHFY",
    d: "M7430 1570 c-24 -8 -23 -8 8 -9 17 -1 32 4 32 9 0 11 -5 11 -40 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnDT5zrMq",
    d: "M7920 1549 c0 -30 21 -52 45 -47 13 2 10 10 -14 38 l-30 35 -1 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puNk5zkbU",
    d: "M1748 1553 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pucWHH7lU",
    d: "M3110 1540 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg5e4K0eX",
    d: "M1658 1543 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phGnuE5G",
    d: "M2380 1519 c0 -19 4 -21 43 -15 29 5 55 2 80 -9 37 -15 37 -15 37 9 0 30 -16 36 -96 36 -58 0 -64 -2 -64 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1H7aCltCe",
    d: "M3020 1520 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BHqoHLep",
    d: "M1468 1523 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWbE4tzQa",
    d: "M2300 1510 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMCH8OIpb",
    d: "M2173 1513 c-35 -3 -43 -8 -43 -25 0 -18 4 -19 53 -13 88 10 107 16 107 31 0 14 -20 15 -117 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7oQ4HBWY",
    d: "M2930 1500 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pieyRRdZU",
    d: "M1345 1505 c-5 -2 -27 -6 -47 -10 -24 -4 -38 -11 -38 -20 0 -17 15 -18 84 -9 36 5 46 11 46 25 0 18 -18 23 -45 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ARZA6XDX",
    d: "M2050 1480 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p49ZYB0J8",
    d: "M2560 1486 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvZL6ldhA",
    d: "M2840 1480 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNEWcrZVm",
    d: "M6535 1459 c-328 -50 -315 -47 -315 -66 0 -13 10 -14 65 -8 63 6 65 6 65 -17 0 -20 11 -27 95 -54 87 -28 95 -29 95 -13 0 15 -20 25 -92 46 -88 26 -90 28 -60 37 18 5 32 13 32 17 0 5 6 6 13 4 6 -3 100 17 207 44 107 27 184 49 170 49 -14 0 -137 -17 -275 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUMERRoXL",
    d: "M1960 1470 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcWLplbos",
    d: "M2720 1476 c0 -8 12 -17 26 -20 36 -9 84 2 84 20 0 10 -14 14 -55 14 -40 0 -55 -4 -55 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQEXBLfWe",
    d: "M1880 1460 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psc8r48pU",
    d: "M7643 1448 c19 -46 37 -48 37 -4 0 32 -3 36 -25 36 -24 0 -25 -1 -12 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prWzQ1avI",
    d: "M1088 1463 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19QoboOwq",
    d: "M1790 1450 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pADIgjmmG",
    d: "M5063 1458 c-51 -11 -60 -38 -13 -38 25 0 30 -4 30 -23 0 -32 38 -49 70 -32 l24 13 -33 17 -33 17 21 22 c12 12 21 25 21 29 0 9 -35 7 -87 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pORI3xFyK",
    d: "M1710 1440 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5rEtixb7",
    d: "M5364 1444 c22 -12 26 -18 15 -25 -19 -11 -10 -17 39 -25 34 -5 42 -4 42 9 0 20 -37 43 -85 51 l-40 6 29 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14oAxHOPL",
    d: "M1630 1430 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17LBGk6rW",
    d: "M928 1433 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfUYnUR5p",
    d: "M1540 1420 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14C7YOZwz",
    d: "M1460 1410 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HAItNOPm",
    d: "M8050 1414 c0 -23 43 -68 60 -62 6 2 -4 21 -24 43 -30 34 -35 37 -36 19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZorzvT4d",
    d: "M1380 1400 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po4jzJzpD",
    d: "M1290 1390 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNvu9jCO7",
    d: "M6148 1403 c-25 -6 -23 -33 2 -33 13 0 20 -7 20 -20 0 -21 10 -24 48 -14 25 7 31 34 7 34 -8 0 -15 9 -15 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p144BivRXq",
    d: "M768 1393 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbyZFnabN",
    d: "M968 1357 c-216 -36 -248 -43 -248 -59 0 -10 3 -18 6 -18 4 0 386 63 522 85 19 4 32 12 32 20 0 22 -33 19 -312 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pha9Lp2cW",
    d: "M6048 1393 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4mdB2Uis",
    d: "M4947 1369 c-7 -27 0 -46 20 -53 23 -9 26 -2 19 39 -8 39 -31 47 -39 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfp7cMpoi",
    d: "M5948 1383 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBegvSTeI",
    d: "M5322 1370 c9 -6 19 -24 23 -40 9 -42 35 -39 35 4 0 34 -16 46 -60 46 -12 -1 -12 -2 2 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5DP5gT9A",
    d: "M5848 1373 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT2XH6jj9",
    d: "M5748 1363 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHggLCqH6",
    d: "M5648 1353 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BluCmEno",
    d: "M550 1307 c-128 -57 -229 -127 -186 -127 9 0 16 -9 16 -20 0 -24 4 -25 41 -3 33 20 37 33 12 34 -14 0 -15 2 -3 6 8 3 18 11 22 17 5 7 8 4 8 -6 0 -22 5 -22 41 -1 16 10 27 23 25 30 -3 7 -1 13 3 13 5 0 11 -5 13 -12 6 -17 168 30 168 48 0 9 -11 14 -29 14 -24 0 -30 5 -33 25 l-3 25 -95 -43z m78 -14 c-10 -2 -18 -9 -18 -14 0 -5 -7 -9 -15 -9 -8 0 -15 7 -15 15 0 10 10 15 33 14 17 -1 24 -3 15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4RqXchIQ",
    d: "M5538 1343 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pncwHpa5l",
    d: "M5438 1333 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf5JtjzSX",
    d: "M6010 1320 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p216D9Ygx",
    d: "M5920 1310 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peoorkoE2",
    d: "M5040 1265 c0 -43 -1 -45 -30 -45 -24 0 -30 -4 -30 -21 0 -19 4 -21 33 -14 17 4 40 7 50 7 15 -1 17 6 13 46 -3 26 -5 53 -5 60 -1 6 -8 12 -16 12 -11 0 -15 -12 -15 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV4MrOOB9",
    d: "M5750 1290 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ3Nf5vzK",
    d: "M7703 1278 c19 -46 37 -48 37 -4 0 32 -3 36 -25 36 -24 0 -25 -1 -12 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzQXpoYT",
    d: "M5660 1280 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pv6V83Utb",
    d: "M6580 1280 c0 -11 9 -24 19 -30 23 -12 71 -14 71 -2 0 9 -32 29 -66 42 -20 8 -24 7 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BAZsdFy3",
    d: "M7983 1284 c-7 -7 -13 -20 -13 -29 0 -13 9 -15 53 -9 53 7 75 14 43 14 -10 0 -30 8 -44 19 -23 16 -29 16 -39 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5gyzorfC",
    d: "M4918 1273 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz9A8XRYl",
    d: "M5490 1260 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11WsPwglp",
    d: "M4828 1263 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prQwJBGqe",
    d: "M5400 1250 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BotvN1tE",
    d: "M4738 1253 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p119FT4c4g",
    d: "M5354 1228 c10 -52 19 -53 31 0 6 28 4 32 -15 32 -20 0 -22 -4 -16 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjMPBkDCD",
    d: "M4638 1243 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HZHybN4Q",
    d: "M4548 1233 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puNkULAZl",
    d: "M4458 1223 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFhWKJDQF",
    d: "M4358 1213 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BFUk4JMD",
    d: "M5271 1189 c0 -19 4 -43 9 -54 6 -13 7 -2 3 30 -7 59 -13 72 -12 24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FY70Guqw",
    d: "M6720 1198 c0 -30 49 -78 79 -78 l22 0 -21 30 c-11 16 -34 39 -50 50 l-30 21 0 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pM4GMiZL5",
    d: "M4268 1203 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pM33wV77s",
    d: "M4890 1190 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvHurKs2D",
    d: "M4178 1193 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEXLK9hG1",
    d: "M4078 1183 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piY3hH8g1",
    d: "M4720 1170 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plazv0dXj",
    d: "M3988 1173 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvAZhtaxP",
    d: "M4630 1160 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GDT2unip",
    d: "M4810 1172 c0 -8 90 -62 103 -62 3 0 7 8 9 18 5 22 -42 52 -82 52 -17 0 -30 -4 -30 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvNgs89du",
    d: "M283 1144 c-22 -17 -33 -34 -33 -51 0 -21 2 -24 15 -13 10 8 15 9 15 1 0 -6 20 2 45 17 32 19 45 33 45 49 0 32 -45 30 -87 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSdvtNTF2",
    d: "M3898 1163 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmibY7N3u",
    d: "M4530 1150 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOQyHAx13",
    d: "M3798 1153 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plrvYoY42",
    d: "M4423 1153 c-18 -3 -23 -11 -23 -37 0 -27 6 -35 35 -49 39 -19 95 -23 95 -7 0 5 -21 20 -47 33 l-46 24 36 7 c48 9 51 37 5 35 -18 -1 -43 -4 -55 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13dZtKM1",
    d: "M5360 1138 c0 -34 11 -68 21 -68 5 0 9 10 9 23 0 33 -11 67 -21 67 -5 0 -9 -10 -9 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppJPmqq2W",
    d: "M3708 1143 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phUDNDI1C",
    d: "M7227 1082 c27 -37 77 -109 113 -160 36 -50 69 -92 74 -92 4 0 -3 15 -16 33 -14 17 -66 89 -117 160 -51 70 -94 127 -97 127 -2 0 17 -31 43 -68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paFm3zGxN",
    d: "M3618 1133 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ2BW4WAt",
    d: "M5067 1110 c3 -19 1 -30 -6 -30 -6 0 -11 -4 -11 -10 0 -5 9 -10 20 -10 21 0 25 16 14 58 -9 33 -24 27 -17 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbJxZQ1tV",
    d: "M7768 1093 c28 -77 58 -63 31 16 -7 20 -18 31 -30 31 -18 0 -18 -1 -1 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz7EorNyq",
    d: "M3518 1123 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phPvGCGMW",
    d: "M3428 1113 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSsLkqbwu",
    d: "M3328 1103 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptvBYzVvP",
    d: "M3238 1093 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvqPCJdl3",
    d: "M3148 1083 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pL4BhTur9",
    d: "M3048 1073 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poBFZMcLx",
    d: "M3680 1060 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbus0KnZv",
    d: "M3770 1066 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peJ97zTML",
    d: "M2958 1063 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbnLWFQXL",
    d: "M2868 1053 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pksqA6tzK",
    d: "M3522 1039 c2 -16 15 -25 48 -35 50 -15 209 -19 175 -4 -11 5 -55 9 -97 9 -42 1 -80 6 -83 11 -3 6 1 10 9 10 9 0 16 7 16 15 0 11 -11 15 -36 15 -31 0 -35 -3 -32 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "popap7YYP",
    d: "M2768 1043 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxj5cJ85x",
    d: "M3390 1030 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdY39Qqp5",
    d: "M3880 1036 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSaCcMmO5",
    d: "M6868 1023 c11 -16 34 -41 51 -57 l31 -30 0 29 c0 36 -45 85 -78 85 l-23 0 19 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkJTuq4uL",
    d: "M2678 1033 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po9RpnQ02",
    d: "M3300 1020 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmF6cBerR",
    d: "M5370 1018 c0 -34 11 -68 21 -68 5 0 9 10 9 23 0 33 -11 67 -21 67 -5 0 -9 -10 -9 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p24TLzt5B",
    d: "M2588 1023 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFTe1zutk",
    d: "M230 1011 c0 -9 150 -90 203 -110 24 -10 27 -8 27 12 0 17 -10 28 -35 40 -20 9 -43 17 -53 17 -9 0 -39 12 -67 25 -53 26 -75 31 -75 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9Sfp9RER",
    d: "M2488 1013 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8DLJhuhl",
    d: "M3110 1000 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paz9WsOuF",
    d: "M4053 1005 c-11 -12 -3 -15 48 -21 47 -5 57 -9 44 -16 -9 -6 -38 -7 -63 -4 -32 4 -41 3 -27 -3 11 -5 34 -10 50 -10 17 -1 59 -10 95 -21 81 -25 90 -25 90 0 0 16 -7 20 -31 20 -32 0 -59 19 -59 43 0 10 -17 16 -52 21 -72 8 -81 7 -95 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMEELXorG",
    d: "M563 994 c-7 -19 4 -44 19 -44 23 0 41 17 35 33 -8 20 -47 29 -54 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12ghFPyCe",
    d: "M2398 1003 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13mtOq8pM",
    d: "M4650 986 c0 -26 34 -46 80 -46 54 0 27 29 -55 60 -22 8 -25 7 -25 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18H126pNd",
    d: "M5073 974 c3 -20 9 -39 12 -42 12 -12 17 9 11 43 -9 47 -31 47 -23 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOD2JMydo",
    d: "M530 987 c0 -11 -8 -17 -22 -17 l-22 0 20 -20 c26 -27 58 -17 48 14 -9 29 -24 44 -24 23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10GoS40Eo",
    d: "M2308 993 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC58zQpdL",
    d: "M3812 994 c8 -7 210 -35 216 -29 3 3 1 5 -4 5 -5 0 -52 7 -104 15 -107 17 -116 17 -108 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piTaVF2zC",
    d: "M2208 983 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVQuKmpqx",
    d: "M2830 970 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6Tg9fKpD",
    d: "M5280 963 c0 -38 10 -73 21 -73 10 0 12 44 3 78 -9 31 -24 28 -24 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Dykmtac5",
    d: "M2118 973 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQDtGU86A",
    d: "M2028 963 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVmNzlKWd",
    d: "M2640 950 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19EVeRH3P",
    d: "M1928 953 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0GbJbYFY",
    d: "M2550 940 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Gn2ocey5",
    d: "M1838 943 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg8dOZ7my",
    d: "M470 910 c0 -25 5 -30 38 -39 20 -6 53 -11 72 -11 27 0 31 -3 20 -10 -13 -9 -12 -12 4 -25 28 -21 56 -19 56 4 0 17 4 17 73 5 97 -17 127 -17 127 1 0 16 -9 18 -215 50 -118 18 -140 24 -137 38 2 11 -4 17 -18 17 -16 0 -20 -6 -20 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7pC86Aye",
    d: "M1748 933 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxB4XODlp",
    d: "M2360 920 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12Pu87Put",
    d: "M7844 878 c12 -35 40 -111 60 -170 21 -60 42 -108 47 -108 15 0 11 19 -43 182 -41 123 -56 158 -70 158 -16 0 -15 -5 6 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfDTesdDr",
    d: "M1648 923 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p255GeJ1A",
    d: "M2270 910 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXpIZaBBJ",
    d: "M4820 905 c0 -20 5 -25 25 -25 14 0 25 -4 25 -10 0 -5 16 -10 35 -10 19 0 35 4 35 9 0 12 -5 15 -68 40 l-52 21 0 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYX6NYarv",
    d: "M1558 913 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GmSBhFZX",
    d: "M1468 903 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pH20Q0yz0",
    d: "M2080 890 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjzeyecS0",
    d: "M4340 883 c0 -18 3 -23 8 -15 6 9 31 5 108 -18 118 -35 124 -36 124 -10 0 16 -7 20 -34 20 -19 0 -36 5 -38 11 -2 6 -25 13 -51 16 -26 3 -47 10 -47 14 0 5 -16 9 -35 9 -32 0 -35 -3 -35 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcYSjS1is",
    d: "M1368 893 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p126W9kgtj",
    d: "M1990 880 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRqBrUNHE",
    d: "M5386 844 c6 -51 5 -56 -15 -61 -31 -8 -27 -33 7 -33 42 0 72 11 72 26 0 8 -7 14 -15 14 -14 0 -33 46 -22 56 3 3 19 -2 36 -10 38 -20 41 -20 41 4 0 13 -14 27 -40 40 -64 33 -71 29 -64 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNmrqWmJp",
    d: "M1278 883 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1C4FjrfxT",
    d: "M1188 873 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOuiaRYIG",
    d: "M1800 860 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKLRu8zeX",
    d: "M5083 850 c6 -28 5 -29 -18 -20 -21 8 -25 7 -25 -10 0 -10 -9 -22 -20 -25 -15 -5 -20 -15 -20 -41 0 -40 0 -40 138 -22 78 10 92 15 92 31 0 16 -6 17 -60 11 l-60 -7 0 34 c0 45 -10 79 -22 79 -6 0 -8 -12 -5 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDEFMSncb",
    d: "M1088 863 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKf04IBGF",
    d: "M1710 850 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2P8mA3EA",
    d: "M998 853 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pozBDTJVH",
    d: "M7080 835 c0 -41 66 -108 101 -103 21 3 18 8 -38 68 -62 65 -62 65 -63 35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf8vkWIxN",
    d: "M1520 830 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPIGCZJon",
    d: "M1430 820 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptOHmC5Lh",
    d: "M5522 818 c2 -18 11 -24 36 -26 40 -4 41 8 3 31 -38 22 -43 22 -39 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CNkrpQHR",
    d: "M4610 816 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4wfhJq3e",
    d: "M700 806 c0 -14 11 -18 93 -32 32 -5 37 -4 37 14 0 15 -9 21 -46 26 -69 9 -84 8 -84 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18odxFvz5",
    d: "M1240 800 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GryLaRaS",
    d: "M7456 758 c74 -102 82 -113 87 -108 6 6 -101 154 -115 159 -6 2 7 -21 28 -51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1E7FoWz8R",
    d: "M860 786 c0 -7 10 -16 23 -20 41 -11 57 -7 57 14 0 17 -7 20 -40 20 -27 0 -40 -4 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqZjAyvh2",
    d: "M1050 780 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pH9oqBH16",
    d: "M4710 786 c0 -10 25 -20 78 -31 42 -9 83 -18 90 -20 6 -3 12 0 12 5 0 6 -4 10 -10 10 -5 0 -10 7 -10 15 0 10 -11 15 -35 15 -19 0 -35 -4 -35 -10 0 -5 -4 -10 -10 -10 -5 0 -10 9 -10 20 0 16 -7 20 -35 20 -24 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXS743lSx",
    d: "M4390 776 c0 -8 108 -36 137 -35 24 0 26 1 8 9 -11 5 -33 9 -50 10 -26 1 -27 3 -10 10 15 6 6 9 -32 9 -29 1 -53 -1 -53 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plNQCrrmO",
    d: "M5650 771 c0 -6 -16 -11 -35 -11 -25 0 -35 -5 -35 -15 0 -36 -26 -95 -41 -95 -9 0 -31 -16 -48 -35 -17 -19 -35 -35 -41 -35 -5 0 -10 -4 -10 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -9 -15 -20 0 -15 -7 -20 -29 -20 -45 0 -61 -10 -61 -37 0 -30 4 -29 103 29 130 75 210 171 190 225 -6 14 2 15 58 10 35 -3 79 -9 97 -13 25 -5 32 -3 32 9 0 10 -14 17 -42 22 -24 3 -58 9 -75 12 -21 3 -33 1 -33 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDibJkWts",
    d: "M5854 724 c3 -9 6 -18 6 -20 0 -2 14 -4 30 -4 36 0 41 25 8 34 -38 10 -51 7 -44 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pju5r6B9o",
    d: "M4778 723 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4RvRYfQy",
    d: "M4850 710 c0 -5 -10 -10 -22 -10 -12 0 -19 -3 -15 -6 10 -10 -20 -34 -42 -34 -12 0 -21 -5 -21 -11 0 -8 14 -10 43 -6 47 7 48 7 -70 -45 -68 -29 -81 -48 -34 -48 39 0 61 9 61 26 0 9 12 14 35 14 19 0 35 5 35 10 0 6 11 10 25 10 22 0 25 4 25 35 0 19 5 35 10 35 6 0 10 9 10 20 0 13 -7 20 -20 20 -11 0 -20 -4 -20 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6Mu2Cspy",
    d: "M5859 633 c-17 -52 -13 -51 -109 -40 l-55 7 46 -14 c71 -21 74 -24 43 -57 l-28 -29 35 0 c42 0 59 15 59 52 0 21 5 28 19 28 20 0 31 25 31 73 0 44 -25 32 -41 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17SLzxI24",
    d: "M4670 620 c-13 -9 -13 -10 0 -10 8 0 22 5 30 10 13 9 13 10 0 10 -8 0 -22 -5 -30 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUFoJhA7j",
    d: "M4563 589 c-43 -27 -73 -78 -73 -123 0 -47 14 -46 28 3 7 23 29 54 52 75 22 20 40 43 40 51 0 20 -9 19 -47 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B8Mb69BA",
    d: "M7570 607 c0 -4 12 -25 26 -47 20 -30 33 -40 53 -39 14 0 19 3 11 6 -8 3 -32 24 -52 46 -21 23 -38 39 -38 34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbAyyBeGT",
    d: "M7963 535 c6 -19 16 -35 23 -35 9 0 10 8 1 35 -6 19 -16 35 -23 35 -9 0 -10 -8 -1 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIfJoHAuV",
    d: "M4598 529 c-36 -27 -35 -39 2 -39 27 0 30 3 30 30 0 35 2 35 -32 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pflLwRw9o",
    d: "M6110 514 c0 -3 10 -14 21 -23 21 -17 21 -17 -35 -30 -60 -13 -74 -34 -31 -45 33 -8 75 3 75 20 0 8 9 14 20 14 27 0 27 45 1 60 -21 11 -51 14 -51 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pftyjCJc0",
    d: "M5940 480 c0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -25 0 -14 4 -25 8 -25 11 0 92 58 92 65 0 3 -16 5 -35 5 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pb7MvYEAL",
    d: "M5683 465 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXRxH7l6p",
    d: "M6445 469 c-13 -6 0 -7 40 -3 33 4 62 8 64 10 9 8 -85 2 -104 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJFqaM4qv",
    d: "M7428 453 c42 -58 99 -105 123 -101 21 3 18 8 -35 66 -41 44 -65 62 -83 62 l-24 0 19 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHUG1cCPd",
    d: "M5240 445 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12yuIC0gq",
    d: "M6220 447 c0 -19 15 -19 113 -1 51 10 27 21 -43 20 -61 -1 -70 -3 -70 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQVw0dYFs",
    d: "M4540 428 c0 -24 18 -58 30 -58 6 0 10 15 10 34 0 25 -5 35 -20 39 -15 4 -20 0 -20 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "panR6C6qW",
    d: "M8008 403 c24 -66 45 -69 24 -4 -9 28 -22 51 -29 51 -10 0 -9 -11 5 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzT72eHdJ",
    d: "M5965 426 c-22 -7 -57 -11 -78 -8 -33 4 -37 2 -37 -18 0 -20 3 -22 33 -15 29 6 45 8 98 13 14 2 35 30 27 37 -2 2 -21 -3 -43 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p126gvIMze",
    d: "M5110 410 c0 -5 -9 -10 -19 -10 -11 0 -42 -5 -70 -12 -40 -9 -51 -16 -51 -31 0 -17 5 -18 38 -12 63 12 166 49 170 63 2 8 -8 12 -32 12 -20 0 -36 -4 -36 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p82qAH7ig",
    d: "M5533 395 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPmeIisfx",
    d: "M5710 370 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIrJyAX7e",
    d: "M5413 345 c-26 -11 -33 -20 -33 -41 0 -24 2 -26 32 -20 40 8 40 8 36 44 -3 30 -3 30 -35 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnTXzAmix",
    d: "M5580 340 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pD2UO9KKQ",
    d: "M4710 316 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pidqLjvx1",
    d: "M7560 310 c0 -20 15 -25 44 -14 13 5 14 9 5 20 -18 21 -49 17 -49 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EI1Jde2N",
    d: "M8043 306 c4 -10 -4 -18 -21 -25 -26 -9 -26 -9 11 -10 20 -1 37 3 37 8 0 18 -12 41 -22 41 -6 0 -8 -6 -5 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvRHPlxxg",
    d: "M4840 295 c0 -15 55 -30 87 -22 11 2 1 7 -24 12 -24 4 -43 11 -43 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pD46NsoYt",
    d: "M5303 303 c-7 -2 -13 -11 -13 -19 0 -15 12 -17 48 -8 12 4 22 13 22 20 0 14 -32 18 -57 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHCZCCLTf",
    d: "M7315 265 c-55 -13 -91 -23 -80 -23 42 -1 226 34 219 41 -10 10 -26 8 -139 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTCaGRHD1",
    d: "M7865 270 c-15 -6 -9 -9 25 -9 25 0 54 4 65 9 15 6 9 9 -25 9 -25 0 -54 -4 -65 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1F9IVvRS",
    d: "M7715 260 c-17 -7 -16 -9 10 -9 17 0 39 4 50 9 17 7 16 9 -10 9 -16 0 -39 -4 -50 -9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l6vmRdobMUuQla5Efhg0dhU",
    fill: "rgb(119,119,119)",
    style: {
      transform: "none"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pKySB4bef",
    d: "M5035 2650 c-13 -6 -1 -7 35 -3 30 3 57 7 59 9 9 8 -75 2 -94 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pL0huWywQ",
    d: "M3778 2643 c-24 -6 -23 -23 1 -23 12 0 23 -10 28 -25 7 -22 11 -24 26 -13 15 11 16 17 5 40 -13 27 -24 31 -60 21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16IWWy2mz",
    d: "M4865 2639 c-104 -12 -135 -24 -135 -55 0 -13 2 -24 5 -24 3 0 32 13 63 29 35 19 81 33 120 37 34 3 62 11 62 15 0 10 -3 10 -115 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13BlnhHx6",
    d: "M3688 2633 c-20 -5 -24 -23 -5 -23 24 0 57 12 57 21 0 9 -22 10 -52 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLQwOoYcH",
    d: "M3593 2623 c-13 -2 -23 -9 -23 -15 0 -6 12 -8 31 -4 17 3 35 6 40 6 5 0 9 5 9 10 0 10 -16 11 -57 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyk5b7fdx",
    d: "M3430 2603 c-58 -7 -143 -14 -190 -16 l-85 -4 -8 -49 c-10 -60 -1 -114 18 -114 10 0 15 -10 15 -30 0 -25 -4 -30 -25 -30 -18 0 -25 -5 -25 -20 0 -25 19 -25 76 0 24 11 57 23 73 26 17 4 32 13 35 21 5 12 16 14 49 9 41 -6 168 8 349 39 63 11 99 13 130 6 53 -12 62 -6 18 12 -18 8 -28 17 -22 20 5 4 12 18 14 32 7 33 -24 35 -47 3 -14 -21 -43 -27 -310 -69 -162 -25 -295 -42 -295 -38 0 9 19 13 184 40 77 12 135 24 129 26 -7 3 -76 -5 -153 -16 -198 -29 -183 -33 -178 39 2 33 7 62 11 66 3 3 81 14 172 24 147 15 188 23 174 33 -2 2 -51 -3 -109 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvu6Yk12w",
    d: "M4618 2613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp8DZbMg4",
    d: "M4518 2603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pi8ZYsZHc",
    d: "M4308 2579 c-29 -16 -21 -29 17 -29 28 0 35 4 35 20 0 22 -24 26 -52 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plamYgpjD",
    d: "M2955 2573 c-78 -6 -105 -14 -105 -28 0 -8 -7 -15 -16 -15 -22 0 -47 -66 -39 -107 5 -30 9 -33 40 -33 29 0 35 -4 35 -21 0 -19 4 -21 38 -14 92 17 132 27 132 35 0 16 -30 19 -91 9 -64 -10 -78 -5 -79 29 0 6 -4 12 -8 12 -4 0 -14 -6 -21 -12 -19 -19 -8 79 11 98 8 8 61 23 119 33 94 17 88 23 -16 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMFpocbR3",
    d: "M4593 2533 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po5VLmAQa",
    d: "M4163 2515 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxYfLWyeX",
    d: "M4053 2465 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHYLyEsVR",
    d: "M4450 2435 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pweW8UmnO",
    d: "M4698 2439 c-21 -11 -38 -22 -38 -24 0 -3 18 4 40 15 22 11 40 23 40 25 0 7 0 7 -42 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLGIJxCGi",
    d: "M3893 2395 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZDRbCE4j",
    d: "M4340 2375 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psxSBkHGu",
    d: "M2807 2363 c3 -10 10 -23 15 -29 6 -8 -26 -16 -107 -29 -108 -16 -116 -19 -121 -42 -4 -16 -2 -28 7 -34 23 -15 37 -10 43 15 6 25 18 30 101 42 28 3 58 11 68 16 13 7 27 3 51 -11 35 -22 46 -19 46 11 0 10 7 18 15 18 8 0 15 -7 15 -16 0 -17 10 -16 103 2 28 6 38 34 12 34 -8 0 -15 4 -15 9 0 4 -32 2 -72 -4 -40 -7 -78 -11 -85 -8 -7 3 -13 0 -13 -6 0 -6 -4 -11 -10 -11 -5 0 -10 14 -10 30 0 25 -4 30 -25 30 -19 0 -23 -4 -18 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HXVksMHd",
    d: "M4558 2362 c-16 -9 -28 -20 -28 -25 0 -7 37 15 69 40 15 11 -19 -1 -41 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HqHTkWkY",
    d: "M3783 2345 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMCB5gTdH",
    d: "M4230 2315 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4hM2WeRk",
    d: "M4422 2253 c-51 -41 -92 -80 -92 -86 0 -11 12 -2 110 82 41 36 77 66 79 68 2 2 2 5 0 8 -3 2 -46 -30 -97 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF3LUWRCD",
    d: "M3693 2305 c-18 -8 -33 -19 -33 -25 0 -5 -12 -10 -27 -10 -39 0 -21 -11 44 -26 l58 -14 -68 6 c-37 2 -81 7 -97 11 -25 5 -30 2 -30 -14 0 -17 12 -21 89 -31 138 -19 141 -18 141 23 0 35 0 35 -47 36 -30 1 -37 4 -20 6 21 3 27 10 27 29 0 13 -1 24 -2 24 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8Bg1oTGr",
    d: "M4120 2260 c0 -16 -7 -20 -35 -20 -32 0 -35 -3 -35 -29 l0 -29 70 41 c38 23 70 45 70 50 0 4 -16 7 -35 7 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p103Wdrbh1",
    d: "M2356 2259 c-27 -4 -52 -11 -57 -16 -14 -14 -29 -98 -19 -101 6 -2 10 -15 10 -28 0 -20 5 -24 30 -24 28 0 30 2 20 21 -11 20 -12 20 -26 2 -14 -16 -15 -13 -10 39 3 31 9 63 12 71 3 9 34 21 77 30 75 15 47 21 -37 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvzlIPSJX",
    d: "M3169 2216 c-2 -2 -21 -7 -42 -10 -49 -8 -77 -23 -77 -41 0 -19 5 -19 105 6 55 14 85 26 85 35 0 9 -12 14 -33 14 -19 0 -36 -2 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16bynXDjo",
    d: "M3262 2198 c3 -7 23 -20 46 -28 58 -22 59 -26 8 -49 -25 -11 -46 -25 -46 -30 0 -17 67 -13 84 4 8 8 22 15 30 15 12 0 16 10 16 35 0 33 -2 35 -35 35 -24 0 -35 5 -35 15 0 11 -11 15 -36 15 -24 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOeYMmhBl",
    d: "M2770 2157 c-119 -21 -127 -23 -117 -33 5 -5 257 44 266 52 8 7 -34 2 -149 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Hac0fylI",
    d: "M2828 2132 c-86 -20 -155 -39 -152 -44 3 -4 -4 -8 -15 -8 -12 0 -21 -4 -21 -10 0 -5 -13 -10 -30 -10 -24 0 -30 -4 -30 -21 0 -19 4 -21 38 -14 20 4 51 15 68 26 17 10 39 19 48 19 9 0 16 6 16 14 0 10 11 12 45 8 36 -4 45 -1 45 10 0 12 9 14 45 10 35 -3 45 -1 45 10 0 11 11 14 42 14 33 -1 43 3 46 17 5 22 -1 22 -190 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FCxsOiQa",
    d: "M3970 2140 c0 -28 -3 -30 -35 -30 -32 0 -35 -2 -35 -31 l0 -30 28 20 c15 11 47 39 72 60 l45 40 -37 1 c-36 0 -38 -2 -38 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pecVuC3r3",
    d: "M2358 2073 c-3 -21 -5 -39 -4 -40 1 -1 26 4 56 10 l54 12 -24 23 c-27 25 -40 28 -40 10 -1 -8 -6 -6 -14 5 -19 25 -23 22 -28 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pquukB7Gw",
    d: "M2470 2076 c0 -18 35 -22 45 -6 3 6 2 10 -4 10 -5 0 -16 3 -25 6 -11 4 -16 1 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7atWyF1N",
    d: "M4196 2066 c-31 -26 -31 -51 -2 -91 11 -15 18 -17 26 -9 9 9 8 19 -4 43 -16 31 -16 32 11 56 37 32 9 33 -31 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfGJnDLw5",
    d: "M2509 2043 c-21 -3 -26 -8 -21 -25 4 -16 10 -19 35 -14 17 3 33 8 35 11 7 6 -6 35 -15 34 -4 -1 -20 -4 -34 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJsjyrzop",
    d: "M3820 2015 c0 -16 -6 -25 -15 -25 -8 0 -15 -9 -15 -20 0 -11 5 -20 10 -20 24 0 146 33 155 43 10 9 3 8 -100 -10 l-30 -5 35 30 35 31 -37 1 c-34 0 -38 -3 -38 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pal6mQZu2",
    d: "M2393 2019 c-51 -12 -60 -39 -13 -39 17 0 30 -4 30 -9 0 -9 83 -41 107 -41 30 0 10 28 -29 40 -29 9 -37 15 -25 18 24 5 18 37 -8 39 -11 0 -39 -3 -62 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DiB8jo7r",
    d: "M3055 1996 c-38 -19 -63 -35 -54 -35 9 -1 37 -4 63 -7 38 -6 46 -4 46 9 0 8 5 17 11 19 6 2 9 14 7 26 -3 22 -3 22 -73 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptvDZ8Ezd",
    d: "M4015 2010 c-25 -11 1 -11 35 0 20 6 21 8 5 8 -11 0 -29 -3 -40 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptELro3rK",
    d: "M7757 2000 c-49 -9 -65 -16 -55 -25 6 -6 178 22 186 30 8 7 -76 4 -131 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKtkKrKGs",
    d: "M7998 2003 c23 -2 59 -2 80 0 20 2 1 4 -43 4 -44 0 -61 -2 -37 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAfWxHIeJ",
    d: "M8120 1990 c0 -23 5 -24 51 -8 34 12 34 12 9 19 -45 13 -60 10 -60 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4wXfyyvu",
    d: "M7975 1980 c-14 -6 -2 -9 40 -9 33 0 69 4 80 9 14 6 2 9 -40 9 -33 0 -69 -4 -80 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pG1bG2rWm",
    d: "M7560 1941 c-81 -26 -116 -42 -118 -53 -3 -14 16 -11 110 23 106 38 138 53 127 63 -2 2 -56 -13 -119 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTIGZiP4P",
    d: "M7823 1973 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyDCpNN6i",
    d: "M7930 1895 c-96 -41 -188 -81 -205 -88 -102 -48 -247 -102 -285 -107 l-45 -6 39 -9 c25 -5 51 -4 68 3 16 6 30 6 34 1 9 -15 27 -10 21 5 -4 10 15 22 69 42 41 15 77 31 80 35 3 5 21 9 40 9 22 0 34 5 34 14 0 7 69 44 165 87 91 40 165 77 165 81 0 10 19 18 -180 -67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AJtG4fpZ",
    d: "M2680 1946 c0 -11 9 -16 29 -16 16 0 43 -3 60 -6 24 -5 31 -3 31 10 0 10 -8 16 -22 16 -13 0 -40 3 -60 6 -31 5 -38 4 -38 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEbdIFLqr",
    d: "M3160 1945 c25 -14 25 -14 3 -15 -16 0 -23 -6 -23 -20 0 -17 7 -20 40 -20 39 0 40 1 40 35 0 35 -1 35 -42 35 -42 -1 -43 -1 -18 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnhsIOcUZ",
    d: "M2900 1929 c0 -15 7 -19 35 -19 19 0 35 5 35 10 0 16 50 12 56 -5 8 -21 84 -21 84 0 0 16 -26 21 -137 29 -67 4 -73 3 -73 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HVPdkE8J",
    d: "M5018 1933 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CEEmRI5v",
    d: "M5710 1920 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcwcxRuej",
    d: "M4898 1923 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ06H2Pc3",
    d: "M5910 1910 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCm3bQCNE",
    d: "M4798 1913 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pB7fvsSme",
    d: "M6060 1900 c0 -15 -7 -20 -25 -20 -31 0 -33 -25 -2 -34 12 -3 48 -6 80 -6 50 0 57 2 57 20 0 13 -7 20 -20 20 -11 0 -20 6 -20 14 0 13 -28 26 -57 26 -7 0 -13 -9 -13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLM3uHPkb",
    d: "M4243 1904 c-16 -7 16 -94 34 -94 7 0 13 5 13 10 0 6 11 10 25 10 19 0 25 5 25 21 0 17 -5 20 -24 17 -18 -4 -28 1 -37 19 -13 24 -15 25 -36 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGjYB6GTt",
    d: "M4698 1903 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12Z3JKocm",
    d: "M6200 1890 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXhdF6HkH",
    d: "M6350 1880 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BjCpQyyc",
    d: "M4488 1883 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DeVOqpch",
    d: "M4388 1873 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbesWOVY9",
    d: "M5610 1860 c0 -16 7 -20 33 -20 47 0 77 10 77 26 0 10 -15 14 -55 14 -48 0 -55 -2 -55 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptMmsvxzT",
    d: "M6580 1861 c0 -16 6 -21 28 -21 15 0 51 -3 80 -6 43 -6 52 -4 52 9 0 10 -13 17 -40 21 -22 3 -58 9 -80 12 -36 5 -40 4 -40 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psbUkgu5a",
    d: "M7313 1863 c-29 -9 -53 -21 -53 -28 0 -7 21 -15 53 -19 72 -8 87 -8 87 4 0 6 -15 10 -32 10 l-33 1 33 14 c34 15 43 36 15 34 -10 0 -42 -8 -70 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peHnKgELE",
    d: "M7695 1859 c-27 -11 -54 -25 -60 -30 -11 -11 13 -3 85 29 58 27 40 27 -25 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pONeddXVC",
    d: "M2793 1842 c-24 -15 -43 -30 -43 -34 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 9 0 15 9 15 25 0 31 -5 31 -57 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2KPQytti",
    d: "M5288 1863 c-10 -2 -18 -11 -18 -18 0 -7 8 -16 18 -18 16 -4 16 -5 0 -6 -10 0 -18 -9 -18 -18 0 -14 -2 -15 -9 -4 -5 8 -11 9 -15 3 -8 -13 16 -37 56 -58 29 -15 32 -15 71 13 45 33 49 44 18 59 -25 13 -17 24 16 24 22 0 23 2 9 15 -14 14 -87 19 -128 8z m72 -73 c0 -5 -10 -10 -22 -10 -19 0 -20 2 -8 10 19 13 30 13 30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12BQ6n1VO",
    d: "M5180 1840 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmtc5fnKP",
    d: "M6770 1846 c0 -9 6 -16 14 -16 8 0 35 -24 60 -52 l46 -53 0 38 c0 33 -3 37 -25 37 -20 0 -25 5 -25 25 0 18 -5 25 -19 25 -11 0 -26 3 -35 6 -11 4 -16 1 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppxulBrm1",
    d: "M5060 1830 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp4JvNFuH",
    d: "M6850 1830 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7cuXOP3T",
    d: "M4930 1820 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptX8CLcsP",
    d: "M4810 1810 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMaZtU8Kq",
    d: "M6980 1806 c0 -24 28 -36 86 -36 39 0 29 28 -13 36 -31 6 -34 8 -18 15 15 6 11 8 -17 8 -34 1 -38 -2 -38 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHpv3BbeQ",
    d: "M7478 1823 c-16 -2 -28 -9 -28 -14 0 -5 -11 -9 -25 -9 -14 0 -25 -4 -25 -10 0 -5 -9 -10 -19 -10 -38 0 -51 -11 -51 -46 0 -22 5 -34 13 -34 8 0 56 18 108 41 52 22 109 47 128 55 55 23 29 27 -28 4 -69 -27 -78 -24 -16 5 l50 23 -40 0 c-22 -1 -52 -3 -67 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbjXTALij",
    d: "M4690 1800 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po6XeVYVv",
    d: "M4570 1790 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOznOzB2B",
    d: "M4450 1780 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4wrnhHSg",
    d: "M4184 1768 c-27 -11 -52 -23 -56 -26 -5 -6 129 1 150 7 1 1 2 7 2 15 0 22 -44 24 -96 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjAXnsGzg",
    d: "M4320 1770 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B76XxCMf",
    d: "M5410 1765 c-24 -63 -23 -71 12 -93 l33 -22 -27 0 c-36 0 -36 -16 -1 -23 17 -3 31 0 38 8 5 8 28 16 50 18 l40 4 -43 1 c-35 2 -43 5 -41 20 3 36 -1 52 -15 52 -8 0 -17 -8 -19 -17 -4 -14 -5 -12 -6 5 -1 17 4 22 24 22 l24 0 -23 25 c-29 31 -34 31 -46 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AHgJ4tU0",
    d: "M5215 1760 c-3 -11 -14 -20 -23 -20 -10 0 -13 -3 -7 -8 6 -4 11 -24 12 -46 1 -21 4 -45 7 -52 6 -16 66 -19 66 -4 0 6 -12 10 -26 10 l-27 0 29 22 c16 12 30 22 32 23 6 5 -38 95 -47 95 -5 0 -13 -9 -16 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLgmPQWYT",
    d: "M5525 1749 c-24 -7 -21 -7 14 -3 30 3 47 1 53 -8 6 -10 8 -8 8 5 0 19 -23 21 -75 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUn3qIyup",
    d: "M7000 1730 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10 -30 0 -55 -4 -55 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puihQs33j",
    d: "M7160 1730 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10 -30 0 -55 -4 -55 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pO883UdKl",
    d: "M7770 1718 c0 -13 -18 -47 -40 -76 -45 -59 -49 -72 -21 -72 17 0 37 21 78 79 2 3 17 -8 33 -24 30 -28 30 -28 30 -6 0 13 -9 34 -20 48 -11 14 -20 36 -20 49 0 17 -6 24 -20 24 -14 0 -20 -7 -20 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFf2htQkK",
    d: "M3630 1695 c0 -43 10 -44 33 -6 22 38 22 41 -8 41 -22 0 -25 -4 -25 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11rnBAj8F",
    d: "M5067 1723 c-4 -3 -7 -17 -7 -30 0 -16 6 -23 18 -22 10 0 12 3 5 6 -25 9 -14 41 15 46 l27 4 -26 2 c-14 0 -29 -2 -32 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGWfCIy8j",
    d: "M5575 1710 c-30 -8 -30 -8 -3 -9 19 -1 28 -7 31 -23 3 -17 5 -14 6 10 0 17 0 31 -1 31 -2 -1 -16 -5 -33 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppFFx9nWL",
    d: "M7048 1703 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4cnUrdZj",
    d: "M7185 1700 c17 -4 44 -8 60 -8 25 -1 27 1 10 8 -11 5 -38 8 -60 8 -38 0 -39 -1 -10 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AKjlbx9E",
    d: "M2538 1675 c-20 -14 -45 -25 -55 -25 -34 0 -63 -12 -63 -26 0 -9 12 -14 35 -14 19 0 35 5 35 10 0 6 16 10 35 10 19 0 35 5 35 10 0 6 7 10 15 10 9 0 15 9 15 25 0 14 -3 25 -8 25 -4 0 -24 -11 -44 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRZiO4dEN",
    d: "M3750 1670 c-20 -6 -21 -8 -5 -8 11 0 31 4 45 8 20 6 21 8 5 8 -11 0 -31 -4 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwtrgK38s",
    d: "M3550 1640 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psTSOvVdb",
    d: "M3660 1650 c-20 -6 -21 -8 -5 -8 11 0 29 3 40 8 25 11 -1 11 -35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZVfMOnWR",
    d: "M2288 1623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE8BZfl60",
    d: "M3420 1610 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CJB2hx4O",
    d: "M2208 1613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15zs3F7Rs",
    d: "M3330 1590 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1D3XD6USo",
    d: "M5380 1585 c0 -31 11 -32 47 0 l28 24 -37 1 c-34 0 -38 -3 -38 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGF5W3IGK",
    d: "M2058 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HT3mUZvu",
    d: "M7543 1586 c-50 -6 -95 -14 -99 -18 -4 -5 31 -8 77 -8 l84 0 20 -57 c22 -63 45 -82 45 -36 0 43 -11 73 -26 73 -8 0 -14 5 -14 10 0 6 9 10 20 10 13 0 20 7 20 20 0 22 6 22 -127 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pK5kcjfIY",
    d: "M3240 1570 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfHA5L2X0",
    d: "M7910 1559 c0 -30 21 -52 45 -47 13 2 10 10 -14 38 l-30 35 -1 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqjtL36Sj",
    d: "M1828 1563 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYJ9LKTgw",
    d: "M3150 1550 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12cozkOO8",
    d: "M1668 1543 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBFExusrS",
    d: "M3060 1530 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNN7h3atK",
    d: "M7690 1521 c0 -28 3 -31 30 -31 25 0 30 -4 30 -25 0 -21 5 -25 30 -25 25 0 30 -4 30 -25 0 -21 5 -25 30 -25 25 0 30 -4 30 -25 0 -22 4 -25 35 -25 30 0 35 -3 35 -23 0 -13 6 -35 13 -51 10 -23 16 -26 41 -22 16 4 40 6 55 7 25 0 26 0 3 9 -12 5 -91 67 -175 137 -208 175 -187 161 -187 124z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19c4Zqecf",
    d: "M1568 1533 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pa0TPMC0Y",
    d: "M2370 1520 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BxJMQ7e1",
    d: "M2280 1510 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GkylA1aZ",
    d: "M2970 1510 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDfL6K6Hb",
    d: "M1408 1513 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pagaltU3Y",
    d: "M2200 1500 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXMKxb8c5",
    d: "M2120 1490 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1A8pQM7ol",
    d: "M2520 1500 c0 -12 33 -30 54 -30 9 0 16 9 16 20 0 16 -7 20 -35 20 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7vSzVk8W",
    d: "M2880 1490 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRurWDO9",
    d: "M2030 1480 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10D5xWbT5",
    d: "M1218 1483 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pboqv6gwz",
    d: "M1950 1470 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12qxwqxgy",
    d: "M2740 1476 c0 -16 32 -26 60 -19 37 10 23 33 -20 33 -27 0 -40 -4 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVMtkgt6N",
    d: "M6470 1449 c-140 -22 -270 -42 -287 -45 -21 -3 -33 -11 -33 -21 0 -13 10 -15 71 -9 39 4 77 10 85 13 10 4 14 -3 14 -21 0 -23 4 -26 35 -26 37 0 46 13 19 28 -17 10 19 21 261 82 83 21 137 38 120 38 -16 0 -145 -18 -285 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pax4wr0Pk",
    d: "M1860 1460 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psmATqmfk",
    d: "M1780 1450 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11jgEPgPA",
    d: "M1003 1448 c-46 -10 -61 -38 -20 -38 58 0 97 13 97 31 0 21 -12 22 -77 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvVmXQ2Lo",
    d: "M1700 1440 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14WdjKlbw",
    d: "M5100 1433 c0 -25 0 -26 20 -8 11 10 20 22 20 27 0 4 -9 8 -20 8 -15 0 -20 -7 -20 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz8zpStP1",
    d: "M1610 1430 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1767bRm1S",
    d: "M4985 1419 c-24 -22 -35 -40 -35 -59 0 -31 13 -44 53 -54 37 -9 34 -26 -5 -26 -49 0 -78 -11 -78 -28 0 -12 10 -14 60 -9 l60 7 0 -31 c0 -17 4 -28 10 -24 6 3 10 1 10 -4 0 -6 4 -11 9 -11 6 0 7 29 4 70 l-6 69 32 18 c64 36 67 39 43 52 -17 9 -28 8 -56 -6 -20 -9 -36 -23 -36 -30 0 -14 -18 -17 -44 -7 -24 9 -21 54 3 54 33 0 51 11 51 31 0 29 -34 23 -75 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVl0LkFUr",
    d: "M1530 1420 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxD2Ta8jY",
    d: "M8040 1424 c0 -23 33 -58 50 -52 6 2 -3 19 -19 38 -26 31 -30 32 -31 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNvpnNfP8",
    d: "M1450 1410 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5UaM4BU7",
    d: "M838 1413 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Bh6es0At",
    d: "M1360 1400 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FjQSmp2C",
    d: "M1280 1390 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pa1sw8KIK",
    d: "M935 1354 c-142 -25 -262 -48 -265 -53 -3 -4 -25 -11 -49 -14 -24 -3 -47 -11 -52 -18 -5 -8 -8 -3 -11 14 -3 26 -3 26 -35 10 -27 -13 -32 -20 -27 -39 6 -21 3 -24 -25 -24 -17 0 -31 -4 -31 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -9 -9 -15 -25 -15 -14 0 -25 -4 -25 -9 0 -6 -19 -14 -42 -18 -38 -7 -43 -12 -46 -38 l-4 -29 39 29 38 28 -30 -33 c-34 -38 -35 -38 100 46 130 80 236 112 550 164 132 22 255 42 273 45 19 4 32 12 32 20 0 22 -45 18 -335 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pN59OHa7Z",
    d: "M5387 1383 c5 -14 1 -15 -35 -9 l-42 6 20 -20 c11 -11 20 -26 20 -34 0 -18 31 -26 108 -26 56 0 62 2 62 21 0 19 -4 20 -49 14 -52 -7 -75 6 -44 24 10 6 12 11 6 11 -7 0 -13 7 -13 15 0 8 -9 15 -20 15 -14 0 -18 -5 -13 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psjgDC0i4",
    d: "M6068 1393 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZyVAkRH0",
    d: "M738 1383 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "per7Vsa1o",
    d: "M5968 1383 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDIK44PJX",
    d: "M5858 1373 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18l6fQ27q",
    d: "M663 1355 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ETRQ5Imz",
    d: "M5758 1363 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pt3dVgb4t",
    d: "M5658 1353 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poWeGVTDV",
    d: "M5558 1343 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVnmc83Td",
    d: "M6090 1330 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjtEnmroZ",
    d: "M6450 1327 c0 -7 25 -21 56 -32 30 -10 95 -45 145 -76 84 -55 89 -57 89 -34 0 18 -14 32 -57 60 -32 20 -70 39 -85 42 -16 3 -28 9 -28 13 0 9 -84 40 -107 40 -7 0 -13 -6 -13 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLDLcI14n",
    d: "M7693 1308 c19 -46 37 -48 37 -4 0 32 -3 36 -25 36 -24 0 -25 -1 -12 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOMGHNA1E",
    d: "M5830 1300 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1hu1rEAS",
    d: "M5570 1270 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16a1Gz0Zn",
    d: "M7740 1260 c0 -16 4 -30 10 -30 5 0 7 7 4 15 -5 12 0 14 25 9 27 -6 31 -4 31 15 0 17 -6 21 -35 21 -32 0 -35 -2 -35 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbgPERTDT",
    d: "M7820 1266 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgx7VxX6W",
    d: "M4848 1263 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HZBzWDtd",
    d: "M5354 1238 c3 -17 8 -34 11 -36 8 -8 14 3 21 36 6 28 4 32 -16 32 -20 0 -22 -4 -16 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMn7QZ78y",
    d: "M4748 1253 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19cRsPQ1F",
    d: "M4658 1243 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnQ0wuotT",
    d: "M4568 1233 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p28aby0R6",
    d: "M4468 1223 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14gZf706V",
    d: "M4378 1213 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOub8zMYE",
    d: "M4288 1203 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17n7rvYzh",
    d: "M4880 1186 c0 -13 -2 -31 -5 -38 -4 -10 11 -24 43 -41 59 -32 62 -33 62 -7 0 13 -15 27 -47 44 l-47 23 32 8 c44 9 42 35 -3 35 -30 0 -35 -3 -35 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE6zEZK9m",
    d: "M4188 1193 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWSv6ZnqJ",
    d: "M4098 1183 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj45WJObd",
    d: "M4710 1170 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pM2Kqk8QU",
    d: "M4008 1173 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKeWg7knS",
    d: "M4620 1160 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwoejBRJ0",
    d: "M3908 1163 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgyBz2H4K",
    d: "M4520 1150 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psXYsnMMo",
    d: "M7753 1138 c15 -37 37 -49 37 -20 0 34 -11 52 -31 52 -17 0 -18 -3 -6 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbhNIvoIV",
    d: "M3818 1153 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19bf4PZL5",
    d: "M4430 1140 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14DRi1DCs",
    d: "M5065 1120 c4 -26 3 -40 -4 -40 -6 0 -11 -7 -11 -15 0 -9 9 -15 21 -15 19 0 21 4 15 31 -3 17 -6 42 -6 55 0 13 -5 24 -11 24 -7 0 -8 -14 -4 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10rjN950O",
    d: "M3718 1143 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfaQinKjc",
    d: "M5364 1118 c3 -17 8 -34 11 -36 11 -11 16 9 10 37 -9 42 -29 41 -21 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poRYGoutb",
    d: "M3628 1133 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HXujWoiR",
    d: "M3538 1123 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1273sEXwc",
    d: "M3438 1113 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmVXEU3kT",
    d: "M3348 1103 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pd2GRNmi4",
    d: "M4430 1100 c0 -5 10 -10 23 -10 18 0 19 2 7 10 -19 13 -30 13 -30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmeztFUuI",
    d: "M3258 1093 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9iICcj1X",
    d: "M3158 1083 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLWJqmEuP",
    d: "M4480 1067 c0 -27 53 -57 100 -57 42 0 37 16 -10 40 -79 40 -90 42 -90 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLJVnKit5",
    d: "M3068 1073 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnN0R5MU0",
    d: "M3670 1060 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ps6czYaCT",
    d: "M5281 1048 c-1 -21 4 -38 9 -38 12 0 12 27 0 55 -7 16 -9 13 -9 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poJAjKpgo",
    d: "M212 1043 c2 -20 13 -33 40 -48 48 -26 59 -13 19 21 -18 15 -30 33 -27 40 4 9 -2 14 -15 14 -16 0 -20 -5 -17 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piInS8yXg",
    d: "M2978 1063 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psMwQwRaF",
    d: "M3570 1050 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1165PpYw7",
    d: "M3810 1056 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17e91qohP",
    d: "M2878 1053 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcDbYrdZp",
    d: "M7790 1046 c0 -20 50 -159 61 -170 5 -5 12 -7 16 -3 11 11 -49 187 -64 187 -7 0 -13 -6 -13 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piXKN5Lae",
    d: "M2788 1043 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17eL6XpdB",
    d: "M2698 1033 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1vX27shg",
    d: "M3290 1020 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyOOyVsMw",
    d: "M3933 1026 c-10 -11 7 -17 92 -30 57 -9 114 -16 127 -17 23 0 23 0 -2 -10 -14 -6 -54 -8 -90 -5 -51 4 -45 2 29 -9 52 -8 96 -13 99 -10 2 2 2 16 -2 30 -4 16 -13 25 -26 25 -11 0 -20 4 -20 8 0 7 -145 33 -181 32 -7 -1 -19 -7 -26 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1C7tHoqTW",
    d: "M7312 967 c29 -43 59 -84 67 -90 17 -14 -58 95 -96 139 -13 16 -1 -6 29 -49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p01VaCmtZ",
    d: "M2598 1023 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxFbx8miw",
    d: "M3200 1010 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkivMkWKa",
    d: "M5374 998 c3 -17 8 -34 11 -36 11 -11 16 9 10 37 -9 42 -29 41 -21 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwFT7HFo5",
    d: "M2508 1013 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HF8C1Fkv",
    d: "M3100 1000 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLZwjmSZT",
    d: "M5076 973 c7 -51 11 -60 20 -51 9 9 -7 98 -18 98 -5 0 -6 -19 -2 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcEmdAY3j",
    d: "M560 993 c0 -10 4 -24 9 -32 8 -12 12 -11 27 4 17 17 17 18 -1 31 -25 19 -35 18 -35 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6azO0k2S",
    d: "M2418 1003 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcZkr72lV",
    d: "M3010 990 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5CQA2gTs",
    d: "M3590 1000 c14 -4 36 -8 50 -8 23 -1 23 0 5 8 -11 5 -33 8 -50 8 -29 0 -29 0 -5 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3NzZdzYi",
    d: "M2318 993 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pm3GlxxHf",
    d: "M2920 980 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXoIQ7AbE",
    d: "M6918 973 c11 -16 34 -41 51 -57 l31 -30 0 29 c0 36 -45 85 -78 85 l-23 0 19 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peWCvq6Sb",
    d: "M310 976 c0 -12 40 -36 60 -36 25 0 6 28 -25 37 -27 9 -35 8 -35 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC9xYHNKv",
    d: "M493 983 c-20 -7 -16 -17 15 -35 33 -20 53 -11 45 20 -5 21 -30 28 -60 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj8IaI7PZ",
    d: "M2228 983 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyCTQBMm5",
    d: "M5283 954 c3 -20 9 -39 12 -42 11 -12 16 8 10 42 -9 48 -29 48 -22 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKIyA43Zt",
    d: "M2138 973 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CLKOr8JC",
    d: "M2730 960 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyH8nOQNO",
    d: "M3933 973 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16YIwx34W",
    d: "M4710 956 c0 -26 34 -46 80 -46 54 0 27 29 -55 60 -22 8 -25 7 -25 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FEr3xZCU",
    d: "M430 950 c0 -13 7 -20 20 -20 11 0 20 -7 20 -15 0 -20 26 -19 34 1 4 10 -3 23 -16 35 -31 25 -58 24 -58 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pncjBM39Z",
    d: "M2038 963 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5as4KmRw",
    d: "M1948 953 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDgk9OCCJ",
    d: "M2540 940 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B7zYEElK",
    d: "M1858 943 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf4bb9yB1",
    d: "M2450 930 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZgr1Mqgp",
    d: "M1758 933 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2q277qQp",
    d: "M5380 905 c0 -32 2 -35 30 -35 35 0 38 10 10 28 -11 7 -20 19 -20 27 0 8 -4 15 -10 15 -5 0 -10 -16 -10 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pncE7WSap",
    d: "M1668 923 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FrmtVVbP",
    d: "M2260 910 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgxTzpJ9N",
    d: "M4290 916 c0 -8 11 -17 25 -20 14 -4 25 -14 26 -24 0 -10 3 -12 6 -4 2 6 11 12 19 12 8 0 14 5 14 10 0 6 -4 10 -10 10 -5 0 -10 7 -10 15 0 10 -11 15 -35 15 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12Y9bp3bO",
    d: "M1568 913 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC3irnDLO",
    d: "M2170 900 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10m1STCfD",
    d: "M1478 903 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxkC4UPgq",
    d: "M7030 884 c0 -39 47 -87 81 -82 21 3 19 7 -29 58 l-51 55 -1 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWgQCK2v",
    d: "M522 878 c2 -13 15 -27 36 -35 32 -13 32 -13 32 16 0 21 -6 30 -22 35 -40 10 -50 7 -46 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxs8kbh5U",
    d: "M1388 893 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16k0PaHSL",
    d: "M1980 880 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdQsurCI0",
    d: "M4890 875 c0 -20 5 -25 25 -25 14 0 25 -4 25 -10 0 -5 11 -10 25 -10 14 0 25 -4 25 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 -4 -10 -10 -10 -5 0 -10 -7 -10 -15 0 -18 5 -18 30 -5 11 6 21 6 24 1 4 -5 -7 -12 -24 -16 -33 -7 -42 -35 -11 -35 10 0 39 3 65 6 37 5 46 11 46 27 0 15 -5 18 -24 15 -23 -5 -24 -2 -30 64 -4 37 -12 68 -18 68 -7 0 -8 -14 -4 -39 4 -30 2 -40 -10 -45 -8 -3 -13 -2 -10 3 6 8 -8 15 -126 62 l-48 19 0 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pa0Bp5lqC",
    d: "M600 871 c0 -15 12 -20 63 -28 41 -7 51 -11 30 -12 -38 -1 -45 -25 -10 -35 37 -10 47 -7 47 14 0 20 4 21 60 14 52 -6 60 -4 60 10 0 9 -1 16 -2 16 -2 0 -55 9 -118 20 -140 24 -130 24 -130 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plfijHwyN",
    d: "M1288 883 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pr2yFbb4X",
    d: "M1890 870 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12Aozrbuw",
    d: "M5290 855 c0 -24 5 -35 15 -35 16 0 18 12 9 48 -10 34 -24 26 -24 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxuKX0qYN",
    d: "M1198 873 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HifMD6pO",
    d: "M1108 863 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRJXE35ai",
    d: "M1700 850 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12FTSOW65",
    d: "M4480 856 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paYHEv8CY",
    d: "M1008 853 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HXIFxv8m",
    d: "M1610 840 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFAo74p2R",
    d: "M5440 852 c0 -5 21 -21 48 -35 l47 -27 -40 0 c-30 0 -36 -3 -25 -10 24 -16 80 -12 80 5 0 8 5 15 10 15 21 0 8 17 -29 38 -38 22 -91 30 -91 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgChuEsFo",
    d: "M1420 820 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pN4wyCUnS",
    d: "M4580 826 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzNq3iCiO",
    d: "M7436 788 c38 -54 84 -106 68 -77 -22 39 -90 129 -97 129 -5 0 8 -24 29 -52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13y1gR0G3",
    d: "M1330 810 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pK0SdDrGv",
    d: "M1140 790 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAhNa2tlj",
    d: "M4680 796 c0 -13 79 -40 89 -30 2 2 -1 4 -7 4 -7 0 -12 9 -12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ6vWsSoE",
    d: "M7882 770 c10 -29 25 -46 34 -38 9 9 -18 68 -31 68 -11 0 -12 -6 -3 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkzvCt3HW",
    d: "M4450 765 c0 -8 6 -15 13 -15 6 0 23 -3 36 -7 17 -4 22 -3 17 5 -4 7 -19 12 -34 13 -24 0 -25 1 -7 9 19 8 19 9 -2 9 -14 1 -23 -5 -23 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p85GDlDBk",
    d: "M5188 773 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1C95sWbon",
    d: "M4815 760 c-36 -6 -37 -7 -10 -9 17 -2 48 -8 70 -16 33 -11 36 -13 15 -14 -15 -1 -30 -5 -35 -9 -6 -5 -29 -14 -52 -21 -32 -9 -43 -17 -43 -31 0 -23 14 -25 59 -9 20 7 31 18 31 30 0 15 7 19 35 19 33 0 35 2 35 35 0 33 -2 35 -32 34 -18 -1 -51 -5 -73 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EsAy0FRl",
    d: "M5770 746 c0 -9 17 -16 45 -20 37 -6 46 -12 51 -32 9 -34 34 -31 34 5 0 27 -5 31 -54 45 -66 20 -76 20 -76 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph09SGBu5",
    d: "M5910 705 c0 -22 4 -25 36 -25 44 0 42 18 -4 37 -31 13 -32 12 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psZAtOTTg",
    d: "M5990 665 c0 -18 5 -25 20 -25 13 0 20 -7 20 -20 0 -15 7 -20 25 -20 34 0 31 16 -9 56 -40 40 -56 43 -56 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZedbyPxq",
    d: "M5541 666 c-7 -8 -11 -27 -9 -42 l3 -27 33 31 c17 16 32 35 32 41 0 16 -46 13 -59 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3fxxzHZa",
    d: "M4662 644 c-29 -14 -52 -30 -52 -35 0 -14 47 -10 63 5 8 8 27 16 43 18 18 2 30 10 32 21 5 25 -24 22 -86 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HPjOfe0H",
    d: "M7527 658 c6 -7 29 -39 52 -71 24 -32 45 -56 48 -54 6 7 -89 137 -100 137 -6 0 -6 -5 0 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pe6zhn5ke",
    d: "M4785 625 l-30 -14 38 -1 c26 0 37 4 37 15 0 18 -5 18 -45 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B3UTzrVK",
    d: "M5758 581 c29 -10 55 -21 58 -24 3 -3 -19 -22 -50 -44 -30 -21 -55 -41 -56 -45 0 -5 16 -8 35 -8 24 0 35 5 35 15 0 8 9 15 20 15 13 0 20 7 20 20 0 11 5 20 10 20 6 0 10 11 10 24 0 25 -2 25 -105 41 -17 3 -6 -3 23 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvdgvIAv5",
    d: "M7953 568 c19 -46 39 -49 25 -4 -6 20 -17 36 -25 36 -11 0 -11 -5 0 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2MQrJy0f",
    d: "M4542 569 c-12 -12 -18 -28 -15 -40 5 -19 8 -18 39 12 25 24 30 35 21 41 -18 12 -24 10 -45 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AMTBTJ8G",
    d: "M4673 575 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piCsxKKLm",
    d: "M5390 525 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEdsbVW4v",
    d: "M6010 513 l1 -38 24 28 c14 16 30 25 35 22 6 -3 10 1 10 9 0 12 -10 16 -35 16 -34 0 -35 -1 -35 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13ZuzgsL5",
    d: "M7410 501 c0 -15 25 -51 74 -105 l75 -82 -87 -18 c-160 -32 -183 -38 -179 -42 3 -4 235 29 300 42 23 5 26 8 16 20 -6 8 -20 14 -30 14 -11 0 -19 7 -19 18 0 9 -34 53 -75 97 -62 67 -74 76 -75 56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvegNtsry",
    d: "M7988 463 c24 -66 45 -69 24 -4 -9 28 -22 51 -29 51 -10 0 -9 -11 5 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11CURGoTG",
    d: "M5293 493 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCV95aCfe",
    d: "M4546 458 c-10 -38 -7 -48 14 -48 16 0 20 7 20 35 0 40 -24 49 -34 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAigT8FlE",
    d: "M6455 470 c-13 -6 -2 -7 30 -3 28 3 52 7 54 9 9 8 -65 2 -84 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHONAeBQZ",
    d: "M5643 445 c-61 -28 -68 -45 -18 -45 19 0 35 5 35 10 0 6 9 10 20 10 15 0 20 7 20 25 0 14 -1 25 -2 25 -2 0 -27 -11 -55 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prlM920Fb",
    d: "M6098 463 c-10 -2 -18 -10 -18 -17 0 -15 74 -28 108 -19 27 7 29 33 3 33 -10 0 -31 2 -47 4 -16 2 -37 2 -46 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMcmSuoUS",
    d: "M6308 463 c-10 -2 -18 -8 -18 -13 0 -10 93 -2 125 11 22 8 -76 10 -107 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17WExyRtr",
    d: "M4490 442 c0 -11 8 -26 19 -36 18 -16 18 -15 7 19 -12 38 -26 47 -26 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph93WglbT",
    d: "M5160 415 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4A72ePw8",
    d: "M5850 409 c0 -28 2 -30 28 -25 15 2 50 7 77 11 84 10 105 16 105 31 0 18 -32 18 -94 -1 -27 -8 -52 -13 -54 -10 -3 3 0 5 6 5 7 0 12 5 12 10 0 6 -18 10 -40 10 -38 0 -40 -2 -40 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbC7KfFiz",
    d: "M5758 403 c-20 -5 -25 -43 -7 -43 29 0 89 25 89 37 0 13 -44 16 -82 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppcHektbu",
    d: "M5513 385 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptq5hVStG",
    d: "M4893 357 c-25 -5 -43 -16 -43 -23 0 -9 -12 -14 -35 -14 -24 0 -35 -5 -35 -14 0 -15 24 -22 105 -30 l50 -5 -37 11 c-21 6 -38 15 -38 19 0 4 32 15 70 24 45 11 70 22 70 31 0 16 -43 17 -107 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptSObzygf",
    d: "M5620 350 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12pWj2HPt",
    d: "M4632 338 c3 -7 19 -18 36 -25 31 -13 32 -12 32 12 0 22 -4 25 -36 25 -23 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppgsQvsxD",
    d: "M5360 324 c-19 -8 -56 -20 -82 -25 -27 -6 -48 -15 -48 -20 0 -13 55 -11 117 3 45 11 53 16 53 35 0 13 -1 23 -2 23 -2 -1 -19 -8 -38 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyjtnHnkQ",
    d: "M5430 310 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13oR5cTKq",
    d: "M8044 305 c4 -10 -2 -19 -17 -25 -20 -8 -19 -9 11 -9 17 -1 32 3 32 8 0 18 -12 41 -22 41 -6 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GXJNvWnj",
    d: "M7875 270 c-16 -7 -13 -9 15 -9 19 0 44 4 55 9 16 7 13 9 -15 9 -19 0 -44 -4 -55 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14fY6dyl5",
    d: "M7720 260 c-20 -6 -21 -8 -5 -8 11 0 34 4 50 8 27 7 27 8 5 8 -14 0 -36 -4 -50 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQuuKW1Lk",
    d: "M7483 243 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l5iFAzKiqSY46MUlT5z3HZV",
    fill: "rgb(102,102,102)",
    style: {
      transform: "none"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pVsajPhbb",
    d: "M4992 2650 c-34 -4 -65 -10 -69 -13 -9 -10 31 -7 122 8 85 13 52 17 -53 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peyXHxnNH",
    d: "M3783 2643 c-28 -5 -30 -23 -4 -23 11 0 22 -9 26 -19 9 -29 35 -14 35 20 0 30 -5 32 -57 22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxdCxzYoM",
    d: "M3612 2625 c-56 -7 -106 -16 -110 -20 -7 -8 165 2 206 12 19 5 33 25 15 22 -5 -1 -54 -7 -111 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBmCbkPEZ",
    d: "M4728 2623 c-10 -2 -18 -11 -18 -19 0 -8 -4 -14 -10 -14 -5 0 -10 -11 -10 -25 0 -30 2 -31 51 -3 28 15 39 28 39 45 0 23 -12 27 -52 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EkU1KHup",
    d: "M4628 2613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12EW0dsux",
    d: "M3370 2590 c0 -12 27 -12 55 0 16 7 13 9 -17 9 -21 1 -38 -3 -38 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBC950wb2",
    d: "M4418 2593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pksP3SRuA",
    d: "M3163 2578 c-13 -16 -23 -68 -16 -85 9 -24 33 -14 33 15 0 35 9 49 40 61 24 9 24 10 3 10 -12 1 -28 3 -36 6 -7 3 -18 0 -24 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAJxXndqN",
    d: "M3270 2580 c0 -12 27 -12 55 0 16 7 13 9 -17 9 -21 1 -38 -3 -38 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2D4NFA8s",
    d: "M4318 2583 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbi8SKVY8",
    d: "M2985 2570 c-13 -6 -5 -7 25 -3 25 3 47 7 49 9 9 8 -55 2 -74 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzUTLErtE",
    d: "M4253 2555 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ7h5ahYn",
    d: "M2827 2553 c-7 -7 -10 -53 -3 -53 2 0 18 14 36 30 l32 30 -29 0 c-16 0 -33 -3 -36 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYMr9RH4a",
    d: "M3804 2506 c-5 -20 -14 -24 -62 -30 -81 -10 -102 -16 -102 -33 0 -22 110 -8 128 15 9 13 15 14 20 5 8 -12 110 -39 118 -31 2 3 -13 10 -34 16 -36 11 -38 14 -34 47 3 27 1 35 -12 35 -8 0 -18 -11 -22 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "px5n9Bj9o",
    d: "M4143 2505 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5TM7GPsT",
    d: "M4553 2513 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYVVPLMaD",
    d: "M3155 2438 c-2 -13 -4 -32 -2 -42 2 -18 -11 -22 -128 -42 -71 -12 -132 -20 -134 -18 -2 2 -11 -5 -19 -17 -12 -18 -12 -22 4 -34 12 -8 23 -10 29 -4 5 5 19 9 31 9 13 0 35 5 51 12 15 7 52 12 81 13 32 0 56 5 61 13 5 8 17 11 34 7 15 -4 34 -1 49 8 12 8 101 27 196 42 151 25 172 30 172 46 0 23 17 24 -170 -7 -85 -14 -167 -27 -182 -29 -31 -5 -39 11 -10 19 9 3 68 13 129 22 62 10 111 20 109 22 -3 2 -62 -4 -132 -13 -117 -16 -128 -16 -136 -1 -13 23 -27 20 -33 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCB5USPRM",
    d: "M2800 2414 c0 -38 15 -74 30 -74 6 0 10 9 10 20 0 18 6 20 53 18 35 -1 42 -2 20 -5 -18 -2 -33 -9 -33 -15 0 -5 6 -8 13 -5 6 2 45 10 86 17 66 12 71 15 55 27 -11 8 -29 11 -42 8 -13 -3 -31 0 -39 6 -11 10 -16 10 -23 0 -6 -10 -10 -7 -16 10 l-7 24 -13 -30 -12 -30 -7 28 c-7 26 -25 38 -25 17 0 -5 -4 -10 -10 -10 -5 0 -10 7 -10 15 0 8 -7 15 -15 15 -11 0 -15 -11 -15 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AmEgHpsW",
    d: "M4430 2425 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10owLoi8g",
    d: "M3911 2401 c-76 -32 -89 -51 -37 -51 25 0 36 4 36 15 0 10 11 15 35 15 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -32 -13 -67 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FZbJ4WTz",
    d: "M4608 2389 c-21 -11 -38 -22 -38 -24 0 -3 18 4 40 15 22 11 40 23 40 25 0 7 0 7 -42 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pykN2vGMk",
    d: "M4320 2365 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9vJIDhdT",
    d: "M4482 2303 c-39 -32 -71 -62 -71 -66 -1 -11 41 20 104 77 71 64 50 57 -33 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIC1RCxNA",
    d: "M3763 2335 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GBN672Wh",
    d: "M4203 2323 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17RAdFR2J",
    d: "M2780 2315 c-8 -2 -32 -6 -52 -10 -58 -9 -48 -29 10 -20 70 10 92 16 92 26 0 9 -19 10 -50 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBXz1m97U",
    d: "M3655 2287 c-54 -25 -51 -30 29 -42 25 -4 49 -12 52 -17 4 -5 -8 -7 -28 -4 -57 10 -163 26 -170 26 -5 0 -8 -8 -8 -18 0 -16 14 -20 89 -30 48 -7 105 -12 125 -12 37 0 37 0 34 37 -3 33 -7 39 -32 43 -16 3 -32 13 -35 22 -6 16 -10 16 -56 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz8HvUmL0",
    d: "M4093 2263 c-13 -5 -19 -53 -7 -53 13 0 84 44 84 52 0 9 -57 10 -77 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzllVclT0",
    d: "M2313 2250 c-26 -10 -49 -102 -38 -156 5 -28 10 -34 30 -34 31 0 33 -17 3 -22 -21 -3 -21 -4 8 -32 32 -32 100 -53 154 -47 l35 3 -34 12 -35 12 82 18 c56 12 82 22 82 32 0 17 -28 18 -103 3 -36 -8 -57 -17 -57 -25 0 -8 -9 -14 -20 -14 -11 0 -20 4 -20 9 0 4 -11 6 -24 4 -35 -7 -41 14 -6 22 27 6 44 35 20 35 -5 0 -10 9 -10 20 0 28 -20 25 -21 -2 0 -23 0 -22 -10 2 -13 33 -16 35 -34 20 -13 -11 -15 -7 -14 26 3 84 10 98 59 111 44 11 44 11 10 12 -19 0 -45 -4 -57 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10JyxPxh9",
    d: "M2985 2252 c15 -16 85 -27 85 -13 0 6 -6 11 -14 11 -7 0 -29 3 -47 6 -24 5 -31 3 -24 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17JEsn60g",
    d: "M4284 2139 c-102 -85 -132 -119 -104 -119 6 0 9 -3 6 -8 -6 -11 21 -72 33 -72 21 0 21 22 1 55 -12 19 -20 39 -18 43 2 5 41 41 88 82 114 98 115 99 109 105 -3 2 -54 -36 -115 -86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBRyqDc5h",
    d: "M2596 2176 c-4 -22 -1 -48 9 -72 8 -20 15 -45 15 -55 0 -11 6 -19 14 -19 27 0 76 35 76 54 0 15 -5 17 -30 13 -22 -5 -30 -3 -30 8 0 9 20 18 58 25 31 6 68 16 82 21 22 8 20 8 -9 4 -19 -3 -58 -8 -87 -11 l-51 -6 -7 36 c-9 46 -32 47 -40 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBQaMdyBY",
    d: "M3292 2188 c3 -7 19 -18 36 -25 31 -13 32 -12 32 12 0 22 -4 25 -36 25 -23 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pd9bRt0Ww",
    d: "M2975 2164 c-49 -12 -125 -30 -167 -39 -64 -14 -78 -20 -78 -36 0 -10 5 -19 10 -19 6 0 85 19 175 41 109 27 165 46 165 55 0 21 -11 21 -105 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTPpZ8WTn",
    d: "M3980 2150 c0 -28 -3 -30 -35 -30 -32 0 -35 -2 -35 -31 l0 -30 28 20 c15 11 47 39 72 60 l45 40 -37 1 c-36 0 -38 -2 -38 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ff0863NG",
    d: "M3273 2100 c-51 -23 -55 -40 -10 -40 42 0 60 12 55 38 l-3 21 -42 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14nM4Btoj",
    d: "M2410 2075 c0 -27 1 -27 42 -21 22 4 45 9 51 13 16 9 -21 25 -44 18 -11 -4 -26 -1 -34 5 -13 10 -15 8 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVEGQQ2xm",
    d: "M3830 2019 l0 -30 30 21 c44 31 45 40 6 40 -33 0 -36 -2 -36 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16ThqcSd8",
    d: "M3039 1988 l-44 -21 40 -8 c22 -4 48 -8 58 -8 20 -1 23 25 4 44 -12 11 -21 10 -58 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15z8BjtK4",
    d: "M3916 1994 c-38 -8 -71 -16 -74 -19 -14 -14 12 -11 98 10 103 25 87 31 -24 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pboMJJw93",
    d: "M7783 2003 c-18 -2 -33 -9 -33 -14 0 -11 85 -2 110 12 16 9 -14 10 -77 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGcgo8wRV",
    d: "M8040 2000 c73 -6 74 -6 20 -9 -30 -1 -64 -7 -75 -12 -13 -6 5 -7 58 -4 42 3 77 4 77 2 0 -2 -40 -21 -90 -42 -49 -21 -90 -42 -90 -46 0 -11 20 -3 145 56 117 55 113 64 -30 62 l-90 -1 75 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTFuf07Kz",
    d: "M3130 1965 c0 -8 6 -15 13 -15 7 0 22 -7 33 -15 18 -14 17 -14 -13 -9 -29 6 -33 4 -33 -15 0 -17 6 -21 29 -21 48 0 61 9 61 45 0 36 -13 45 -61 45 -19 0 -29 -5 -29 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9IoNOzgW",
    d: "M3746 1954 c-10 -25 -7 -74 4 -74 6 0 18 16 27 35 9 19 23 35 30 35 7 0 13 5 13 10 0 17 -67 12 -74 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CZdca6d9",
    d: "M7530 1931 c-79 -25 -116 -42 -118 -53 -3 -13 17 -9 110 23 105 38 138 53 127 62 -2 2 -56 -12 -119 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdFKzXyXa",
    d: "M2540 1945 c0 -12 18 -15 104 -15 57 0 118 -3 135 -6 23 -5 31 -3 31 8 0 11 -19 17 -77 22 -132 11 -193 8 -193 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pawxNe2p3",
    d: "M2880 1936 c0 -16 21 -26 56 -26 31 0 32 26 2 34 -37 10 -58 7 -58 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pURWUJow5",
    d: "M3020 1921 c0 -17 6 -21 31 -21 17 0 37 7 45 15 13 13 13 15 1 15 -8 0 -29 3 -46 6 -27 6 -31 4 -31 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYyy15LwV",
    d: "M5028 1933 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Bh2UZePb",
    d: "M5670 1920 c0 -17 7 -20 50 -20 36 0 50 4 50 14 0 15 -30 26 -72 26 -21 0 -28 -5 -28 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAonylEGS",
    d: "M4908 1923 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prLGIySdK",
    d: "M5900 1910 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLzuSJOuD",
    d: "M6050 1900 c0 -16 7 -20 30 -20 19 0 30 -5 30 -14 0 -18 32 -26 113 -26 60 0 67 2 67 20 0 11 -6 20 -14 20 -8 0 -16 4 -18 10 -1 5 -18 12 -35 16 -26 5 -33 3 -33 -10 0 -12 -9 -16 -35 -16 -23 0 -35 5 -35 14 0 13 -28 26 -57 26 -7 0 -13 -9 -13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmMpI7Ehj",
    d: "M4598 1893 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6mYQXh8K",
    d: "M6340 1880 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5qStPXPt",
    d: "M4498 1883 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pntQdcM71",
    d: "M6480 1870 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pU1Wtke8F",
    d: "M4398 1873 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTiuOkQ22",
    d: "M5550 1860 c0 -16 7 -20 38 -20 52 0 82 10 82 26 0 10 -16 14 -60 14 -53 0 -60 -2 -60 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3xrNjNfV",
    d: "M7835 1854 c-33 -14 -64 -30 -69 -35 -6 -5 -18 -9 -28 -9 -11 0 -18 -7 -18 -20 0 -13 5 -18 15 -14 16 7 26 -11 29 -51 1 -32 31 -34 40 -2 3 12 3 38 0 58 -6 35 -5 36 45 58 28 12 51 26 51 31 0 12 6 14 -65 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7cqB7ZI7",
    d: "M5270 1855 c0 -8 -7 -15 -15 -15 -8 0 -15 5 -15 10 0 6 -20 10 -45 10 -39 0 -45 -3 -45 -20 0 -19 5 -20 83 -15 64 4 75 3 50 -5 -30 -10 -73 -52 -73 -71 0 -5 10 -9 21 -9 16 0 20 5 17 18 -4 15 -1 18 18 14 17 -3 24 0 24 12 0 18 4 18 73 7 26 -4 50 -4 53 0 5 9 -26 27 -65 40 -23 6 -22 7 12 8 77 2 22 31 -59 31 -24 0 -34 -5 -34 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmzti7p0c",
    d: "M6660 1856 c0 -14 47 -25 110 -26 29 -1 41 -8 70 -46 19 -25 34 -52 34 -59 -1 -9 7 -15 18 -15 16 0 19 6 16 38 -2 29 -8 38 -25 40 -15 2 -23 11 -25 30 -3 29 -12 31 -140 46 -46 5 -58 3 -58 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DMd2aUmP",
    d: "M7521 1789 c-96 -38 -176 -68 -178 -66 -2 3 51 26 117 53 l121 49 -53 3 c-31 2 -54 -1 -56 -7 -2 -6 -15 -11 -28 -11 -13 0 -24 -4 -24 -10 0 -5 -11 -10 -24 -10 -13 0 -26 -5 -28 -12 -3 -7 -43 -12 -119 -14 -63 -2 -106 -1 -96 2 9 3 17 15 17 26 0 18 -4 19 -40 13 -51 -9 -135 4 -105 16 17 6 15 8 -11 8 -17 1 -46 4 -63 7 -27 6 -31 4 -31 -15 0 -16 6 -21 25 -21 14 0 25 -4 25 -9 0 -4 19 -13 43 -18 24 -6 33 -11 20 -12 -16 -1 -23 -7 -23 -21 0 -19 7 -20 162 -20 158 0 194 -8 100 -21 -44 -6 -42 -6 25 -8 39 0 73 3 75 8 2 6 77 42 168 81 91 40 167 74 169 76 11 11 -28 -3 -188 -67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5oxR0Bd1",
    d: "M5030 1830 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11855qhgC",
    d: "M7233 1838 c-41 -13 -44 -38 -5 -38 47 0 72 11 72 31 0 21 -17 23 -67 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkSgD8U6M",
    d: "M4910 1820 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptjFLMMow",
    d: "M2733 1802 c-24 -15 -43 -30 -43 -34 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 9 0 15 9 15 25 0 31 -5 31 -57 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGBbMStss",
    d: "M4790 1810 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOVv1OS8e",
    d: "M4670 1800 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjsforpzR",
    d: "M4550 1790 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRnfCzT6S",
    d: "M4420 1780 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peq3me9yF",
    d: "M7591 1749 c-63 -27 -129 -49 -145 -50 l-31 -1 33 -11 c23 -7 40 -7 58 2 23 10 26 9 31 -9 8 -29 25 -24 21 6 -3 24 2 28 67 51 75 27 89 36 84 52 -2 5 -54 -12 -118 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSysWxEsB",
    d: "M4300 1770 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16GxjAC0d",
    d: "M5410 1764 c-15 -38 -12 -54 10 -54 13 0 20 7 20 20 0 11 5 20 10 20 6 0 5 8 -2 20 -17 27 -27 25 -38 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5gad1Zwy",
    d: "M4170 1760 l-45 -19 45 0 c59 -1 90 8 90 25 0 19 -36 17 -90 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWIpMVz6X",
    d: "M3646 1754 c-9 -23 -7 -74 2 -74 8 0 52 71 52 84 0 14 -48 5 -54 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FUG3mkvC",
    d: "M5061 1708 c1 -16 3 -18 6 -6 2 9 12 19 21 21 12 3 10 5 -5 6 -18 1 -23 -4 -22 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pW5QOYNNP",
    d: "M7108 1703 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DUhZV4va",
    d: "M5439 1666 c10 -11 8 -16 -8 -21 -12 -3 -21 -15 -21 -26 0 -14 -7 -19 -25 -19 -13 0 -29 -8 -34 -17 -7 -12 -13 -14 -18 -7 -14 19 -50 34 -84 34 -27 0 -30 -2 -18 -16 53 -64 175 -53 220 20 25 42 25 66 -2 66 -17 0 -19 -3 -10 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLyE1dWxT",
    d: "M7819 1633 c38 -53 108 -115 127 -111 14 2 5 17 -45 71 -36 38 -72 67 -83 67 -19 0 -19 0 1 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHTlebex7",
    d: "M2448 1643 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9xNgbUa1",
    d: "M2368 1633 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prl8gvoWT",
    d: "M3460 1620 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19BX7gAIV",
    d: "M7712 1618 c-14 -14 -16 -48 -4 -48 10 0 34 20 51 43 12 15 11 17 -11 17 -13 0 -29 -5 -36 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HTdl7dZY",
    d: "M2218 1613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10D7oSDo1",
    d: "M3370 1600 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXInHd9y8",
    d: "M2138 1603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3H5dtdUR",
    d: "M3280 1580 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJIHVU9bC",
    d: "M7628 1593 c-24 -6 -28 -25 -12 -61 17 -40 34 -41 34 -2 0 20 5 30 15 30 8 0 15 9 15 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNwz0T2Uk",
    d: "M1988 1583 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11ygvR93p",
    d: "M7535 1580 c-16 -7 -13 -9 18 -9 20 -1 37 4 37 9 0 12 -27 12 -55 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXyOFCxcK",
    d: "M1908 1573 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Hu9Bp49x",
    d: "M3190 1560 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNzBDZQw8",
    d: "M1758 1553 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgGVGngnK",
    d: "M3100 1540 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVkREApKR",
    d: "M1578 1533 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HQSX9Cp7",
    d: "M2350 1520 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyAEQiiZz",
    d: "M3010 1520 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppCNc6fmX",
    d: "M1478 1523 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ9MZFWg5",
    d: "M2270 1510 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psH84YpsF",
    d: "M2143 1513 c-35 -3 -43 -8 -43 -25 0 -18 4 -19 53 -13 88 10 107 16 107 31 0 14 -20 15 -117 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19EBmdMpH",
    d: "M2920 1500 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peTp0afyq",
    d: "M1348 1503 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pL8AeCZYN",
    d: "M2020 1480 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11oxl0WMe",
    d: "M2570 1486 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIy84nYRT",
    d: "M2830 1480 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzZx6s8bQ",
    d: "M1930 1470 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLqq8xka3",
    d: "M6460 1444 c-151 -23 -278 -43 -282 -43 -5 -1 -8 -8 -8 -17 0 -15 8 -16 60 -11 33 4 72 10 85 13 22 5 25 3 25 -20 0 -19 5 -26 18 -26 11 0 45 -9 76 -20 52 -18 57 -18 54 -3 -2 12 -26 24 -73 38 -57 18 -66 23 -45 27 122 29 410 107 390 106 -14 0 -149 -20 -300 -44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFN9BjKCX",
    d: "M1165 1475 c-5 -2 -27 -6 -47 -10 -24 -4 -38 -11 -38 -20 0 -17 15 -18 84 -9 36 5 46 11 46 25 0 18 -18 23 -45 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3BciTPqE",
    d: "M1850 1460 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p157X5CCya",
    d: "M1723 1463 c-35 -3 -43 -8 -43 -25 0 -18 4 -19 53 -13 88 10 107 16 107 31 0 14 -20 15 -117 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWWyggzTV",
    d: "M5080 1425 c0 -32 3 -35 28 -35 19 0 23 3 13 9 -11 7 -10 13 4 35 l17 26 -31 0 c-29 0 -31 -2 -31 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPvCrETDm",
    d: "M5365 1449 c29 -17 31 -19 17 -28 -10 -6 -9 -14 3 -37 8 -16 15 -34 15 -41 0 -6 14 1 30 15 17 15 30 33 30 42 0 18 -42 44 -85 54 -26 5 -27 5 -10 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8WtuPPkt",
    d: "M1513 1437 c-71 -8 -83 -13 -83 -28 0 -22 -4 -22 97 -9 131 17 143 20 143 35 0 17 -29 17 -157 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZeCqXDqK",
    d: "M8030 1434 c0 -23 33 -58 50 -52 6 2 -3 19 -19 38 -26 31 -30 32 -31 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqpwEUZWi",
    d: "M888 1423 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pK2KKB1jT",
    d: "M1303 1413 c-35 -3 -43 -8 -43 -25 0 -18 4 -19 53 -13 88 10 107 16 107 31 0 14 -20 15 -117 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HNqR3FNK",
    d: "M945 1357 c-132 -22 -241 -44 -243 -49 -2 -4 -19 -8 -38 -8 -19 0 -34 -4 -34 -10 0 -5 -12 -10 -26 -10 -45 0 -134 -30 -134 -46 0 -8 -10 -14 -25 -14 -14 0 -25 -4 -25 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -6 -15 -13 0 -9 -9 -12 -28 -10 -39 6 -113 -48 -105 -77 5 -21 6 -21 27 -3 44 39 60 46 31 14 -28 -31 -24 -30 55 19 47 30 99 62 116 72 59 35 232 78 469 118 304 51 295 49 295 66 0 20 -33 17 -305 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKPnIawCT",
    d: "M6078 1393 c-33 -8 -20 -33 17 -33 28 0 35 -4 35 -20 0 -21 10 -24 48 -14 30 9 28 34 -3 34 -18 0 -25 5 -25 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptS7opJfy",
    d: "M7678 1353 c20 -54 42 -68 42 -26 0 52 -11 73 -36 73 l-24 0 18 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC9fZ2qjb",
    d: "M5978 1383 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF79oKZEU",
    d: "M7880 1362 c0 -33 27 -62 58 -62 19 0 21 -4 16 -30 -7 -34 4 -38 53 -19 l28 10 -50 45 c-28 24 -62 53 -77 65 l-28 20 0 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjFfrl8QL",
    d: "M708 1373 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNXPOLuPZ",
    d: "M5878 1373 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIX7D7D2U",
    d: "M5778 1363 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pK98diKBN",
    d: "M5040 1325 c0 -24 5 -35 15 -35 8 0 15 7 15 15 0 8 10 23 22 35 l22 20 -37 0 c-36 0 -37 -1 -37 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXWZvHKKn",
    d: "M5678 1353 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSPBLS9kH",
    d: "M5578 1343 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKocdwUSy",
    d: "M5478 1333 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15mxOisxr",
    d: "M6000 1320 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phwT4PDHD",
    d: "M5910 1310 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLl7XKc66",
    d: "M6510 1307 c0 -12 52 -37 78 -37 22 0 12 19 -18 35 -36 18 -60 19 -60 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pe0Xs91Y1",
    d: "M5740 1290 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUUfNChee",
    d: "M8160 1296 c0 -9 7 -19 15 -23 25 -9 27 2 5 22 -18 17 -20 17 -20 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14ZsO8pfp",
    d: "M5650 1280 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDJCmAiGT",
    d: "M4958 1273 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMBH7Ofx",
    d: "M5480 1260 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10gDJBD4Z",
    d: "M4858 1263 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZBCjVYbp",
    d: "M5390 1250 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJcX1RaT6",
    d: "M4768 1253 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqJI6QSeo",
    d: "M6610 1252 c0 -13 105 -72 129 -72 19 0 21 3 11 15 -32 38 -140 82 -140 57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pruWlpBfH",
    d: "M4668 1243 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdTeM3H5T",
    d: "M4578 1233 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXreet7tW",
    d: "M5040 1230 c0 -5 -16 -10 -35 -10 -28 0 -35 -4 -35 -20 0 -22 10 -24 56 -11 l31 9 7 -55 c4 -31 5 -58 2 -60 -2 -2 -22 5 -45 16 -42 22 -91 28 -91 12 0 -12 118 -71 141 -71 16 0 18 7 13 68 -8 107 -14 132 -29 132 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17GE9XD93",
    d: "M7730 1224 c0 -22 89 -276 100 -288 25 -25 18 15 -26 153 -30 95 -52 151 -61 151 -7 0 -13 -7 -13 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSaaN8V2f",
    d: "M4488 1223 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzZGTYj5t",
    d: "M4398 1213 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pv2UDhPmz",
    d: "M4298 1203 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRsQkFrna",
    d: "M4208 1193 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTP0GRTgG",
    d: "M4108 1183 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p105BHiUh8",
    d: "M4700 1170 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQU6omOB2",
    d: "M4018 1173 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18buXIafX",
    d: "M4610 1160 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVS7nJ4lT",
    d: "M3928 1163 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pu4gt32wv",
    d: "M4510 1150 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvIjhhFEf",
    d: "M3828 1153 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGIQCCybN",
    d: "M4408 1153 c-24 -6 -25 -68 -2 -77 25 -9 74 -7 74 4 0 5 -12 16 -27 23 l-27 15 32 7 c43 9 43 35 0 34 -18 -1 -41 -3 -50 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15kTSO8jk",
    d: "M3738 1143 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGECVb8VY",
    d: "M3648 1133 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkDFuaeQa",
    d: "M5367 1108 c7 -37 10 -44 19 -35 9 8 -6 67 -17 67 -4 0 -6 -15 -2 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgR0UFi9r",
    d: "M3548 1123 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnKfCuwkH",
    d: "M3458 1113 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "px7M3bS9E",
    d: "M3368 1103 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSTCkUFvT",
    d: "M3268 1093 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQTWsJDFt",
    d: "M3178 1083 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6v9GgVEb",
    d: "M3088 1073 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15RTVTL4c",
    d: "M3660 1060 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pITlbEovb",
    d: "M2988 1063 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNV4PPZ2o",
    d: "M5280 1024 c0 -54 8 -94 19 -94 8 0 -4 128 -13 137 -3 4 -6 -16 -6 -43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT0Lrqui",
    d: "M2898 1053 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSyNybeem",
    d: "M3850 1046 c0 -7 17 -18 38 -23 37 -10 38 -9 34 13 -4 20 -11 24 -38 24 -22 0 -34 -5 -34 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfSBRRVYL",
    d: "M2808 1043 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peizwgTGp",
    d: "M3380 1030 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDgeoZqE5",
    d: "M3500 1036 c0 -13 29 -26 60 -26 13 0 13 1 0 10 -10 6 -11 10 -2 10 6 0 12 5 12 10 0 6 -16 10 -35 10 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKQoqzQGB",
    d: "M4560 1027 c0 -17 11 -28 45 -45 47 -23 105 -29 105 -12 0 9 -74 50 -126 70 -21 8 -24 7 -24 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnOce6k5J",
    d: "M2708 1033 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX3koMvxe",
    d: "M240 1015 c0 -12 47 -45 65 -45 16 0 0 21 -30 39 -28 16 -35 17 -35 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAjcrpG6U",
    d: "M2618 1023 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AgsaC5Eb",
    d: "M3190 1010 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9Cl3UJn6",
    d: "M5074 988 c19 -153 18 -166 -6 -173 -69 -19 -78 -27 -78 -61 0 -31 3 -34 30 -34 45 0 77 19 83 49 3 15 2 70 -3 122 -5 52 -10 104 -10 117 0 12 -5 22 -11 22 -6 0 -8 -16 -5 -42z m16 -217 c0 -10 -25 -21 -48 -21 -12 1 -10 5 8 15 29 17 40 18 40 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poc3gzYFE",
    d: "M5375 998 c8 -37 12 -44 21 -35 9 9 -6 67 -18 67 -6 0 -7 -13 -3 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11LZvMEIF",
    d: "M2528 1013 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZxm9jqeY",
    d: "M4080 1010 c0 -5 -10 -11 -22 -11 -13 -1 9 -7 47 -13 70 -12 69 -18 -5 -29 -18 -3 -14 -5 11 -6 20 0 56 -8 79 -16 56 -20 70 -19 70 5 0 15 -7 20 -25 20 -20 0 -25 5 -25 24 0 20 -6 24 -46 30 -65 8 -84 8 -84 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pogcuVznR",
    d: "M560 995 c0 -24 12 -45 26 -45 23 0 17 47 -6 53 -13 3 -20 0 -20 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDHsqdElc",
    d: "M2428 1003 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkwq0cwhB",
    d: "M502 986 c-19 -10 -21 -15 -10 -23 7 -6 25 -14 40 -18 25 -6 26 -5 19 21 -9 33 -19 37 -49 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTWcoIu5T",
    d: "M2338 993 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p67N81yLi",
    d: "M2910 980 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5GiCRyIk",
    d: "M2238 983 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9Ht043Pi",
    d: "M2820 970 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUjdClyeV",
    d: "M330 964 c0 -13 43 -34 70 -34 13 0 20 7 20 19 0 15 -9 20 -45 23 -28 2 -45 -1 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1A4PBQaK2",
    d: "M2148 973 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p25bDAQux",
    d: "M2058 963 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psj8VgKxE",
    d: "M2630 950 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxDPdRlVk",
    d: "M7330 940 c12 -16 24 -30 26 -30 3 0 -4 14 -16 30 -12 17 -24 30 -26 30 -3 0 4 -13 16 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py28kg1sP",
    d: "M1968 953 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paNn6CWPA",
    d: "M1868 943 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgqzHT3Er",
    d: "M2440 930 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHwC9gBan",
    d: "M4770 925 c0 -22 4 -25 35 -25 24 0 35 -5 35 -15 0 -10 11 -15 35 -15 65 0 37 24 -82 71 -20 7 -23 5 -23 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piemIJK2p",
    d: "M6968 923 c35 -48 69 -75 92 -71 21 3 19 6 -20 51 -29 32 -49 47 -67 47 l-24 0 19 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pa9vbKWY0",
    d: "M1778 933 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paGJ8wdpb",
    d: "M2350 920 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HqfGMRFs",
    d: "M1678 923 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJfm4lQ7k",
    d: "M1588 913 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ8KLbEJW",
    d: "M2160 900 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppk0r32zh",
    d: "M1498 903 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSUA2byXf",
    d: "M2070 890 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxLWXtvcy",
    d: "M5380 898 c0 -25 12 -58 21 -58 16 0 23 52 8 61 -20 12 -29 11 -29 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16GhzogLB",
    d: "M500 885 c0 -17 61 -49 70 -36 3 3 50 -1 105 -10 55 -9 85 -17 68 -18 -41 -1 -45 -27 -5 -35 98 -19 102 -19 102 2 0 16 -8 22 -32 25 l-33 4 33 1 c40 2 44 28 5 36 -44 9 -203 34 -260 41 -45 6 -53 4 -53 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTJhLirGq",
    d: "M1398 893 c-10 -2 -18 -11 -18 -19 0 -10 13 -14 45 -14 38 0 45 3 45 20 0 15 -6 20 -27 19 -16 -1 -36 -3 -45 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GuI77KKL",
    d: "M4380 887 c0 -8 25 -21 60 -30 76 -21 80 -21 80 3 0 16 -7 20 -35 20 -19 0 -35 5 -35 10 0 6 -16 10 -35 10 -23 0 -35 -5 -35 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4Vr8EMUG",
    d: "M1308 883 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVE7bNFbZ",
    d: "M1880 870 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15EGdbuaQ",
    d: "M1218 873 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph8JOdqhb",
    d: "M1790 860 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pva7JDyjc",
    d: "M5290 845 c0 -24 5 -35 15 -35 16 0 18 12 9 48 -10 34 -24 26 -24 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3PQbhE5c",
    d: "M1118 863 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIXWzCUro",
    d: "M5460 852 c0 -11 15 -26 38 -37 27 -14 32 -20 20 -22 -34 -8 -20 -33 17 -33 32 0 35 3 35 28 0 22 -9 32 -49 55 -58 32 -61 32 -61 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AHsZONE",
    d: "M7419 814 c23 -32 79 -112 124 -176 60 -86 87 -117 102 -117 13 1 15 3 5 6 -8 2 -68 78 -134 168 -65 91 -123 168 -129 172 -6 3 9 -20 32 -53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paJ05G8zp",
    d: "M1028 853 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ka1ZHs3",
    d: "M1600 840 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcSwCz5KW",
    d: "M1510 830 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLgvgKPqD",
    d: "M4550 836 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHuMfckt6",
    d: "M1320 810 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HazDJ5YN",
    d: "M7872 800 c10 -29 25 -46 34 -38 9 9 -18 68 -31 68 -11 0 -12 -6 -3 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJY5j4kfz",
    d: "M1230 800 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p844Sebrc",
    d: "M4650 806 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5oZRMcei",
    d: "M880 786 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puvTY4CTs",
    d: "M1040 780 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvCdXpOhT",
    d: "M4750 775 c0 -9 14 -17 38 -21 20 -3 54 -10 75 -14 21 -4 37 -4 37 1 0 5 -4 9 -10 9 -5 0 -10 6 -10 14 0 8 -17 16 -46 20 -69 9 -84 8 -84 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqa3b3RA7",
    d: "M5580 755 c0 -24 5 -35 15 -35 8 0 15 7 15 15 0 20 53 20 160 -1 45 -8 84 -13 87 -10 13 12 -12 24 -79 35 -40 7 -95 17 -121 22 -74 14 -77 13 -77 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfXpAAS30",
    d: "M5198 773 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pd9bJUlot",
    d: "M4480 750 c8 -5 26 -9 40 -9 23 0 23 1 5 9 -11 5 -29 9 -40 9 -17 1 -17 -1 -5 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puueEnKeI",
    d: "M5880 710 c0 -16 7 -20 35 -20 39 0 46 14 16 30 -31 16 -51 12 -51 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkrzQQQWE",
    d: "M4856 713 c-4 -4 -51 -22 -104 -39 -79 -25 -98 -35 -100 -52 l-3 -22 66 25 c36 14 74 25 85 25 13 0 20 7 20 18 0 14 7 17 40 14 35 -4 40 -2 40 17 0 21 -28 30 -44 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmPSIqH3I",
    d: "M7938 613 c24 -66 45 -69 24 -4 -9 28 -22 51 -29 51 -10 0 -9 -11 5 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puZ0oZYFz",
    d: "M6040 585 l0 -65 -30 0 c-16 0 -30 -4 -30 -10 0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -25 0 -22 -4 -25 -40 -25 -29 0 -40 -4 -40 -15 0 -8 -7 -15 -15 -15 -9 0 -15 -9 -15 -21 0 -19 4 -20 43 -14 82 12 97 17 97 30 0 11 -7 12 -32 4 -18 -5 -35 -9 -38 -9 -3 0 25 20 61 44 37 25 69 52 73 61 4 10 12 15 21 11 8 -3 22 -9 30 -12 9 -4 15 0 15 9 0 9 -9 19 -20 22 -16 5 -19 12 -14 31 7 25 -12 74 -28 74 -4 0 -8 -29 -8 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pab6ckV9e",
    d: "M4595 593 c-40 -6 -85 -50 -85 -82 l1 -26 28 31 c16 18 46 43 67 58 21 14 34 25 29 25 -6 -1 -23 -4 -40 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcjBkGkfY",
    d: "M5780 576 c37 -14 54 -11 30 4 -8 6 -26 9 -40 9 -22 0 -21 -2 10 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfTYpbTEN",
    d: "M4655 566 c-66 -29 -131 -122 -109 -157 13 -22 33 -6 39 31 4 25 12 40 21 40 8 0 14 9 14 20 0 14 7 20 23 20 32 0 49 14 45 38 -3 19 -5 19 -33 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFUCrmyL8",
    d: "M7360 549 c0 -31 60 -92 86 -87 14 2 7 14 -34 58 -47 51 -51 53 -52 29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prprEwdwG",
    d: "M7970 524 c0 -20 18 -54 29 -54 5 0 4 16 -2 35 -11 36 -27 47 -27 19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJFfa9k8z",
    d: "M7693 523 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pB3E6zHc6",
    d: "M6133 496 c9 -7 17 -16 17 -19 0 -2 -31 -13 -70 -22 -48 -12 -70 -22 -70 -32 0 -13 11 -15 57 -11 31 3 59 10 61 16 2 7 17 12 33 12 25 0 29 4 29 29 0 30 -15 41 -53 41 -20 -1 -21 -2 -4 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWBWaPGUT",
    d: "M5260 470 c0 -5 -11 -10 -25 -10 -20 0 -25 -5 -25 -25 0 -23 2 -24 27 -14 54 20 93 41 93 50 0 5 -16 9 -35 9 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFna6FgCb",
    d: "M6210 447 c0 -16 5 -18 33 -14 17 3 53 9 80 13 72 10 56 19 -33 19 -72 0 -80 -2 -80 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15dEj39X8",
    d: "M5623 435 c-61 -29 -68 -45 -18 -45 19 0 35 5 35 10 0 6 9 10 20 10 15 0 20 7 20 25 0 14 -1 25 -2 25 -2 -1 -27 -12 -55 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXRjMLkI0",
    d: "M5080 390 c0 -22 20 -26 51 -10 30 16 23 30 -16 30 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2cnajO60",
    d: "M4574 361 c10 -10 26 -21 37 -24 15 -4 19 0 19 19 0 21 -5 24 -37 24 -35 0 -36 -1 -19 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMdutZKoG",
    d: "M5660 360 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pM3q0c144",
    d: "M7534 346 l26 -34 -71 -13 c-80 -14 -108 -34 -33 -24 119 18 129 20 132 39 5 23 -35 66 -61 66 -18 0 -17 -3 7 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSvhhtlOE",
    d: "M5443 355 c-18 -8 -33 -19 -33 -25 0 -5 -9 -10 -20 -10 -13 0 -20 -7 -20 -20 0 -11 6 -20 13 -20 29 0 57 13 57 26 0 17 37 19 42 3 6 -17 68 -1 68 17 0 9 -11 14 -34 14 -22 0 -36 5 -38 14 -3 12 -8 13 -35 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puRJpYGb6",
    d: "M8035 329 c18 -51 19 -47 -7 -52 -16 -3 -13 -5 11 -6 30 -1 33 1 27 24 -11 45 -25 75 -35 75 -6 0 -4 -18 4 -41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWU9KPqzt",
    d: "M4660 330 c0 -14 30 -27 83 -34 42 -7 47 -5 47 12 0 15 -9 21 -46 26 -64 8 -84 8 -84 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3QJp7hSy",
    d: "M5293 303 c-24 -5 -33 -33 -10 -33 29 0 57 13 57 26 0 14 -6 15 -47 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10UDXte5w",
    d: "M4875 280 c11 -5 29 -8 40 -8 16 0 15 2 -5 8 -34 11 -60 11 -35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4ddfdD11",
    d: "M5205 280 c-16 -7 -13 -9 18 -9 20 -1 37 4 37 9 0 12 -27 12 -55 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13SrDEWgh",
    d: "M7890 270 l-25 -8 25 0 c14 0 34 3 45 8 l20 9 -20 -1 c-11 0 -31 -4 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pE8lfzRH3",
    d: "M7295 260 c-27 -7 -27 -8 -5 -8 14 0 36 4 50 8 20 6 21 8 5 8 -11 0 -33 -4 -50 -8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l2aea4mXDR06u6CEPQ8ldQD",
    fill: "rgb(85,85,85)",
    style: {
      transform: "none"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p17nnhpC9G",
    d: "M3735 2638 c-43 -5 -81 -11 -84 -13 -11 -12 10 -14 77 -6 69 7 73 6 78 -15 4 -15 11 -20 25 -17 10 3 19 7 19 9 0 13 -21 54 -27 53 -5 -1 -44 -6 -88 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HuhdFeWu",
    d: "M4690 2620 c-151 -16 -295 -31 -320 -35 -49 -8 -148 -41 -166 -56 -6 -5 -30 -16 -54 -24 -24 -9 -53 -23 -63 -33 -11 -9 -21 -16 -23 -14 -12 7 -36 0 -54 -18 -25 -25 -120 -73 -120 -61 0 17 -62 -11 -67 -30 -6 -20 -34 -34 -42 -20 -4 6 -18 4 -37 -4 -25 -10 -31 -19 -32 -48 -1 -28 3 -36 21 -42 38 -11 2 -16 -56 -7 -38 6 -60 5 -67 -2 -8 -8 -13 -7 -20 4 -7 12 -39 16 -150 18 -136 3 -140 3 -140 -17 0 -20 5 -21 142 -21 l142 0 -167 -106 c-92 -59 -167 -113 -167 -120 0 -9 -12 -14 -34 -14 -18 0 -48 -3 -65 -6 -24 -5 -31 -3 -31 10 0 20 -54 22 -97 4 -26 -11 -20 -13 67 -24 112 -14 100 -12 100 -24 0 -6 -16 -8 -37 -5 -139 17 -143 17 -143 -5 0 -16 6 -20 34 -20 19 0 36 5 38 11 2 6 12 10 21 8 12 -3 -71 -69 -242 -194 -144 -104 -261 -196 -261 -204 0 -9 -7 -11 -22 -7 -13 3 -35 6 -50 6 -16 0 -28 5 -28 10 0 6 -10 20 -22 32 l-22 22 -246 -28 c-135 -15 -442 -51 -682 -80 -409 -49 -438 -51 -438 -34 0 19 -11 22 -47 12 -25 -7 -31 -29 -10 -37 6 -3 0 -6 -15 -6 -19 -1 -28 4 -28 14 0 16 -12 18 -48 9 -23 -7 -31 -33 -9 -35 6 0 -35 -12 -93 -25 -65 -15 -106 -21 -108 -14 -2 5 -9 10 -16 10 -21 0 -140 -51 -151 -64 -6 -7 -44 -28 -85 -46 -91 -39 -191 -107 -205 -138 -5 -12 -18 -22 -27 -22 -10 0 -22 -9 -28 -21 -20 -37 -8 -62 45 -91 55 -30 65 -33 65 -18 0 5 -16 18 -37 27 -57 28 -63 46 -28 84 17 17 44 40 60 52 l30 20 -30 -33 c-34 -38 -45 -43 104 50 111 69 242 106 566 159 221 37 1384 181 1455 181 15 0 49 -10 76 -22 40 -18 73 -23 176 -26 l127 -4 422 93 c233 52 415 95 407 97 -13 3 -1 33 58 150 70 136 78 148 110 156 36 10 44 22 18 28 -10 2 34 45 117 117 123 107 147 123 383 251 467 253 496 268 561 276 33 3 69 10 80 15 l20 8 -20 -1 c-11 0 -144 -13 -295 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10mDCoizv",
    d: "M3397 2600 c-81 -9 -150 -20 -154 -24 -9 -9 10 -7 200 13 92 10 170 21 174 24 10 10 -57 6 -220 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5tLjF9C8",
    d: "M3164 2576 c-19 -14 -21 -135 -4 -180 14 -37 13 -39 -13 -32 -13 3 -74 -3 -137 -14 -67 -12 -119 -16 -128 -11 -15 8 10 16 121 36 36 7 37 9 23 24 -13 12 -20 13 -35 4 -15 -9 -22 -8 -35 5 -14 14 -18 15 -25 3 -7 -11 -11 -10 -19 4 -9 17 -10 17 -16 -3 -4 -12 -13 -22 -21 -22 -16 0 -25 -22 -25 -61 0 -26 3 -29 34 -29 19 0 36 6 39 14 3 7 19 16 36 18 25 4 31 1 31 -14 0 -21 -7 -21 104 -3 49 8 99 21 112 30 13 8 30 15 39 15 8 0 15 6 15 14 0 8 13 16 30 18 17 3 30 1 30 -4 0 -4 16 -8 35 -8 23 0 35 5 35 14 0 17 52 28 62 13 5 -8 46 -5 150 12 181 29 188 30 188 47 0 18 17 20 -305 -30 -154 -24 -284 -40 -289 -36 -5 5 6 11 25 15 19 3 68 12 109 19 41 8 62 14 45 14 -16 1 -65 -5 -107 -12 l-78 -12 -6 31 c-10 56 -1 99 24 111 l23 11 -25 5 c-14 3 -33 0 -42 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19JVHRhAh",
    d: "M2862 2563 c-26 -4 -35 -11 -47 -40 -19 -44 -19 -63 -1 -63 7 0 16 12 19 28 10 45 21 52 98 66 l74 14 -55 -1 c-30 0 -70 -2 -88 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pk8kYkIpW",
    d: "M4520 2329 l-35 -31 32 22 c29 19 50 40 41 40 -2 0 -19 -14 -38 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DmzuYbJk",
    d: "M2700 2302 c-52 -8 -96 -16 -98 -17 -4 -4 -9 -139 -5 -155 2 -9 14 -20 26 -25 14 -6 23 -21 25 -38 2 -17 8 -26 15 -23 7 3 31 10 55 17 31 8 42 16 42 31 0 21 -8 21 -84 2 -19 -5 -26 -2 -26 9 0 11 22 20 78 32 90 19 103 23 80 24 -15 1 -60 -7 -144 -24 -17 -4 -23 1 -27 24 -10 48 3 102 27 111 12 5 54 14 94 20 39 7 72 16 72 21 0 11 -10 10 -130 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18nrRZ5K4",
    d: "M3650 2284 c-27 -12 -32 -17 -20 -24 8 -5 25 -10 38 -10 17 0 22 6 22 25 0 14 -1 25 -2 25 -2 -1 -19 -8 -38 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOg2w615I",
    d: "M4335 2179 c-133 -110 -143 -119 -128 -119 12 0 226 180 238 200 12 19 -1 9 -110 -81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pd2S4Mqbg",
    d: "M2328 2253 c-10 -2 -18 -9 -18 -14 0 -6 5 -7 12 -3 7 4 28 11 48 15 33 6 33 7 5 7 -16 0 -38 -2 -47 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p44E3JET7",
    d: "M2975 2250 c11 -5 31 -9 45 -9 23 0 23 1 5 9 -11 5 -31 9 -45 9 -23 0 -23 -1 -5 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BWBdcd7D",
    d: "M3100 2240 c0 -5 12 -10 28 -11 23 -1 17 -5 -33 -29 -33 -15 -77 -31 -97 -34 -24 -4 -38 -12 -38 -21 0 -8 4 -15 10 -15 25 0 125 31 128 40 2 6 19 10 38 10 32 0 34 2 34 35 0 33 -2 35 -35 35 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJE6VF28Q",
    d: "M3210 2211 c0 -14 9 -20 35 -23 31 -4 35 -1 35 19 0 20 -5 23 -35 23 -28 0 -35 -4 -35 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFqsLQuzf",
    d: "M3320 2180 c0 -6 11 -16 26 -22 l25 -12 -23 -13 c-22 -12 -22 -12 10 -13 30 0 32 2 32 35 0 33 -2 35 -35 35 -19 0 -35 -5 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pb6WrphMk",
    d: "M2274 2145 c-7 -39 14 -116 34 -123 8 -2 12 8 12 32 0 20 -4 36 -10 36 -5 0 -10 20 -10 45 0 53 -16 60 -26 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GAiDgWuX",
    d: "M2883 2143 c-14 -3 -20 -9 -16 -19 9 -25 73 -14 73 12 0 14 -14 15 -57 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKumMqH5d",
    d: "M2798 2123 c-10 -2 -18 -11 -18 -19 0 -23 64 -14 68 9 3 17 -12 20 -50 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdU7CYsg",
    d: "M2331 2098 c-1 -16 4 -28 9 -28 12 0 12 8 0 35 -8 18 -9 17 -9 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3u3IxaOp",
    d: "M2363 2075 c2 -36 10 -41 55 -29 32 9 29 38 -3 32 -18 -4 -26 0 -30 13 -10 32 -25 21 -22 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pICgAPBsC",
    d: "M3223 2075 c-59 -27 -68 -45 -23 -45 46 0 80 20 80 47 0 12 -1 23 -2 23 -2 0 -27 -11 -55 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPEZZ7BOI",
    d: "M2460 2076 c0 -18 35 -22 45 -6 3 6 2 10 -4 10 -5 0 -16 3 -25 6 -11 4 -16 1 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13arAfMHU",
    d: "M2565 2050 c-11 -5 -33 -9 -48 -9 -15 -1 -30 -8 -34 -17 -4 -12 -14 -14 -39 -10 -42 8 -84 -2 -84 -20 0 -8 5 -14 12 -14 6 0 31 -10 55 -21 49 -24 173 -39 173 -21 0 6 -17 14 -37 17 -21 3 -58 11 -83 18 l-45 13 70 16 c39 9 85 20 103 23 40 8 44 35 5 34 -16 0 -37 -4 -48 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJoTOTX2S",
    d: "M7815 2000 c-7 -12 19 -12 55 0 22 7 21 8 -12 9 -20 1 -40 -3 -43 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psUA8YT2u",
    d: "M8003 2003 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRXXusFz7",
    d: "M8105 2000 c15 -6 5 -9 -35 -10 -30 -1 -64 -6 -75 -11 -13 -6 8 -7 60 -3 l80 5 -40 -20 c-22 -11 -36 -20 -32 -20 14 -2 107 41 107 49 0 9 -37 20 -65 19 l-20 0 20 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqMF9s0PS",
    d: "M3915 1990 l-20 -9 20 1 c11 0 31 4 45 8 l25 8 -25 0 c-14 0 -34 -3 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLIwEKnSH",
    d: "M4196 1992 c-7 -11 31 -92 44 -92 16 0 12 39 -7 71 -18 29 -28 35 -37 21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4ikMf6Os",
    d: "M7701 1986 c-59 -21 -47 -35 14 -17 30 9 55 19 55 24 0 10 -29 7 -69 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbBzdyvr0",
    d: "M2750 1941 c0 -9 33 -21 58 -21 6 0 12 7 12 15 0 10 -11 15 -35 15 -19 0 -35 -4 -35 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTY1GyA3T",
    d: "M2850 1935 c0 -8 6 -15 14 -15 7 0 28 -3 45 -6 24 -5 31 -3 31 9 0 15 -28 27 -67 27 -14 0 -23 -6 -23 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgzxrVoBN",
    d: "M7486 1916 c-55 -17 -101 -37 -103 -43 -3 -7 -11 -9 -18 -7 -8 3 -72 -13 -142 -35 -125 -40 -129 -41 -178 -27 -27 8 -41 15 -30 16 24 3 -125 25 -230 35 -47 4 -75 3 -75 -3 0 -11 34 -22 70 -22 28 0 100 -76 100 -106 0 -14 9 -15 73 -10 39 4 146 10 237 14 l165 7 110 45 109 45 -119 5 -120 5 123 44 c109 39 142 56 131 65 -2 2 -49 -11 -103 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXFd7hmO0",
    d: "M5038 1933 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10FEFXtJj",
    d: "M5650 1926 c0 -14 -22 -16 -197 -16 -116 0 -287 -8 -413 -20 -276 -25 -280 -25 -280 0 0 21 -10 24 -47 14 -34 -9 -28 -32 10 -37 24 -3 21 -4 -15 -5 -42 -2 -48 1 -48 18 0 21 -10 24 -47 14 -32 -9 -29 -32 5 -37 19 -3 14 -4 -15 -6 -37 -1 -43 2 -43 19 0 11 -6 20 -12 20 -29 0 -58 -13 -58 -25 0 -8 10 -16 23 -18 13 -2 5 -5 -18 -6 -22 -1 -64 -4 -92 -7 -49 -6 -53 -5 -53 15 0 18 -5 21 -35 18 -25 -1 -35 -7 -35 -19 0 -9 6 -18 13 -21 6 -2 3 -3 -7 -1 -11 2 -27 -7 -38 -21 -10 -13 -39 -31 -63 -41 -25 -9 -44 -19 -42 -21 2 -2 278 20 613 48 l609 52 588 1 c553 1 587 2 587 18 0 10 -8 19 -17 19 -62 5 -155 9 -198 9 -27 0 -70 5 -93 11 -33 9 -46 9 -51 1 -5 -9 -24 -7 -71 5 -46 11 -65 13 -68 4 -4 -13 -82 -15 -82 -2 0 14 -63 26 -68 12 -5 -14 -159 -15 -164 -1 -2 6 -20 13 -41 17 -30 4 -37 3 -37 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FAtsOFGT",
    d: "M7988 1917 c-16 -6 -28 -14 -28 -18 0 -10 58 10 66 22 6 11 -3 10 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnsGssWPu",
    d: "M4808 1913 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psiPUJK9y",
    d: "M7881 1871 c-36 -15 -67 -33 -69 -39 -2 -6 28 3 67 20 39 17 71 35 71 39 0 11 6 13 -69 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plMOffjaj",
    d: "M6570 1860 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4CvqD5aG",
    d: "M7476 1771 c-170 -68 -187 -82 -93 -80 38 1 39 2 12 8 -27 6 -17 12 105 65 74 32 142 62 150 67 38 21 -18 2 -174 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPlE4ByQN",
    d: "M5293 1823 c-27 -5 -83 -59 -83 -79 0 -8 10 -14 25 -14 22 0 24 2 15 25 -9 23 -8 25 9 15 14 -7 20 -7 23 1 5 16 98 25 98 10 0 -9 5 -9 20 -1 16 9 18 8 14 -5 -10 -24 16 -75 37 -75 12 0 19 7 19 19 0 14 8 21 28 24 27 4 26 4 -4 6 -19 0 -40 11 -55 27 -40 44 -86 59 -146 47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pygouxnqC",
    d: "M7668 1782 c-116 -49 -116 -70 0 -29 102 36 95 32 90 50 -2 12 -20 8 -90 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phYc1WsIT",
    d: "M2673 1762 c-24 -15 -43 -30 -43 -34 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 9 0 15 9 15 25 0 31 -5 31 -57 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSocG7nz2",
    d: "M7770 1705 c0 -44 1 -45 31 -45 28 0 30 2 18 16 -7 9 -12 29 -11 45 2 23 -2 29 -18 29 -17 0 -20 -7 -20 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUhNZis4h",
    d: "M7500 1710 c-8 -5 -26 -10 -40 -10 -24 -1 -24 -2 -3 -10 27 -11 63 -2 63 16 0 16 -1 17 -20 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4XNQQgqr",
    d: "M7537 1679 c4 -13 9 -17 15 -11 11 11 3 32 -12 32 -4 0 -6 -9 -3 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIQbtrMLa",
    d: "M5200 1651 c0 -11 11 -33 25 -48 l24 -28 1 33 c0 23 -5 32 -16 32 -14 0 -14 3 -4 15 10 13 9 15 -9 15 -14 0 -21 -6 -21 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phO6WpxOz",
    d: "M5438 1653 c-12 -3 -18 -14 -18 -34 0 -47 14 -38 48 34 3 7 -2 8 -30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmmsAbIwY",
    d: "M2298 1623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvrVcpm8h",
    d: "M2148 1603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQbEnrQT5",
    d: "M2068 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pckSfmj40",
    d: "M5300 1575 c0 -19 5 -25 23 -25 57 0 90 29 51 44 -22 9 -24 8 -24 -9 0 -8 -4 -15 -9 -15 -5 0 -11 7 -15 15 -9 24 -26 17 -26 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BVHBDLRq",
    d: "M7878 1573 c11 -16 36 -44 56 -62 28 -27 36 -31 36 -17 0 26 -69 106 -92 106 -19 0 -19 0 0 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FHAXaiUz",
    d: "M1838 1563 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EjdtMx1O",
    d: "M1678 1543 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUZGF5N9Z",
    d: "M7693 1524 c-7 -7 -13 -24 -13 -38 0 -31 96 -171 128 -185 12 -6 22 -19 22 -30 0 -23 31 -31 100 -27 25 1 62 3 83 4 l38 2 -73 60 c-40 33 -107 89 -148 125 -112 99 -123 105 -137 89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppv70VZRI",
    d: "M1490 1525 c-8 -2 -32 -6 -52 -10 -24 -4 -38 -11 -38 -20 0 -17 11 -18 88 -9 42 6 52 10 52 25 0 18 -12 21 -50 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CTIyOpId",
    d: "M1288 1493 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14MO5lZFm",
    d: "M6445 1440 c-262 -40 -1020 -118 -1032 -106 -5 4 4 18 20 30 30 24 36 46 12 46 -8 0 -15 6 -15 14 0 14 -48 32 -58 21 -3 -3 -1 -5 4 -5 5 0 10 -18 11 -39 l2 -39 -36 10 c-19 5 -37 7 -41 4 -3 -3 2 -6 11 -6 10 0 19 -11 23 -26 5 -21 11 -24 30 -20 19 5 24 2 24 -12 0 -10 13 -31 29 -46 l29 -27 313 35 c173 20 348 42 389 50 150 30 194 36 199 28 3 -4 41 -19 84 -34 65 -22 78 -23 75 -10 -3 15 -34 28 -128 53 l-45 12 45 14 c25 8 113 31 195 53 83 21 139 38 125 38 -14 0 -133 -17 -265 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pG2v3Fkae",
    d: "M5025 1441 c-22 -10 -46 -25 -54 -34 -12 -15 -9 -17 28 -17 37 0 41 -2 41 -25 0 -14 5 -25 10 -25 6 0 10 -7 10 -15 0 -9 -9 -15 -21 -15 -17 0 -19 -3 -10 -14 10 -12 3 -15 -36 -20 -322 -41 -4003 -426 -4071 -426 -77 0 -182 12 -390 46 -24 4 -32 9 -28 19 3 8 -7 24 -22 36 -21 16 -36 20 -70 16 -24 -2 -45 -7 -48 -10 -12 -12 9 -27 39 -28 53 -2 82 -13 82 -33 0 -34 141 -87 275 -103 63 -7 129 -18 145 -23 19 -6 64 -4 125 4 52 7 97 8 98 4 5 -12 34 -9 65 6 15 8 27 11 27 5 0 -13 27 -11 63 5 37 17 127 25 127 12 0 -5 15 -5 33 -1 17 4 50 8 72 9 22 1 50 8 63 15 13 7 52 11 90 10 91 -2 162 5 189 20 13 6 58 11 100 11 117 -1 124 0 173 16 25 8 77 14 115 14 109 -1 117 0 169 17 32 10 66 13 97 10 32 -4 64 -1 91 9 24 8 70 14 103 13 33 -1 85 1 115 5 30 3 75 8 100 11 87 10 145 16 170 16 14 0 48 7 75 15 28 7 77 14 110 14 89 -1 104 1 178 18 61 13 69 13 80 -1 20 -25 85 -37 197 -35 l105 1 -125 7 c-153 9 -183 18 -115 36 27 6 54 10 60 8 6 -3 36 2 66 9 29 8 56 11 59 6 4 -5 20 -12 38 -15 25 -5 32 -3 32 9 0 16 20 27 51 27 14 0 19 -7 19 -25 0 -15 6 -25 14 -25 8 0 16 -5 18 -11 2 -6 54 -18 116 -27 108 -15 132 -30 52 -33 -31 -1 -30 -2 13 -9 27 -5 51 -11 54 -14 3 -3 13 -1 23 4 12 7 23 4 39 -11 12 -11 38 -23 59 -26 20 -3 39 -9 42 -14 3 -4 37 -15 75 -25 39 -9 84 -23 102 -30 17 -8 36 -14 42 -14 5 0 52 -13 102 -30 51 -16 120 -35 153 -41 65 -11 107 -28 73 -29 -10 0 -37 -9 -59 -20 -23 -11 -52 -20 -65 -20 -13 0 -23 -6 -23 -14 0 -8 -6 -17 -12 -20 -7 -3 14 -4 47 -1 l60 5 -54 -23 c-66 -28 -77 -47 -27 -47 20 0 36 5 36 10 0 6 11 10 25 10 14 0 25 5 25 10 0 6 7 10 15 10 8 0 15 9 15 19 0 37 12 51 41 51 16 0 29 4 29 9 0 4 28 11 63 15 153 17 157 17 157 39 0 16 -5 19 -29 14 -27 -6 -29 -4 -35 36 -4 26 -10 37 -15 29 -9 -15 -230 74 -492 199 -190 90 -194 95 -84 105 192 17 214 20 274 33 73 15 81 14 81 -9 0 -16 7 -20 33 -20 l32 1 -24 13 -24 14 24 7 c13 5 42 9 64 11 22 1 50 5 61 7 20 5 23 0 29 -50 4 -30 4 -57 1 -61 -4 -3 -24 4 -45 16 -47 27 -51 27 -51 4 0 -12 18 -28 49 -45 53 -29 60 -44 62 -122 0 -54 17 -113 18 -65 0 14 -6 104 -14 200 -22 268 -24 255 33 284 l47 24 -27 13 c-32 14 -35 25 -11 51 15 17 14 18 -23 18 -21 0 -57 -9 -79 -19z m65 -670 c0 -11 -25 -21 -53 -21 -21 1 -21 1 3 15 29 16 50 19 50 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNVkS0NO6",
    d: "M8020 1444 c0 -23 33 -58 50 -52 6 2 -3 19 -19 38 -26 31 -30 32 -31 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pB7cTZ3MO",
    d: "M7663 1398 c19 -46 37 -48 37 -4 0 32 -3 36 -25 36 -24 0 -25 -1 -12 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plsoJ6a1",
    d: "M8150 1308 c0 -18 27 -44 37 -34 4 4 -3 16 -15 29 -18 17 -22 18 -22 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdgX31uhM",
    d: "M6550 1295 c0 -16 30 -35 55 -35 26 0 12 23 -23 37 -27 11 -32 11 -32 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pThOEjCWD",
    d: "M7750 1280 c0 -5 -7 -10 -15 -10 -19 0 -19 -31 -1 -75 20 -47 40 -46 32 1 -4 19 -10 42 -13 50 -5 13 1 14 31 9 32 -6 36 -5 36 14 0 17 -6 21 -35 21 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTgdqkbTQ",
    d: "M5354 1249 c3 -17 6 -40 6 -50 0 -11 5 -19 10 -19 6 0 10 11 10 25 0 16 6 25 15 25 8 0 15 5 15 10 0 6 -4 10 -10 10 -5 0 -10 7 -10 15 0 9 -9 15 -21 15 -19 0 -21 -4 -15 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plQA8AkEC",
    d: "M5366 1113 c7 -50 11 -60 19 -51 8 8 -7 98 -17 98 -5 0 -6 -20 -2 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAx5B0zwV",
    d: "M7793 1028 c12 -31 37 -50 37 -29 0 24 -21 61 -35 61 -13 0 -13 -4 -2 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxNhBchcj",
    d: "M5284 996 c3 -27 6 -59 6 -72 0 -13 4 -24 10 -24 12 0 1 121 -13 135 -6 7 -7 -6 -3 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6U6OfjhB",
    d: "M5375 998 c8 -46 12 -55 20 -46 9 9 -7 88 -17 88 -6 0 -7 -17 -3 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2ps8Oc2O",
    d: "M564 987 c3 -12 6 -25 6 -29 0 -5 7 -8 15 -8 24 0 19 47 -6 53 -18 5 -20 2 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQHefFGIm",
    d: "M531 993 c-1 -7 -4 -12 -8 -12 -5 1 -17 1 -28 0 -19 -1 -19 -1 1 -22 12 -11 31 -19 42 -17 19 3 19 5 7 33 -7 17 -14 24 -14 18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUlX9qFPB",
    d: "M6941 980 c-1 -18 23 -50 79 -110 69 -74 79 -82 79 -60 0 17 -24 51 -79 110 -69 74 -79 82 -79 60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIX7kEyNs",
    d: "M5380 908 c0 -30 13 -59 24 -55 7 3 23 -1 37 -9 27 -15 69 -18 69 -5 0 5 -25 21 -55 37 -30 16 -55 32 -55 37 0 4 -4 7 -10 7 -5 0 -10 -6 -10 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piSJhiQ8p",
    d: "M7380 870 c12 -16 24 -30 26 -30 3 0 -4 14 -16 30 -12 17 -24 30 -26 30 -3 0 4 -13 16 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ2CdNMYY",
    d: "M7857 845 c14 -42 29 -62 39 -53 9 9 -29 98 -41 98 -11 0 -11 -8 2 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10mpxMn04",
    d: "M7461 758 c28 -40 72 -103 97 -140 26 -37 51 -68 56 -68 4 0 -3 15 -16 33 -14 17 -60 80 -102 140 -43 59 -79 107 -82 107 -2 0 19 -33 47 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCcbkYkhU",
    d: "M5570 755 c0 -28 4 -35 20 -35 12 0 20 7 20 18 0 14 7 17 45 14 58 -5 58 12 1 27 -76 19 -86 16 -86 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHdxXyr0N",
    d: "M4440 760 c30 -11 66 -19 80 -18 16 0 10 4 -20 12 -28 8 -39 15 -30 18 8 4 -7 6 -35 6 l-50 0 55 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poLzThSyT",
    d: "M5218 773 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1a6Yvt5d",
    d: "M5810 741 c0 -5 14 -14 31 -20 40 -14 39 -14 39 3 0 7 -10 16 -22 20 -33 8 -48 7 -48 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p137t5vwUv",
    d: "M5930 695 c0 -22 4 -25 36 -25 44 0 42 18 -4 37 -31 13 -32 12 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BimOkYbB",
    d: "M7923 658 c19 -46 39 -49 25 -4 -6 20 -17 36 -25 36 -11 0 -11 -5 0 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOeYbDIpH",
    d: "M4625 624 c-73 -44 -71 -42 -58 -55 12 -12 39 -1 65 24 7 7 29 17 48 23 20 5 36 17 38 27 5 27 -26 20 -93 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p76UcphvP",
    d: "M5850 599 c-10 -17 -18 -19 -58 -15 -42 5 -44 5 -15 -4 18 -6 35 -15 38 -20 3 -6 19 -10 36 -10 27 0 29 3 29 35 0 39 -14 46 -30 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Cc7i25v5",
    d: "M7320 589 c0 -30 50 -82 75 -77 14 2 9 13 -28 53 -43 47 -46 48 -47 24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIYNHr2Ie",
    d: "M5450 580 c0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -25 0 -14 4 -25 8 -25 11 0 92 58 92 65 0 3 -16 5 -35 5 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2nN5e9Bg",
    d: "M4512 538 c-13 -13 -17 -58 -4 -58 4 0 17 16 30 35 20 32 21 35 4 35 -10 0 -23 -5 -30 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11Y4xSzWR",
    d: "M6033 543 c-29 -4 -33 -8 -33 -34 0 -27 2 -29 20 -19 11 6 20 15 20 21 0 21 29 18 75 -8 l50 -27 -38 -9 c-44 -11 -49 -32 -8 -40 40 -8 179 14 160 26 -26 16 -201 97 -207 95 -4 0 -22 -3 -39 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSVgdlvlX",
    d: "M5780 519 c-14 -11 -42 -29 -62 -40 -47 -24 -48 -39 -3 -39 28 0 35 4 35 20 0 16 7 20 30 20 27 0 30 3 30 30 0 35 2 35 -30 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12NzIT1Ms",
    d: "M4582 510 c-29 -27 -28 -40 3 -40 21 0 25 5 25 30 0 36 0 36 -28 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psBPUaSTV",
    d: "M5920 470 c0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -24 0 -31 24 -26 71 14 l34 29 -37 1 c-21 0 -38 -4 -38 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prWZnpW7U",
    d: "M6325 460 c-16 -7 -13 -9 15 -9 19 0 55 4 80 8 l45 8 -60 1 c-33 0 -69 -3 -80 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEnigUS6B",
    d: "M8000 441 c0 -6 12 -42 27 -81 22 -60 24 -73 12 -81 -11 -7 -8 -9 9 -9 12 0 22 3 22 7 0 19 -55 173 -62 173 -4 0 -8 -4 -8 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17qp02zcW",
    d: "M5958 422 c-77 -23 -85 -36 -18 -28 91 11 110 17 110 32 0 18 -20 17 -92 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7bths0uU",
    d: "M4541 423 c0 -5 4 -17 9 -28 8 -18 9 -17 9 8 1 15 -3 27 -9 27 -5 0 -10 -3 -9 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FagjSY7Q",
    d: "M5130 405 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzwtVF0Eo",
    d: "M5583 415 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmdxFr885",
    d: "M5493 375 c-43 -18 -42 -35 2 -35 24 0 35 -5 35 -15 0 -16 12 -18 48 -9 36 10 27 34 -12 34 -26 0 -35 5 -38 19 -3 18 -5 18 -35 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phs0LOGvV",
    d: "M5700 370 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTguvjqkP",
    d: "M4612 348 c3 -7 19 -18 36 -25 31 -13 32 -12 32 12 0 22 -4 25 -36 25 -23 0 -34 -4 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p107LPsrcR",
    d: "M5393 335 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pz97zZZBV",
    d: "M7551 314 c-7 -8 -11 -18 -8 -21 10 -9 68 9 64 20 -6 18 -40 19 -56 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdW45c6J0",
    d: "M4790 306 c0 -16 32 -26 75 -25 17 1 22 3 13 6 -21 5 -23 19 -5 26 6 3 -9 6 -35 6 -35 1 -48 -3 -48 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJm0miFGv",
    d: "M5298 302 c-27 -7 -48 -18 -48 -24 0 -7 16 -8 48 -3 54 8 55 9 50 27 -2 12 -10 12 -50 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pppK5DD7m",
    d: "M7402 283 c-40 -9 -71 -17 -69 -20 8 -7 177 21 177 29 0 11 -20 9 -108 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppLTYO4hf",
    d: "M4918 273 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvK0DLBAg",
    d: "M7648 253 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l1FPG655JzmwbymgJ8M7p3V",
    fill: "rgb(68,68,68)",
    style: {
      transform: "none"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pOCY0Xg7V",
    d: "M3688 2631 c-75 -9 -140 -20 -145 -25 -5 -5 7 -6 27 -3 19 3 71 9 115 12 44 4 88 9 97 11 10 3 19 -3 23 -16 4 -11 15 -20 26 -20 16 0 19 4 14 23 -4 12 -10 25 -14 28 -3 3 -68 -2 -143 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZYMLl3Zy",
    d: "M4945 2640 c-12 -5 1 -6 35 -3 30 3 57 7 59 9 9 8 -75 2 -94 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMxtPH5Pl",
    d: "M4590 2610 c-256 -26 -280 -30 -342 -59 -38 -17 -68 -35 -68 -40 0 -21 54 -17 108 9 47 22 96 32 272 54 204 26 348 51 359 61 7 8 -36 4 -329 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15pjAxoRR",
    d: "M3445 2600 c-17 -7 -16 -9 10 -9 17 0 39 4 50 9 17 7 16 9 -10 9 -16 0 -39 -4 -50 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pi9A5RO8X",
    d: "M3355 2590 c-18 -8 -18 -9 5 -9 14 0 34 4 45 9 18 8 18 9 -5 9 -14 0 -34 -4 -45 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyj7tioyl",
    d: "M3265 2580 l-20 -9 20 0 c11 0 29 4 40 9 l20 9 -20 0 c-11 0 -29 -4 -40 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16YM2GI58",
    d: "M2868 2563 c-33 -4 -38 -7 -38 -30 l0 -27 20 22 c12 13 33 22 50 22 16 0 32 5 35 10 3 6 -2 9 -12 8 -10 -1 -35 -3 -55 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Apqf57wZ",
    d: "M4635 2520 c-56 -33 -54 -41 3 -10 49 25 69 40 57 39 -5 0 -32 -13 -60 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HIDxSi30",
    d: "M3806 2505 c-4 -14 -13 -25 -21 -25 -32 0 -12 -18 33 -30 78 -20 89 -21 52 -2 -31 15 -35 21 -32 50 4 39 -22 45 -32 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p69lHYN3g",
    d: "M3150 2473 c0 -81 7 -93 50 -93 21 0 40 -5 42 -11 2 -7 33 -5 98 6 143 24 150 25 150 41 0 18 -20 18 -165 -6 -66 -10 -123 -16 -128 -11 -4 4 -11 34 -14 65 -4 38 -10 56 -19 56 -10 0 -14 -14 -14 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prPylErr6",
    d: "M4324 2362 l-230 -117 -165 -146 -164 -147 -50 -117 c-68 -160 -66 -161 10 -13 55 108 69 129 92 134 155 35 202 56 71 30 -38 -7 -68 -12 -68 -11 0 2 62 56 138 122 128 111 152 127 357 238 121 65 229 124 240 132 51 34 -19 3 -231 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdnKTJm7Y",
    d: "M3668 2463 c-20 -5 -25 -33 -5 -33 29 0 57 13 57 26 0 14 -18 16 -52 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11MXQOcQO",
    d: "M4036 2454 c-22 -8 -47 -21 -55 -28 -16 -15 -20 -16 -46 -16 -8 0 -24 -9 -35 -20 -11 -11 -23 -19 -27 -19 -26 4 -46 -5 -74 -32 -18 -18 -34 -27 -38 -21 -8 13 -71 -12 -71 -28 0 -6 -4 -9 -9 -6 -9 6 -75 -13 -68 -20 8 -8 136 -31 131 -23 -2 5 85 54 196 109 110 55 200 105 200 110 0 14 -58 11 -104 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOmrbsHWO",
    d: "M3538 2443 c-24 -6 -23 -33 1 -33 30 0 51 11 51 26 0 14 -18 16 -52 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVVi6RrnP",
    d: "M2842 2420 c-11 -18 -10 -20 12 -20 19 0 23 4 19 20 -3 11 -8 20 -12 20 -3 0 -12 -9 -19 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10N4lKCNL",
    d: "M2898 2422 c-8 -29 2 -39 50 -47 l44 -7 -23 26 c-26 30 -39 33 -40 9 0 -12 -5 -8 -13 11 -12 26 -14 26 -18 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZmHRw6Sa",
    d: "M3238 2433 c-21 -2 -38 -8 -38 -12 0 -7 65 0 120 13 19 5 -34 4 -82 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BC83XX59",
    d: "M3000 2395 c0 -8 9 -15 20 -15 24 0 27 15 4 24 -22 9 -24 8 -24 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnpAletqn",
    d: "M3110 2340 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phTmQKfo4",
    d: "M4452 2275 c-56 -47 -102 -88 -102 -92 0 -7 19 8 110 86 99 85 105 91 99 91 -3 0 -51 -38 -107 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5sHPs2rO",
    d: "M2975 2345 c-5 -2 -27 -6 -47 -10 -43 -7 -51 -30 -14 -39 13 -3 48 -1 76 4 29 6 54 10 56 10 2 0 4 6 4 14 0 18 -46 31 -75 21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B1N7VjiO",
    d: "M2825 2331 c3 -6 -11 -13 -32 -16 -80 -13 -93 -17 -93 -26 0 -5 12 -6 27 -3 15 4 56 8 90 8 58 1 63 3 63 24 0 18 -6 22 -31 22 -16 0 -28 -4 -24 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTbLw99Zr",
    d: "M2600 2271 c-16 -31 -12 -51 10 -51 16 0 20 7 20 35 0 39 -14 46 -30 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkA258wRq",
    d: "M2990 2249 c14 -6 57 -14 95 -18 l70 -7 -50 -23 c-27 -12 -80 -29 -117 -38 -44 -10 -68 -20 -68 -29 0 -19 5 -18 175 24 136 35 153 37 183 25 30 -12 32 -12 32 7 0 15 7 20 25 20 31 0 33 25 3 34 -34 9 -78 7 -78 -3 0 -5 -16 -11 -35 -13 -23 -3 -35 0 -35 8 0 9 -23 12 -77 12 -43 -1 -94 2 -113 6 -31 5 -32 5 -10 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5xv3tuDG",
    d: "M2295 2233 c-35 -92 -22 -186 32 -233 32 -29 83 -41 83 -20 0 6 5 10 10 10 6 0 10 -7 10 -15 0 -8 6 -15 14 -15 8 0 16 -4 18 -10 5 -14 128 -26 128 -12 0 6 -17 14 -37 17 -53 9 -113 25 -113 30 0 2 34 11 75 20 47 11 75 22 75 30 0 9 21 16 65 20 56 6 65 10 65 27 0 18 -5 19 -35 14 -27 -5 -35 -4 -35 8 0 8 3 16 8 19 4 2 1 2 -6 0 -8 -1 -22 -3 -33 -3 -16 0 -17 -4 -8 -26 5 -15 8 -28 6 -30 -4 -4 -188 -45 -233 -51 -18 -3 -34 0 -38 5 -7 11 36 27 101 37 24 4 45 10 48 15 8 13 -26 21 -40 10 -9 -7 -16 -6 -25 5 -17 20 -30 19 -30 -2 -1 -14 -4 -12 -15 7 l-14 25 -9 -25 -10 -25 -7 28 c-8 32 -13 33 -32 10 -13 -16 -14 -10 -10 51 4 52 10 73 23 83 17 12 17 13 -3 13 -11 0 -24 -8 -28 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parORT94O",
    d: "M3586 2226 c3 -9 -3 -17 -15 -21 -12 -3 -21 -11 -21 -16 0 -5 -7 -9 -15 -9 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -9 0 -5 -11 -12 -25 -15 -14 -4 -25 -11 -25 -16 0 -6 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -9 0 -5 -10 -11 -23 -15 -12 -3 -32 -14 -44 -26 -12 -11 -27 -20 -33 -20 -5 0 -10 -4 -10 -10 0 -5 -5 -10 -11 -10 -7 0 -20 -10 -30 -22 -11 -11 -19 -16 -19 -10 0 16 -67 15 -73 0 -3 -8 -6 -6 -6 5 -1 13 -10 17 -36 17 -19 0 -35 -4 -35 -10 0 -5 -15 -11 -32 -11 -18 -1 26 -9 97 -18 116 -15 125 -17 84 -23 -25 -4 -54 -5 -65 -3 -10 2 -47 6 -81 9 -58 5 -63 4 -63 -14 0 -16 7 -20 35 -20 19 0 35 5 35 10 0 6 9 10 20 10 13 0 18 -5 14 -15 -4 -8 -13 -15 -20 -15 -8 0 -17 -7 -20 -15 -4 -8 -12 -15 -20 -15 -8 0 -14 -4 -14 -10 0 -5 -7 -10 -15 -10 -9 0 -18 -7 -21 -15 -4 -8 -13 -15 -20 -15 -8 0 -17 -7 -20 -15 -4 -8 -13 -15 -20 -15 -8 0 -17 -7 -20 -15 -4 -8 -12 -15 -20 -15 -8 0 -14 -4 -14 -10 0 -5 -7 -10 -15 -10 -9 0 -18 -7 -21 -15 -4 -8 -13 -15 -20 -15 -8 0 -17 -7 -20 -15 -4 -8 -13 -15 -20 -15 -8 0 -17 -7 -20 -15 -4 -8 -12 -15 -20 -15 -8 0 -14 -4 -14 -10 0 -5 -7 -10 -15 -10 -9 0 -18 -7 -21 -15 -4 -8 -13 -15 -20 -15 -8 0 -17 -7 -20 -15 -4 -8 -12 -15 -20 -15 -8 0 -14 -7 -14 -15 0 -8 -6 -15 -14 -15 -15 0 -31 -48 -21 -59 12 -12 215 -14 215 -2 0 7 -22 11 -54 11 -64 0 -118 10 -114 20 2 5 125 97 273 206 265 195 271 198 340 211 39 7 71 12 73 13 2 0 0 5 -3 10 -3 6 6 11 22 12 18 0 13 3 -16 7 l-45 6 190 121 191 122 91 -11 c63 -7 100 -7 124 0 l33 11 -50 1 c-27 1 -95 8 -150 16 -125 18 -126 18 -119 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCiCiUx24",
    d: "M2600 2165 c0 -28 4 -35 20 -35 21 0 24 10 14 48 -10 36 -34 27 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FoV3qyPL",
    d: "M4248 2107 c-74 -60 -91 -88 -56 -95 12 -2 15 2 11 16 -3 12 3 25 14 33 39 28 116 99 112 104 -3 2 -39 -24 -81 -58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcW968DC7",
    d: "M2705 2140 c-14 -7 -8 -8 20 -3 22 3 42 7 44 9 9 8 -45 2 -64 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppwAZ1U4g",
    d: "M2843 2133 c-14 -3 -20 -9 -16 -19 9 -25 73 -14 73 12 0 14 -14 15 -57 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLdo93wPV",
    d: "M2758 2113 c-10 -2 -18 -11 -18 -19 0 -23 64 -14 68 9 3 17 -12 20 -50 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp0MY8sex",
    d: "M3173 2050 c-51 -23 -55 -40 -10 -40 42 0 60 12 55 38 l-3 21 -42 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEaV68fwV",
    d: "M7770 1999 c-71 -10 -163 -42 -168 -58 -2 -7 15 -4 50 9 29 12 100 30 158 40 107 19 74 26 -40 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pngBzVUIs",
    d: "M8065 2000 l70 -6 -55 -3 c-30 -1 -64 -6 -75 -11 -13 -6 8 -7 55 -4 55 4 71 3 60 -5 -8 -6 -10 -11 -4 -11 18 0 49 28 41 37 -5 4 -43 8 -85 9 l-77 1 70 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psuKbO266",
    d: "M4210 1965 c0 -25 28 -85 39 -85 17 0 13 39 -6 71 -19 32 -33 38 -33 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTk1Ox3vo",
    d: "M2760 1940 c0 -10 39 -18 105 -22 l40 -3 -37 -25 c-47 -31 -48 -40 -3 -40 19 0 35 5 35 10 0 6 7 10 15 10 10 0 15 10 15 34 0 31 -3 34 -37 40 -57 9 -133 7 -133 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12me642aH",
    d: "M7970 1909 c-101 -44 -106 -46 -99 -53 5 -5 179 71 194 85 14 14 8 12 -95 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p62tD1kNK",
    d: "M5058 1933 c-19 -5 -25 -33 -8 -33 6 0 10 -9 10 -20 0 -21 30 -26 78 -14 30 9 28 34 -3 34 -18 0 -25 5 -25 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSXAxtMDc",
    d: "M5630 1920 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18IJ9oDEq",
    d: "M7325 1865 c-126 -40 -274 -86 -328 -101 -54 -16 -98 -33 -97 -39 0 -6 26 -9 61 -8 58 3 252 62 359 111 25 11 86 34 135 52 85 29 114 45 104 53 -2 2 -107 -28 -234 -68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFJgu7mpp",
    d: "M4918 1923 c-28 -7 -22 -33 7 -33 18 0 25 -5 25 -20 0 -21 23 -26 68 -14 36 10 27 34 -13 34 -28 0 -35 4 -35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p192qpQ0m6",
    d: "M5880 1912 c0 -29 51 -43 147 -41 43 0 106 -2 140 -6 54 -6 64 -5 69 9 10 26 0 29 -84 33 -170 7 -208 9 -239 17 -29 8 -33 6 -33 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4YOs3V8Q",
    d: "M4818 1913 c-22 -5 -24 -33 -3 -33 8 0 15 -9 15 -20 0 -21 30 -26 78 -14 33 9 28 34 -8 34 -23 0 -30 4 -30 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1H7tpmYvd",
    d: "M4718 1903 c-19 -5 -25 -33 -8 -33 6 0 10 -9 10 -20 0 -21 23 -26 68 -14 27 8 29 34 2 34 -13 0 -20 7 -20 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plirjLJ51",
    d: "M5170 1890 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMEOZyDk1",
    d: "M6313 1894 c-21 -9 -15 -31 10 -38 12 -3 39 -6 60 -6 30 0 37 4 37 20 0 13 -7 20 -19 20 -10 0 -31 2 -47 5 -16 2 -35 2 -41 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXhR1TZFL",
    d: "M6460 1872 c0 -22 39 -32 123 -32 56 0 68 26 15 34 -116 18 -138 17 -138 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEymirvGS",
    d: "M4409 1873 c-16 -4 -29 -31 -29 -60 0 -14 39 -17 78 -7 21 6 32 34 12 34 -5 0 -10 9 -10 20 0 20 -14 23 -51 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUsTPQMvh",
    d: "M4289 1863 c-32 -4 -35 -7 -32 -28 3 -15 -3 -31 -18 -46 l-22 -22 24 7 c13 4 46 12 73 16 27 5 50 11 52 13 2 2 1 18 -2 35 -4 21 -12 31 -23 30 -9 -1 -32 -3 -52 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyIJa1OI8",
    d: "M6650 1855 c0 -10 11 -15 35 -15 39 0 47 14 13 24 -36 9 -48 7 -48 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHNjdF2ng",
    d: "M4600 1840 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EMvwrrIM",
    d: "M6730 1852 c0 -12 34 -19 133 -28 52 -4 77 -3 77 4 0 6 -30 13 -67 17 -38 3 -85 8 -105 11 -22 3 -38 2 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AEmvjx5Z",
    d: "M4490 1830 c0 -15 7 -20 28 -20 42 0 72 11 72 26 0 10 -14 14 -50 14 -43 0 -50 -3 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFDojVsHh",
    d: "M7733 1808 c-40 -17 -73 -37 -73 -45 0 -11 7 -10 38 3 67 29 67 29 65 -18 -1 -24 -5 -62 -8 -85 -8 -47 6 -59 25 -22 9 16 14 18 26 8 11 -9 14 -8 14 9 0 12 -4 23 -9 26 -4 3 -8 39 -7 81 1 41 1 75 1 75 0 -1 -33 -15 -72 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAkttwisk",
    d: "M5313 1814 c-3 -9 0 -20 8 -25 11 -6 8 -9 -8 -9 -14 0 -23 6 -23 15 0 22 -26 18 -50 -7 -24 -26 -26 -48 -4 -48 11 0 14 6 8 22 -6 21 -5 20 40 -6 l47 -28 32 24 c54 41 60 43 52 19 -5 -15 -2 -21 9 -21 9 0 16 -7 16 -15 0 -8 -9 -15 -19 -15 -28 0 -37 -21 -16 -37 26 -18 35 -16 35 7 0 12 7 20 16 20 10 0 14 6 11 14 -4 9 1 17 11 19 15 4 15 5 -1 6 -10 0 -30 14 -43 31 -14 16 -42 34 -62 40 -49 13 -52 13 -59 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgojdsM0S",
    d: "M7518 1787 c-43 -18 -78 -35 -78 -39 0 -9 38 5 115 42 80 38 59 36 -37 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWa1kV9q1",
    d: "M7555 1734 c-70 -30 -94 -49 -52 -41 19 3 30 0 34 -9 8 -22 25 -16 18 6 -5 15 1 22 29 34 20 8 36 20 36 25 0 13 6 15 -65 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV0o6lzWd",
    d: "M2613 1722 c-24 -15 -43 -30 -43 -34 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 9 0 15 9 15 25 0 31 -5 31 -57 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pna113Crg",
    d: "M7330 1714 l-65 -23 70 0 c46 1 62 3 45 8 l-25 7 23 8 c12 4 22 12 22 17 0 5 -1 9 -2 8 -2 -1 -32 -12 -68 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1C3FneMCm",
    d: "M5197 1701 c-7 -27 19 -93 45 -115 l23 -18 5 33 c5 31 3 34 -24 37 l-29 3 34 29 34 29 -27 1 c-16 0 -28 5 -28 10 0 18 -28 11 -33 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCMbi79we",
    d: "M2458 1643 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5hgBAFOq",
    d: "M3215 1563 c-220 -47 -402 -87 -404 -89 -22 -20 68 -4 427 75 229 51 419 95 421 97 12 11 -79 -6 -444 -83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17y0YfBI5",
    d: "M5359 1613 c-18 -56 -21 -58 -35 -24 -17 41 -36 40 -32 -1 3 -28 8 -34 31 -36 22 -3 30 1 34 17 5 21 33 30 33 11 0 -16 18 -12 40 10 27 27 25 40 -5 40 -14 0 -25 5 -25 10 0 26 -30 6 -41 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSTUUaw7R",
    d: "M2378 1633 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKY1qAzd4",
    d: "M2228 1613 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKVhZdxaZ",
    d: "M7870 1604 c0 -23 165 -204 186 -204 21 0 9 16 -98 130 -61 65 -88 88 -88 74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11wjHQiYL",
    d: "M7638 1593 c-22 -5 -24 -33 -3 -33 8 0 15 -9 15 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0 -20 -5 -30 -15 -30 -13 0 -13 -4 -2 -32 16 -38 37 -48 37 -17 0 21 1 21 25 -5 14 -15 25 -31 25 -37 0 -5 5 -9 10 -9 6 0 10 -5 10 -12 0 -20 51 -58 79 -59 14 0 20 -3 14 -6 -7 -2 -13 -11 -13 -18 0 -21 63 -29 143 -18 61 9 65 10 28 12 -30 1 -68 14 -120 42 -67 35 -83 50 -128 115 -29 41 -50 74 -47 74 3 0 51 -31 105 -70 54 -38 99 -68 99 -65 0 2 -55 50 -122 107 -101 85 -119 104 -100 106 28 4 28 18 0 26 -25 6 -34 6 -60 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPggdDXPg",
    d: "M1998 1583 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfRARCPA9",
    d: "M7545 1580 c-16 -7 -13 -9 18 -9 20 -1 37 4 37 9 0 12 -27 12 -55 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peIePJIYn",
    d: "M1918 1573 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3LHWw2G7",
    d: "M1860 1520 c-267 -32 -506 -61 -532 -65 -44 -5 -48 -4 -48 15 0 24 6 24 -100 5 -47 -8 -86 -15 -87 -15 -2 0 -3 -6 -3 -14 0 -13 -20 -26 -41 -26 -5 0 -9 7 -9 15 0 16 -12 18 -48 9 -13 -4 -22 -14 -22 -25 0 -12 -7 -19 -19 -19 -11 0 -26 -3 -35 -6 -11 -4 -16 -1 -16 10 0 20 -9 20 -82 0 -33 -10 -58 -22 -58 -30 0 -8 -36 -24 -90 -40 -50 -15 -90 -31 -90 -36 0 -4 -9 -8 -20 -8 -61 0 -270 -124 -270 -161 0 -16 8 -14 56 17 135 86 320 153 577 208 158 34 263 48 1262 166 161 19 251 26 253 20 4 -11 43 -33 87 -50 23 -9 25 -7 25 15 0 16 -6 25 -15 25 -9 0 -25 8 -36 19 -21 19 -71 31 -124 30 -16 -1 -248 -27 -515 -59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDZpeRBYw",
    d: "M1768 1553 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Bpt0vOLp",
    d: "M1688 1543 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11zf92juQ",
    d: "M1588 1533 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvfmk6ImG",
    d: "M1358 1503 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGeJnZ3mR",
    d: "M6610 1463 c-14 -2 -81 -19 -150 -38 -195 -52 -361 -81 -679 -120 l-293 -37 -37 34 c-19 18 -38 35 -41 36 -3 2 7 14 23 27 15 13 27 28 27 32 0 14 -38 42 -67 49 -27 6 -27 6 -8 -9 11 -9 14 -17 8 -17 -9 0 -11 -10 -6 -32 5 -27 4 -30 -11 -25 -13 5 -15 2 -9 -20 3 -15 14 -36 25 -47 10 -11 15 -22 12 -25 -4 -3 -9 0 -11 7 -3 6 -13 12 -23 12 -17 0 -18 -7 -13 -77 8 -100 23 -142 21 -56 -1 35 1 65 4 69 3 3 175 25 381 49 206 24 392 48 414 54 21 6 80 11 131 11 91 0 118 11 65 25 -27 8 -27 8 17 22 25 7 101 29 170 48 108 29 131 42 50 28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1946KzMJn",
    d: "M5041 1449 c-34 -13 -81 -49 -81 -61 0 -6 15 -8 35 -6 31 4 35 1 35 -19 0 -13 5 -23 10 -23 6 0 10 -7 10 -15 0 -23 15 -18 30 11 12 21 12 27 1 33 -8 5 -11 17 -6 30 4 14 2 21 -6 21 -20 0 -4 11 38 25 l38 14 -40 0 c-22 0 -51 -5 -64 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXQScghRX",
    d: "M4950 1340 c0 -12 33 -30 54 -30 9 0 16 9 16 20 0 16 -7 20 -35 20 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjZcOQXoO",
    d: "M6440 1331 c0 -5 26 -18 58 -30 33 -12 85 -38 116 -57 54 -32 96 -44 96 -26 0 12 -98 67 -172 96 -69 27 -98 32 -98 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18qv8xAkL",
    d: "M8130 1329 c0 -17 47 -66 56 -57 3 4 -8 21 -25 40 -20 22 -31 28 -31 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7GBzbp6D",
    d: "M7717 1245 c25 -75 47 -76 37 -2 -6 41 -10 47 -30 47 -23 0 -23 0 -7 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DeKTylyX",
    d: "M4830 1210 c-85 -11 -156 -19 -157 -19 -2 -1 -3 -7 -3 -15 0 -24 18 -28 69 -16 40 9 55 9 86 -4 21 -9 48 -16 61 -16 13 0 24 -6 24 -13 0 -15 61 -47 90 -47 36 0 21 17 -47 53 -75 39 -74 40 34 54 l71 8 8 -40 c4 -25 9 -33 11 -22 9 37 -6 85 -30 91 -28 7 -34 7 -217 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plTSH6yh7",
    d: "M4355 1159 c-137 -15 -281 -31 -320 -34 -38 -3 -167 -17 -285 -30 -118 -13 -250 -27 -293 -30 -43 -3 -89 -10 -102 -15 -12 -5 -25 -6 -28 -4 -5 5 -264 -20 -334 -31 -19 -4 -33 -12 -33 -20 0 -15 53 -30 70 -20 6 4 34 9 63 11 142 12 193 18 290 32 37 6 75 9 85 7 52 -11 92 -13 87 -5 -6 9 40 22 95 26 19 1 65 6 103 11 49 7 67 6 67 -2 0 -12 117 -49 136 -44 5 2 34 -2 64 -9 30 -6 82 -14 114 -17 59 -7 63 -24 6 -26 -26 0 122 -48 153 -49 9 0 25 -8 35 -17 9 -10 28 -17 41 -15 13 2 56 -8 95 -22 88 -31 321 -99 401 -117 43 -9 53 -14 35 -17 -51 -8 -44 -22 12 -22 84 0 118 9 118 32 0 17 -5 19 -42 13 -37 -5 -91 10 -383 108 -187 63 -339 119 -338 124 1 5 -13 9 -30 9 -18 0 -90 18 -162 40 l-130 39 240 26 c132 15 252 31 266 37 15 6 55 11 90 12 97 3 119 9 119 31 0 24 9 24 -305 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppMMN8Xij",
    d: "M5071 1082 c-1 -7 -5 -11 -9 -8 -4 2 -14 0 -22 -5 -13 -8 -12 -11 3 -20 11 -6 25 -25 33 -43 l13 -31 0 40 c0 37 -17 97 -18 67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p60lvba9s",
    d: "M7783 1058 c12 -31 37 -50 37 -29 0 24 -21 61 -35 61 -13 0 -13 -4 -2 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HDmdVBiL",
    d: "M5281 1040 c0 -14 4 -34 9 -45 8 -18 9 -18 9 5 0 14 -4 34 -9 45 -8 18 -9 18 -9 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNQ88qFD7",
    d: "M5376 998 c7 -54 10 -65 19 -57 8 9 -7 109 -17 109 -5 0 -6 -23 -2 -52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pU9nxtXQ8",
    d: "M6890 1029 c0 -31 60 -92 86 -87 14 2 7 14 -34 58 -47 51 -51 53 -52 29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Fe0j8U0m",
    d: "M564 994 c3 -9 6 -20 6 -25 0 -5 11 -9 25 -9 35 0 31 26 -6 39 -27 9 -30 8 -25 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HLMSisyP",
    d: "M2835 999 c-33 -5 -91 -11 -130 -14 -38 -3 -167 -17 -285 -30 -118 -13 -246 -27 -285 -30 -38 -3 -167 -17 -285 -30 -118 -13 -251 -27 -294 -30 -44 -4 -83 -8 -87 -11 -4 -2 -42 -6 -86 -9 -43 -3 -132 -12 -198 -20 -185 -23 -202 -24 -325 -10 -212 25 -368 69 -356 102 8 20 -49 55 -78 47 -36 -9 -33 -34 3 -34 23 0 30 -5 33 -21 2 -17 24 -31 88 -59 141 -61 256 -82 450 -82 69 0 106 3 230 17 89 10 145 16 170 16 14 0 41 5 60 11 19 6 68 12 110 14 73 4 126 8 220 19 85 10 145 16 170 16 14 0 40 5 58 10 28 9 151 20 222 20 14 0 40 5 58 10 18 6 67 12 110 15 42 2 100 6 127 9 28 3 70 7 95 10 102 10 177 19 268 31 42 5 52 10 52 25 0 21 -14 22 -115 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIp6fzdrd",
    d: "M280 990 c0 -11 60 -44 67 -36 9 9 -7 24 -37 34 -17 7 -30 7 -30 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcDiB411T",
    d: "M4690 975 c0 -5 275 -145 286 -145 3 0 4 7 2 16 -2 9 -58 39 -142 75 -145 62 -146 62 -146 54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2u4qYqRQ",
    d: "M510 950 c19 -13 30 -13 30 0 0 6 -10 10 -22 10 -19 0 -20 -2 -8 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pI5Pa4R0c",
    d: "M5085 893 c4 -40 5 -73 2 -73 -3 0 -17 4 -31 10 -23 8 -26 7 -26 -11 0 -14 10 -25 30 -32 33 -12 38 -24 15 -33 -27 -11 -16 -24 20 -24 24 0 35 5 35 14 0 8 -5 16 -11 18 -6 2 -14 45 -18 96 -5 51 -11 96 -16 100 -4 4 -4 -26 0 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FLLawdpq",
    d: "M5291 928 c-1 -21 4 -38 9 -38 12 0 12 27 0 55 -7 16 -9 13 -9 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPlyLRSVC",
    d: "M5380 916 c0 -40 18 -62 54 -64 46 -3 46 9 1 34 -19 10 -35 24 -35 31 0 7 -4 13 -10 13 -5 0 -10 -6 -10 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQQkIFkxl",
    d: "M7842 890 c10 -29 25 -46 34 -38 9 9 -18 68 -31 68 -11 0 -12 -6 -3 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pO774SE3V",
    d: "M5290 826 c0 -43 0 -44 -40 -50 -26 -4 -40 -11 -40 -21 0 -16 22 -19 83 -9 42 7 40 -1 21 94 -8 45 -24 36 -24 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzLedidkk",
    d: "M7068 823 c11 -16 36 -44 56 -62 36 -35 36 -35 36 -10 0 29 -66 99 -94 99 -16 0 -16 -2 2 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11tOqGRB8",
    d: "M7936 623 c41 -120 80 -222 86 -228 13 -13 11 -3 -70 243 -38 115 -72 202 -79 202 -7 0 16 -82 63 -217z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTSsFMdwE",
    d: "M5390 785 c0 -34 1 -35 40 -35 33 0 40 3 40 20 0 16 -7 20 -30 20 -20 0 -30 5 -30 15 0 8 -4 15 -10 15 -5 0 -10 -16 -10 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPjaNvvWi",
    d: "M5520 805 c25 -14 25 -14 3 -15 -16 0 -23 -6 -23 -20 0 -16 7 -20 35 -20 l35 0 0 -50 c0 -27 4 -50 10 -50 17 0 32 41 28 76 -4 34 -4 34 29 28 45 -9 43 12 -4 31 -26 11 -39 12 -43 4 -5 -6 -9 -3 -13 10 -4 17 -13 21 -44 21 -38 -1 -38 -1 -13 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph74Var3P",
    d: "M4410 771 c8 -5 31 -11 50 -14 19 -2 27 -2 17 0 -9 2 -15 9 -12 14 4 5 -11 9 -32 9 -27 -1 -34 -3 -23 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poe4Vw4NM",
    d: "M5690 761 c0 -10 22 -16 93 -26 64 -10 62 10 -3 24 -62 13 -90 14 -90 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTl3Ejw99",
    d: "M7493 713 c19 -27 57 -79 84 -118 41 -59 54 -70 79 -71 25 -1 26 0 3 3 -20 3 -45 31 -108 119 -45 62 -84 114 -87 114 -3 0 10 -21 29 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFGWPnPNp",
    d: "M4537 743 c18 -2 50 -2 70 0 21 2 7 4 -32 4 -38 0 -55 -2 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6X5UGEZa",
    d: "M5950 686 c0 -13 7 -27 16 -30 22 -9 74 -7 74 2 0 9 -32 29 -66 42 -21 8 -24 7 -24 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbik5DaSc",
    d: "M4820 669 c0 -16 4 -20 18 -15 16 6 16 5 0 -8 -26 -20 -22 -26 17 -26 33 0 35 2 35 35 0 33 -2 35 -35 35 -29 0 -35 -4 -35 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "po0farPFx",
    d: "M4713 663 c-24 -8 -43 -19 -43 -24 0 -5 -7 -9 -16 -9 -19 0 -74 -31 -74 -42 0 -14 27 -8 91 21 35 16 75 31 89 32 29 5 42 39 13 38 -10 0 -37 -7 -60 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15NMfkABA",
    d: "M5860 624 l-13 -46 -46 6 -46 5 33 -14 c18 -8 31 -19 27 -25 -4 -6 6 -10 24 -10 20 0 31 5 31 14 0 8 5 16 11 18 6 2 13 25 16 51 5 37 3 47 -9 47 -10 0 -20 -18 -28 -46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNyKsHju1",
    d: "M7260 650 c0 -32 69 -104 96 -98 14 2 6 15 -39 63 -52 55 -56 58 -57 35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7MT0xr8F",
    d: "M6050 555 c0 -14 5 -25 12 -25 6 0 32 -12 57 -27 39 -23 43 -27 26 -34 -13 -5 -15 -8 -5 -8 24 -1 60 11 60 19 0 4 -29 23 -65 41 -36 19 -65 40 -65 47 0 6 -4 12 -10 12 -5 0 -10 -11 -10 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHQ44R9lb",
    d: "M4500 521 c-12 -24 -13 -81 -2 -81 9 0 32 66 32 89 0 18 -18 13 -30 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOYAufyZd",
    d: "M5756 501 c-3 -5 -26 -18 -51 -30 -54 -25 -58 -41 -10 -41 19 0 35 5 35 10 0 6 9 10 20 10 16 0 20 7 20 30 0 30 -4 37 -14 21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCMMEGpWy",
    d: "M6313 463 c-24 -2 -43 -9 -43 -14 0 -12 100 -1 115 12 5 5 1 8 -10 7 -11 -1 -39 -3 -62 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5PEDWLyW",
    d: "M4547 439 c-7 -26 5 -60 27 -78 14 -12 16 -10 16 12 0 71 -30 117 -43 66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdufcNVI9",
    d: "M5180 425 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3DiPyOjA",
    d: "M5871 440 c-25 -4 -47 -12 -49 -18 -2 -7 -17 -12 -33 -12 -24 0 -29 -4 -29 -26 0 -15 4 -23 10 -19 9 5 177 34 203 35 4 0 7 5 7 11 0 11 -40 7 -88 -7 -9 -3 0 4 21 16 57 31 49 35 -42 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAOJoq7mg",
    d: "M6038 443 c-29 -7 -21 -33 10 -33 42 0 72 11 72 26 0 14 -43 17 -82 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptdZvEEZv",
    d: "M4970 379 c-41 -11 -92 -25 -113 -30 -34 -9 -38 -13 -35 -37 2 -22 9 -28 33 -30 23 -2 27 0 15 8 -22 15 -6 22 125 54 79 19 115 32 115 42 0 19 -48 17 -140 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4YOiBRLQ",
    d: "M5480 368 c-45 -17 -83 -78 -47 -78 28 0 57 13 57 25 0 7 5 15 11 17 6 2 9 13 7 25 -2 17 -7 19 -28 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnw2P2NIo",
    d: "M5593 363 c-15 -3 -23 -12 -23 -24 0 -22 6 -23 66 -8 82 21 44 49 -43 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIHkMH9Mn",
    d: "M7580 320 c0 -14 7 -20 22 -20 20 0 21 1 3 20 -10 11 -20 20 -22 20 -1 0 -3 -9 -3 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQ9KkFGJX",
    d: "M4730 316 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyWlxEDUz",
    d: "M5345 316 c-16 -7 -47 -16 -67 -20 -64 -12 -43 -26 30 -19 37 3 68 7 70 9 2 1 2 11 0 22 -3 19 -6 19 -33 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Bt9Pf2i0",
    d: "M7462 293 c-35 -8 -61 -17 -59 -19 7 -8 157 18 157 27 0 12 -21 10 -98 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BE2m9F9M",
    d: "M8050 298 c0 -9 -6 -19 -12 -21 -7 -3 -3 -6 10 -6 24 -1 27 6 12 29 -8 13 -10 13 -10 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pulo1yvni",
    d: "M7813 263 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l1cj8PQTbbbTSbo3mcSTCPV",
    fill: "rgb(51,51,51)",
    style: {
      transform: "none"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pHtZs0vjK",
    d: "M4983 2643 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOGLUXHrY",
    d: "M3677 2630 c-88 -11 -82 -22 8 -14 87 8 147 23 85 22 -19 0 -61 -4 -93 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piKCd63at",
    d: "M4597 2610 l-277 -28 -118 -52 c-64 -29 -121 -56 -126 -61 -5 -4 -2 -14 7 -23 14 -14 27 -10 134 43 l118 58 267 37 c146 20 277 40 290 45 32 13 30 13 -295 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFvTRnzDB",
    d: "M3810 2610 c0 -13 7 -20 19 -20 14 0 18 5 14 20 -3 11 -12 20 -19 20 -8 0 -14 -9 -14 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peNpT7NqT",
    d: "M3535 2610 c-18 -8 -18 -9 5 -9 14 0 34 4 45 9 18 8 18 9 -5 9 -14 0 -34 -4 -45 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19IksFNKy",
    d: "M3455 2600 l-20 -9 20 0 c11 0 29 4 40 9 l20 9 -20 0 c-11 0 -29 -4 -40 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbO1uaA8H",
    d: "M3360 2590 c-20 -6 -21 -8 -5 -8 11 0 29 3 40 8 25 11 -1 11 -35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prcT7iwRa",
    d: "M3260 2580 c-20 -6 -21 -8 -5 -8 11 0 31 4 45 8 20 6 21 8 5 8 -11 0 -31 -4 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10WT4vXVY",
    d: "M3156 2564 c-10 -26 -7 -44 8 -44 8 0 16 10 18 22 2 14 13 25 28 29 22 6 20 7 -11 8 -25 1 -39 -4 -43 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYUjVx854",
    d: "M2895 2560 l-20 -9 20 0 c11 0 38 4 60 8 l40 9 -40 0 c-22 0 -49 -3 -60 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZ6RuXuhF",
    d: "M2826 2541 c-18 -28 -25 -61 -13 -61 11 0 37 43 37 62 0 11 -17 10 -24 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8PH2yvo5",
    d: "M3810 2485 c0 -30 3 -35 23 -35 16 0 18 3 8 9 -9 6 -10 11 -2 15 19 12 13 46 -9 46 -16 0 -20 -7 -20 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzvPA6RLG",
    d: "M3150 2475 c0 -19 3 -35 8 -35 4 0 6 -18 4 -40 -3 -25 0 -40 7 -40 6 0 11 -7 11 -15 0 -14 3 -14 23 -1 16 10 541 106 582 106 3 0 5 7 5 15 0 8 -2 15 -3 15 -2 0 -134 -20 -292 -45 -159 -24 -292 -42 -296 -40 -8 6 -24 83 -20 103 1 6 -5 12 -14 12 -11 0 -15 -10 -15 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHSgHLBeS",
    d: "M4578 2489 c-21 -11 -38 -22 -38 -24 0 -3 18 4 40 15 22 11 40 23 40 25 0 7 0 7 -42 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p124TAAY5P",
    d: "M2821 2448 c0 -14 -7 -28 -13 -31 -10 -3 -9 -14 3 -50 19 -54 27 -48 -114 -68 -88 -12 -118 -30 -86 -50 20 -13 29 -11 29 6 0 16 8 19 126 38 71 12 83 12 104 -2 17 -11 25 -12 27 -4 3 7 11 9 18 7 8 -3 29 -1 47 5 18 6 47 11 63 12 17 1 51 6 78 12 35 8 47 15 47 29 0 22 12 22 -133 -2 -115 -20 -173 -20 -137 0 8 4 48 13 88 21 66 11 71 14 57 28 -12 13 -19 13 -35 4 -12 -8 -21 -9 -25 -3 -4 7 -13 7 -25 0 -15 -8 -20 -6 -26 12 l-6 21 -12 -22 -12 -22 -13 28 c-12 26 -13 27 -24 8 -11 -18 -12 -17 -18 15 -5 29 -7 31 -8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BRYxYPfU",
    d: "M4490 2440 c-19 -11 -31 -19 -27 -20 11 0 67 29 67 35 0 7 -1 7 -40 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOSp9YMWJ",
    d: "M3993 2435 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNeCOaXF",
    d: "M3218 2423 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHjfvcWaD",
    d: "M3903 2395 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCLPbuCjC",
    d: "M4388 2389 c-36 -19 -47 -29 -30 -29 4 0 25 11 47 25 48 29 36 32 -17 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzYcPvDJr",
    d: "M3813 2355 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCpKLzIZa",
    d: "M4203 2296 c-86 -43 -128 -74 -265 -195 l-163 -143 -42 -92 c-57 -124 -53 -132 8 -14 39 77 54 99 75 104 17 4 22 9 14 14 -8 5 38 50 125 126 100 87 165 134 243 176 111 61 118 66 111 72 -2 2 -50 -19 -106 -48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p0HXIDOkt",
    d: "M4465 2283 c-43 -39 -44 -41 -9 -15 37 28 72 63 63 62 -2 -1 -26 -21 -54 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKl7jZlLN",
    d: "M3699 2303 c-33 -14 -38 -29 -11 -37 9 -3 -2 -3 -25 -1 -61 7 -53 -1 13 -15 36 -8 59 -8 63 -2 3 5 21 17 39 26 17 9 32 20 32 25 0 15 -79 18 -111 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pahTTiAiu",
    d: "M3220 2230 c0 -15 7 -20 25 -20 14 0 25 -5 25 -11 0 -9 23 -21 85 -43 18 -7 16 -10 -17 -27 -45 -23 -49 -39 -9 -39 49 0 61 9 61 46 0 30 -3 34 -25 34 -18 0 -25 5 -25 20 0 11 -4 20 -10 20 -5 0 -10 6 -10 14 0 15 -30 26 -72 26 -21 0 -28 -5 -28 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPTuHhblC",
    d: "M3580 2215 c0 -20 -5 -25 -25 -25 -14 0 -25 -4 -25 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -9 -9 -15 -25 -15 -14 0 -25 -4 -25 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -9 -9 -15 -25 -15 -14 0 -25 -4 -25 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -5 -10 -11 -10 -6 0 -17 -7 -25 -15 -9 -8 -33 -15 -54 -15 -21 0 -41 -6 -43 -12 -3 -8 -6 -7 -6 4 -1 9 8 20 19 23 13 4 20 15 20 30 0 22 -3 24 -25 15 -57 -22 -85 -41 -85 -59 0 -13 9 -21 28 -25 69 -13 131 -16 172 -7 28 5 36 9 20 10 -26 2 -4 18 257 182 l111 70 92 -10 c54 -6 100 -6 113 -1 18 7 15 8 -18 8 -22 -1 -89 6 -149 15 -60 9 -111 17 -113 17 -2 0 -3 -11 -3 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSEIO0gPP",
    d: "M4272 2125 c-56 -47 -102 -88 -102 -91 0 -3 5 -14 10 -25 16 -29 33 -23 25 9 -5 26 1 34 73 95 75 63 110 97 100 97 -2 0 -50 -38 -106 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paQfOP7hs",
    d: "M2590 2173 c1 -10 7 -36 15 -58 19 -53 20 -52 -15 -60 -17 -4 -30 -13 -30 -22 0 -12 8 -13 43 -8 23 4 51 13 62 19 11 7 80 28 153 46 90 22 132 37 132 46 0 18 3 19 -150 -16 -153 -35 -150 -34 -150 -15 0 8 12 17 28 21 46 10 49 14 5 9 -39 -5 -42 -4 -48 25 -7 33 -45 44 -45 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWLFM00wp",
    d: "M3023 2172 c-33 -9 -53 -20 -53 -30 0 -8 6 -12 14 -9 8 3 31 9 51 13 20 3 39 13 42 21 8 20 3 21 -54 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXXlndnmv",
    d: "M2311 2083 c-14 -51 -14 -57 7 -76 26 -24 102 -49 102 -35 0 7 6 4 13 -6 19 -26 147 -49 147 -26 0 5 -17 12 -37 15 -74 13 -103 26 -103 46 0 18 -5 19 -50 13 -35 -5 -50 -3 -50 5 0 6 13 14 29 17 16 3 28 11 26 18 -15 57 -35 70 -35 23 -1 -18 -3 -16 -15 11 -8 17 -16 32 -19 32 -3 0 -10 -17 -15 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1A4km4J8d",
    d: "M2404 2074 c3 -9 6 -18 6 -20 0 -7 23 -4 65 7 34 10 37 13 20 19 -11 4 -29 3 -40 -3 -13 -7 -20 -7 -23 2 -2 6 -11 11 -19 11 -10 0 -13 -6 -9 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pO4fZcACV",
    d: "M2477 2033 c-24 -4 -25 -6 -12 -19 18 -19 75 -10 75 12 0 14 -9 15 -63 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17AS0gat3",
    d: "M7815 2001 c-11 -4 30 -6 90 -4 148 6 163 11 35 11 -58 0 -114 -3 -125 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4vtZ3ITQ",
    d: "M8073 2003 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdzsdGY5D",
    d: "M8115 1993 c-11 -2 -69 -7 -130 -12 l-110 -9 144 4 c83 1 148 7 154 13 11 11 -14 13 -58 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pt34A7nzG",
    d: "M3875 1980 c-25 -11 1 -11 35 0 20 6 21 8 5 8 -11 0 -29 -3 -40 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p121CXB6KW",
    d: "M3013 1963 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prYx7Cb8m",
    d: "M7598 1952 c-27 -8 -48 -20 -48 -25 0 -11 34 -3 91 22 53 24 24 26 -43 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p180fuhbdU",
    d: "M4220 1943 c0 -10 11 -41 24 -69 23 -49 23 -51 5 -75 l-18 -25 50 15 c27 8 49 21 49 28 0 7 5 13 10 13 6 0 10 -7 10 -15 0 -9 9 -15 23 -15 38 0 67 12 67 26 0 8 7 14 15 14 8 0 15 -7 15 -15 0 -8 8 -15 18 -15 33 0 62 12 62 26 0 8 5 14 10 14 6 0 10 9 10 20 0 11 -6 20 -12 20 -30 0 -58 -13 -58 -26 0 -8 -7 -14 -15 -14 -8 0 -15 7 -15 15 0 16 -12 18 -47 9 -13 -4 -23 -13 -23 -20 0 -8 -7 -14 -15 -14 -8 0 -15 7 -15 15 0 16 -12 18 -47 9 -13 -4 -23 -13 -23 -21 0 -8 -4 -11 -10 -8 -5 3 -10 15 -10 27 0 23 -39 98 -52 98 -4 0 -8 -8 -8 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FMYOeStG",
    d: "M8033 1934 c-29 -13 -53 -26 -53 -29 0 -5 110 42 119 50 10 11 -17 2 -66 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYYJHZJKe",
    d: "M2780 1941 c0 -11 36 -21 78 -21 37 0 43 15 10 24 -34 9 -88 7 -88 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWFJzmpgF",
    d: "M2980 1920 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbtCgzcNO",
    d: "M5068 1933 c-10 -2 -18 -11 -18 -19 0 -8 -4 -14 -10 -14 -5 0 -10 -10 -10 -21 0 -19 4 -21 41 -16 49 6 47 5 55 45 6 29 4 32 -17 31 -13 -1 -32 -3 -41 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plC0KAeG7",
    d: "M5610 1920 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcvqtuRXN",
    d: "M3083 1922 c18 -4 24 -22 7 -22 -5 0 -10 -7 -10 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -9 -9 -15 -25 -15 -15 0 -25 -6 -25 -14 0 -23 101 -39 219 -34 84 4 171 19 414 73 170 38 304 71 300 72 -5 2 -149 -26 -319 -62 -308 -65 -418 -79 -497 -62 -21 4 -35 12 -32 17 3 5 128 99 278 209 236 172 280 201 323 209 42 7 34 8 -56 8 -58 0 -97 -2 -87 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF7z7jCfz",
    d: "M4927 1923 c-14 -4 -17 -11 -13 -26 3 -12 6 -28 6 -34 0 -14 31 -17 68 -7 25 7 31 34 7 34 -8 0 -15 9 -15 20 0 20 -13 23 -53 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyfJKqZ2X",
    d: "M5870 1910 c0 -16 7 -20 35 -20 40 0 49 24 13 34 -38 10 -48 7 -48 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5BMAVnJD",
    d: "M4828 1913 c-13 -3 -18 -15 -18 -40 0 -35 0 -36 36 -30 46 8 45 7 38 45 -6 32 -16 36 -56 25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxWfzWCFt",
    d: "M5998 1914 c-10 -3 -18 -11 -18 -19 0 -26 97 -35 107 -10 3 9 3 18 0 21 -7 8 -70 13 -89 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3TPG3JvZ",
    d: "M7463 1907 c-18 -5 -33 -16 -33 -23 0 -10 7 -11 30 -2 28 9 47 26 39 32 -2 1 -19 -2 -36 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPDcl2jCX",
    d: "M4728 1903 c-10 -2 -18 -11 -18 -19 0 -8 -4 -14 -10 -14 -5 0 -10 -9 -10 -20 0 -21 23 -26 68 -14 17 5 22 14 22 40 0 35 -8 39 -52 27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj1RsisVF",
    d: "M5150 1890 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGPCwb5CB",
    d: "M6160 1893 c0 -21 32 -33 91 -33 22 0 29 5 29 20 0 15 -7 20 -29 20 -16 0 -43 3 -60 6 -26 6 -31 4 -31 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pm225T057",
    d: "M4618 1893 c-10 -2 -18 -11 -18 -19 0 -8 -4 -14 -10 -14 -5 0 -10 -10 -10 -21 0 -19 4 -21 36 -16 44 7 42 6 50 45 7 33 -1 37 -48 25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcxEmH3rF",
    d: "M6310 1881 c0 -15 11 -19 61 -25 103 -10 149 -8 149 9 0 16 -26 21 -137 29 -65 4 -73 3 -73 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzPGJtI8y",
    d: "M7836 1851 c-106 -46 -140 -71 -97 -71 31 0 38 -57 13 -106 -31 -60 -51 -73 -131 -83 -77 -10 -105 -21 -53 -21 21 0 35 -7 42 -19 5 -11 20 -22 32 -24 23 -4 23 -4 1 -6 -21 -1 -22 -2 -6 -46 15 -46 34 -67 41 -47 2 7 15 12 28 12 21 0 24 -5 24 -35 0 -19 5 -35 10 -35 6 0 10 -7 10 -15 0 -9 9 -15 25 -15 20 0 25 -5 25 -25 0 -18 -5 -25 -20 -25 -27 0 -25 -26 3 -34 34 -9 47 -7 47 7 0 9 12 11 40 9 22 -2 40 0 40 5 0 6 -22 22 -50 37 -37 20 -63 47 -105 105 -57 81 -68 105 -37 79 25 -22 182 -130 182 -126 0 2 -49 44 -109 93 -61 50 -110 93 -110 98 -1 4 7 7 17 7 21 0 82 59 82 79 0 8 6 11 15 7 8 -3 15 -1 15 3 0 5 -5 11 -11 13 -7 2 -7 12 -1 29 6 14 8 45 5 70 l-5 45 81 37 c72 33 96 48 74 46 -5 0 -57 -22 -117 -48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ek4gqjPk",
    d: "M2798 1842 c-32 -20 -58 -40 -58 -44 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 9 0 15 9 15 25 0 14 -3 25 -7 25 -5 0 -34 -17 -65 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJZ8JYIrq",
    d: "M6530 1866 c0 -15 30 -26 73 -26 38 0 35 26 -4 34 -49 9 -69 7 -69 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phsFoKAuB",
    d: "M7318 1862 c-34 -11 -48 -21 -48 -34 0 -17 2 -17 38 -2 20 9 49 20 65 26 30 11 37 29 10 27 -10 0 -39 -8 -65 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FxcHyH2x",
    d: "M6640 1855 c0 -10 11 -15 35 -15 39 0 47 14 13 24 -36 9 -48 7 -48 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZkfxsgut",
    d: "M6775 1841 c11 -5 70 -11 130 -14 l110 -6 -80 14 c-90 15 -193 19 -160 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p122HwocOz",
    d: "M5308 1823 c-37 -9 -18 -30 32 -37 58 -8 96 5 64 21 -25 13 -74 21 -96 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BM4D8sPN",
    d: "M7118 1798 c-77 -25 -98 -35 -98 -50 0 -11 7 -18 18 -17 32 1 215 74 220 87 6 19 -33 13 -140 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGS7FVyUa",
    d: "M7450 1759 c-73 -30 -121 -59 -72 -44 34 10 169 74 157 74 -5 0 -44 -14 -85 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1UWfJdqQ",
    d: "M7605 1754 c-87 -38 -96 -45 -77 -51 6 -3 12 -11 12 -19 0 -8 4 -14 10 -14 5 0 9 10 7 22 -2 19 8 26 67 47 38 15 71 32 74 39 5 17 -3 15 -93 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNgXnwGHl",
    d: "M5430 1762 c0 -12 -6 -22 -14 -22 -22 0 -28 -42 -8 -56 14 -11 17 -10 20 7 2 11 11 19 22 19 24 0 23 29 -2 54 -18 19 -18 19 -18 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqvk4GveX",
    d: "M5210 1751 c-16 -31 -12 -51 10 -51 11 0 20 -7 20 -15 0 -19 14 -19 29 -1 10 12 8 19 -8 35 -12 12 -21 28 -21 36 0 21 -17 19 -30 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPQjojuZV",
    d: "M6930 1743 l-45 -16 28 -10 c42 -14 97 -1 97 23 0 24 -18 24 -80 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp7tZXhLh",
    d: "M7320 1705 l-25 -14 28 -1 c17 0 27 5 27 15 0 18 1 18 -30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16kBCepzY",
    d: "M2550 1680 c-25 -16 -51 -30 -57 -30 -7 0 -13 -7 -13 -15 0 -10 11 -15 35 -15 19 0 35 5 35 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 9 0 15 9 15 25 0 32 -5 31 -60 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC2Mi8TRw",
    d: "M7388 1693 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfvCAMrTD",
    d: "M2388 1633 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkP8NH9Js",
    d: "M5280 1630 c0 -5 -14 -10 -30 -10 -27 0 -29 -2 -18 -19 19 -31 79 -54 121 -46 34 7 37 10 37 41 0 45 -17 43 -37 -3 l-16 -38 -18 43 c-17 38 -39 57 -39 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ETFrvWU5",
    d: "M7850 1624 c0 -23 43 -68 60 -62 6 2 -4 21 -24 43 -30 34 -35 37 -36 19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPIpFr06b",
    d: "M2308 1623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqsLhYacJ",
    d: "M3510 1620 c-20 -6 -21 -8 -5 -8 11 0 31 4 45 8 20 6 21 8 5 8 -11 0 -31 -4 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmTlX8zNE",
    d: "M2158 1603 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pahLcp91i",
    d: "M2078 1593 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyA9AjIbg",
    d: "M1928 1573 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pijHKeTWB",
    d: "M2320 1560 c0 -21 16 -25 58 -14 39 11 27 34 -18 34 -33 0 -40 -3 -40 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzz6UxQg3",
    d: "M1848 1563 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11MSsEimk",
    d: "M2193 1563 c-35 -3 -43 -8 -43 -25 0 -18 4 -19 53 -13 88 10 107 16 107 31 0 14 -20 15 -117 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOucmLVlP",
    d: "M1698 1543 c-28 -7 -22 -33 7 -33 19 0 25 -5 25 -21 0 -19 4 -20 53 -14 90 11 107 16 107 32 0 13 -10 15 -70 9 -66 -7 -70 -6 -70 13 0 21 -13 24 -52 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13OO6E6Dy",
    d: "M2023 1543 c-35 -3 -43 -8 -43 -25 0 -18 4 -19 53 -13 88 10 107 16 107 31 0 14 -20 15 -117 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgqM4Sarj",
    d: "M1598 1533 c-30 -8 -20 -31 15 -36 28 -3 26 -4 -10 -5 -36 -2 -43 -5 -43 -23 0 -19 4 -20 53 -14 88 10 107 16 107 31 0 9 -11 14 -35 14 -28 0 -35 4 -35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEBcRcq1F",
    d: "M2460 1532 c0 -7 17 -18 63 -40 4 -2 7 8 7 22 0 23 -4 26 -35 26 -19 0 -35 -4 -35 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVKvrkFfI",
    d: "M1500 1525 c-8 -2 -32 -6 -52 -10 -48 -7 -51 -32 -5 -38 28 -3 26 -4 -10 -5 -36 -2 -43 -5 -43 -23 0 -19 4 -20 53 -14 87 10 107 16 107 30 0 9 -14 15 -37 18 l-38 4 38 1 c30 2 37 6 37 22 0 19 -11 23 -50 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Eq5chMsh",
    d: "M1900 1510 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FZ59tYLC",
    d: "M1305 1495 c-5 -2 -27 -6 -47 -10 -29 -4 -38 -11 -38 -25 0 -17 -7 -20 -40 -20 -34 0 -40 -3 -40 -21 0 -19 4 -20 53 -14 99 12 109 15 104 36 -3 10 -1 19 4 19 5 0 9 -9 9 -20 0 -21 10 -24 48 -14 25 7 31 34 7 34 -8 0 -15 9 -15 20 0 19 -17 24 -45 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptAdcGDQO",
    d: "M7990 1478 c0 -10 27 -46 60 -80 32 -35 59 -56 59 -48 0 8 -27 44 -59 80 -38 40 -60 58 -60 48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pU9f8oo4G",
    d: "M6610 1460 c-19 -4 -87 -21 -150 -38 -190 -52 -341 -79 -664 -118 -246 -30 -311 -35 -327 -26 -17 11 -19 9 -19 -13 0 -14 2 -25 3 -25 49 0 704 85 743 96 57 16 169 13 222 -7 16 -6 22 -5 22 6 0 9 -15 17 -40 21 -22 4 -43 10 -45 14 -4 6 93 36 295 89 41 11 11 12 -40 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph1jBXFSf",
    d: "M1048 1453 c-10 -2 -18 -11 -18 -19 0 -7 -12 -16 -27 -20 -16 -3 -34 -7 -40 -10 -7 -2 -13 3 -13 11 0 16 -12 18 -47 9 -13 -4 -23 -12 -23 -20 0 -17 -72 -38 -81 -23 -9 15 -69 1 -69 -16 0 -13 -31 -22 -77 -23 -33 -1 -133 -52 -133 -68 0 -9 -11 -14 -32 -14 -39 0 -82 -30 -77 -53 3 -14 15 -11 79 18 41 19 121 49 177 67 70 22 103 38 103 48 0 12 2 12 9 2 7 -11 29 -9 122 11 63 14 140 31 172 37 37 7 57 16 57 26 0 8 -7 14 -15 14 -8 0 -15 7 -15 15 0 15 -17 17 -52 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWis0xLcw",
    d: "M5000 1425 c-39 -29 -50 -43 -50 -67 0 -11 8 -18 20 -18 11 0 20 7 20 15 0 8 5 15 10 15 6 0 10 9 10 20 0 34 27 22 34 -15 5 -26 3 -40 -9 -51 -13 -14 -13 -18 0 -37 25 -36 19 -54 -20 -61 -50 -10 -48 -38 3 -34 35 3 38 1 48 -32 9 -29 10 -18 6 61 -3 61 0 103 7 117 9 17 8 23 -6 30 -14 8 -15 13 -4 25 10 13 9 17 -6 26 -10 6 -12 11 -5 11 6 0 12 5 12 10 0 18 -35 10 -70 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwwbWzChg",
    d: "M5388 1443 c6 -3 12 -8 12 -13 0 -5 -6 -10 -12 -13 -10 -3 -10 -7 -1 -17 18 -20 4 -41 -23 -34 -19 5 -23 3 -18 -10 3 -9 12 -16 20 -16 8 0 14 -4 14 -10 0 -5 10 -10 22 -10 17 0 19 3 11 11 -9 9 -6 17 13 32 20 15 23 22 12 28 -10 7 -8 9 7 9 19 0 19 0 0 19 -11 11 -31 22 -45 24 -14 2 -19 2 -12 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf8krJ198",
    d: "M7698 1303 c20 -54 42 -68 42 -26 0 52 -11 73 -36 73 l-24 0 18 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AfWx2jz8",
    d: "M8120 1339 c0 -16 46 -66 55 -58 2 3 -9 21 -25 40 -19 22 -29 29 -30 18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFl1T1kZH",
    d: "M6480 1320 c0 -11 59 -40 80 -40 16 0 12 18 -7 28 -32 17 -73 23 -73 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HHC5oL9v",
    d: "M5354 1258 c16 -118 37 -438 32 -470 l-6 -38 90 0 c49 0 90 4 90 8 0 5 21 5 48 1 26 -4 55 -8 65 -8 29 -1 19 17 -15 24 -17 4 -45 16 -62 26 -17 10 -46 19 -63 19 -23 0 -33 5 -33 15 0 8 -22 26 -50 40 -27 14 -50 31 -50 38 0 21 -20 240 -25 278 -5 35 -4 37 30 43 41 8 49 36 10 36 -16 0 -25 6 -25 15 0 8 -9 15 -21 15 -18 0 -20 -4 -15 -42z m196 -471 c0 -1 -30 -2 -67 -1 l-68 1 -3 37 -3 37 70 -36 c39 -19 71 -36 71 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkV2pxqbx",
    d: "M6590 1276 c0 -17 134 -106 160 -106 31 0 16 16 -59 64 -80 51 -101 60 -101 42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11GblDQQ",
    d: "M7930 1255 c0 -8 9 -15 20 -15 24 0 27 15 4 24 -22 9 -24 8 -24 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2boTx4yq",
    d: "M4910 1213 c-8 -3 -18 -11 -22 -17 -6 -8 -10 -7 -16 1 -6 10 -56 7 -233 -12 -316 -35 -309 -34 -359 -39 -25 -3 -67 -7 -95 -10 -27 -3 -70 -8 -95 -10 -25 -3 -67 -7 -95 -11 -27 -3 -59 -6 -70 -6 -52 -1 -85 -11 -85 -24 0 -10 11 -15 33 -16 23 -1 26 -3 10 -6 -37 -7 -27 -31 15 -38 20 -3 53 -10 72 -15 37 -10 221 -32 226 -28 1 2 -57 21 -129 43 l-132 40 50 8 c28 4 70 9 95 12 25 2 65 7 90 10 25 2 65 7 90 9 25 3 63 7 85 10 22 2 85 9 140 15 55 6 136 16 180 21 123 15 158 13 206 -15 43 -24 89 -33 89 -17 0 5 -16 17 -35 28 -46 24 -44 34 5 34 33 0 40 3 40 20 0 20 -26 26 -60 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBFVzCh9X",
    d: "M7768 1103 c19 -51 50 -75 38 -30 -13 52 -26 77 -41 77 -13 0 -12 -6 3 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9LyTonfH",
    d: "M230 1093 c-33 -42 -23 -75 32 -104 31 -17 34 -2 5 22 -34 26 -34 44 0 73 26 23 26 23 5 28 -16 5 -28 -1 -42 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBkhRSO2U",
    d: "M5283 1070 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puzDFokwD",
    d: "M3763 1093 c-15 -3 -23 -12 -23 -24 0 -17 6 -20 43 -17 35 2 43 7 45 26 4 23 -9 26 -65 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF9f7atc7",
    d: "M6840 1079 c0 -31 60 -92 86 -87 14 2 7 14 -34 58 -47 51 -51 53 -52 29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16wHWBYVz",
    d: "M3668 1083 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf7Ra5yyt",
    d: "M3575 1073 c-11 -3 -23 -10 -27 -17 -5 -8 -8 -7 -8 2 0 11 -12 12 -52 8 -122 -15 -128 -17 -128 -37 0 -18 5 -20 43 -14 68 9 110 10 137 1 17 -5 21 -4 11 2 -10 7 1 12 38 17 41 6 51 11 51 26 0 19 -20 23 -65 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peIcjFY0E",
    d: "M5046 1065 c-3 -8 1 -18 9 -22 8 -5 18 -19 24 -33 10 -25 10 -25 10 5 0 51 -29 85 -43 50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10LKOnzMT",
    d: "M3288 1043 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pC8h0UZ9g",
    d: "M3193 1033 c-15 -3 -23 -12 -23 -25 0 -18 4 -20 31 -14 17 3 38 6 45 6 8 0 14 9 14 20 0 20 -15 23 -67 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plYcvhtyG",
    d: "M3098 1023 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFAd4gVIs",
    d: "M3003 1013 c-15 -3 -23 -12 -23 -25 0 -18 4 -20 31 -14 17 3 38 6 45 6 8 0 14 9 14 20 0 20 -15 23 -67 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3v62vnRc",
    d: "M7802 1008 c3 -7 20 -57 39 -110 30 -88 49 -120 49 -86 0 33 -66 208 -78 208 -8 0 -12 -6 -10 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXFhktyp7",
    d: "M2908 1003 c-10 -2 -18 -14 -18 -25 0 -18 4 -20 31 -14 17 3 35 6 40 6 5 0 9 9 9 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GGXLh3ZJ",
    d: "M513 987 c-28 -12 -29 -23 -4 -37 28 -15 41 -12 41 8 0 30 -13 40 -37 29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTld0NaJp",
    d: "M568 975 c3 -18 11 -25 28 -25 32 0 33 35 2 44 -34 9 -36 8 -30 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2NOq02Um",
    d: "M2818 993 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEydAkdIy",
    d: "M300 980 c0 -11 60 -44 67 -36 9 9 -7 24 -37 34 -17 7 -30 7 -30 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Dg3TEd3K",
    d: "M2718 983 c-10 -2 -18 -14 -18 -25 0 -18 4 -20 31 -14 17 3 35 6 40 6 5 0 9 9 9 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzkQY2bF7",
    d: "M2628 973 c-10 -2 -18 -14 -18 -25 0 -18 4 -20 31 -14 17 3 35 6 40 6 5 0 9 9 9 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvh8eCyQh",
    d: "M4170 965 l-45 -12 40 -8 c51 -9 100 -23 150 -45 57 -25 460 -141 524 -152 64 -10 101 -27 60 -28 -14 0 -29 -4 -35 -9 -5 -4 -46 -19 -91 -31 -46 -13 -83 -27 -83 -32 0 -4 -8 -8 -18 -8 -24 0 -56 -24 -51 -39 3 -8 16 -5 44 9 35 18 185 53 193 46 1 -2 -30 -17 -69 -33 -83 -33 -99 -53 -45 -53 20 0 36 5 36 10 0 6 11 10 25 10 14 0 25 5 25 10 0 6 11 10 25 10 22 0 25 4 25 34 0 34 0 34 68 49 37 8 104 21 150 28 70 11 82 15 82 32 0 16 -5 18 -34 13 -32 -6 -35 -5 -41 24 -4 16 -12 30 -18 30 -7 0 -55 18 -107 39 -52 22 -96 38 -98 36 -9 -9 14 -25 112 -75 62 -32 101 -57 93 -61 -11 -6 -106 -21 -137 -21 -8 0 -177 54 -374 121 -198 66 -360 120 -360 120 -1 -1 -21 -7 -46 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGh6y45GH",
    d: "M2528 963 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phqBPPw6d",
    d: "M4753 944 c27 -14 51 -23 54 -20 6 5 -81 47 -95 46 -4 -1 15 -12 41 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5FMroGVb",
    d: "M450 950 c0 -5 -11 -10 -25 -10 -14 0 -25 -5 -25 -10 0 -16 104 -62 109 -49 2 6 -2 15 -8 18 -6 4 -9 15 -6 24 4 10 -1 19 -14 26 -25 14 -31 14 -31 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11c6JfWdf",
    d: "M2438 953 c-10 -2 -18 -14 -18 -25 0 -18 4 -20 31 -14 17 3 35 6 40 6 5 0 9 9 9 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14SyCn9O1",
    d: "M2338 943 c-20 -5 -24 -28 -8 -38 21 -13 70 6 70 26 0 19 -21 23 -62 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyUxqXOOU",
    d: "M5081 930 c0 -14 4 -34 9 -45 8 -18 9 -18 9 5 0 14 -4 34 -9 45 -8 18 -9 18 -9 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p93CKPuLb",
    d: "M2248 933 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNtr8mwZs",
    d: "M2148 923 c-20 -5 -24 -28 -8 -38 21 -13 70 6 70 26 0 19 -21 23 -62 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvMrabv8m",
    d: "M2058 913 c-20 -5 -24 -28 -8 -38 21 -13 70 6 70 26 0 19 -21 23 -62 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEjNm1X5L",
    d: "M1958 903 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxDAKKTpY",
    d: "M1868 893 c-20 -5 -24 -28 -8 -38 21 -13 70 6 70 26 0 19 -21 23 -62 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppOxkMDYk",
    d: "M1768 883 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBz7GncYb",
    d: "M1678 873 c-20 -5 -24 -28 -8 -38 21 -13 70 6 70 26 0 19 -21 23 -62 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyNGyFGQS",
    d: "M552 859 c7 -21 146 -67 227 -75 61 -6 71 -4 71 9 0 11 -12 18 -37 22 -62 10 -234 46 -250 52 -11 4 -14 2 -11 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8C18mnjj",
    d: "M1575 861 c-11 -5 -24 -6 -28 -4 -16 9 -77 -8 -77 -22 0 -18 34 -28 63 -19 12 4 41 8 64 9 49 2 58 8 50 30 -7 16 -39 19 -72 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOXnMLSnL",
    d: "M5293 821 c5 -39 5 -39 -34 -45 -55 -9 -54 -36 1 -36 28 0 40 4 40 14 0 8 6 16 13 18 10 2 11 13 4 46 -11 54 -32 57 -24 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHulZaj9M",
    d: "M1385 841 c-11 -5 -24 -6 -28 -4 -16 10 -77 -8 -77 -22 0 -20 40 -28 74 -16 15 6 43 11 62 11 27 0 34 4 34 20 0 21 -27 26 -65 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnUz5fZ9d",
    d: "M1208 825 c-8 -9 -103 -16 -225 -18 -101 -1 -113 -4 -113 -19 0 -14 9 -18 43 -20 64 -2 147 0 197 6 140 16 150 18 150 37 0 13 -7 19 -23 19 -13 0 -26 -2 -29 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqNnCfwyX",
    d: "M7129 763 c42 -59 148 -155 167 -151 15 3 2 21 -65 91 -49 50 -92 87 -103 87 -19 0 -19 -1 1 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phFSPX2Vr",
    d: "M4418 769 c15 -6 30 -5 40 1 13 7 8 9 -23 9 -35 0 -37 -1 -17 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjkITBdT6",
    d: "M7897 735 c17 -50 40 -75 29 -32 -11 47 -25 77 -35 77 -5 0 -3 -20 6 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTLEfFQBF",
    d: "M5710 761 c0 -11 13 -15 92 -31 32 -6 60 -16 63 -21 9 -14 45 -11 45 5 0 10 -29 21 -91 35 -103 24 -109 25 -109 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11nRBnaV2",
    d: "M5560 663 c0 -35 1 -36 19 -19 10 10 21 26 24 37 4 15 0 19 -19 19 -21 0 -24 -5 -24 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2VH8PeA5",
    d: "M6000 655 c0 -21 5 -25 30 -25 36 0 38 13 8 34 -31 22 -38 20 -38 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZyVoDmjw",
    d: "M6040 585 c0 -42 24 -49 34 -10 8 30 1 45 -20 45 -9 0 -14 -11 -14 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOBQ8U2p",
    d: "M7593 575 c19 -27 40 -51 46 -53 10 -3 2 7 -59 78 -12 14 -6 3 13 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GX3Vf0pR",
    d: "M4553 575 c-23 -20 -25 -24 -10 -25 27 0 57 18 57 35 0 22 -15 18 -47 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfddNhGSP",
    d: "M5847 586 c-4 -9 -16 -12 -34 -9 -24 4 -25 3 -10 -7 9 -6 15 -15 12 -21 -4 -5 5 -9 19 -9 22 0 26 4 26 30 0 32 -5 38 -13 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3D44o3MK",
    d: "M7971 523 c11 -32 25 -62 31 -68 8 -7 9 -6 6 5 -3 8 -13 39 -22 68 -10 28 -22 52 -26 52 -5 0 0 -26 11 -57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYP4zlubY",
    d: "M5400 550 c0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -25 0 -14 3 -25 6 -25 12 0 94 55 94 63 0 4 -16 7 -35 7 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRa8sVkie",
    d: "M4500 514 c-21 -55 -2 -61 29 -9 20 35 20 35 0 35 -12 0 -23 -10 -29 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pujJzjl6x",
    d: "M5760 500 l-35 -29 38 -1 c35 0 37 2 37 30 0 17 -1 30 -3 30 -1 0 -18 -13 -37 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUEgJKsuc",
    d: "M5990 520 c0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -10 0 -15 -10 -15 -30 l0 -30 49 32 c27 18 54 41 60 50 10 16 7 18 -19 18 -16 0 -30 -4 -30 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pROgeSN6r",
    d: "M6120 514 c0 -3 10 -14 22 -23 22 -18 21 -18 -30 -31 -63 -15 -72 -40 -14 -40 44 0 152 17 161 25 8 9 -21 25 -46 25 -13 0 -23 4 -23 10 0 5 -13 16 -30 25 -31 16 -40 18 -40 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJzWAcigt",
    d: "M5230 445 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19uOy6b1s",
    d: "M5673 455 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgd7aQgnt",
    d: "M6345 459 c-13 -6 0 -7 40 -3 33 4 62 8 64 10 9 8 -85 2 -104 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5FHhE359",
    d: "M4490 442 c0 -5 7 -17 16 -28 14 -17 15 -17 10 -1 -3 10 -6 23 -6 28 0 5 -4 9 -10 9 -5 0 -10 -4 -10 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18Y60WmAM",
    d: "M5988 428 c-42 -11 -51 -28 -15 -28 38 0 67 12 67 26 0 16 -1 16 -52 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pO5nUIuqx",
    d: "M5833 423 c-22 -8 -15 -43 8 -43 11 0 18 4 15 9 -3 5 8 14 24 20 17 5 30 12 30 15 0 7 -60 6 -77 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg6cNusud",
    d: "M5100 395 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19cbGGtPk",
    d: "M5563 405 c-43 -18 -42 -35 2 -35 31 0 35 3 35 25 0 14 -1 25 -2 25 -2 -1 -18 -7 -35 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXMLs9Gne",
    d: "M4560 381 c0 -13 22 -29 63 -46 37 -15 37 -15 37 10 0 18 -5 25 -20 25 -11 0 -20 5 -20 10 0 6 -13 10 -30 10 -16 0 -30 -4 -30 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdnVi0Tw8",
    d: "M5650 360 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVKOHMjog",
    d: "M5408 337 c-32 -15 -48 -28 -48 -41 0 -16 5 -17 33 -12 17 4 34 11 35 16 2 6 10 10 18 10 8 0 14 10 14 25 0 14 -1 25 -2 25 -2 0 -24 -10 -50 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCH5T1XPC",
    d: "M5498 343 c-20 -3 -28 -10 -28 -24 0 -22 3 -23 70 -8 31 7 50 16 50 25 0 14 -30 16 -92 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjQ1kDvN5",
    d: "M8040 324 c14 -37 13 -44 -12 -45 -18 -1 -19 -2 -5 -6 36 -9 46 3 35 41 -6 20 -15 36 -19 36 -5 0 -4 -12 1 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12MuMFJVO",
    d: "M4670 326 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AjQ7phzH",
    d: "M7560 320 c0 -5 -17 -12 -37 -16 -58 -10 -77 -26 -23 -19 82 11 100 16 100 31 0 8 -9 14 -20 14 -11 0 -20 -4 -20 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGxxuYPSA",
    d: "M4800 306 c0 -14 30 -26 65 -26 19 1 19 1 1 11 -15 9 -16 13 -5 20 9 6 2 9 -23 9 -26 0 -38 -4 -38 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdNhZwhoC",
    d: "M5240 287 c-28 -6 -38 -12 -27 -15 27 -6 87 7 87 18 0 11 0 11 -60 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIPmmmkMD",
    d: "M7823 263 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l5fDh9VhUhPKK6vjkVdJADZ",
    fill: "rgb(34,34,34)",
    style: {
      transform: "none"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p174vOUaQJ",
    d: "M3725 2629 c-14 -6 -6 -7 28 -3 43 5 49 3 54 -15 8 -30 33 -26 33 4 0 23 -3 25 -47 24 -27 0 -57 -5 -68 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnjkGdthB",
    d: "M4898 2633 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p35Tk1Dwf",
    d: "M3635 2620 l-20 -9 20 0 c11 0 29 4 40 9 l20 9 -20 0 c-11 0 -29 -4 -40 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15VYumFJL",
    d: "M4560 2605 c-124 -13 -226 -24 -227 -24 -4 -1 -3 -31 0 -31 21 0 532 72 536 75 8 9 -83 3 -309 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14B0qPzSw",
    d: "M3540 2610 c-20 -6 -21 -8 -5 -8 11 0 31 4 45 8 20 6 21 8 5 8 -11 0 -31 -4 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkju0qjJK",
    d: "M3425 2600 l-50 -7 45 0 c25 -1 56 3 70 7 31 10 8 10 -65 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pN6rlwskl",
    d: "M3308 2583 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FDiqebdj",
    d: "M3156 2558 c-13 -49 -6 -136 12 -154 16 -17 17 -17 20 0 2 9 -1 30 -6 46 -6 16 -9 37 -7 47 14 69 14 83 1 83 -8 0 -16 -10 -20 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFiGSTAZf",
    d: "M3218 2573 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFHBfzQRP",
    d: "M4283 2565 c-38 -16 -43 -35 -10 -35 30 0 50 14 45 33 -3 14 -7 14 -35 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pojE9XXrI",
    d: "M2878 2563 c-42 -4 -48 -7 -57 -35 -13 -37 -13 -38 -3 -38 4 0 15 12 24 28 14 22 28 29 80 38 62 11 46 14 -44 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7dwUTxP9",
    d: "M4173 2515 c-18 -8 -33 -19 -33 -25 0 -16 60 -12 66 5 11 27 0 34 -33 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7kZUi4kM",
    d: "M3810 2506 c0 -8 -4 -17 -9 -20 -5 -4 -125 -24 -268 -46 -341 -52 -323 -49 -323 -65 0 -8 6 -15 14 -15 8 0 135 21 283 46 187 32 283 44 318 40 43 -4 47 -3 28 7 -17 9 -19 16 -12 30 6 9 7 22 4 27 -9 15 -35 12 -35 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKKcGgEFm",
    d: "M4075 2471 c-22 -10 -70 -32 -107 -50 -37 -17 -71 -31 -75 -31 -5 0 -20 -8 -33 -17 -14 -10 -33 -19 -43 -20 -43 -7 -103 -53 -68 -53 5 0 11 -7 13 -16 2 -12 40 3 178 71 96 48 176 88 178 90 2 2 2 12 0 24 -3 20 -4 20 -43 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pru3p5I9D",
    d: "M4415 2404 c-114 -58 -197 -106 -192 -110 4 -5 267 135 267 142 0 6 2 6 -75 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peFB9OJTa",
    d: "M2900 2408 c0 -25 -4 -28 -35 -28 -34 0 -41 -8 -36 -47 2 -14 -15 -19 -89 -29 -30 -3 -64 -10 -75 -15 -20 -8 -20 -8 1 -8 11 -1 45 3 75 9 30 5 76 11 103 14 58 6 66 12 40 30 -18 14 -18 15 6 25 14 5 51 13 83 16 31 4 57 10 57 15 0 13 -33 21 -44 10 -6 -6 -15 -5 -28 6 -16 15 -18 15 -24 -1 -6 -15 -9 -15 -20 6 l-13 24 -1 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Cz9j2mJ8",
    d: "M3038 2347 c-56 -8 -68 -13 -68 -28 0 -22 -1 -22 76 -9 32 6 74 13 92 16 19 3 32 11 32 19 0 17 -28 18 -132 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FR1AORCw",
    d: "M3665 2286 l-50 -23 54 -12 c44 -9 56 -9 63 1 10 17 10 28 -1 28 -5 0 -11 7 -13 15 -2 12 -12 11 -53 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13BGu3BIg",
    d: "M2597 2253 c-8 -49 -6 -77 9 -131 9 -30 13 -56 10 -59 -3 -3 -47 -14 -98 -24 -51 -11 -100 -22 -108 -26 -16 -6 -60 -4 -74 4 -4 3 -2 9 5 14 11 7 10 9 -3 9 -12 0 -18 7 -17 23 1 15 3 17 6 6 2 -10 14 -20 26 -23 28 -7 128 14 121 26 -3 5 -14 6 -24 3 -11 -4 -20 1 -25 12 -6 17 -7 17 -20 0 -13 -18 -14 -18 -23 0 -10 17 -11 16 -20 -6 -9 -24 -9 -24 -20 9 -12 32 -13 33 -27 14 -13 -18 -14 -17 -16 16 l-1 35 -8 -30 c-13 -50 -11 -64 10 -85 11 -11 17 -20 13 -20 -3 0 2 -9 12 -20 10 -11 26 -20 35 -20 10 0 33 -6 51 -14 64 -26 79 -28 79 -13 0 8 -12 18 -27 22 -38 9 -19 18 97 43 106 23 150 41 150 60 0 7 -12 12 -29 12 -16 0 -31 6 -35 15 -3 8 0 15 6 15 7 0 4 6 -7 14 -15 11 -17 22 -12 65 3 28 4 58 0 66 -9 25 -31 17 -36 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pM53UFH3k",
    d: "M4134 2257 c-23 -12 -115 -88 -205 -168 -160 -142 -165 -148 -194 -219 -43 -105 -42 -106 12 -5 48 89 48 90 98 102 40 10 43 12 13 8 -21 -2 -38 -2 -38 0 0 12 272 240 313 262 26 14 47 30 47 35 0 10 2 11 -46 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWxf2OmSa",
    d: "M4308 2154 l-138 -115 16 -37 c17 -43 31 -59 41 -49 3 4 -1 23 -10 42 -9 20 -17 39 -17 44 0 5 56 57 125 115 108 93 134 118 123 116 -2 -1 -65 -53 -140 -116z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pv67SWDNm",
    d: "M2291 2219 c-13 -39 -14 -59 -2 -59 5 0 12 17 16 37 4 21 12 41 18 45 8 5 6 8 -5 8 -9 0 -21 -13 -27 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10ctc53fe",
    d: "M3025 2240 c44 -11 75 -11 75 0 0 6 -23 9 -52 9 -45 -1 -49 -2 -23 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjajXZfYd",
    d: "M3180 2237 c0 -13 -91 -50 -174 -71 -28 -7 -52 -18 -54 -24 -5 -17 8 -15 157 22 97 25 140 32 157 25 21 -7 24 -6 24 16 0 18 -8 28 -26 35 -36 14 -84 12 -84 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjziggdtZ",
    d: "M3564 2205 c-3 -20 -4 -39 0 -42 3 -3 26 8 51 24 41 27 51 29 88 22 47 -9 103 -12 96 -4 -4 3 -206 35 -225 35 -2 0 -6 -16 -10 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EFG4zSQL",
    d: "M3300 2189 c0 -5 16 -17 35 -25 19 -8 35 -17 35 -19 0 -3 -25 -16 -55 -30 -60 -26 -71 -45 -26 -45 42 0 61 10 61 31 0 14 7 19 25 19 22 0 25 4 25 34 0 26 -5 35 -22 40 -36 9 -78 7 -78 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parnQEeKB",
    d: "M3480 2150 c0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -25 0 -14 3 -25 6 -25 12 0 94 55 94 63 0 4 -16 7 -35 7 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf6CAQh0p",
    d: "M2858 2133 c-10 -2 -18 -11 -18 -20 0 -11 6 -14 23 -9 12 3 28 6 35 6 6 0 12 7 12 15 0 15 -17 17 -52 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4MegQjW8",
    d: "M2768 2113 c-20 -5 -25 -33 -5 -33 29 0 57 13 57 26 0 14 -18 16 -52 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8OgMbtFp",
    d: "M3370 2080 c0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -9 -9 -15 -25 -15 -14 0 -25 -4 -25 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -3 -15 -7 0 -11 -50 -33 -72 -33 -10 0 -18 -6 -18 -14 0 -20 47 -29 75 -14 54 29 195 124 195 131 0 4 -16 7 -35 7 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pT8kExGL1",
    d: "M3055 1991 l-60 -29 45 -1 c25 -1 62 -4 83 -7 33 -6 37 -4 37 15 0 14 -6 21 -19 21 -11 0 -21 7 -23 15 -2 12 -14 10 -63 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJwJ7bNL8",
    d: "M7873 2003 c20 -2 54 -2 75 0 20 2 3 4 -38 4 -41 0 -58 -2 -37 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p52EQZMXR",
    d: "M7698 1982 c-27 -8 -48 -19 -48 -24 0 -4 12 -3 28 3 15 6 56 17 92 24 62 13 63 13 20 13 -25 0 -66 -7 -92 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcdLyjqb1",
    d: "M8115 1991 l-30 -7 26 -5 c15 -3 40 0 55 7 29 12 29 12 4 12 -14 0 -38 -3 -55 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pebC0LnTw",
    d: "M7943 1973 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phGe0Wkch",
    d: "M2500 1952 c0 -15 37 -22 123 -22 45 0 77 4 77 10 0 6 -30 10 -69 10 -38 0 -83 3 -100 6 -18 4 -31 2 -31 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppDWoxBOa",
    d: "M2780 1943 c0 -12 46 -23 91 -23 33 0 36 -7 12 -26 -16 -12 -14 -13 20 -14 35 0 37 2 37 30 0 27 -3 30 -34 30 -18 0 -54 3 -80 6 -28 4 -46 3 -46 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkyPF4u0h",
    d: "M7483 1913 c-65 -21 -113 -42 -113 -49 0 -13 215 57 235 77 15 15 -2 11 -122 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwHSwE69f",
    d: "M2960 1920 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pb2DtxaLd",
    d: "M4230 1926 c0 -8 9 -34 19 -59 17 -39 18 -47 5 -65 -13 -19 -13 -20 16 -9 22 8 30 18 30 35 0 21 2 22 15 8 8 -8 15 -19 15 -25 0 -6 8 -11 18 -11 33 0 62 12 62 26 0 8 7 14 15 14 8 0 15 -7 15 -15 0 -9 9 -15 23 -15 38 0 67 12 67 26 0 8 7 14 15 14 8 0 15 -7 15 -15 0 -8 8 -15 18 -15 33 0 62 12 62 26 0 8 7 14 15 14 8 0 15 -7 15 -15 0 -8 8 -15 18 -15 33 0 62 12 62 26 0 8 7 14 15 14 8 0 15 -7 15 -15 0 -9 9 -15 23 -15 38 0 67 12 67 26 0 8 5 14 10 14 6 0 10 -7 10 -15 0 -16 28 -19 67 -9 21 6 43 58 30 71 -11 10 -67 -9 -67 -23 0 -8 -7 -14 -15 -14 -8 0 -15 7 -15 15 0 16 -12 18 -47 9 -13 -4 -23 -13 -23 -20 0 -8 -7 -14 -15 -14 -8 0 -15 7 -15 15 0 16 -12 18 -47 9 -13 -4 -23 -13 -23 -20 0 -8 -9 -14 -20 -14 -11 0 -20 7 -20 15 0 16 -12 18 -47 9 -13 -4 -23 -13 -23 -20 0 -8 -7 -14 -15 -14 -8 0 -15 7 -15 15 0 16 -12 18 -47 9 -13 -4 -23 -13 -23 -20 0 -8 -7 -14 -15 -14 -8 0 -15 7 -15 15 0 16 -12 18 -47 9 -13 -4 -23 -13 -23 -20 0 -8 -7 -14 -15 -14 -8 0 -15 7 -15 16 0 12 -8 14 -44 9 -43 -7 -44 -6 -67 34 -23 42 -39 53 -39 27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBBFHKr77",
    d: "M5088 1933 c-10 -2 -18 -11 -18 -19 0 -9 -11 -14 -30 -14 -23 0 -30 -4 -30 -20 0 -21 16 -25 58 -14 12 4 22 13 22 20 0 8 7 14 15 14 8 0 15 -7 15 -15 0 -16 28 -19 68 -9 33 9 28 34 -8 34 -20 0 -30 5 -30 15 0 15 -25 18 -62 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPhi2YrfX",
    d: "M5590 1931 c0 -8 -53 -11 -180 -11 -173 0 -180 -1 -180 -20 0 -20 7 -20 350 -20 343 0 350 0 350 20 0 23 5 22 -150 24 -63 1 -132 5 -152 10 -27 6 -38 5 -38 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOdLmbsSn",
    d: "M3087 1906 c4 -21 2 -26 -16 -26 -16 0 -21 -6 -21 -25 0 -22 -4 -25 -35 -25 -24 0 -35 -5 -35 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -15 0 -20 -7 -20 -25 0 -22 -4 -25 -35 -25 -24 0 -35 -5 -35 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -7 -15 -16 -15 -23 0 -44 -25 -44 -54 0 -22 5 -25 54 -31 67 -9 107 -1 50 10 -42 7 -72 21 -64 28 27 24 547 401 563 407 21 8 21 9 -3 9 -14 1 -41 4 -61 7 -35 6 -36 5 -32 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppFEEHjal",
    d: "M6000 1903 c0 -16 9 -22 38 -27 66 -11 82 -8 82 14 0 15 -7 20 -29 20 -16 0 -43 3 -60 6 -26 6 -31 4 -31 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1eHbUpnE",
    d: "M7740 1809 c-239 -102 -259 -109 -320 -108 l-65 0 70 35 c81 39 77 39 -28 0 -42 -16 -77 -33 -77 -38 0 -6 42 -9 110 -6 91 3 110 1 114 -12 2 -8 4 -4 5 10 1 23 11 29 101 60 108 38 119 36 120 -17 0 -25 25 -31 33 -9 3 7 2 30 -3 49 -9 44 -13 41 113 97 89 40 110 51 90 49 -5 0 -123 -50 -263 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7sYSAekl",
    d: "M6150 1891 c0 -15 12 -19 77 -25 117 -9 143 -8 143 9 0 16 -28 22 -142 29 -70 4 -78 3 -78 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTFGo2ei9",
    d: "M6400 1876 c0 -16 30 -26 78 -26 37 0 45 24 10 34 -42 11 -88 7 -88 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZbMyauoT",
    d: "M6550 1867 c0 -15 48 -27 113 -27 43 0 50 16 10 24 -89 16 -123 17 -123 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FURwxqXB",
    d: "M7263 1843 c-64 -20 -83 -30 -83 -44 0 -17 5 -17 73 7 87 32 107 42 107 54 0 13 0 13 -97 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxMapbR20",
    d: "M6720 1851 c0 -9 102 -22 169 -20 l46 1 -45 8 c-87 14 -170 20 -170 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHwbr580y",
    d: "M2693 1772 c-40 -26 -73 -50 -73 -54 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 9 0 15 9 15 25 0 14 -3 25 -7 25 -5 0 -41 -22 -80 -48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTCZLkDiL",
    d: "M5370 1810 c0 -6 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 7 -15 15 0 24 -53 19 -77 -7 -24 -27 -36 -58 -23 -58 6 0 10 -16 10 -35 l0 -35 25 16 c29 19 31 34 9 75 -8 17 -13 33 -11 36 3 2 24 -7 47 -22 l41 -26 40 32 c22 17 42 30 44 27 2 -2 -2 -24 -9 -49 l-14 -46 31 -19 32 -19 -41 -3 c-32 -2 -43 -8 -47 -23 -4 -15 0 -19 19 -19 16 0 24 6 25 18 0 10 3 12 6 5 7 -19 31 -16 43 6 23 43 5 116 -36 152 -25 21 -54 31 -54 19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pB62aPsOV",
    d: "M7075 1785 c-27 -8 -81 -25 -120 -38 l-70 -24 45 -7 c37 -5 63 -1 140 26 130 46 134 79 5 43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4h4gx37n",
    d: "M7830 1644 c0 -23 43 -68 60 -62 6 2 -4 21 -24 43 -30 34 -35 37 -36 19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgUiNAHq5",
    d: "M2468 1643 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPQDARIWv",
    d: "M7725 1630 c-21 -27 -84 -51 -113 -44 -9 3 -28 1 -42 -5 -25 -10 -25 -10 6 -10 27 -1 32 -6 43 -42 8 -26 20 -43 32 -46 10 -3 19 -12 19 -19 0 -8 7 -14 15 -14 8 0 15 -9 15 -20 0 -13 -7 -20 -20 -20 -19 0 -19 -1 -2 -47 25 -69 47 -70 40 -2 -3 30 -3 46 -1 37 2 -10 9 -18 14 -18 5 0 9 -7 9 -15 0 -8 6 -15 14 -15 8 0 16 -10 18 -22 2 -19 10 -24 41 -26 43 -4 46 3 13 29 -23 18 -136 171 -136 184 0 3 24 -12 53 -33 147 -107 158 -107 26 1 -58 47 -98 73 -108 70 -14 -4 -14 -3 -1 6 8 6 22 11 31 11 29 0 61 34 57 60 l-3 25 -20 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p02TBFRjw",
    d: "M5270 1621 c0 -12 -4 -21 -10 -21 -23 0 -8 -22 25 -36 52 -21 56 -18 35 29 -21 46 -50 62 -50 28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFQvW2L9U",
    d: "M2318 1623 c-33 -8 -20 -33 17 -33 28 0 35 4 35 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13ENoDlsy",
    d: "M2240 1615 c-8 -2 -32 -6 -52 -10 -48 -7 -51 -32 -5 -38 31 -4 31 -4 -5 -5 -32 -2 -38 1 -38 18 0 21 -10 24 -47 14 -34 -9 -29 -34 7 -34 24 0 30 -4 30 -21 0 -19 4 -20 53 -14 87 10 107 16 107 30 0 9 -14 15 -37 18 l-38 4 38 1 c30 2 37 6 37 22 0 19 -11 23 -50 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EzsJN15l",
    d: "M5353 1585 c-3 -9 -3 -19 1 -22 9 -10 59 10 64 25 6 18 -57 16 -65 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZwk90ft9",
    d: "M2008 1583 c-31 -8 -21 -33 12 -33 23 0 30 -4 30 -20 0 -21 10 -24 48 -14 33 9 28 34 -8 34 -23 0 -30 4 -30 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQdjbJjrf",
    d: "M2343 1583 c-35 -3 -43 -8 -43 -24 0 -18 5 -19 64 -13 57 6 68 4 92 -15 15 -11 31 -21 35 -21 15 0 10 39 -8 60 -18 20 -36 22 -140 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptlgOmOoK",
    d: "M1858 1563 c-25 -6 -23 -33 2 -33 14 0 20 -7 20 -21 0 -19 4 -20 53 -14 90 11 107 16 107 32 0 13 -10 15 -65 9 -61 -6 -65 -5 -65 14 0 20 -13 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkNZrJ5yW",
    d: "M1780 1555 c-8 -2 -32 -6 -52 -10 -24 -4 -38 -11 -38 -20 0 -8 5 -15 10 -15 6 0 10 -9 10 -21 0 -19 4 -20 53 -14 88 10 107 16 107 31 0 8 -9 14 -20 14 -13 0 -20 7 -20 20 0 19 -11 23 -50 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfR9VxZga",
    d: "M3190 1550 c-20 -6 -21 -8 -5 -8 11 0 31 4 45 8 20 6 21 8 5 8 -11 0 -31 -4 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1B09IOTYL",
    d: "M1608 1533 c-10 -2 -18 -11 -18 -18 0 -7 8 -16 18 -18 9 -3 2 -5 -15 -6 -27 -1 -33 3 -33 19 0 21 -10 24 -47 14 -31 -9 -29 -34 2 -34 19 0 25 -5 25 -21 0 -19 4 -20 53 -14 88 10 107 16 107 31 0 8 -9 14 -20 14 -13 0 -20 7 -20 20 0 20 -14 23 -52 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZy0TUFv",
    d: "M2975 1508 c-188 -38 -231 -50 -155 -42 47 4 304 57 335 69 30 11 -48 -1 -180 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piyySl4NE",
    d: "M7960 1509 c0 -17 66 -86 75 -77 3 3 -13 25 -34 49 -25 27 -40 38 -41 28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3xrgnMsy",
    d: "M1375 1505 c-5 -2 -27 -6 -47 -10 -36 -6 -38 -8 -38 -41 l0 -36 53 7 c88 10 107 16 107 31 0 8 -7 14 -15 14 -8 0 -15 9 -15 20 0 19 -17 24 -45 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFRwxatvr",
    d: "M1185 1475 c-5 -2 -27 -6 -47 -10 -22 -3 -38 -12 -38 -19 0 -18 -90 -32 -100 -16 -10 16 -70 3 -70 -16 0 -17 -17 -19 -22 -3 -6 17 -68 1 -68 -17 0 -15 -7 -16 -81 -18 -28 -1 -65 -12 -98 -29 -29 -15 -58 -27 -64 -27 -24 0 -138 -60 -229 -121 -113 -75 -138 -97 -138 -121 0 -10 -5 -18 -11 -18 -6 0 -9 -10 -7 -22 2 -17 29 -36 118 -82 111 -57 115 -58 118 -36 4 27 -12 40 -53 40 -33 0 -110 32 -137 57 -28 25 -21 45 27 86 139 119 373 208 725 276 58 11 130 23 160 26 30 3 67 8 83 11 34 7 36 34 2 34 -16 0 -25 6 -25 15 0 14 -20 18 -45 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDUfdl9ps",
    d: "M1460 1460 c0 -21 10 -24 48 -14 36 10 27 34 -13 34 -28 0 -35 -4 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBWy4cO2s",
    d: "M5043 1448 c-25 -8 -33 -17 -33 -34 0 -12 4 -24 9 -26 4 -1 11 -12 15 -23 5 -19 2 -20 -34 -17 -31 3 -40 1 -40 -11 0 -9 12 -18 29 -22 32 -7 55 -29 65 -62 9 -28 56 -21 -623 -92 -379 -39 -566 -63 -571 -71 -5 -9 -9 -9 -11 -1 -3 8 -347 -25 -1144 -109 -627 -65 -1159 -122 -1182 -125 -35 -5 -43 -10 -43 -26 0 -18 5 -20 38 -15 42 7 1900 205 1977 211 28 2 104 11 170 18 73 9 129 11 143 6 34 -13 52 -11 52 6 0 10 10 15 30 15 17 0 30 -4 30 -10 0 -5 -4 -10 -10 -10 -5 0 -10 -6 -10 -14 0 -16 53 -31 70 -21 6 4 16 2 23 -3 17 -14 127 -27 127 -15 0 6 -43 23 -95 38 -52 16 -94 30 -92 31 1 2 106 14 232 28 127 14 307 35 400 45 246 28 285 31 285 21 0 -8 119 -80 133 -80 4 0 7 7 7 15 0 8 -22 26 -50 40 -27 14 -50 29 -50 33 0 5 38 12 85 18 72 8 85 7 89 -6 2 -8 4 17 4 55 0 39 3 85 7 103 5 21 4 32 -4 32 -7 0 -9 9 -5 25 4 17 2 25 -7 26 -8 0 4 9 26 20 33 15 36 18 15 18 -14 -1 -40 -6 -57 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEYOdddsa",
    d: "M6575 1450 c-25 -11 1 -11 35 0 20 6 21 8 5 8 -11 0 -29 -3 -40 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4HgW4FjJ",
    d: "M5398 1415 c-4 -17 -1 -25 8 -25 8 0 14 -8 14 -17 0 -15 3 -14 23 5 l22 23 -24 20 c-31 25 -38 24 -43 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "patO5bJml",
    d: "M6405 1406 c-68 -20 -281 -62 -407 -81 -21 -3 -38 -10 -38 -16 0 -13 101 -3 213 23 101 23 181 19 273 -12 42 -15 54 -16 54 -6 0 8 -27 21 -67 31 -38 10 -74 21 -81 25 -8 4 24 17 72 30 47 12 86 24 86 26 0 7 -25 2 -105 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15cnRQK7X",
    d: "M4979 1407 c-8 -7 -18 -20 -22 -29 -5 -14 -1 -18 18 -18 21 0 25 5 25 30 0 34 0 34 -21 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVcyJB5WA",
    d: "M8078 1373 c27 -38 100 -108 106 -102 7 7 -103 129 -115 129 -6 0 -1 -12 9 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzmrTcKIe",
    d: "M5347 1350 c7 -26 53 -28 53 -2 0 12 -9 18 -29 19 -24 2 -28 -1 -24 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVkPiM79T",
    d: "M5898 1313 c-20 -5 -24 -23 -5 -23 24 0 57 12 57 21 0 9 -22 10 -52 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmKaOSYdF",
    d: "M6510 1311 c0 -5 23 -21 51 -35 28 -14 60 -33 72 -41 23 -16 57 -20 57 -6 0 9 -119 74 -157 86 -14 3 -23 2 -23 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plBJ7ntI2",
    d: "M5357 1233 c3 -43 10 -87 15 -98 5 -13 7 0 3 37 -5 56 -5 56 25 63 33 7 41 35 10 35 -13 0 -20 7 -20 20 0 13 -7 20 -19 20 -18 0 -19 -6 -14 -77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pd3ipbcRw",
    d: "M5655 1285 c-98 -13 -174 -19 -179 -14 -16 15 -26 10 -26 -12 0 -18 4 -20 43 -14 23 3 101 12 172 20 178 21 205 25 205 36 0 12 -14 11 -215 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBj2vNF70",
    d: "M7863 1285 c-26 -29 -4 -45 64 -45 48 0 47 14 -3 38 -52 26 -46 25 -61 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEWf7uUcU",
    d: "M7770 1276 c0 -13 28 -26 58 -26 6 0 12 9 12 20 0 16 -7 20 -35 20 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10BPNxknu",
    d: "M7731 1218 c2 -30 105 -302 116 -305 10 -4 0 36 -72 260 -10 31 -25 57 -32 57 -7 0 -13 -6 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyhxAS7yE",
    d: "M6721 1174 c33 -34 34 -34 37 -13 4 26 -21 49 -52 49 -17 0 -15 -5 15 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poqy6etfk",
    d: "M6770 1150 c0 -33 79 -114 106 -108 14 2 6 16 -44 68 -56 59 -61 63 -62 40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWwCoz8EE",
    d: "M5371 1070 c0 -19 4 -44 9 -55 7 -16 9 -13 9 15 0 19 -4 44 -9 55 -7 16 -9 13 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puBQuWkgl",
    d: "M5050 1051 c0 -5 7 -11 15 -15 8 -3 15 -15 15 -27 0 -12 3 -20 6 -16 11 11 -7 67 -22 67 -8 0 -14 -4 -14 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18Nx1D3ox",
    d: "M515 986 c-23 -16 -16 -29 13 -24 14 2 17 8 13 21 -6 16 -9 16 -26 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pntYuODSo",
    d: "M580 971 c0 -15 6 -21 21 -21 25 0 22 33 -4 38 -12 2 -17 -3 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14I3aQife",
    d: "M5387 888 c5 -96 4 -108 -11 -108 -9 0 -16 -7 -16 -16 0 -25 199 -16 225 10 21 20 20 21 -57 61 -85 44 -111 26 -28 -19 28 -15 50 -28 50 -30 0 -1 -31 -2 -69 -2 l-69 -1 -4 39 c-3 34 -1 39 14 35 24 -7 23 15 -2 31 -12 7 -20 24 -21 40 0 15 -4 36 -9 47 -6 12 -7 -22 -3 -87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwowN3W1n",
    d: "M4176 966 l-48 -10 108 -32 c60 -18 161 -49 224 -68 130 -40 140 -42 140 -22 0 9 -64 36 -188 77 -175 60 -191 63 -236 55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSSQ2VZXk",
    d: "M4740 955 c0 -5 216 -115 225 -115 3 0 5 5 5 11 0 5 -15 16 -32 24 -18 7 -70 29 -115 49 -46 19 -83 33 -83 31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjEWTcfJ5",
    d: "M5082 940 c0 -14 4 -38 8 -55 7 -27 8 -27 8 -5 0 14 -4 39 -8 55 -7 27 -8 27 -8 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "php45gLhv",
    d: "M5294 868 l4 -87 -29 -6 c-45 -10 -37 -35 12 -35 l41 0 -7 88 c-10 120 -27 152 -21 40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18wIBaNWi",
    d: "M492 888 c7 -22 155 -79 251 -98 51 -10 129 -20 175 -23 74 -5 82 -3 82 13 0 15 -13 18 -92 24 -131 10 -293 43 -357 72 -62 28 -64 28 -59 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgP31b3Am",
    d: "M7871 814 c20 -59 40 -92 38 -63 -1 28 -35 113 -47 117 -7 2 -4 -18 9 -54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIpKjR96a",
    d: "M1408 843 c-10 -2 -18 -14 -18 -25 0 -18 4 -20 31 -14 17 3 35 6 40 6 5 0 9 9 9 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj1pjwqo2",
    d: "M5000 835 c0 -8 23 -26 51 -41 28 -14 48 -29 43 -33 -17 -16 -154 -32 -174 -21 -10 5 -29 10 -42 9 -25 -1 -20 -3 27 -15 l30 -7 -30 -8 c-189 -48 -355 -124 -355 -162 0 -16 6 -14 45 13 54 37 164 80 205 80 17 0 30 5 30 10 0 6 12 10 28 10 15 0 59 9 97 20 38 11 80 20 92 20 13 0 23 5 23 10 0 6 27 10 60 10 54 0 60 2 60 21 0 19 -4 21 -36 14 -43 -8 -53 3 -55 55 -1 19 -3 27 -6 18 -5 -22 -11 -22 -57 -3 -32 14 -36 14 -36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17oMGPOqj",
    d: "M1313 833 c-15 -3 -23 -12 -23 -25 0 -18 4 -20 31 -14 17 3 38 6 45 6 8 0 14 9 14 20 0 20 -15 23 -67 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEv1rh1kK",
    d: "M1218 823 c-10 -2 -18 -14 -18 -25 0 -18 4 -20 31 -14 17 3 35 6 40 6 5 0 9 9 9 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16ZQmZ1DS",
    d: "M4630 817 c0 -15 156 -64 167 -53 11 11 -9 22 -76 45 -75 24 -91 26 -91 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peSMrg9Dj",
    d: "M1123 813 c-15 -3 -23 -12 -23 -25 0 -18 4 -20 31 -14 17 3 38 6 45 6 8 0 14 9 14 20 0 20 -15 23 -67 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfa4pEeyc",
    d: "M1028 803 c-10 -2 -18 -14 -18 -25 0 -18 4 -20 31 -14 17 3 35 6 40 6 5 0 9 9 9 20 0 20 -20 24 -62 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV04Jlv4V",
    d: "M5610 775 c0 -11 41 -25 71 -25 24 0 4 17 -31 27 -31 8 -40 7 -40 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Gp88VcHX",
    d: "M7140 775 c0 -13 37 -60 95 -120 68 -73 94 -95 94 -80 0 12 -38 61 -94 120 -70 74 -94 95 -95 80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10Jc6irsO",
    d: "M4423 769 c14 -8 22 -8 30 0 8 8 3 11 -18 11 -26 -1 -28 -2 -12 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12CwSAQf4",
    d: "M5700 762 c0 -10 15 -15 95 -28 51 -9 75 -21 75 -39 0 -11 13 -15 50 -15 51 0 64 12 32 29 -49 26 -252 69 -252 53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15WleyVP4",
    d: "M5570 695 c0 -39 14 -46 30 -16 16 31 12 51 -10 51 -16 0 -20 -7 -20 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17pxlSgUU",
    d: "M6020 640 c0 -17 5 -30 10 -30 6 0 10 -9 10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -16 -10 -37 0 -35 1 -36 19 -19 13 11 27 15 40 11 24 -7 29 10 5 19 -12 4 -15 14 -11 33 6 31 -14 78 -38 86 -11 5 -15 -1 -15 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1gzBQ5lA",
    d: "M7941 613 c11 -32 25 -62 31 -68 8 -7 9 -6 6 5 -3 8 -13 39 -22 68 -10 28 -22 52 -26 52 -5 0 0 -26 11 -57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pk4aZXzr0",
    d: "M5863 625 c-11 -33 -10 -35 13 -35 21 0 24 5 24 35 0 22 -5 35 -13 35 -8 0 -18 -16 -24 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3wZFbP7b",
    d: "M4685 577 c-64 -31 -135 -93 -135 -117 0 -6 11 -10 25 -10 21 0 25 5 25 30 0 27 3 30 30 30 20 0 30 5 30 15 0 9 9 15 25 15 41 0 75 21 75 47 0 12 -1 23 -3 23 -1 0 -34 -15 -72 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3VubHdd7",
    d: "M5460 590 c0 -5 -7 -10 -15 -10 -9 0 -15 -9 -15 -25 0 -14 4 -25 8 -25 11 0 92 58 92 65 0 3 -16 5 -35 5 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSjHFdDpY",
    d: "M5803 569 c14 -8 16 -14 6 -25 -9 -11 -7 -14 15 -14 20 0 26 5 26 23 0 18 -6 22 -33 24 -26 2 -29 0 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psO1dvhki",
    d: "M5333 518 c-21 -10 -34 -58 -17 -58 13 0 104 54 104 62 0 11 -61 9 -87 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16z9aCK4r",
    d: "M6144 495 c11 -8 17 -17 15 -20 -3 -2 -67 -21 -143 -42 -76 -20 -134 -39 -129 -40 12 -4 353 44 360 50 9 10 -8 27 -28 27 -10 0 -19 4 -19 8 0 10 -45 32 -63 32 -7 0 -3 -7 7 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBUNCBARv",
    d: "M4490 452 c0 -10 6 -26 13 -36 12 -16 13 -14 9 18 -4 37 -22 51 -22 18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phIj7Gcyp",
    d: "M5900 460 c0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -11 -10 -25 -10 -14 0 -28 -7 -31 -15 -4 -8 -16 -15 -29 -15 -51 0 -85 -12 -85 -31 0 -23 20 -24 75 -4 22 8 50 15 63 15 12 0 22 4 22 9 0 4 20 16 44 25 24 9 52 26 61 36 18 20 17 20 -18 20 -21 0 -37 -4 -37 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppyOaFiGT",
    d: "M6318 463 c-32 -2 -58 -8 -58 -13 0 -12 4 -12 105 5 79 12 65 15 -47 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgpwKprnk",
    d: "M5643 440 c-51 -23 -55 -40 -10 -40 42 0 60 12 55 38 l-3 21 -42 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAhmeL1Xd",
    d: "M5150 415 c0 -24 1 -25 32 -12 46 19 48 37 4 37 -32 0 -36 -3 -36 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8N8X3ib7",
    d: "M8028 360 c15 -44 30 -80 34 -80 3 0 -6 36 -20 80 -14 44 -29 80 -33 80 -4 0 4 -36 19 -80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pM0TeKVZ9",
    d: "M4550 400 c0 -32 94 -82 187 -100 73 -13 73 -13 73 8 0 14 -14 20 -65 30 -35 6 -74 12 -85 12 -11 0 -20 7 -20 15 0 8 -6 15 -14 15 -8 0 -16 7 -20 15 -6 17 -56 21 -56 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnFqYxdEW",
    d: "M5053 403 c-15 -3 -23 -12 -23 -25 0 -18 4 -19 37 -13 45 8 73 22 73 35 0 10 -44 11 -87 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pi6vvODM8",
    d: "M5533 390 c-52 -23 -55 -40 -8 -40 24 0 35 -5 35 -15 0 -16 12 -18 48 -9 30 8 28 34 -2 34 -19 0 -25 6 -28 25 l-3 24 -42 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQhNYXfMM",
    d: "M7520 385 c0 -10 10 -29 22 -42 12 -13 19 -25 16 -28 -2 -3 -42 -12 -87 -22 -45 -9 -80 -18 -78 -20 6 -6 217 29 217 36 0 4 -20 27 -45 51 -35 35 -45 40 -45 25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRCvPTJEt",
    d: "M5367 322 c-18 -7 -66 -22 -107 -32 -90 -22 -85 -23 56 -10 151 15 214 28 214 46 0 12 -14 14 -66 12 -36 -2 -80 -9 -97 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPlr3IjHl",
    d: "M7988 273 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l1lkgFeGBNMELjuiv0PWP9t",
    fill: "rgb(17,17,17)",
    style: {
      transform: "none"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pJmQSQKsZ",
    d: "M3705 2630 l-50 -7 45 0 c25 0 59 3 75 7 26 7 27 8 5 7 -14 0 -47 -3 -75 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phAjHDYOS",
    d: "M4558 2604 l-238 -24 -252 -113 c-138 -63 -254 -119 -256 -125 -2 -7 8 -12 26 -12 40 0 62 9 62 26 0 9 11 14 29 14 39 0 61 9 61 26 0 9 11 14 29 14 16 0 93 32 172 71 l143 71 256 34 c140 19 262 36 270 38 39 10 -86 2 -302 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12Z02S6KF",
    d: "M3588 2613 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pejvdC7ha",
    d: "M3498 2603 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FKGR2k7L",
    d: "M3403 2593 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyqNmvQPP",
    d: "M3313 2583 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puayXQIeZ",
    d: "M3154 2534 c-3 -25 -3 -72 0 -105 4 -32 4 -59 0 -59 -4 0 -61 -9 -127 -21 -67 -11 -132 -17 -146 -14 -36 9 -13 20 77 35 68 13 87 23 60 33 -7 2 -22 0 -32 -5 -14 -8 -21 -6 -28 7 -9 15 -11 15 -23 -1 -12 -16 -13 -16 -20 6 l-8 24 -12 -30 -12 -29 -8 28 c-8 30 -15 33 -33 15 -23 -23 -15 86 9 116 20 25 20 26 1 26 -14 0 -24 -13 -36 -43 -26 -68 -19 -157 13 -157 9 0 12 -3 6 -8 -5 -4 -10 -14 -10 -22 0 -11 -28 -19 -110 -32 -60 -9 -111 -17 -112 -17 -1 -1 -5 -21 -8 -45 -4 -27 -1 -66 9 -106 9 -35 14 -66 10 -69 -3 -3 -64 -18 -135 -32 -105 -21 -131 -24 -140 -13 -11 13 5 20 109 43 55 12 69 26 19 18 -29 -5 -39 -2 -44 10 -5 12 -8 11 -18 -8 l-13 -22 -7 23 -7 23 -13 -24 -13 -24 -7 28 c-8 30 -15 33 -33 15 -9 -9 -12 -2 -12 35 0 26 -4 47 -10 47 -15 0 -12 -96 4 -135 16 -37 47 -62 86 -68 14 -2 42 -11 62 -21 21 -9 57 -16 80 -15 37 0 40 2 18 9 -14 5 -45 14 -70 21 -56 14 -46 20 95 49 55 12 102 24 105 29 3 4 132 40 288 79 l282 72 65 -22 c65 -23 78 -34 50 -44 -26 -10 -16 -24 16 -24 27 0 29 -2 15 -15 -8 -8 -19 -15 -25 -15 -6 0 -11 -4 -11 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -9 -9 -15 -25 -15 -14 0 -25 -4 -25 -10 0 -5 -7 -10 -15 -10 -10 0 -15 -10 -15 -30 0 -29 1 -29 206 102 l206 131 70 -6 c101 -9 79 1 -43 18 -128 18 -119 18 -119 -1 0 -20 -20 -39 -48 -48 -12 -4 -22 -12 -22 -17 0 -5 -7 -9 -15 -9 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -4 -10 -10 -10 -5 0 -10 16 -10 35 0 32 -2 35 -30 35 -19 0 -30 5 -30 14 0 14 -29 26 -66 26 -12 0 -35 7 -50 15 -21 11 -58 15 -129 14 -80 -1 -92 -3 -60 -10 22 -4 58 -8 80 -9 l40 -2 -60 -28 c-82 -38 -442 -117 -458 -101 -9 9 -8 14 3 21 9 6 10 10 3 10 -17 0 -27 63 -16 107 l9 38 99 17 c85 14 103 14 122 2 14 -9 30 -11 50 -5 15 4 82 16 148 26 66 10 127 23 135 30 17 14 543 107 602 107 27 -1 35 3 32 13 -3 7 -1 16 5 20 20 11 13 45 -9 45 -15 0 -20 -7 -20 -25 0 -14 -3 -25 -7 -25 -5 0 -136 -20 -292 -44 -181 -28 -287 -49 -292 -57 -4 -8 -11 -11 -14 -7 -12 12 -34 113 -30 135 3 13 7 34 10 48 4 18 1 25 -9 25 -10 0 -17 -15 -22 -46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p37q5rjeL",
    d: "M4224 2302 c-113 -58 -146 -82 -257 -181 -70 -62 -127 -115 -127 -118 0 -2 57 45 126 106 103 89 152 123 260 181 74 39 134 73 134 76 0 6 5 8 -136 -64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMMLJAavx",
    d: "M3701 2302 l-84 -37 54 -12 c29 -6 56 -8 59 -4 3 5 24 18 48 30 42 21 55 41 28 41 -8 0 -16 4 -18 9 -1 5 -41 -7 -87 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppRA9hQLW",
    d: "M4280 2129 c-58 -49 -104 -95 -102 -102 2 -6 23 -54 48 -105 35 -73 42 -97 34 -112 -9 -17 -7 -18 27 -14 88 12 101 15 107 30 15 39 8 44 -51 42 l-58 -3 -46 88 -47 88 99 85 c85 74 108 96 97 93 -2 0 -50 -41 -108 -90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIEKJnsjv",
    d: "M3222 2070 c-45 -21 -82 -44 -82 -50 0 -19 59 -10 115 17 43 21 55 32 55 50 0 13 -1 23 -3 23 -2 0 -40 -18 -85 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7UBjQgLh",
    d: "M7863 2003 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15ddS2mAy",
    d: "M3798 1973 c-23 -24 -79 -133 -78 -152 0 -3 17 25 38 64 26 49 44 71 62 76 14 4 19 7 11 8 -7 1 -11 7 -7 16 8 21 4 19 -26 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p37UFzJiW",
    d: "M7658 1968 c-54 -17 -98 -35 -98 -40 0 -4 33 4 73 19 39 15 99 32 132 39 47 9 52 12 25 13 -19 0 -79 -14 -132 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvQOybFJc",
    d: "M3030 1977 l-25 -10 23 -5 c26 -4 36 1 31 16 -3 6 -14 5 -29 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pc2JmEvjl",
    d: "M3100 1976 c0 -7 10 -16 23 -20 41 -11 57 -7 57 14 0 17 -7 20 -40 20 -27 0 -40 -4 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pw0HPnk2J",
    d: "M8068 1983 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7RLs2LZR",
    d: "M2655 1940 c28 -12 75 -12 75 0 0 6 -21 10 -47 9 -36 0 -43 -3 -28 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWC97VcJS",
    d: "M2740 1943 c0 -6 39 -14 87 -19 l87 -9 -92 -60 c-50 -33 -92 -63 -92 -67 0 -5 16 -8 35 -8 19 0 35 5 35 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 10 0 15 10 15 34 0 39 -4 40 -112 51 -42 5 -68 4 -68 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkK9KjjcY",
    d: "M2930 1920 c0 -17 7 -20 45 -20 49 0 64 23 23 34 -45 12 -68 7 -68 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCqZRFwEo",
    d: "M5108 1933 c-12 -3 -18 -14 -18 -35 0 -30 1 -31 41 -25 43 6 59 19 59 50 0 13 -8 17 -32 16 -18 -1 -41 -3 -50 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pewn6d6qS",
    d: "M5440 1920 c0 -19 7 -20 105 -20 83 0 105 3 105 14 0 19 -32 26 -127 26 -76 0 -83 -2 -83 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p92PFioEd",
    d: "M3060 1901 c0 -21 -5 -31 -15 -31 -9 0 -18 -7 -21 -15 -4 -8 -12 -15 -20 -15 -8 0 -14 -7 -14 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -9 0 -18 -7 -21 -15 -4 -8 -13 -15 -20 -15 -8 0 -17 -7 -20 -15 -4 -8 -12 -15 -20 -15 -8 0 -14 -7 -14 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -9 0 -18 -7 -21 -15 -4 -8 -12 -15 -20 -15 -8 0 -14 -5 -14 -10 0 -12 -53 -1 -58 12 -2 4 -10 8 -18 8 -8 0 -14 5 -14 10 0 6 -11 10 -25 10 -14 0 -25 4 -25 9 0 6 -15 11 -32 13 -20 2 -3 7 45 12 42 4 77 12 77 17 0 5 9 9 20 9 11 0 20 5 20 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 9 0 15 10 15 26 0 32 -8 30 -91 -27 -59 -39 -66 -42 -202 -60 -78 -10 -157 -21 -174 -24 -35 -6 -45 -30 -15 -38 13 -4 11 -5 -5 -6 -17 -1 -23 5 -23 19 0 21 -10 24 -47 14 -27 -7 -30 -31 -5 -37 13 -4 11 -5 -5 -6 -17 -1 -23 5 -23 19 0 21 -10 24 -47 14 -25 -7 -31 -29 -10 -37 7 -3 5 -6 -5 -6 -12 -1 -18 6 -18 19 0 11 -1 20 -3 20 -8 0 -224 -30 -254 -35 -20 -4 -33 -12 -33 -20 0 -8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 16 -20 19 -57 9 -14 -4 -23 -14 -23 -25 0 -11 -4 -19 -10 -19 -5 0 -10 9 -10 20 0 21 -16 25 -57 14 -25 -7 -31 -29 -10 -37 7 -3 5 -6 -5 -6 -12 -1 -18 6 -18 19 0 11 -2 20 -4 20 -21 0 -474 -75 -546 -91 -124 -27 -163 -39 -175 -56 -5 -7 -30 -15 -54 -18 -49 -4 -151 -43 -151 -56 0 -5 -6 -9 -13 -9 -26 0 -123 -53 -214 -117 -93 -64 -129 -108 -119 -141 6 -18 114 -77 123 -68 3 2 -10 12 -29 21 -46 24 -68 45 -68 65 0 10 28 41 63 69 131 108 362 194 697 260 58 12 353 50 655 86 303 35 565 67 583 70 37 7 43 31 10 38 -20 4 -19 4 5 6 21 1 27 -4 27 -19 0 -23 2 -23 90 -10 58 8 66 7 83 -10 47 -51 156 -81 286 -79 l76 2 -87 8 c-48 4 -94 11 -103 17 -14 7 35 47 261 213 153 112 285 207 293 211 12 5 11 7 -5 7 -12 1 -42 4 -68 7 l-46 7 0 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKkh8kDv7",
    d: "M4948 1923 c-10 -2 -18 -11 -18 -19 0 -8 -4 -14 -10 -14 -5 0 -10 7 -10 15 0 8 -8 15 -17 15 -34 0 -63 -12 -63 -26 0 -8 -7 -14 -15 -14 -8 0 -15 7 -15 15 0 16 -12 18 -47 9 -22 -6 -33 -34 -13 -34 6 0 10 -7 10 -15 0 -9 9 -15 23 -15 38 0 67 12 67 26 0 8 7 14 15 14 8 0 15 -7 15 -15 0 -8 8 -15 18 -15 33 0 62 12 62 26 0 8 7 14 15 14 8 0 15 -7 15 -15 0 -16 28 -19 68 -9 33 9 28 34 -8 34 -20 0 -30 5 -30 15 0 15 -25 18 -62 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11xpgxzXB",
    d: "M5830 1912 c0 -22 22 -26 258 -38 106 -5 122 -4 122 9 0 20 -26 24 -175 32 -66 3 -139 8 -162 12 -38 5 -43 3 -43 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvI9v4EB",
    d: "M7355 1871 c-99 -32 -243 -78 -320 -102 -131 -41 -137 -44 -100 -49 22 -3 58 0 80 6 74 22 520 185 530 195 15 15 -1 11 -190 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcpykCNhy",
    d: "M5200 1900 c0 -21 23 -26 68 -14 41 11 26 34 -23 34 -38 0 -45 -3 -45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzJGkxkCN",
    d: "M4638 1893 c-19 -5 -25 -33 -8 -33 6 0 10 -7 10 -15 0 -16 28 -19 68 -9 25 7 31 34 7 34 -8 0 -15 7 -15 15 0 15 -25 18 -62 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCkhwEMGL",
    d: "M6260 1886 c0 -16 30 -26 78 -26 46 0 42 26 -5 34 -57 9 -73 7 -73 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZfIXYPYH",
    d: "M4538 1883 c-12 -3 -18 -14 -18 -34 0 -25 4 -29 28 -29 42 0 72 11 72 26 0 8 -4 14 -10 14 -5 0 -10 7 -10 15 0 15 -25 18 -62 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pExjRR7Je",
    d: "M6410 1877 c0 -18 29 -21 313 -38 104 -6 191 -8 194 -5 4 3 -2 6 -13 6 -10 0 -100 9 -199 20 -315 35 -295 34 -295 17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5ZNgcFWP",
    d: "M7695 1788 c-126 -54 -214 -97 -193 -93 25 4 38 2 41 -7 3 -7 6 -4 6 7 1 17 20 28 99 57 88 32 98 34 110 19 34 -41 -22 -164 -80 -176 -30 -7 -30 -7 -26 -66 2 -32 1 -59 -4 -59 -12 0 25 -93 40 -98 7 -2 12 7 13 25 1 17 3 21 6 11 2 -10 9 -18 14 -18 5 0 9 -7 9 -15 0 -8 7 -15 15 -15 8 0 15 -9 15 -20 0 -11 7 -20 15 -20 8 0 15 -7 15 -16 0 -12 -8 -14 -45 -8 l-45 6 22 -63 c13 -34 29 -64 37 -67 9 -3 11 2 8 14 -4 11 -9 32 -13 47 l-6 28 58 -5 c33 -3 73 -8 91 -12 18 -3 40 -3 50 0 14 6 0 17 -60 50 -71 39 -85 52 -142 132 -34 49 -61 91 -59 93 1 2 39 -22 83 -54 45 -31 81 -55 81 -53 0 2 -41 38 -92 79 -84 68 -90 74 -66 77 25 3 80 53 91 84 3 9 15 3 40 -21 51 -49 66 -34 19 19 -32 37 -40 53 -40 88 0 23 -3 50 -6 60 -5 14 9 25 71 54 150 70 56 35 -172 -64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAtsXgMPW",
    d: "M4440 1873 c-36 -14 -42 -63 -7 -63 49 0 67 11 67 41 0 24 -4 29 -22 28 -13 0 -30 -3 -38 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3sRTOhX8",
    d: "M5244 1786 c-33 -33 -45 -66 -24 -66 6 0 10 -7 10 -15 0 -8 -7 -15 -16 -15 -24 0 -10 -58 23 -92 24 -25 78 -46 90 -35 10 11 -19 47 -37 47 -11 0 -20 7 -20 15 0 10 -10 15 -27 15 l-28 1 28 25 29 25 -16 41 c-9 22 -15 43 -12 45 3 3 21 -5 41 -17 20 -12 39 -20 42 -17 3 4 2 22 -1 42 -9 46 -36 47 -82 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "psB5TmlaL",
    d: "M5384 1795 c-9 -22 1 -29 15 -11 8 10 9 16 1 21 -5 3 -13 -1 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pprQAvivV",
    d: "M5408 1745 l-14 -50 36 -22 35 -22 -43 -1 c-40 0 -44 -3 -58 -35 -16 -40 -19 -68 -4 -45 5 8 10 10 10 3 0 -37 84 34 96 83 9 34 -3 88 -25 115 l-19 23 -14 -49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DSIP2NvK",
    d: "M7386 1731 c-52 -21 -64 -30 -51 -35 10 -4 21 -2 25 3 3 6 30 21 60 35 74 34 51 32 -34 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7Q13MzfD",
    d: "M7575 1580 c-18 -8 -17 -9 8 -9 15 -1 27 -5 27 -11 0 -5 5 -10 10 -10 6 0 10 9 10 20 0 21 -20 25 -55 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phDhlJKfd",
    d: "M7930 1539 c0 -17 66 -86 75 -77 3 3 -13 25 -34 49 -25 27 -40 38 -41 28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5SBNOW4I",
    d: "M2860 1480 c-34 -7 -34 -7 -5 -8 17 0 41 4 55 8 33 11 0 11 -50 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pv3C4OZ2w",
    d: "M5048 1448 c-20 -5 -44 -18 -54 -29 -16 -18 -16 -19 3 -19 17 0 22 -8 25 -37 3 -21 2 -39 -3 -41 -4 -2 4 -15 17 -29 14 -15 24 -36 22 -47 -3 -19 -16 -22 -158 -38 -85 -9 -156 -17 -157 -17 -2 -1 -3 -8 -3 -17 0 -13 7 -15 35 -10 19 4 44 2 55 -4 16 -8 24 -8 35 3 8 9 47 17 99 22 54 4 86 11 87 18 0 7 5 3 10 -8 6 -14 8 -1 5 45 -1 36 1 76 6 89 5 15 4 28 -3 37 -6 8 -9 21 -5 29 3 10 -1 18 -11 22 -14 5 -9 11 22 25 43 19 32 22 -27 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCqu6CUHz",
    d: "M5392 1424 c-11 -11 -11 -18 -2 -29 16 -19 2 -38 -24 -31 -21 5 -21 4 -13 -87 5 -51 12 -105 17 -122 7 -23 8 -18 4 21 -5 50 -5 52 24 62 17 6 32 8 35 6 7 -8 616 65 702 83 246 53 457 -20 668 -234 71 -72 97 -93 97 -78 0 12 -37 58 -88 110 -105 109 -203 168 -349 209 -138 39 -131 37 -108 46 33 14 14 11 -116 -15 -68 -14 -266 -43 -439 -65 l-315 -39 -43 42 -43 42 26 18 c29 22 32 44 8 63 -22 17 -25 17 -41 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Eiyw7UmO",
    d: "M8060 1404 c0 -6 19 -28 42 -49 36 -35 38 -36 21 -10 -25 36 -63 72 -63 59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAj6M3nsk",
    d: "M4952 1348 c2 -15 11 -24 26 -26 20 -3 23 0 20 20 -2 15 -11 24 -26 26 -20 3 -23 0 -20 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdfdy8OWD",
    d: "M4658 1183 c-21 -5 -24 -33 -4 -33 36 0 76 14 76 26 0 14 -34 17 -72 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV6bDttE5",
    d: "M4568 1173 c-10 -2 -18 -11 -18 -19 0 -8 8 -14 18 -14 33 0 62 12 62 26 0 14 -26 17 -62 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pD87pV2nI",
    d: "M2760 984 c-949 -100 -1751 -183 -1782 -183 -69 -1 -82 -25 -19 -35 23 -3 306 23 687 64 357 38 906 97 1219 130 314 34 595 63 625 65 30 3 108 11 174 19 111 13 122 13 185 -5 76 -22 232 -49 276 -48 30 1 30 1 5 9 -14 5 -65 21 -113 36 -48 15 -86 28 -84 31 3 2 126 17 273 33 148 17 284 32 302 35 40 7 45 36 5 34 -16 -1 -804 -84 -1753 -185z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTL2rZXjT",
    d: "M5070 1105 l0 -35 -50 25 c-27 14 -56 25 -65 25 -32 0 -13 -19 55 -54 l70 -37 0 55 c0 31 -2 56 -5 56 -3 0 -5 -16 -5 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paGnHnjpq",
    d: "M5372 1075 c0 -16 3 -39 8 -50 8 -18 9 -18 8 5 0 14 -4 36 -8 50 -8 24 -8 24 -8 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNrJs5C2W",
    d: "M7788 1053 c24 -66 45 -69 24 -4 -9 28 -22 51 -29 51 -10 0 -9 -11 5 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6AgYaqI6",
    d: "M5083 975 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FJbgiS3t",
    d: "M570 975 c0 -18 5 -25 19 -25 28 0 37 21 16 37 -27 19 -35 16 -35 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKX0R7tOa",
    d: "M500 980 c-13 -8 -12 -11 5 -24 36 -27 53 -19 39 18 -7 18 -22 20 -44 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGPaesPHx",
    d: "M5386 910 c3 -41 7 -87 9 -102 3 -21 0 -28 -18 -31 -12 -2 -4 -5 18 -5 22 -1 35 2 29 6 -6 4 -14 24 -17 46 -5 34 -4 38 13 33 27 -7 26 19 0 33 -11 6 -20 21 -21 33 0 12 -4 31 -9 42 -6 13 -7 -8 -4 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPDFqxuCc",
    d: "M7820 973 c0 -16 204 -592 208 -588 6 6 -192 595 -200 595 -5 0 -8 -3 -8 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDMHmJYza",
    d: "M4165 961 c-27 -6 -23 -9 47 -29 42 -12 86 -22 97 -22 40 0 20 27 -32 43 -57 18 -64 18 -112 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2YbJuTsa",
    d: "M462 928 c3 -30 10 -36 68 -65 80 -40 141 -60 245 -79 101 -18 135 -18 135 0 0 15 -30 26 -76 26 -59 0 -238 41 -291 67 -40 18 -52 29 -48 42 3 10 -3 21 -16 29 -19 12 -20 11 -17 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pPuCi9asU",
    d: "M5296 862 c5 -79 4 -84 -15 -89 -12 -3 -21 -12 -21 -19 0 -19 57 -18 76 0 18 18 18 26 0 26 -16 0 -25 29 -27 85 0 22 -5 49 -10 60 -6 13 -7 -8 -3 -63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15MC5s4qw",
    d: "M4800 928 c3 -3 71 -40 153 -82 l147 -77 -2 63 c-1 47 -2 53 -5 22 l-4 -42 -132 55 c-155 65 -164 68 -157 61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8aoyHPgL",
    d: "M4400 888 c0 -9 66 -33 213 -76 257 -75 360 -93 187 -32 -140 50 -335 111 -372 118 -20 3 -28 0 -28 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYE9vz1pr",
    d: "M7050 865 c0 -25 112 -139 131 -133 8 3 -15 33 -59 79 -55 57 -71 69 -72 54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJBO8U8xq",
    d: "M5450 857 c0 -8 23 -24 50 -37 58 -27 64 -42 18 -40 -56 3 -68 1 -68 -15 0 -12 13 -15 60 -15 57 0 60 -1 60 -24 0 -16 -17 -41 -51 -73 -42 -40 -50 -54 -47 -77 l3 -29 57 52 c58 53 85 104 73 141 -5 15 -2 20 12 20 26 0 133 -16 197 -30 l56 -11 0 -45 c0 -62 -24 -107 -53 -99 -17 5 -19 4 -7 -4 12 -8 11 -14 -10 -37 -14 -14 -49 -40 -77 -56 -29 -16 -53 -34 -53 -39 0 -15 67 -10 84 6 8 8 19 15 25 15 6 0 11 7 11 15 0 8 8 15 18 15 25 0 42 19 42 47 0 16 6 23 20 23 16 0 20 7 20 30 0 17 5 30 10 30 6 0 10 23 10 50 0 43 -3 52 -23 59 -44 17 -185 42 -241 42 -40 1 -56 5 -56 15 0 11 -115 84 -133 84 -4 0 -7 -6 -7 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNng4GGEs",
    d: "M5085 754 c-139 -24 -175 -35 -175 -51 0 -17 15 -16 183 13 88 16 107 22 107 36 0 21 -7 21 -115 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p877JOi5u",
    d: "M5920 695 c0 -20 6 -27 30 -31 17 -4 30 -10 30 -15 0 -5 5 -9 11 -9 19 0 39 -28 39 -54 0 -14 -4 -26 -10 -26 -5 0 -10 -9 -10 -20 0 -13 -7 -20 -20 -20 -11 0 -20 -4 -20 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -11 -10 -25 -10 -14 0 -25 -4 -25 -9 0 -5 -18 -12 -40 -16 -33 -6 -40 -11 -40 -30 0 -22 2 -23 33 -13 17 5 51 19 74 29 24 10 45 19 48 19 13 0 125 81 138 100 14 20 15 19 73 -12 l59 -32 -30 -9 c-155 -43 -265 -76 -240 -73 17 2 127 17 245 33 214 28 215 28 145 35 -102 11 -105 12 -105 20 0 4 -27 21 -60 38 -57 29 -60 32 -60 68 0 53 -36 88 -125 122 -23 9 -25 7 -25 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pthXRfetm",
    d: "M4750 671 c-93 -30 -191 -84 -230 -126 -20 -21 -25 -37 -25 -75 0 -27 5 -54 10 -59 7 -7 10 1 7 27 -1 21 4 48 13 62 8 14 18 33 21 43 3 9 12 17 19 17 7 0 23 8 36 18 35 26 125 59 193 71 63 12 85 8 45 -8 -106 -40 -128 -61 -64 -61 19 0 35 5 35 10 0 6 11 10 25 10 14 0 25 5 25 10 0 6 9 10 20 10 16 0 20 7 20 34 0 26 -5 35 -22 40 -32 8 -33 8 -128 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQbhewvyK",
    d: "M7280 614 c0 -3 64 -71 142 -150 78 -79 139 -147 135 -150 -3 -4 -32 -12 -64 -19 -74 -16 -39 -17 51 -2 l69 12 -153 158 c-131 136 -180 176 -180 151z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2nSM1eyZ",
    d: "M4652 559 c-89 -44 -131 -139 -82 -184 20 -18 20 -17 20 48 0 65 1 67 25 67 14 0 28 6 31 14 3 8 16 17 30 20 17 5 24 13 24 31 0 14 -1 25 -2 25 -2 0 -22 -10 -46 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pRVCwJ6xJ",
    d: "M5380 525 c0 -30 3 -30 41 -8 38 23 37 33 -6 33 -31 0 -35 -3 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4GGzq5V1",
    d: "M5273 488 c-13 -6 -23 -15 -23 -20 0 -4 -11 -8 -25 -8 -20 0 -25 -5 -25 -25 l0 -25 52 21 c62 24 108 50 108 61 0 12 -61 8 -87 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pco167woY",
    d: "M5603 420 c-51 -23 -55 -40 -10 -40 42 0 60 12 55 38 l-3 21 -42 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p97xl0UmP",
    d: "M5108 423 c-11 -3 -18 -14 -18 -29 l0 -24 47 18 c57 21 69 42 21 41 -18 -1 -41 -3 -50 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p19U9MlqAs",
    d: "M4913 367 c-46 -11 -83 -26 -83 -32 0 -8 -20 -8 -70 -1 -38 5 -70 13 -70 18 0 4 -16 8 -35 8 -81 0 -17 -40 95 -59 36 -7 78 -14 95 -18 26 -5 28 -4 17 10 -15 17 -18 16 131 53 42 10 67 22 67 30 0 19 -47 16 -147 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "podcU8ati",
    d: "M5431 346 c-149 -59 -146 -83 6 -52 37 8 85 17 106 20 39 7 53 36 18 36 -12 0 -21 8 -23 19 -3 18 -11 16 -107 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDJ4gMEBW",
    d: "M5623 373 c-15 -3 -23 -12 -23 -24 0 -22 6 -23 66 -8 82 21 44 49 -43 32z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l4t40ta9mS6aSFq5k5tgRZy",
    fill: "rgb(0,0,0)",
    style: {
      transform: "none"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p8jettevy",
    d: "M3788 2633 c13 -3 22 -12 22 -24 0 -11 7 -19 16 -19 10 0 14 7 12 23 -2 18 -10 22 -38 24 -19 0 -25 -1 -12 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DqocXaNx",
    d: "M4515 2599 l-190 -20 -350 -157 -350 -157 50 -11 c28 -6 52 -7 56 -2 3 4 138 74 300 154 l294 147 235 32 c263 37 243 43 -45 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15kX8UQ59",
    d: "M3154 2523 c-4 -31 -2 -76 4 -102 6 -25 9 -47 8 -48 -7 -8 -251 -44 -274 -41 -48 5 -25 23 50 37 82 16 82 16 74 30 -5 7 -13 7 -27 -2 -17 -10 -22 -9 -34 6 -13 17 -14 17 -20 -4 l-7 -22 -13 23 -12 22 -7 -23 -7 -24 -15 28 c-14 26 -17 27 -28 11 -12 -16 -13 -15 -19 7 -9 35 3 96 22 113 9 8 27 16 41 19 18 3 14 5 -13 6 -36 1 -39 -1 -59 -46 -34 -77 -11 -188 44 -212 23 -10 51 -9 165 9 76 11 151 28 167 36 34 18 596 115 623 108 13 -4 19 0 19 13 0 10 4 29 8 41 7 20 5 23 -11 20 -10 -2 -19 -13 -21 -25 -2 -14 -12 -24 -30 -27 -51 -11 -553 -86 -572 -86 -26 0 -45 88 -32 148 8 33 7 42 -3 42 -9 0 -16 -20 -21 -57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p10rrUWnLn",
    d: "M2730 2300 c-27 -6 -29 -8 -10 -8 14 -1 43 3 65 7 33 7 35 9 10 9 -16 -1 -46 -4 -65 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCp3Xvzrb",
    d: "M2624 2280 c-37 -15 -41 -95 -9 -182 17 -44 29 -38 -140 -72 -84 -17 -124 -21 -132 -14 -20 17 -7 25 60 38 35 6 70 16 78 22 10 7 6 8 -14 3 -16 -3 -35 -1 -42 5 -10 8 -16 7 -24 -7 -9 -17 -11 -16 -20 7 -6 16 -10 19 -10 8 -1 -30 -21 -30 -32 -1 -10 27 -11 27 -22 8 -10 -19 -11 -18 -18 9 -7 27 4 116 16 137 4 5 2 9 -3 9 -14 0 -32 -72 -32 -125 0 -55 22 -108 53 -127 60 -37 162 -56 337 -63 96 -3 191 -10 210 -14 l35 -7 -195 -129 c-107 -70 -206 -132 -220 -137 -26 -9 -508 -73 -860 -113 -562 -65 -870 -133 -1096 -239 -159 -75 -334 -206 -334 -250 0 -23 34 -44 210 -130 190 -92 272 -120 395 -136 165 -21 174 -21 1520 125 910 99 1171 125 1183 120 8 -3 20 -1 26 3 6 5 63 14 126 20 105 10 121 10 185 -9 72 -20 235 -49 270 -48 11 0 -32 17 -95 38 -130 43 -129 43 35 60 55 6 246 26 425 46 l325 35 133 -68 c127 -67 132 -68 132 -45 0 13 -4 21 -10 18 -10 -6 -190 85 -190 97 0 4 36 10 80 14 44 3 83 11 86 15 3 5 10 7 15 4 5 -4 9 4 9 17 0 13 -3 18 -8 12 -4 -8 -761 -91 -2052 -227 l-2045 -215 -115 13 c-202 23 -370 75 -357 110 10 24 -27 45 -81 45 -63 0 -155 38 -173 71 -11 22 -8 27 47 76 101 91 273 168 502 227 207 53 323 70 1010 151 l633 75 37 -29 c43 -34 118 -61 165 -60 l32 1 -27 10 c-16 5 -28 13 -28 16 1 4 127 99 282 212 l281 205 -54 7 c-78 9 -409 28 -504 28 -82 0 -195 25 -179 39 5 5 59 18 119 31 61 12 112 26 115 30 3 5 133 41 289 80 l284 72 61 -22 c34 -12 65 -25 69 -29 4 -4 -75 -47 -175 -96 l-183 -89 113 -9 c94 -7 116 -6 130 6 9 8 105 70 212 138 l195 124 -45 7 c-59 9 -536 7 -490 -1 l35 -7 -56 -26 c-31 -14 -141 -44 -245 -67 -235 -52 -219 -50 -219 -24 0 12 -4 25 -8 29 -9 9 -9 71 -1 112 5 24 13 32 33 35 26 4 26 4 1 5 -14 0 -34 -3 -46 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16roPiSx3",
    d: "M4138 2255 c-26 -14 -49 -29 -52 -34 -3 -5 19 4 49 21 30 16 55 31 55 34 0 6 0 6 -52 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCqXlvBaL",
    d: "M3693 2213 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMk5mqfQ6",
    d: "M4214 2073 l-42 -35 50 -107 c41 -88 48 -109 38 -124 -6 -11 -7 -17 -2 -13 5 3 240 26 523 51 l514 47 400 -6 c220 -2 508 -12 640 -20 132 -8 299 -17 370 -20 l130 -6 -155 20 c-317 39 -876 71 -1273 73 -362 1 -381 0 -730 -36 -196 -20 -365 -37 -375 -37 -11 0 -33 30 -65 90 l-48 89 38 35 c49 46 40 45 -13 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNzyj42QD",
    d: "M3776 1948 c-9 -12 -16 -27 -16 -33 1 -5 7 1 15 15 7 14 24 28 37 31 22 7 22 7 1 8 -12 1 -29 -9 -37 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plKG0BCK8",
    d: "M7230 1829 c-292 -94 -328 -108 -284 -109 41 0 113 22 345 106 162 58 296 108 298 110 12 12 -53 -8 -359 -107z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12s0McLIE",
    d: "M7665 1774 c-202 -87 -197 -85 -161 -77 18 4 31 1 37 -8 7 -11 9 -9 9 7 0 18 16 27 102 58 112 40 118 39 118 -25 0 -22 -11 -52 -30 -82 -16 -26 -31 -47 -32 -48 -2 -1 -50 -7 -108 -14 -88 -10 -96 -13 -49 -14 l57 -1 75 -212 c41 -117 123 -351 182 -520 60 -170 110 -307 111 -305 2 1 -50 165 -115 362 -89 274 -114 361 -103 363 7 2 50 -1 94 -7 114 -15 124 -3 34 41 -68 34 -79 44 -136 124 -34 47 -64 94 -68 102 -3 9 25 -5 64 -32 61 -42 64 -43 24 -9 -25 21 -58 50 -74 64 l-30 27 32 7 c21 4 41 20 59 46 16 21 30 39 34 39 3 0 95 -89 204 -197 110 -109 179 -175 154 -148 -26 28 -114 124 -198 214 -144 155 -151 165 -151 205 0 22 -3 50 -6 61 -4 16 2 25 28 37 78 39 0 10 -157 -58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppsx4zwpx",
    d: "M6863 1833 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7Sbh5jzD",
    d: "M5273 1808 c-31 -15 -29 -23 13 -47 45 -27 48 -26 91 6 32 25 34 28 17 40 -21 16 -90 16 -121 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph25n6QQF",
    d: "M5216 1752 c-18 -36 -21 -88 -5 -98 6 -3 22 4 35 18 l25 24 -20 43 -19 44 -16 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP8cWBhGL",
    d: "M5411 1749 c-16 -47 -14 -57 18 -74 28 -14 30 -14 36 6 7 21 -21 99 -36 99 -4 0 -12 -14 -18 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pldSfGnts",
    d: "M5394 1643 c-20 -4 -52 -68 -40 -81 12 -12 76 28 91 58 15 29 15 30 -7 29 -13 -1 -32 -4 -44 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptAtw2lWk",
    d: "M5224 1615 c17 -25 71 -58 90 -53 12 3 12 8 -1 41 -15 36 -17 38 -59 35 -41 -3 -42 -4 -30 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pIcpJXEUB",
    d: "M5045 1444 c-97 -36 -124 -112 -44 -129 16 -4 36 -16 44 -28 l15 -21 0 22 c0 13 5 33 11 44 9 17 8 24 -6 34 -14 11 -15 16 -6 28 9 11 8 15 -6 21 -15 5 -12 10 17 25 41 23 31 24 -25 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12aQb2oqB",
    d: "M5392 1420 c-7 -12 -8 -20 -2 -20 5 0 10 -10 10 -21 0 -18 -5 -20 -26 -16 -26 5 -26 5 -20 -47 3 -28 6 -71 7 -96 1 -39 2 -41 8 -15 l6 29 395 47 c217 26 410 52 429 59 50 19 181 7 274 -25 170 -59 206 -88 672 -564 298 -304 422 -437 413 -443 -9 -5 -3 -8 15 -8 15 0 27 4 27 8 0 18 -856 885 -908 921 -32 21 -79 48 -107 60 -58 27 -201 71 -226 71 -10 0 -19 5 -21 11 -3 8 -42 3 -128 -14 -69 -15 -262 -43 -429 -63 l-304 -37 -40 44 -40 43 27 21 c31 25 32 36 8 58 -23 21 -25 21 -40 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMqHtmBdv",
    d: "M5373 1115 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poz3Ug3Nu",
    d: "M5383 995 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peATsqwyx",
    d: "M570 981 c0 -23 9 -31 26 -24 21 8 17 30 -6 36 -14 4 -20 0 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pF5xzHtqQ",
    d: "M510 980 c-13 -8 -13 -11 2 -26 20 -20 38 -11 31 16 -6 22 -11 24 -33 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFz60sK37",
    d: "M5297 883 l5 -113 -55 0 c-82 0 -268 -35 -426 -80 -152 -44 -266 -101 -301 -150 -26 -36 -35 -83 -21 -107 9 -15 10 -12 11 19 0 53 53 108 144 153 63 32 199 65 212 52 3 -2 -21 -15 -53 -27 -143 -57 -226 -108 -249 -152 -46 -89 26 -150 214 -181 73 -13 82 -12 80 1 -2 12 27 23 122 47 258 67 432 149 549 261 69 65 74 73 74 112 0 39 2 42 27 42 28 0 191 -26 222 -36 9 -3 20 -14 23 -26 10 -28 -14 -107 -37 -121 -10 -7 -18 -17 -18 -24 0 -38 -321 -196 -515 -254 l-60 -18 55 0 c73 -1 380 58 485 94 109 37 210 94 251 142 l21 25 51 -26 c28 -14 53 -30 56 -35 3 -5 -47 -23 -112 -41 -64 -17 -121 -33 -127 -35 -29 -10 62 -1 235 25 107 16 172 28 144 28 -43 -1 -67 7 -146 47 -91 46 -94 48 -90 79 2 21 -3 40 -17 57 -39 50 -198 108 -341 124 -52 5 -89 19 -184 68 -70 37 -122 70 -127 82 -5 14 -8 3 -7 -35 0 -30 3 -45 5 -33 4 22 6 22 84 -17 43 -22 79 -42 79 -45 0 -3 -33 -5 -74 -5 -69 0 -75 2 -79 23 l-4 22 -2 -23 c-1 -21 -5 -23 -43 -20 l-43 3 -12 105 -11 105 5 -112z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbEnEcBPX",
    d: "M4170 962 c-32 -4 -26 -7 60 -33 432 -133 657 -195 666 -186 4 4 -678 229 -686 226 -3 -1 -21 -4 -40 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdt7Ln9eL",
    d: "M4960 845 c69 -35 128 -64 133 -64 4 -1 7 7 7 17 0 10 -8 18 -17 19 -10 1 -67 22 -126 47 -60 25 -112 46 -115 45 -4 0 49 -29 118 -64z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwacs);
export default __webpack_public_path__ + "static/media/awacs.1c6446470914ca7d63ccbd47e584d43b.svg";
export { ForwardRef as ReactComponent };